/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AML {
  /** An enumeration. */
  channel?: Channel;
  comment?: string | AMLComment;

  /** An enumeration. */
  review_status: AMLReviewStatus;

  /** An enumeration. */
  risk_level: AMLRiskLevel;
  is_identity_checked?: boolean;
  is_pep_or_sanctioned?: boolean;
}

/**
 * An enumeration.
 */
export enum AMLBlancoPurpose {
  RefinanceLoan = "refinance_loan",
  NewLoan = "new_loan",
  RefinanceAndNewLoan = "refinance_and_new_loan",
}

export interface AMLBlancoResponse {
  /** An enumeration. */
  channel?: Channel;
  comment?: string | AMLComment;

  /** An enumeration. */
  review_status: AMLReviewStatus;

  /** An enumeration. */
  risk_level: AMLRiskLevel;
  is_identity_checked?: boolean;
  is_pep_or_sanctioned?: boolean;
  purpose?: string;
  purpose_when_new_loan?: string;
}

export interface AMLComment {
  /** @example sms|5ce26c2450d832460390f580 */
  user_id: string;

  /** @example The customer said that they wanted to do that */
  comment: string;

  /** @format date-time */
  timestamp: string;
  comment_id: string;
  action?: string;
}

export interface AMLInsertion {
  /** An enumeration. */
  channel?: Channel;
  comment?: string;
}

export interface AMLReviewPayload {
  application_id: string;

  /** An enumeration. */
  review_status: AMLReviewStatus;
  comment: string;
}

/**
 * An enumeration.
 */
export enum AMLReviewStatus {
  Approved = "approved",
  Rejected = "rejected",
  NotReviewed = "not_reviewed",
}

/**
 * An enumeration.
 */
export enum AMLRiskLevel {
  Medium = "medium",
  High = "high",
  Unknown = "unknown",
}

export interface AcceptOffer {
  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;

  /** @format uuid */
  offer_id: string;
  synchronous?: boolean;
}

export interface AcceptOfferPayload {
  application_id: string;
  offer_id: string;
  bank_account_number?: string;
  bank_clearing_number?: string;
}

export interface AcceptedLoans {
  amount: number;
  sum: number;
  accepted_per_meeting: number;
  number_of_meetings: number;

  /** An enumeration. */
  currency: Currency;
}

export interface Account {
  /** @example 1234567 */
  account_number: string;

  /** @example 1337 */
  clearing_number?: string;

  /** @example 21 */
  bank_id?: number;

  /** @example ICA Banken */
  bank_name?: string;
}

/**
 * An enumeration.
 */
export enum Action {
  CREATED = "CREATED",
  UPDATE = "UPDATE",
  CUSTOMER_ADDED = "CUSTOMER_ADDED",
  FIRST_TIME_CUSTOMER = "FIRST_TIME_CUSTOMER",
  INTERNAL_COMMENT_ADDED = "INTERNAL_COMMENT_ADDED",
  ACTIVATED = "ACTIVATED",
  HANDLER_ASSIGNED = "HANDLER_ASSIGNED",
  FIRST_OFFER_RECEIVED = "FIRST_OFFER_RECEIVED",
  OFFER_RECEIVED = "OFFER_RECEIVED",
  CANCELED = "CANCELED",
  PROPERTY_ADDED = "PROPERTY_ADDED",
  DOCUMENT_ATTACHED = "DOCUMENT_ATTACHED",
  VERIFIED_BANK_ID = "VERIFIED_BANK_ID",
  AML_REVIEW = "AML_REVIEW",
  DEACTIVATED = "DEACTIVATED",
}

export interface ActionPayload {
  notification_ids: string[];

  /** An enumeration. */
  action: NotificationEvent;
}

export interface AdditionalCostPerPerson {
  /** @example 2 */
  number_of_people: number;

  /** @example 2620 */
  cost: number;
}

export interface Affiliate {
  name: string;

  /** @format uri */
  website?: string;
  affiliate_parent?: string;
  partner_url?: string[];

  /** An enumeration. */
  country?: Country;

  /** @format uri */
  webhook_url?: string;
  network?: boolean;
  publisher_data?: PublisherData;
  affiliate_id: string;
  creator: string;

  /** An enumeration. */
  status: ModelsAffiliateAffiliateAffiliateStatus;

  /** @format date-time */
  created_at: string;

  /** @format date-time */
  updated_at: string;

  /** @format date-time */
  deactivated_at?: string;
  campaign?: ModelsAffiliateAffiliateCampaign[];
}

export interface AffiliateApiLeadSource {
  type?: "AFFILIATE_API";
  external_id?: string;
  submission_id?: string;
  affiliate_id?: string;
}

/**
 * An enumeration.
 */
export enum AffiliateApplicantRole {
  MAIN_APPLICANT = "MAIN_APPLICANT",
  CO_APPLICANT = "CO_APPLICANT",
  GUARANTOR = "GUARANTOR",
}

/**
 * An enumeration.
 */
export enum AffiliateApplyingWith {
  PARENT = "PARENT",
  SPOUSE = "SPOUSE",
  ALONE = "ALONE",
  COHABITANT = "COHABITANT",
}

export interface AffiliateBlancoLoan {
  /** @example 100000 */
  amount?: number;

  /** An enumeration. */
  loan_type?: AffiliateLoanType;
  responsibility?:
    | AffiliateResponsibilitySE
    | AffiliateResponsibilityNO
    | (AffiliateResponsibilitySE & AffiliateResponsibilityNO);

  /** @example 21 */
  creditor_id?: number;

  /** @example true */
  refinance?: boolean;

  /**
   * @min 0
   * @example 3000
   */
  monthly_payment?: number;

  /** @example 3.3 */
  rate?: number;
}

export interface AffiliateBlancoLoanForMortgage {
  /** @example 100000 */
  amount?: number;

  /** An enumeration. */
  loan_type?: AffiliateLoanType;
  responsibility?:
    | AffiliateResponsibilitySE
    | AffiliateResponsibilityNO
    | (AffiliateResponsibilitySE & AffiliateResponsibilityNO);

  /** @example 21 */
  creditor_id?: number;
}

/**
 * An enumeration.
 */
export enum AffiliateBlancoPurposeForNewLoan {
  CAR_BOAT_OR_MC = "CAR_BOAT_OR_MC",
  CONSUMPTION = "CONSUMPTION",
  PROPERTY_RENOVATION = "PROPERTY_RENOVATION",
  LOAN_FOR_SOMEBODY_ELSE = "LOAN_FOR_SOMEBODY_ELSE",
  INVESTMENT = "INVESTMENT",
  EDUCATION = "EDUCATION",
  HEALTH_CARE = "HEALTH_CARE",
  DEBT_COLLECTION = "DEBT_COLLECTION",
  INVESTMENT_ABROAD = "INVESTMENT_ABROAD",
  DIVORCE = "DIVORCE",
  BUY_PROPERTY = "BUY_PROPERTY",
}

export interface AffiliateBuyingInfo {
  property_price?: number;
  buying_date?: string;
  new_production?: boolean;
}

export interface AffiliateCallback {
  /** An enumeration. */
  status: ModelsAffiliatePartnerApplicationAffiliateStatus;

  /** @format date-time */
  timestamp: string;
  external_id: string;
  submission_id: string;
  message?: string;
  success?: boolean;
}

export interface AffiliateCar {
  monthly_cost?: number;
}

export interface AffiliateCars {
  /** @min 0 */
  owned?: number;
  leased?: AffiliateCar[];
}

export interface AffiliateCreateBlancoApplication {
  /** Can be any string. The given value be sent back as part of the webhook request */
  external_id: string;

  /** An enumeration. */
  country: Country;

  /**
   * Time slot when to book meeting with customer. Has to be a available slot based on the response from the /bookings endpoint
   * @format date-time
   */
  book_meeting_at: string;
  applicants: OptionalAffiliateApplicantBlanco[];

  /** Current loan situation */
  current_loans: AffiliateBlancoLoan[];
  children_in_the_household: number;
  children_in_the_household_full_time: number;

  /** The time customer would like to pay back loan (in months) */
  desired_payback_time?: number;

  /** Total desired amount customer wants to borrow. This is refinance and new loan amounts */
  desired_amount: number;

  /** Used when customer wants to borrow money for purpose different than refinancing existing loans */
  new_loan?: AffiliateNewLoan;
}

export interface AffiliateCreditor {
  name: string;
  creditor_id: number;
}

export interface AffiliateData {
  name: string;

  /** @format uri */
  website?: string;
  affiliate_parent?: string;
  partner_url?: string[];

  /** An enumeration. */
  country?: Country;

  /** @format uri */
  webhook_url?: string;
  network?: boolean;
  publisher_data?: PublisherData;
}

export interface AffiliateEmployer {
  /**
   * Name of the employer.
   * @example Zensum AB
   */
  name: string;
  type: "FULL" | "TRIAL" | "HOURLY" | "PROJECT" | "SELF_EMPLOYED" | "COMPANY_OWNER";

  /** @format date */
  start_date: string;

  /**
   * Used in cases when the type is PROJECT
   * @format date
   */
  end_date?: string;

  /**
   * Employer phone number
   * @example +46761234567
   */
  phone?: string;
  organization_number?: string;
  profession?: string;
}

/**
 * An enumeration.
 */
export enum AffiliateHousingType {
  RENTED = "RENTED",
  OWN_APARTMENT = "OWN_APARTMENT",
  OWN_HOUSE = "OWN_HOUSE",
  LIVE_IN = "LIVE_IN",
}

export interface AffiliateIncome {
  /** @example 10000 */
  amount: number;

  /** @example EMPLOYMENT */
  type: AffiliateIncomeType;

  /** @example Zensum AB */
  name: string;
}

/**
 * An enumeration.
 */
export enum AffiliateIncomeType {
  RENT = "RENT",
  OTHER = "OTHER",
  EMPLOYMENT = "EMPLOYMENT",
  PARTNER = "PARTNER",
}

export interface AffiliateLeadCreationPayload {
  desired_mortgage_loan?: AffiliateNewMortgageLoan;
  current_mortgage_loan?: AffiliateRefinanceInfo;
  buying_info?: AffiliateBuyingInfo;
  other_loans?: AffiliateBlancoLoanForMortgage[];
  other_properties_to_keep?: AffiliateOtherProperty[];

  /** An enumeration. */
  co_applicant_relationship_to_main_applicant?: AffiliateMortgageRelationshipStatus;
  cars?: AffiliateCars;
  external_id: string;
  applicants: OptionalAffiliateApplicant[];
  property?: AffiliateProperty;
  children_in_the_household?: number;
  comment?: string;

  /** An enumeration. */
  country: Country;

  /** @format date-time */
  meeting_start: string;
}

/**
 * An enumeration.
 */
export enum AffiliateLoanType {
  CREDIT_CARD = "CREDIT_CARD",
  UNSECURED_LOAN = "UNSECURED_LOAN",
  CAR_LOAN = "CAR_LOAN",
  CHECK_CREDIT = "CHECK_CREDIT",
  OTHER = "OTHER",
  STUDENT_LOAN = "STUDENT_LOAN",
  INSTALLMENT = "INSTALLMENT",
  TOP_MORTGAGE_LOAN = "TOP_MORTGAGE_LOAN",
  MEMBER_LOAN = "MEMBER_LOAN",
  MORTGAGE = "MORTGAGE",
}

/**
 * An enumeration.
 */
export enum AffiliateMaritalStatus {
  UNMARRIED = "UNMARRIED",
  MARRIED = "MARRIED",
  PARTNER = "PARTNER",
}

/**
 * An enumeration.
 */
export enum AffiliateMortgageLoanType {
  REFINANCE = "REFINANCE",
  PRE_APPROVAL = "PRE_APPROVAL",
  BUY = "BUY",
}

/**
 * An enumeration.
 */
export enum AffiliateMortgageRelationshipStatus {
  SPOUSE = "SPOUSE",
  CHILD = "CHILD",
  PARENT = "PARENT",
  PARTNER = "PARTNER",
}

export interface AffiliateNetworkCallbackEvent {
  affiliate_network_id: string;

  /** An enumeration. */
  callback_trigger: PersonStatus;
  callback_url: string;
  application_id: string;

  /** @format date-time */
  timestamp: string;

  /** An enumeration. */
  status: AffiliateNetworkCallbackStatus;
  publisher_id: string;
  application_origin?: string;

  /** An enumeration. */
  product?: Product;
  zid?: string;
}

/**
 * An enumeration.
 */
export enum AffiliateNetworkCallbackStatus {
  SENT = "SENT",
  FAILED = "FAILED",
  PENDING = "PENDING",
  DUPLICATE = "DUPLICATE",
  NOT_SENT = "NOT_SENT",
}

export interface AffiliateNewLoan {
  desired_amount: number;

  /** An enumeration. */
  loan_purpose: AffiliateBlancoPurposeForNewLoan;
}

export interface AffiliateNewMortgageLoan {
  mortgage_loan_amount?: number;
  down_payment?: number;
  down_payment_loan_amount?: number;
  bridge_loan_amount?: number;
  disbursement_date?: string;

  /** An enumeration. */
  applying_with?: AffiliateApplyingWith;

  /** An enumeration. */
  loan_purpose?: AffiliateMortgageLoanType;

  /** An enumeration. */
  buying_situation?: AffiliateSituation;
  private_loan_amount?: number;
}

export interface AffiliateNotEmployed {
  type: "RETIRED" | "EARLY_RETIRED" | "NO_WORK";

  /** @format date */
  start_date: string;
}

export interface AffiliateOptionsResponse {
  /** List of possible loan responsibilities */
  responsibility: EnumDescription[];

  /** List of possible marital statuses */
  marital_status: EnumDescription[];

  /** List of possible income types */
  income_type?: EnumDescription[];

  /** List of possible employer types */
  employer_type: EnumDescription[];

  /** List of possible housing types */
  housing_type: EnumDescription[];

  /** List of possible loan types */
  loan_type: EnumDescription[];

  /** List of possible property types */
  property_type: EnumDescription[];

  /** List of possible co-applicant relationships */
  co_applicant_relationship_to_main_applicant: EnumDescription[];

  /** List of possible loan purposes */
  loan_purpose: EnumDescription[];

  /** List of possible applying with types */
  applying_with: EnumDescription[];

  /** List of possible situation types */
  situation: EnumDescription[];

  /** List of possible rate types */
  rate_type: EnumDescription[];

  /** List of possible current housing types */
  currently_living_in: EnumDescription[];
  creditors: AffiliateCreditor[];
}

export interface AffiliateOtherProperty {
  monthly_cost?: number;
  mortgage_amount?: number;

  /** An enumeration. */
  property_type: AffiliatePropertyType;
  estimated_value?: number;
  property_ownership_share?: number;
  loan_ownership_share?: number;
}

export interface AffiliateProperty {
  /** An enumeration. */
  property_type: AffiliatePropertyType;
  estimated_value?: number;
  housing_monthly_cost?: number;
  square_meters?: number;
  address?: AffiliatePropertyAddress;
}

export interface AffiliatePropertyAddress {
  /** Street address of property  */
  street_address?: string;

  /** City of the property */
  city?: string;

  /** Postal code of the property */
  postal_code?: string;

  /** Municipality of the property (Sweden's municipalities) */
  municipality_code?: string;
}

/**
 * An enumeration.
 */
export enum AffiliatePropertyType {
  CONDOMINIUM = "CONDOMINIUM",
  HOUSE = "HOUSE",
  VACATION_HOME = "VACATION_HOME",
}

export interface AffiliateRatePart {
  /** An enumeration. */
  rate_type: AffiliateRateType;
  amount?: number;
  rate?: number;
  monthly_payment?: number;

  /** @format date */
  until?: string;
  loan_number?: string;

  /** @format date */
  condition_rollover_date?: string;
  monthly_amortisation?: number;
}

/**
 * An enumeration.
 */
export enum AffiliateRateType {
  FIXED = "FIXED",
  FLEXIBLE = "FLEXIBLE",
  MIXED = "MIXED",
}

export interface AffiliateRefinanceInfo {
  current_creditor_id?: number;
  amount?: number;
  rate?: number;
  monthly_payment?: number;
  rate_parts?: AffiliateRatePart[];

  /** An enumeration. */
  rate_type?: AffiliateRateType;
  ownership_share_of_loan?: number;
}

export interface AffiliateResponse {
  submission_id: string;
}

/**
 * An enumeration.
 */
export enum AffiliateResponsibilityNO {
  MAIN_APPLICANT = "MAIN_APPLICANT",
  CO_APPLICANT = "CO_APPLICANT",
  SHARED = "SHARED",
}

/**
 * An enumeration.
 */
export enum AffiliateResponsibilitySE {
  MAIN_APPLICANT = "MAIN_APPLICANT",
  CO_APPLICANT = "CO_APPLICANT",
  SHARED = "SHARED",
  GUARANTOR = "GUARANTOR",
}

/**
 * An enumeration.
 */
export enum AffiliateSituation {
  SOLD = "SOLD",
  WILL_SELL = "WILL_SELL",
  ONLY_BUY = "ONLY_BUY",
}

export interface AllDisbursedLoans {
  amount: number;
  sum: number;
  average_sum: number;

  /** An enumeration. */
  currency: Currency;
}

export interface AllInsurances {
  seller_id?: string[];
  total_premium_amount: number;
  total_count: number;
  total_insured_amount: number;
  cancelled_insurances_within_period: number;

  /** An enumeration. */
  currency?: Currency;
}

export interface AllOptionalZoordinates {
  /** An enumeration. */
  Product?: ZProduct;

  /** An enumeration. */
  Country?: ZCountry;

  /** An enumeration. */
  Office?: ZOffice;

  /** An enumeration. */
  EmploymentType?: ZEmploymentType;

  /** An enumeration. */
  Department?: ZDepartment;
}

/**
 * An enumeration.
 */
export enum AmortizationPlan {
  FIXED_RATE = "FIXED_RATE",
  STRAIGHT_LINE = "STRAIGHT_LINE",
}

/**
 * An enumeration.
 */
export enum AmortizationRule {
  FI2018 = "FI2018",
  FI2016 = "FI2016",
  SKB70 = "SKB70",
  OTHER = "OTHER",
}

export interface Apartment {
  /** @example 1001 */
  apartment_number: string;
}

export interface ApiLeadSource {
  type?: "ZRM_API";
}

/**
 * "Application model returned by apps-mgr
 */
export interface AppBase {
  loan?: NewMortgageLoan;

  /**
   * In SE we can only refinance one existing mortgage so this object is the loan to be refinanced,
   * not used in NO
   */
  refinance_info?: RefinanceInfo;
  buying_info?: BuyingInfo;
  selling_info?: SellingInfo;
  applicants?: BareApplicantWithRole[];

  /** @example 79975430-f34c-4c78-addd-ac7d978106aa */
  property_id?: string;
  discount?: Discount;
  loans?: Loan[];
  other_mortgages?: MortgageLoan[];

  /** An enumeration. */
  status?: AppsmgrModelsStatusStatus;

  /** An enumeration. */
  substatus?: Substatus;

  /** An enumeration. */
  bank_status?: BankStatus;
  children_in_the_household?: number;
  children_in_the_household_fulltime?: number;
  other_properties_to_keep?: OtherProperty[];

  /** An enumeration. */
  co_relationship_to_main_applicant?: RelationshipStatus;

  /** An enumeration. */
  guarantor_relationship_to_main_applicant?: RelationshipStatus;
  cars?: AppsmgrMortgageSeSpecCommonDefinitionsCars;
  brokerage?: Brokerage;

  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;

  /** @example MOSE000001 */
  application_id: string;
  offers?: Offer[];

  /** @format date-time */
  date_created?: string;

  /** @format date-time */
  date_updated?: string;
}

/**
 * An enumeration.
 */
export enum AppState {
  DRAFT = "DRAFT",
  COMPLETE = "COMPLETE",
  OFFERED = "OFFERED",
  ACCEPTED = "ACCEPTED",
  DISBURSED = "DISBURSED",
}

/**
 * An enumeration.
 */
export enum AppStateLabel {
  LATE_DENIAL = "LATE_DENIAL",
}

export interface ApplicantDocument {
  document_id: string;
  document_type: string | DocumentType;
}

export interface ApplicantNO {
  country?: "NO";

  /** @example 198001011234 */
  pni: string;

  /** @example John */
  first_name: string;

  /** @example Doe */
  last_name: string;

  /** @example john@example.com */
  email?: string;

  /** @example +46701234567 */
  phone_number?: string;

  /**
   * @min 0
   * @example 10000
   */
  monthly_property_cost?: number;

  /** @example unmarried */
  marital_status?: MaritalStatus;

  /**
   * Official marital status from ID check; should not be modified; marital_status has higher priority
   * @example unmarried
   */
  registered_marital_status?: MaritalStatus;

  /** @example 12345 */
  post_code?: string;

  /** @example Stockholm */
  city?: string;
  incomes?: Income[];

  /** @example 10000 */
  net_monthly_income?: number;
  account?: Account;

  /** @example Street 1 */
  street_address?: string;

  /**
   * Number of children to pay child support for
   * @min 0
   * @max 10
   * @example 0
   */
  paying_child_support?: number;

  /**
   * Number of children to receive child support for
   * @min 0
   * @max 10
   * @example 0
   */
  receiving_child_support?: number;
  consents?: Consents;

  /** @example 198001011234 */
  partner_pni?: string;

  /** @example John Doe */
  partner_name?: string;

  /** @example 0115 */
  municipality_code?: string;

  /** @example Stockholm */
  municipality?: string;

  /** @example false */
  is_pep?: boolean;

  /**
   * @min 1
   * @example 73
   */
  age?: number;

  /** @example {"home":"+46701234567"} */
  other_phones?: PhoneNumber[];

  /** @example 123456 */
  sverker_id?: number;

  /** @example 1 */
  children?: number;

  /** @example 1 */
  citizen?: number;

  /** @example elementarySchool */
  education?: EducationType;

  /** @example 10000 */
  monthly_partner_income?: number;

  /** @format date */
  immigrated_at?: string;

  /** @example John Doe */
  fullname?: string;
  documents?: ApplicantDocument[];
  verified_credits?: boolean;

  /** @example 2019-01-01 */
  housing_since?: string;

  /** @example false */
  deceased?: boolean;

  /** @example false */
  emigrated?: boolean;

  /** @example false */
  is_sanction?: boolean;

  /** @example false */
  is_rca?: boolean;

  /** @format date-time */
  date_created?: string;

  /** @format date-time */
  date_updated?: string;

  /** @format date-time */
  last_credit_check?: string;

  /** @format date-time */
  last_externally_verified_credits?: string;
  pep_quality?: boolean;

  /** A cluster is a group of customers displayed with a color */
  cluster?: string;

  /** @example RENTED */
  housing_type?: HousingTypeNO;
  employer?: EmployerNO;
  ev_estate?: EvEstate[];

  /** @example ["NO"] */
  citizenship_iso_codes?: string[];
  externally_verified_credits?: ExternallyVerifiedCredit[];

  /**
   * @format uuid
   * @example 88b3b8a0-5b9e-4b9c-9c1b-8b1b8b1b8b1b
   */
  customer_id: string;
  credit_check?: CreditCheckNO;
  block_list?: BlockList;
  external_block_check?: ExternalBlockCheckNO;
}

/**
 * An enumeration.
 */
export enum ApplicantRole {
  MAIN_APPLICANT = "MAIN_APPLICANT",
  CO_APPLICANT = "CO_APPLICANT",
  GUARANTOR = "GUARANTOR",
}

export interface ApplicantSE {
  country?: "SE";

  /** @example 198001011234 */
  pni: string;

  /** @example John */
  first_name: string;

  /** @example Doe */
  last_name: string;

  /** @example john@example.com */
  email?: string;

  /** @example +46701234567 */
  phone_number?: string;

  /**
   * @min 0
   * @example 10000
   */
  monthly_property_cost?: number;

  /** @example unmarried */
  marital_status?: MaritalStatus;

  /**
   * Official marital status from ID check; should not be modified; marital_status has higher priority
   * @example unmarried
   */
  registered_marital_status?: MaritalStatus;

  /** @example 12345 */
  post_code?: string;

  /** @example Stockholm */
  city?: string;
  incomes?: Income[];

  /** @example 10000 */
  net_monthly_income?: number;
  account?: Account;

  /** @example Street 1 */
  street_address?: string;

  /**
   * Number of children to pay child support for
   * @min 0
   * @max 10
   * @example 0
   */
  paying_child_support?: number;

  /**
   * Number of children to receive child support for
   * @min 0
   * @max 10
   * @example 0
   */
  receiving_child_support?: number;
  consents?: Consents;

  /** @example 198001011234 */
  partner_pni?: string;

  /** @example John Doe */
  partner_name?: string;

  /** @example 0115 */
  municipality_code?: string;

  /** @example Stockholm */
  municipality?: string;
  is_pep?: boolean;

  /**
   * @min 1
   * @example 73
   */
  age?: number;

  /** @example {"home":"+46701234567"} */
  other_phones?: PhoneNumber[];

  /** @example 123456 */
  sverker_id?: number;

  /** @example 1 */
  children?: number;

  /** @example 1 */
  citizen?: number;

  /** @example elementarySchool */
  education?: EducationType;

  /** @example 10000 */
  monthly_partner_income?: number;

  /** @format date */
  immigrated_at?: string;

  /** @example John Doe */
  fullname?: string;
  documents?: ApplicantDocument[];
  verified_credits?: boolean;

  /** @example 2019-01-01 */
  housing_since?: string;

  /** @example false */
  deceased?: boolean;

  /** @example false */
  emigrated?: boolean;
  is_sanction?: boolean;
  is_rca?: boolean;

  /** @format date-time */
  date_created?: string;

  /** @format date-time */
  date_updated?: string;

  /** @format date-time */
  last_credit_check?: string;

  /** @format date-time */
  last_externally_verified_credits?: string;
  pep_quality?: any;

  /** A cluster is a group of customers displayed with a color */
  cluster?: string;

  /** @example RENTED */
  housing_type?: HousingTypeSE;
  employer?: EmployerSE;
  census_registration_year?: string;
  credit_regulation_information?: CreditRegulationInformation[];
  credit_regulations?: CreditRegulation[];
  case_collection?: CaseCollectionItem[];
  current_section_of_case?: CurrentSectionOfCaseItem[];
  current_frame?: CurrentFrameItem[];
  html?: string;
  last_queries?: LastQuery[];
  notes?: Note[];
  tax?: TaxItem[];
  tax_thousands?: TaxThousand[];
  fraudster?: boolean;
  investigation_barrier?: boolean;
  uc_interall?: string;
  date_of_birth?: string;
  prenup_text?: string;
  uc_internal_2?: any;
  parish?: string;
  parish_code?: string;
  blocked?: boolean;
  protected_address?: boolean;
  protected_identity?: boolean;
  marital_status_date?: string;
  minor?: string;
  lost_id_documents?: boolean;

  /** @example Stockholms län */
  county?: string;

  /** @example 01 */
  county_code?: string;

  /**
   * @format uuid
   * @example 88b3b8a0-5b9e-4b9c-9c1b-8b1b8b1b8b1b
   */
  customer_id: string;
  credit_check?: CreditCheckSE;
  block_list?: BlockList;
}

/**
 * Application model in ZRM
 */
export interface Application {
  loan?: NewMortgageLoan;

  /**
   * In SE we can only refinance one existing mortgage so this object is the loan to be refinanced,
   * not used in NO
   */
  refinance_info?: RefinanceInfo;
  buying_info?: BuyingInfo;
  selling_info?: SellingInfo;
  applicants?: BareApplicantWithRole[];

  /** @example 79975430-f34c-4c78-addd-ac7d978106aa */
  property_id?: string;
  discount?: Discount;
  loans?: Loan[];
  other_mortgages?: MortgageLoan[];

  /** An enumeration. */
  status?: AppsmgrModelsStatusStatus;

  /** An enumeration. */
  substatus?: Substatus;

  /** An enumeration. */
  bank_status?: BankStatus;
  children_in_the_household?: number;
  children_in_the_household_fulltime?: number;
  other_properties_to_keep?: OtherProperty[];

  /** An enumeration. */
  co_relationship_to_main_applicant?: RelationshipStatus;

  /** An enumeration. */
  guarantor_relationship_to_main_applicant?: RelationshipStatus;
  cars?: AppsmgrMortgageSeSpecCommonDefinitionsCars;
  brokerage?: Brokerage;

  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;

  /** @example MOSE000001 */
  application_id: string;
  offers?: Offer[];

  /** @format date-time */
  date_created?: string;

  /** @format date-time */
  date_updated?: string;
  meta?: ApplicationMapping;
}

export interface ApplicationAssigned {
  type: "APPLICATION_ASSIGNED";

  /**
   * @format date-time
   * @example 2022-01-19T13:13:52.541833
   */
  timestamp: string;

  /** An enumeration. */
  status: NotificationEvent;
  data: ApplicationAssignedData;

  /** @example a9eb4560-9628-4c84-9cd6-0b605ae2f5ee */
  notification_id: string;

  /** @example sms|5ce26c2450d832460390f580 */
  user_id?: string;
}

export interface ApplicationAssignedData {
  /** @example MOSE0000511 */
  application_id: string;
}

export interface ApplicationCreatedResponse {
  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;

  /** @example MOSE000001 */
  application_id: string;
}

export interface ApplicationCreatedResponseExt {
  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;

  /** @example MOSE000001 */
  application_id: string;
}

export interface ApplicationDisbursed {
  type: "APPLICATION_DISBURSED";

  /**
   * @format date-time
   * @example 2022-01-19T13:13:52.541833
   */
  timestamp: string;

  /** An enumeration. */
  status: NotificationEvent;
  data: ApplicationDisbursedData;

  /** @example a9eb4560-9628-4c84-9cd6-0b605ae2f5ee */
  notification_id: string;

  /** @example sms|5ce26c2450d832460390f580 */
  user_id?: string;
}

export interface ApplicationDisbursedData {
  /** @example MOSE0000511 */
  application_id: string;
}

export interface ApplicationMapping {
  /** @example MOSE000002 */
  application_id: string;

  /** @example sms|5ce26c2450d832460390f580 */
  handler_id?: string;

  /** @example sms|5ce26c2450d832460390f580 */
  creator_id?: string;
  new_app_checklist?: string[];
  new_app_options?: Option[];
  events?: Event[];
  documents?: DocumentAssignation[];

  /** An enumeration. */
  source?: ApplicationSource;
  lead_id?: string;
  aml: AML;
  bank_id_verifications?: BankIDSigned[];
  internal_comments: (
    | ModelsApplicationMappingCommentsInternalComment
    | BankIDSigned
    | (ModelsApplicationMappingCommentsInternalComment & BankIDSigned)
  )[];

  /** @format date-time */
  updated_at: string;

  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;
}

export interface ApplicationMappingWithNamesInComments {
  /** @example MOSE000002 */
  application_id: string;

  /** @example sms|5ce26c2450d832460390f580 */
  handler_id?: string;

  /** @example sms|5ce26c2450d832460390f580 */
  creator_id?: string;
  new_app_checklist?: string[];
  new_app_options?: Option[];
  events?: Event[];
  documents?: DocumentAssignation[];

  /** An enumeration. */
  source?: ApplicationSource;
  lead_id?: string;
  aml: AML;
  bank_id_verifications?: BankIDSigned[];
  internal_comments: (
    | InternalCommentWithName
    | BankIDSignedWithNames
    | (InternalCommentWithName & BankIDSignedWithNames)
  )[];

  /** @format date-time */
  updated_at: string;

  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;
}

export interface ApplicationPayload {
  application_id: string;
}

export interface ApplicationQuery {
  application_id: string;
}

/**
 * An enumeration.
 */
export enum ApplicationReview {
  TryAgainLater = "tryAgainLater",
  EitherOr = "eitherOr",
  LikingZensum = "likingZensum",
  DislikesZensum = "dislikesZensum",
  GoodCase = "goodCase",
  OkayCase = "okayCase",
  BadCase = "badCase",
  CreditNotes = "creditNotes",
  MostHappy = "mostHappy",
  Happy = "happy",
  KindaSortaHappy = "kindaSortaHappy",
  Other = "other",
}

/**
 * An enumeration.
 */
export enum ApplicationSource {
  BLANCO = "BLANCO",
  KH_BLANCO = "KH_BLANCO",
  LOG_BLANCO = "LOG_BLANCO",
  HL_BLANCO = "HL_BLANCO",
  WINBACK = "WINBACK",
  DIRECT = "DIRECT",
  RECOMMENDATION = "RECOMMENDATION",
  AFFILIATE_PARTNER = "AFFILIATE_PARTNER",
  TF_AGENCY = "TF_AGENCY",
  AFFILIATE_API = "AFFILIATE_API",
  ONLINE_LEAD = "ONLINE_LEAD",
  OTHER = "OTHER",
}

/**
 * "Application model returned by apps-mgr
 */
export interface ApplicationWithNamesInComments {
  loan?: NewMortgageLoan;

  /**
   * In SE we can only refinance one existing mortgage so this object is the loan to be refinanced,
   * not used in NO
   */
  refinance_info?: RefinanceInfo;
  buying_info?: BuyingInfo;
  selling_info?: SellingInfo;
  applicants?: BareApplicantWithRole[];

  /** @example 79975430-f34c-4c78-addd-ac7d978106aa */
  property_id?: string;
  discount?: Discount;
  loans?: Loan[];
  other_mortgages?: MortgageLoan[];

  /** An enumeration. */
  status?: AppsmgrModelsStatusStatus;

  /** An enumeration. */
  substatus?: Substatus;

  /** An enumeration. */
  bank_status?: BankStatus;
  children_in_the_household?: number;
  children_in_the_household_fulltime?: number;
  other_properties_to_keep?: OtherProperty[];

  /** An enumeration. */
  co_relationship_to_main_applicant?: RelationshipStatus;

  /** An enumeration. */
  guarantor_relationship_to_main_applicant?: RelationshipStatus;
  cars?: AppsmgrMortgageSeSpecCommonDefinitionsCars;
  brokerage?: Brokerage;

  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;

  /** @example MOSE000001 */
  application_id: string;
  offers?: Offer[];

  /** @format date-time */
  date_created?: string;

  /** @format date-time */
  date_updated?: string;
  meta: ApplicationMappingWithNamesInComments;
}

/**
 * An enumeration.
 */
export enum ApplyingWith {
  PARENT = "PARENT",
  SPOUSE = "SPOUSE",
  ALONE = "ALONE",
  COHABITANT = "COHABITANT",
}

export interface AppsSearchResult {
  search_types: Record<string, SearchType[]>;
  apps: AppBase[];
}

export interface AssignApplicationPayload {
  /** @example sms|5ce26c2450d832460390f580 */
  handler_id: string;
}

export interface Assignee {
  handler_id?: string;
  name?: string;
}

export interface Available {
  available: ModelsDialMaker2CampaignAggregateCampaign[];
  joined_campaigns: JoinedCampaignExt[];
}

export interface AvailableBookings {
  available_slots: Slots[];
}

/**
 * An enumeration.
 */
export enum BalconyType {
  BALCONY = "BALCONY",
  PATIO = "PATIO",
  NONE = "NONE",
}

export interface Bank {
  /** @example 42 */
  bank_id: number;

  /** @example SE */
  country: Country;

  /** @example Nordax */
  name: string;
}

export interface BankAPIDrivenKALP {
  /** @example 42 */
  bank_id: number;

  /** @example SE */
  country: Country;

  /** @example Nordax */
  name: string;

  /** @example true */
  api_driven: true;
}

export interface BankApplicant {
  customer: LimitedApplicantSE | LimitedApplicantNO;

  /** An enumeration. */
  role: ApplicantRole;
}

export interface BankBaseApp {
  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;
  applicants: BankApplicant[];
  application_id: string;

  /** @format date-time */
  date_created: string;

  /** @format date-time */
  date_updated: string;

  /** An enumeration. */
  status: AppsmgrModelsStatusStatus;
  loan?: NewMortgageLoan;

  /**
   * In SE we can only refinance one existing mortgage so this object is the loan to be refinanced,
   * not used in NO
   */
  refinance_info?: RefinanceInfo;
  buying_info?: BuyingInfo;
  selling_info?: SellingInfo;
  property?: Condominium | House | VacationHome | (Condominium & House & VacationHome);
  loans?: Loan[];
  other_mortgages?: MortgageLoan[];
  children_in_the_household?: number;
  children_in_the_household_fulltime?: number;
  other_properties_to_keep?: OtherProperty[];

  /** An enumeration. */
  co_relationship_to_main_applicant?: RelationshipStatus;

  /** An enumeration. */
  guarantor_relationship_to_main_applicant?: RelationshipStatus;
  cars?: AppsmgrMortgageSeSpecCommonDefinitionsCars;

  /** An enumeration. */
  bank_status: BankStatus;
}

export interface BankComment {
  comment: string;
  application_id: string;
  bank_id: number;
}

export interface BankCommunication {
  events: (
    | BankCommunicationEventOffer
    | BankCommunicationEvent
    | BankCommunicationEventDocumentInfo
    | BankCommunicationEventCommentAdded
    | BankCommunicationEventBankMessage
    | BankCommunicationEventInvalidInvite
    | BankCommunicationEventDocumentSent
    | (BankCommunicationEventOffer &
        BankCommunicationEvent &
        BankCommunicationEventDocumentInfo &
        BankCommunicationEventCommentAdded &
        BankCommunicationEventBankMessage &
        BankCommunicationEventInvalidInvite &
        BankCommunicationEventDocumentSent)
  )[];
  bank_id: number;
  bank_name?: string;
  actions: IntegrationAction[];
  encoded_app_id: string;
  last_external_id?: string;
}

export type BankCommunicationData = object;

export interface BankCommunicationDataCommentAdded {
  comment: string;
  user_name?: string;
  user_name_shown_to_bank?: string;
}

export interface BankCommunicationDataDocumentInfo {
  documents: ModelsApplicationApplicationDocRequest[];
}

export interface BankCommunicationDataDocumentSent {
  document_id: string;
  customer_id: string;
}

export interface BankCommunicationDataInvalidInvite {
  messages: string[];
}

export interface BankCommunicationDataOffer {
  offeredAmount: number;

  /** An enumeration. */
  currency: Currency;
  bindingPeriodMonth: number;
  interestRate: number;
  discount: number;

  /** An enumeration. */
  amortizationRule: AmortizationRule;
  monthlyAmortization: number;
  invoiceFee?: number;
  setupFee?: number;
  autogiroFee?: number;
  amortizationLength?: number;
  firstMonthlyPayment: number;
}

export interface BankCommunicationEvent {
  /** An enumeration. */
  direction: ModelsMessageCommonDirection;
  event_id: string;
  type: BankEventType;

  /** @format date-time */
  timestamp: string;
  data: BankCommunicationData;
  user_id?: string;
}

export interface BankCommunicationEventBankMessage {
  /** An enumeration. */
  direction: ModelsMessageCommonDirection;
  event_id: string;
  type: "MESSAGE";

  /** @format date-time */
  timestamp: string;
  data: BankCommunicationDataCommentAdded;
  user_id?: string;
}

export interface BankCommunicationEventCommentAdded {
  /** An enumeration. */
  direction: ModelsMessageCommonDirection;
  event_id: string;
  type: "COMMENT_TO_BANK_ADDED" | "COMMENT_ADDED" | ("COMMENT_TO_BANK_ADDED" & "COMMENT_ADDED");

  /** @format date-time */
  timestamp: string;
  data: BankCommunicationDataCommentAdded;
  user_id?: string;
}

export interface BankCommunicationEventDocumentInfo {
  /** An enumeration. */
  direction: ModelsMessageCommonDirection;
  event_id: string;
  type: "DOCUMENT_INFO";

  /** @format date-time */
  timestamp: string;
  data: BankCommunicationDataDocumentInfo;
  user_id?: string;
}

export interface BankCommunicationEventDocumentSent {
  /** An enumeration. */
  direction: ModelsMessageCommonDirection;
  event_id: string;
  type: "DOCUMENT_TO_BANK_ADDED";

  /** @format date-time */
  timestamp: string;
  data: BankCommunicationDataDocumentSent;
  user_id?: string;
}

export interface BankCommunicationEventInvalidInvite {
  /** An enumeration. */
  direction: ModelsMessageCommonDirection;
  event_id: string;
  type: "INVITE_APP_INVALID";

  /** @format date-time */
  timestamp: string;
  data: BankCommunicationDataInvalidInvite;
  user_id?: string;
}

export interface BankCommunicationEventOffer {
  /** An enumeration. */
  direction: ModelsMessageCommonDirection;
  event_id: string;
  type: "OFFER";

  /** @format date-time */
  timestamp: string;
  data: BankCommunicationDataOffer;
  user_id?: string;
}

export interface BankDisbursePayload {
  mortgage_amount?: number;
  bridge_loan_amount?: number;

  /** @format date */
  disburse_date?: string;
  application_id: string;
}

export interface BankEvent {
  /** An enumeration. */
  direction: AppsmgrModelsApi2BankEventsDirection;

  /** @format uuid4 */
  event_id: string;
  type: BankEventType;

  /** @format date-time */
  timestamp: string;
  data: BankEventData;
  user_id?: string;
}

export interface BankEventCommentAdded {
  /** An enumeration. */
  direction: AppsmgrModelsApi2BankEventsDirection;

  /** @format uuid4 */
  event_id: string;
  type: "COMMENT_TO_BANK_ADDED" | "COMMENT_ADDED" | ("COMMENT_TO_BANK_ADDED" & "COMMENT_ADDED");

  /** @format date-time */
  timestamp: string;
  data: BankEventDataCommentAdded;
  user_id?: string;
}

export type BankEventData = object;

export interface BankEventDataCommentAdded {
  comment: string;
  user_name?: string;
  user_name_shown_to_bank?: string;
}

export interface BankEventDataDocumentInfo {
  documents: AppsmgrModelsApi2BankEventsDocRequest[];
}

export interface BankEventDataDocumentSent {
  document_id: string;
  customer_id: string;
}

export interface BankEventDataInvalidInvite {
  messages: string[];
}

export interface BankEventDataOfferCreditCardOffer {
  offer: CreditCardOffer;
}

export interface BankEventDataOfferMortgageOfferExt {
  offer: MortgageOfferExt;
}

export interface BankEventDocumentInfo {
  /** An enumeration. */
  direction: AppsmgrModelsApi2BankEventsDirection;

  /** @format uuid4 */
  event_id: string;
  type: "DOCUMENT_INFO";

  /** @format date-time */
  timestamp: string;
  data: BankEventDataDocumentInfo;
  user_id?: string;
}

export interface BankEventDocumentSent {
  /** An enumeration. */
  direction: AppsmgrModelsApi2BankEventsDirection;

  /** @format uuid4 */
  event_id: string;
  type: "DOCUMENT_TO_BANK_ADDED";

  /** @format date-time */
  timestamp: string;
  data: BankEventDataDocumentSent;
  user_id?: string;
}

export interface BankEventInvalidInvite {
  /** An enumeration. */
  direction: AppsmgrModelsApi2BankEventsDirection;

  /** @format uuid4 */
  event_id: string;
  type: "INVITE_APP_INVALID";

  /** @format date-time */
  timestamp: string;
  data: BankEventDataInvalidInvite;
  user_id?: string;
}

export interface BankEventMessage {
  /** An enumeration. */
  direction: AppsmgrModelsApi2BankEventsDirection;

  /** @format uuid4 */
  event_id: string;
  type: "MESSAGE";

  /** @format date-time */
  timestamp: string;
  data: BankEventDataCommentAdded;
  user_id?: string;
}

export interface BankEventOfferCreditCardOffer {
  /** An enumeration. */
  direction: AppsmgrModelsApi2BankEventsDirection;

  /** @format uuid4 */
  event_id: string;
  type: "OFFER";

  /** @format date-time */
  timestamp: string;
  data: BankEventDataOfferCreditCardOffer;
  user_id?: string;
}

export interface BankEventOfferMortgageOfferExt {
  /** An enumeration. */
  direction: AppsmgrModelsApi2BankEventsDirection;

  /** @format uuid4 */
  event_id: string;
  type: "OFFER";

  /** @format date-time */
  timestamp: string;
  data: BankEventDataOfferMortgageOfferExt;
  user_id?: string;
}

/**
 * An enumeration.
 */
export enum BankEventType {
  INVITE_REQUESTED = "INVITE_REQUESTED",
  INVITE_FILTERS_SUCCESS = "INVITE_FILTERS_SUCCESS",
  INVITE_FILTERED_OUT = "INVITE_FILTERED_OUT",
  INVITE_APP_INVALID = "INVITE_APP_INVALID",
  INVITE_SEND_FAILED = "INVITE_SEND_FAILED",
  INVITE_SEND_FAILED_TRANSIENT = "INVITE_SEND_FAILED_TRANSIENT",
  INVITE_SEND_SUCCESS = "INVITE_SEND_SUCCESS",
  INVITE_POSTPONED = "INVITE_POSTPONED",
  SEND_POSTPONED = "SEND_POSTPONED",
  INVITE_CANCELLED = "INVITE_CANCELLED",
  INVITE_DENIED = "INVITE_DENIED",
  INVITE_SENT = "INVITE_SENT",
  OFFER = "OFFER",
  ACCEPT_REQUESTED = "ACCEPT_REQUESTED",
  ACCEPT_SEND_FAILED = "ACCEPT_SEND_FAILED",
  ACCEPT_SEND_FAILED_TRANSIENT = "ACCEPT_SEND_FAILED_TRANSIENT",
  ACCEPT_SEND_SUCCESS = "ACCEPT_SEND_SUCCESS",
  ACCEPT = "ACCEPT",
  MESSAGE = "MESSAGE",
  STATUS_UPDATE = "STATUS_UPDATE",
  DOCUMENT_INFO = "DOCUMENT_INFO",
  COMMENT_TO_BANK_ADDED = "COMMENT_TO_BANK_ADDED",
  COMMENT_ADDED = "COMMENT_ADDED",
  COMMENT_TO_BANK_SEND_SUCCESS = "COMMENT_TO_BANK_SEND_SUCCESS",
  COMMENT_TO_BANK_SEND_FAILED = "COMMENT_TO_BANK_SEND_FAILED",
  DISBURSEMENT = "DISBURSEMENT",
  DEBENTURESIGNED = "DEBENTURE_SIGNED ",
  CANCEL_REQUESTED = "CANCEL_REQUESTED",
  CANCEL_SEND_FAILED = "CANCEL_SEND_FAILED",
  CANCEL_SEND_FAILED_TRANSIENT = "CANCEL_SEND_FAILED_TRANSIENT",
  CANCEL_SEND_SUCCESS = "CANCEL_SEND_SUCCESS",
  REJECTION = "REJECTION",
  DOCUMENT_TO_BANK_ADDED = "DOCUMENT_TO_BANK_ADDED",
  DOCUMENT_TO_BANK_SEND_SUCCESS = "DOCUMENT_TO_BANK_SEND_SUCCESS",
  DOCUMENT_TO_BANK_SEND_FAILED = "DOCUMENT_TO_BANK_SEND_FAILED",
  DEACTIVATED = "DEACTIVATED",
  REACTIVATED = "REACTIVATED",
  SIGN_STATUS = "SIGN_STATUS",
  SIGN_REQUEST = "SIGN_REQUEST",
  SIGN_SEND_FAILED = "SIGN_SEND_FAILED",
  SIGN_SEND_FAILED_TRANSIENT = "SIGN_SEND_FAILED_TRANSIENT",
  SIGN_SEND_SUCCESS = "SIGN_SEND_SUCCESS",
  LEFT_TO_LIVE = "LEFT_TO_LIVE",
}

export interface BankEventsCreditCardOffer {
  events: (
    | BankEventOfferCreditCardOffer
    | BankEvent
    | BankEventDocumentInfo
    | BankEventCommentAdded
    | BankEventMessage
    | BankEventInvalidInvite
    | BankEventDocumentSent
    | (BankEventOfferCreditCardOffer &
        BankEvent &
        BankEventDocumentInfo &
        BankEventCommentAdded &
        BankEventMessage &
        BankEventInvalidInvite &
        BankEventDocumentSent)
  )[];
  bank_id: number;
  bank_name?: string;
  actions: IntegrationAction[];
  encoded_app_id: string;
  last_external_id?: string;
}

export interface BankEventsMortgageOfferExt {
  events: (
    | BankEventOfferMortgageOfferExt
    | BankEvent
    | BankEventDocumentInfo
    | BankEventCommentAdded
    | BankEventMessage
    | BankEventInvalidInvite
    | BankEventDocumentSent
    | (BankEventOfferMortgageOfferExt &
        BankEvent &
        BankEventDocumentInfo &
        BankEventCommentAdded &
        BankEventMessage &
        BankEventInvalidInvite &
        BankEventDocumentSent)
  )[];
  bank_id: number;
  bank_name?: string;
  actions: IntegrationAction[];
  encoded_app_id: string;
  last_external_id?: string;
}

export interface BankIDLoginResponse {
  token: string;
}

export interface BankIDPayload {
  customer_id: string;
  application_id: string;
}

export interface BankIDSigned {
  /** @example sms|5ce26c2450d832460390f580 */
  user_id: string;
  comment?: string;

  /** @format date-time */
  timestamp: string;
  comment_id: string;
  action: "VERIFIED_BANK_ID";
  customer_id: string;
}

export interface BankIDSignedWithNames {
  /** @example sms|5ce26c2450d832460390f580 */
  user_id: string;
  comment?: string;

  /** @format date-time */
  timestamp: string;
  comment_id: string;
  action: "VERIFIED_BANK_ID";
  customer_id: string;

  /** @example Hamza Sabljaković */
  user_name: string;

  /** @example https://s.gravatar.com/avatar/f900a71f2bcbc2c65a42958724378bb3?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fte.png */
  user_avatar: string;

  /** @example Pelle Jönsson */
  customer_name: string;
}

export interface BankKALP {
  /** @example 42 */
  bank_id: number;

  /** @example SE */
  country: Country;

  /** @example Nordax */
  name: string;

  /**
   * The current mortgage the customer has
   * @example 0.06
   */
  current_property_interest: number;

  /** @example 0.02 */
  current_property_amortization: number;

  /** @example 0.06 */
  other_properties_to_keep_interest: number;

  /** @example 0.02 */
  other_properties_to_keep_amortization: number;

  /** @example {"HOUSE":4000,"VACATION_HOME":1500} */
  other_properties_to_keep_fixed_monthly_running_cost: Record<string, number>;

  /** @example {"CONDOMINIUM":500} */
  other_properties_to_keep_additional_monthly_running_cost: Record<string, number>;

  /** @example 0.1121 */
  other_loans_interest: number;

  /** @example 96 */
  other_loans_amortization_terms_in_months: number;

  /** @example ["STUDENT_LOAN"] */
  other_loans_type_exclude: LoanType[];

  /** @example ["HOUSE","CONDOMINIUM","VACATION_HOME"] */
  other_properties_to_keep_amortization_property_types: AppsmgrModelsApplicationPropertyType[];

  /** @example [{"cost":3400,"from_and_including_age":26,"to_and_including_age":30}] */
  cost_per_person: CostPerPerson[];

  /** @example [{"number_of_people":2,"cost":2620}] */
  additional_cost_per_person_in_household: AdditionalCostPerPerson[];

  /** @example [{"number_of_children":2,"benefit":1250}] */
  child_benefit: ChildBenefit[];

  /** @example {"HOUSE":740,"VACATION_HOME":740} */
  property_tax_per_property: Record<string, number>;
  tax_deductions: TaxDeduction;
  cars?: ModelsMortgageKALPCars;

  /** @example false */
  api_driven: false;
}

export interface BankMessageReceived {
  type: "BANK_MESSAGE_RECEIVED";

  /**
   * @format date-time
   * @example 2022-01-19T13:13:52.541833
   */
  timestamp: string;

  /** An enumeration. */
  status: NotificationEvent;
  data: BankMessageReceivedData;

  /** @example a9eb4560-9628-4c84-9cd6-0b605ae2f5ee */
  notification_id: string;

  /** @example sms|5ce26c2450d832460390f580 */
  user_id?: string;
}

export interface BankMessageReceivedData {
  /** @example MOSE0000511 */
  application_id: string;

  /** @example 42 */
  bank_id: number;
}

export interface BankOffer {
  offeredAmount: number;

  /** An enumeration. */
  currency: Currency;
  bindingPeriodMonth: number;
  interestRate: number;
  discount: number;

  /** An enumeration. */
  amortizationRule: AmortizationRule;
  monthlyAmortization: number;
  invoiceFee?: number;
  setupFee?: number;
  autogiroFee?: number;
  amortizationLength?: number;
}

export interface BankOfferPayload {
  bank_id: number;
  bank_reference_id?: string;
  offer: BankOffer;
  application_id: string;
}

export interface BankRejectPayload {
  application_id: string;
  reason: string;
}

/**
 * An enumeration.
 */
export enum BankStatus {
  NEW = "NEW",
  ONGOING = "ONGOING",
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
  DISBURSED = "DISBURSED",
}

export interface BankUserWithBankNames {
  /** @example 8275f688-4893-11ec-9540-47a28460295a */
  user_id: string;

  /** @example Glenn */
  first_name: string;

  /** @example Hysén */
  last_name: string;

  /**
   * @format email
   * @example glenn.hysen@banken.se
   */
  username: string;

  /** @example false */
  deactivated?: boolean;
  banks: Integration[];
}

export interface BanksToExcludeInsuranceOfferingFor {
  SE: number[];
  NO: number[];
}

/**
 * Used to store applicant data in the application object in MongoDB
 */
export interface BareApplicantWithRole {
  /**
   * @format uuid4
   * @example 88b15dc4-55c2-4268-95c5-52506c52842a
   */
  customer_id: string;

  /** An enumeration. */
  role: ApplicantRole;
}

export interface BaseComment {
  comment: string;
  application_id: string;
  bank_id: number;
}

export interface BaseFormPreferencePayload {
  form_id: string;

  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;
}

export type BaseModel = object;

export interface BasicSubmissionReview {
  submission_id: string;
  handled?: boolean;
  reviews?: Reviewer[];
  success?: boolean;
  ongoing?: boolean;

  /** @format date-time */
  submission_timestamp: string;
  raw_data: object;

  /** An enumeration. */
  country: Country;

  /** An enumeration. */
  product: Product;
  request_id: string;
  checklist?: Checklist;
}

/**
* Helper class that provides a standard way to create an ABC using
inheritance.
*/
export interface BigQueryCampaignSource {
  type?: "BIG_QUERY";
  query: string;
  mapping?: Record<string, string>;

  /** @format date-time */
  imported_at?: string;
}

export interface BlancoAMLPatchPayload {
  /** @example outbound */
  channel?: Channel;

  /** An enumeration. */
  purpose?: AMLBlancoPurpose;

  /** An enumeration. */
  purpose_when_new_loan?: LoanPurpose;

  /** An enumeration. */
  country?: Country;
  comment?: string;
}

export interface BlancoAMLReviewPayload {
  comment?: string;

  /** @example approved */
  aml_review: AMLReviewStatus;

  /** An enumeration. */
  country: Country;
}

export interface BlancoGoal {
  /** An enumeration. */
  type_event: GoalType;
  user_id?: string[];

  /** An enumeration. */
  country: Country;

  /**
   * What year the goal is set for
   * @example 2022
   */
  year: number;

  /**
   * Month from 1-12
   * @example 12
   */
  month: number;

  /** @format date-time */
  timestamp: string;

  /**
   * Count of sent loans
   * @example 100
   */
  sent_loans: number;

  /**
   * A procent of the return rate of sent loans between 1-100
   * @example 80
   */
  return_rate: number;

  /**
   * The count of disbursed loans
   * @example 80
   */
  disbursed_loans_count: number;

  /**
   * Working days of the handler for chosen month
   * @example 20
   */
  working_days: number;

  /**
   * Count of sent loans per day
   * @example 4.5
   */
  sent_loans_per_day: number;

  /**
   * The amount of all disbursed loans in the chosen currency
   * @example 11000000
   */
  disbursed_amount: number;

  /**
   * The amount of all sent loans in chosen currency
   * @example 15000000
   */
  sent_loans_amount: number;

  /**
   * The count of signed insurances
   * @example 40
   */
  signed_insurances: number;

  /**
   * The total premium of all signed insurances
   * @example 8000
   */
  total_premium: number;

  /**
   * Average loan amount for chosen period, usually set from previous months
   * @example 210000
   */
  average_loan_amount: number;

  /**
   * Average premium of the insurances, usually set from previous months
   * @example 200
   */
  average_premium: number;

  /**
   * Amount of leads sent to Mortgage
   * @example 20
   */
  mortgage_leads?: number;
}

export interface BlancoGoalMb {
  /** An enumeration. */
  type_event: GoalType;
  user_id?: string[];

  /** An enumeration. */
  country: Country;

  /**
   * What year the goal is set for
   * @example 2022
   */
  year: number;

  /**
   * Month from 1-12
   * @example 12
   */
  month: number;

  /** @format date-time */
  timestamp: string;

  /**
   * Number of created applications
   * @example 100
   */
  applications: number;

  /**
   * Working days of the handler for chosen month
   * @example 20
   */
  working_days: number;

  /**
   * Number of disbursed loans
   * @example 20
   */
  disbursed_loans_count: number;

  /**
   * The amount of disbursed loans
   * @example 12000000
   */
  disbursed_loans_amount: number;

  /**
   * The percentage of applications sent with a co-applicant
   * @example 50
   */
  co_applicant_percentage: number;

  /**
   * Average loan amount for chosen period, usually set from previous months
   * @example 210000
   */
  average_loan_amount: number;

  /**
   * Count of created applications per day
   * @example 4.5
   */
  applications_per_day: number;

  /**
   * Percent of applications that have GR
   * @example 50
   */
  gr_percentage: number;

  /**
   * Percent of sent applications that get disbursed
   * @example 0.28
   */
  disbursement_rate: number;
}

export interface BlancoGoalMbPayload {
  /**
   * What year the goal is set for
   * @example 2022
   */
  year: number;

  /**
   * Month from 1-12
   * @example 12
   */
  month: number;
  user_ids?: string[];

  /**
   * Number of created applications
   * @example 100
   */
  applications: number;

  /**
   * Working days of the handler for chosen month, example: 20
   * @example 20
   */
  working_days: number;

  /**
   * Number of disbursed loans
   * @example 20
   */
  disbursed_loans_count: number;

  /**
   * The amount of disbursed loans
   * @example 12000000
   */
  disbursed_loans_amount: number;

  /**
   * The percentage of applications sent with a co-applicant
   * @example 50
   */
  co_applicant_percentage: number;

  /**
   * Average loan amount for chosen period, usually set from previous months
   * @example 210000
   */
  average_loan_amount: number;

  /**
   * Count of created applications per day
   * @example 4.5
   */
  applications_per_day: number;

  /**
   * Percent of applications that have GR
   * @example 50
   */
  gr_percentage: number;

  /**
   * Percent of sent applications that get disbursed
   * @example 12.5
   */
  disbursement_rate: number;
}

export interface BlancoGoalPayload {
  /**
   * What year the goal is set for
   * @example 2022
   */
  year: number;

  /**
   * Month from 1-12
   * @example 12
   */
  month: number;
  user_ids?: string[];

  /**
   * The count of sent loans
   * @example 100
   */
  sent_loans: number;

  /**
   * A procent of the return rate of sent loans between 1-100
   * @example 80
   */
  return_rate: number;

  /**
   * Working days of the handler for chosen month, example: 20
   * @example 20
   */
  working_days: number;

  /**
   * The count of signed insurances
   * @example 40
   */
  signed_insurances: number;

  /**
   * An amount in the local currency
   * @example 200
   */
  average_premium: number;

  /**
   * Count of sent loans per day
   * @example 4.5
   */
  sent_loans_per_day: number;

  /**
   * The amount of all disbursed loans in the chosen currency
   * @example 11000000
   */
  disbursed_amount: number;

  /**
   * Average loan amount for chosen period, usually set from previous months
   * @example 210000
   */
  average_loan_amount: number;

  /**
   * The count of disbursed loans
   * @example 80
   */
  disbursed_loans_count: number;

  /**
   * The amount of all sent loans in chosen currency
   * @example 15000000
   */
  sent_loans_amount: number;

  /**
   * The total premium of all signed insurances
   * @example 8000
   */
  total_premium: number;

  /**
   * The amount of leads sent to mortgage
   * @example 20
   */
  mortgage_leads?: number;
}

export interface BlancoLoan {
  /** @example 100000 */
  desired_amount?: number;
  loan_purpose?: LoanPurposeNO | LoanPurposeSE | (LoanPurposeNO & LoanPurposeSE);
}

export interface BlockCustomerFieldManuallyPayload {
  /** An enumeration. */
  country: Country;
  reason: string;

  /** An enumeration. */
  field: BlockField;
  blocked: boolean;
  values: string[];
}

/**
 * An enumeration.
 */
export enum BlockField {
  Phone = "phone",
  Pni = "pni",
  Email = "email",
}

export interface BlockList {
  pni?: boolean;
  phone_number?: boolean;
  email?: boolean;
}

export interface BodyActivateCampaignDialmakerCampaignActivatePost {
  /** @format uuid */
  campaign_id: string;
}

export interface BodyAdminDialmakerAdminOutcomesPost {
  campaign_ids: string[];
  user_ids?: string[];
}

export interface BodyCallBackDialmakerCardOutcomeCallBackPost {
  /** @format uuid */
  lead_id: string;

  /** @format date-time */
  when?: string;
  comment?: string;
  personal_callback?: boolean;
  get_next?: boolean;
}

export interface BodyCallBackDialmakerCardOutcomeLaterPost {
  /** @format uuid */
  lead_id: string;

  /** @format date-time */
  when?: string;
  comment?: string;
  personal_callback?: boolean;
  get_next?: boolean;
}

export interface BodyCallFailureDialmakerCardOutcomeFailurePost {
  /** @format uuid */
  lead_id: string;
  outcome: string;
  get_next?: boolean;
  comment?: string;
}

export interface BodyCallNoContactDialmakerCardOutcomeNoContactPost {
  /** @format uuid */
  lead_id: string;
  outcome: string;
  get_next?: boolean;
  comment?: string;
}

export interface BodyCallSuccessDialmakerCardOutcomeSuccessPost {
  /** @format uuid */
  lead_id: string;
  comment?: string;
  get_next?: boolean;
}

export interface BodyDeactivateCampaignDialmakerCampaignDeactivatePost {
  /** @format uuid */
  campaign_id: string;
}

export interface BodyDeleteExtractionDialmakerCampaignExtractionDelete {
  /** @format uuid */
  campaign_id: string;

  /** @format uuid */
  extraction_id: string;

  /** Force unextract already assigned extractions */
  force?: boolean;
}

export interface BodyElk46CallWebhookMessageElk46CallPost {
  to: string;
  callid: string;
}

export interface BodyExportAndExtractLeadsUrlDialmakerCampaignExportPost {
  /**
   * Campaign ID to export leads from
   * @format uuid
   */
  campaign_id: string;

  /** Number of leads to extract and export */
  leads_count: number;
}

export interface BodyExportAndExtractLeadsUrlDownloadDialmakerCampaignExtractionExportPost {
  /**
   * Extraction ID to export leads from
   * @format uuid
   */
  extraction_id: string;
}

export interface BodyExtractCampaignsDialmakerCampaignExtractPost {
  /** @format uuid */
  campaign_id: string;

  /** @min 0 */
  number_of_leads: number;
}

export interface BodyFindCampaignsDialmakerCampaignFindPost {
  filter?: Filter;
  order?: Order;
}

export interface BodyGetOutcomesDialmakerCardOutcomesPost {
  /** @format uuid */
  lead_id: string;
}

export interface BodyHangupDialmakerCardHangupPost {
  /** @format uuid */
  lead_id: string;
}

export interface BodyImportLeadsDialmakerCampaignImportPost {
  /** @format uuid */
  campaign_id: string;

  /**
   * Source ID to import from, e.g. sheet or query id for campaign source
   * @format uuid
   */
  source_id?: string;
}

export interface BodyJoinCampaignDialmakerCampaignsJoinPost {
  /** @format uuid */
  campaign_id: string;

  /** @max 16 */
  color: number;
}

export interface BodyLeaveCampaignDialmakerCampaignsLeavePost {
  /** @format uuid */
  campaign_id: string;
}

export interface BodyLockDialmakerCardLockPost {
  /** @format uuid */
  lead_id: string;
  force?: boolean;
}

export interface BodyPauseCampaignDialmakerCampaignsPausePost {
  /** @format uuid */
  campaign_id: string;
}

export interface BodyPlayCampaignDialmakerCampaignsPlayPost {
  /** @format uuid */
  campaign_id: string;
}

export interface BodySaveOutcomesDialmakerMiscOutcomesPost {
  outcomes: Outcomes;
}

export interface BodySearchDialmakerCardSearchPost {
  search: string;
}

export interface BodySlackCallbackSlackCallbackPost {
  payload: any;
}

export interface BodySubmissionJotformWebhookFormIdPost {
  submissionID?: string;
}

export interface BodyUpdateDialmakerCardUpdatePost {
  /** @format uuid */
  lead_id: string;
  data: UpdateDMLeadData;
}

export interface BodyUploadAttachmentDialmakerCampaignImageUploadPost {
  /** @format binary */
  file: File;
}

export interface BodyUploadAttachmentMessageAttachmentsUploadPost {
  /** @format binary */
  file: File;
  file_name: string;
}

export interface BodyUploadDialmakerSheetCampaignIdUploadWithPreviewPost {
  /** @format binary */
  file: File;
}

export interface BodyViewDialmakerCardViewPost {
  /** @format uuid */
  lead_id: string;
}

export interface BookableSlot {
  /**
   * @format date-time
   * @example 2022-01-19T13:14:52.247222
   */
  start_date: string;

  /**
   * @format date-time
   * @example 2022-01-19T13:29:52.247242
   */
  end_date: string;

  /**
   * @min 0
   * @example 3
   */
  available_slots?: number;
}

export interface BookingPayload {
  /**
   * @format date-time
   * @example 2022-10-20 12:30
   */
  timeId: string;

  /** @example 0772244466 */
  phoneNumber: string;

  /**
   * @format email
   * @example name@mail.com
   */
  email: string;
}

export interface BooliPropertySearchResult {
  /** @example 59667 */
  id: string;

  /** @example 9a96b620-4efa-46c0-9012-b8d1360472f9 */
  streetGuid: string;
  streetName: string;
  streetNumber: string;

  /** @example Stopvägen 58 */
  postAddress?: string;
  postCode: string;
  longitude: number;
  latitude: number;

  /** @example 48874 */
  housingCoopId?: string;
  hasResidences: boolean;
}

export interface BooliSearchPayload {
  /** An enumeration. */
  country: Country;
  street_name: string;
  post_code: string;
  street_number?: string;
}

export interface BooliValuationPayload {
  property_id: string;
  living_area: number;
}

export interface Brokerage {
  agency?: string;
  broker?: string;
  email?: string;
  phone?: string;
}

export interface Budget {
  /** An enumeration. */
  type_event: GoalType;
  user_id?: string[];

  /** An enumeration. */
  country: Country;

  /**
   * What year the goal is set for
   * @example 2022
   */
  year: number;

  /**
   * Month from 1-12
   * @example 12
   */
  month: number;

  /** @format date-time */
  timestamp: string;

  /**
   * Budget of applications created
   * @example 400
   */
  applications: number;

  /**
   * Budget of average loan amount
   * @example 210000
   */
  average_loan_amount: number;

  /**
   * Budget of number of disbursed loans
   * @example 200
   */
  disbursed_loans_count: number;

  /**
   * Budget of the amount of disbursed loans in countries currency
   * @example 210000
   */
  disbursed_loans_amount: number;

  /**
   * Budget of disbursement rate
   * @example 10.5
   */
  disbursement_rate: number;
}

export interface BudgetPayload {
  /**
   * What year the goal is set for
   * @example 2022
   */
  year: number;

  /**
   * Month from 1-12
   * @example 12
   */
  month: number;
  user_ids?: string[];

  /**
   * Budget of applications created
   * @example 400
   */
  applications: number;

  /**
   * Budget of average loan amount
   * @example 210000
   */
  average_loan_amount: number;

  /**
   * Budget of number of disbursed loans
   * @example 200
   */
  disbursed_loans_count: number;

  /**
   * Budget of the amount of disbursed loans in countries currency
   * @example 210000
   */
  disbursed_loans_amount: number;

  /**
   * Budget of disbursement rate
   * @example 10.5
   */
  disbursement_rate: number;
}

export interface BuyingInfo {
  property_price?: number;
  buying_date?: string;
  new_production?: boolean;
  first_owner?: boolean;
  down_payment?: number;
}

export interface CallOutcomeCallBack {
  user_id: string;

  /** @format date-time */
  timestamp: string;
  type?: "CALL_BACK";

  /** @format uuid */
  campaign_id: string;
  comment?: string;

  /** @format date-time */
  when?: string;
  personal_callback?: boolean;
}

export interface CallOutcomeFailure {
  user_id: string;

  /** @format date-time */
  timestamp: string;
  type?: "FAILURE";

  /** @format uuid */
  campaign_id: string;
  comment?: string;
  outcome: string;
}

export interface CallOutcomeNoContact {
  user_id: string;

  /** @format date-time */
  timestamp: string;
  type?: "NO_CONTACT";

  /** @format uuid */
  campaign_id: string;
  comment?: string;
  outcome: string;
}

export interface CallOutcomeSuccess {
  user_id: string;

  /** @format date-time */
  timestamp: string;
  type?: "SUCCESS";

  /** @format uuid */
  campaign_id: string;
  comment?: string;
}

/**
 * An enumeration.
 */
export enum CallbackResult {
  Completed = "completed",
  Cancelled = "cancelled",
  UserCancel = "userCancel",
  ExpiredTransaction = "expiredTransaction",
  InvalidParameters = "invalidParameters",
  Error = "error",
}

export interface CampaignExport {
  /** @format uuid */
  export_id: string;

  /** @format uuid */
  extraction_id: string;

  /** @format date-time */
  timestamp: string;
}

export interface CampaignExtraction {
  /** @format uuid */
  extraction_id: string;
  extracted_by?: string;

  /** @min 0 */
  leads_count: number;

  /** @format date-time */
  timestamp: string;
}

export interface CampaignExtractionsStats {
  already_extracted: number;
  without_outcome: number;
  exported_without_outcome: number;
  available_to_call: number;
  left_to_extract?: number;
}

export interface CampaignOngoingExtraction {
  /** @format uuid */
  campaign_id: string;

  /** @format uuid */
  job_id: string;
  job_status?: string;

  /** @format uuid */
  extraction_id: string;
  leads_count: number;
  user_id: string;
}

export interface CampaignStats {
  active: number;
}

/**
 * An enumeration.
 */
export enum CampaignType {
  COLD = "COLD",
  POOL = "POOL",
  PROCESS = "PROCESS",
}

export interface CancelOfferPayload {
  /** An enumeration. */
  reason: CancelReason;
  application_id: string;
  bank_id: number;
  synchronous?: boolean;
}

/**
 * An enumeration.
 */
export enum CancelReason {
  BETTER_INTEREST_OTHER_BANK = "BETTER_INTEREST_OTHER_BANK",
  OFFERED_AMOUNT_TOO_LOW = "OFFERED_AMOUNT_TOO_LOW",
  NO_DEAL = "NO_DEAL",
  OTHER_REASON = "OTHER_REASON",
}

export interface Car {
  monthlyCost?: number;
}

export interface CarCost {
  actual_cost?: boolean;

  /** @example 2000 */
  fixed_cost: number;
}

export interface CaseCollectionItem {
  uc_type_template_descition?: string;
  year?: string;
}

/**
 * An enumeration.
 */
export enum Channel {
  Inbound = "inbound",
  Outbound = "outbound",
  Online = "online",
}

export interface Checklist {
  /** An enumeration. */
  status?: SubmissionStatus;
  form_validation?: ModelsOnlineLoanApplicationStatus;
  get_customers?: ModelsOnlineLoanApplicationStatus;
  has_recent_app_check?: ModelsOnlineLoanApplicationStatus;
  has_recent_app_email?: ModelsOnlineLoanApplicationStatus;
  created_application?: ModelsOnlineLoanApplicationStatus;
  quick_application?: ModelsOnlineLoanApplicationStatus;
  confirmation_email?: ModelsOnlineLoanApplicationStatus;
  sms_to_co_applicant?: ModelsOnlineLoanApplicationStatus;
  parsed_application?: ModelsOnlineLoanApplicationStatus;
  sms_blanco_app_creation?: ModelsOnlineLoanApplicationStatus;
  converted_to_blanco_model?: ModelsOnlineLoanApplicationStatus;
  created_blanco_application?: ModelsOnlineLoanApplicationStatus;
}

export interface ChildBenefit {
  /** @example 2 */
  number_of_children: number;

  /** @example 1250 */
  benefit: number;
}

export interface ClientAutostartToken {
  customerId: string;

  /** An enumeration. */
  status: SigningStatus;
  autostartToken?: string;

  /** ISO 8601 CET date time: 2021-09-22T16:16:16.9910526+02:00 */
  autostartTokenReceivedAt?: DateTime;
  bankIdSignRedirectUrl?: string;
  message?: string;
  signedDate?: string;

  /** @format date-time */
  autostartToken_timestamp?: string;
}

export interface CommentPayload {
  /** @example Decided this with customer */
  comment: string;
}

export interface Condominium {
  property_id: string;

  /** @example 3600000 */
  value?: number;

  /** @example 3500000 */
  booli_value?: number;
  external_id?: string;

  /** @example CONDOMINIUM */
  property_type: "CONDOMINIUM";

  /** An enumeration. */
  country: Country;

  /** @example Storgatan 11A */
  street_address?: string;

  /** @example 12453 */
  post_code?: string;

  /** @example Bandhagen */
  city?: string;

  /** @example true */
  other_owner?: boolean;

  /** @example 9999 */
  monthly_cost?: number;

  /** @example 56 */
  square_meter_living_area?: number;

  /** @example Stockholm */
  municipality?: string;

  /** @example 018027 */
  municipality_code?: string;

  /** @example 6000000 */
  estimated_value?: number;
  latitude?: number;
  longitude?: number;
  ev_partial?: EvPartialCommon;

  /** @example 1001 */
  apartment_number?: string;

  /** @example true */
  elevator?: boolean;

  /** @example 556953-5742 */
  organization_number?: string;

  /** @example Brf Svanen */
  organization_name?: string;

  /** @example 3 */
  floor?: number;

  /** @example PATIO */
  balcony_type?: BalconyType;
  rooms?: number;
}

export interface CondominiumItem {
  /** Housing association organization number */
  organizationNumber?: string;

  /** Housing association organization name */
  organizationName?: string;

  /** Apartment number in housing association */
  apartmentNumber?: string;

  /** Floor number. Decimal, could be negative. Example: 1,0, -1,0 or 1,5. */
  floor?: number;

  /** If there an elevator in apartment building? */
  elevator?: boolean;

  /** Balcony type */
  balconyType?: BalconyType;
}

export interface Consents {
  /** @example true */
  email_marketing: boolean;

  /** @example true */
  sms_marketing: boolean;

  /** @example true */
  customer_club_marketing: boolean;
}

export interface ContactFormPayload {
  /** @example John */
  givenName: string;

  /** @example Doe */
  lastName: string;

  /** @example 0772244466 */
  phoneNumber: string;

  /**
   * @format email
   * @example name@mail.com
   */
  email: string;

  /** @example Sample message */
  message: string;
}

export interface Conversation {
  customer_id: string;
  application_id_or_lead_id?: string | string;
  phone_number?: string;
  pni?: string;
  open: boolean;
}

export interface ConvertPayload {
  /** @example LEADMOSE000001 */
  lead_id: string;
}

export interface ConvertResult {
  application_id: string;
}

/**
 * An enumeration.
 */
export enum ConvertToBlancoStatus {
  Success = "success",
  Failure = "failure",
  InProgress = "in_progress",
  NotEligible = "not_eligible",
  Enqueued = "enqueued",
}

export interface CostPerPerson {
  /** @example 3400 */
  cost: number;

  /** @example 26 */
  from_and_including_age: number;

  /** @example 30 */
  to_and_including_age: number;
}

/**
 * An enumeration.
 */
export enum Country {
  SE = "SE",
  NO = "NO",
}

export interface CreateAndUpdateEmployeeRequest {
  /**
   * @format email
   * @example employee@zensum.se
   */
  email?: string;

  /** @example Sven */
  first_name?: string;

  /** @example Svensson */
  last_name?: string;

  /** @example [{"Product":"MO","Country":"SE","Office":"ST","EmploymentType":"FU","Department":"SK"}] */
  zoordinates: Zoordinates[];
  phone_number?: string;
  telavox_ids?: string[];
  sverker_usernames?: SverkerUsername[];

  /** @example ["employee:admin","partner:admin"] */
  roles: RoleType[];
}

export interface CreateApplicantNO {
  country?: "NO";

  /** @example 198001011234 */
  pni: string;

  /** @example John */
  first_name?: string;

  /** @example Doe */
  last_name?: string;

  /** @example john@example.com */
  email?: string;

  /** @example +46701234567 */
  phone_number?: string;

  /**
   * @min 0
   * @example 10000
   */
  monthly_property_cost?: number;

  /** @example unmarried */
  marital_status?: MaritalStatus;

  /**
   * Official marital status from ID check; should not be modified; marital_status has higher priority
   * @example unmarried
   */
  registered_marital_status?: MaritalStatus;

  /** @example 12345 */
  post_code?: string;

  /** @example Stockholm */
  city?: string;
  incomes?: Income[];

  /** @example 10000 */
  net_monthly_income?: number;
  account?: Account;

  /** @example Street 1 */
  street_address?: string;

  /**
   * Number of children to pay child support for
   * @min 0
   * @max 10
   * @example 0
   */
  paying_child_support?: number;

  /**
   * Number of children to receive child support for
   * @min 0
   * @max 10
   * @example 0
   */
  receiving_child_support?: number;
  consents?: Consents;

  /** @example 198001011234 */
  partner_pni?: string;

  /** @example John Doe */
  partner_name?: string;

  /** @example 0115 */
  municipality_code?: string;

  /** @example Stockholm */
  municipality?: string;

  /** @example false */
  is_pep?: boolean;

  /**
   * @min 1
   * @example 73
   */
  age?: number;

  /** @example {"home":"+46701234567"} */
  other_phones?: PhoneNumber[];

  /** @example 123456 */
  sverker_id?: number;

  /** @example 1 */
  children?: number;

  /** @example 1 */
  citizen?: number;

  /** @example elementarySchool */
  education?: EducationType;

  /** @example 10000 */
  monthly_partner_income?: number;

  /** @format date */
  immigrated_at?: string;

  /** @example John Doe */
  fullname?: string;
  documents?: ApplicantDocument[];
  verified_credits?: boolean;

  /** @example 2019-01-01 */
  housing_since?: string;

  /** @example false */
  deceased?: boolean;

  /** @example false */
  emigrated?: boolean;

  /** @example false */
  is_sanction?: boolean;

  /** @example false */
  is_rca?: boolean;

  /** @format date-time */
  date_created?: string;

  /** @format date-time */
  date_updated?: string;

  /** @format date-time */
  last_credit_check?: string;

  /** @format date-time */
  last_externally_verified_credits?: string;
  pep_quality?: boolean;

  /** A cluster is a group of customers displayed with a color */
  cluster?: string;

  /** @example RENTED */
  housing_type?: HousingTypeNO;
  employer?: OptionalEmployerNO;
  ev_estate?: EvEstate[];

  /** @example ["NO"] */
  citizenship_iso_codes?: string[];
  externally_verified_credits?: ExternallyVerifiedCredit[];
}

/**
 * Create application payload extended with fields for ZRM
 */
export interface CreateApplicationPayloadExt {
  loan?: NewMortgageLoan;

  /**
   * In SE we can only refinance one existing mortgage so this object is the loan to be refinanced,
   * not used in NO
   */
  refinance_info?: RefinanceInfo;
  buying_info?: BuyingInfo;
  selling_info?: SellingInfo;
  applicants?: BareApplicantWithRole[];

  /** @example 79975430-f34c-4c78-addd-ac7d978106aa */
  property_id?: string;
  discount?: Discount;
  loans?: Loan[];
  other_mortgages?: MortgageLoan[];

  /** An enumeration. */
  status?: AppsmgrModelsStatusStatus;

  /** An enumeration. */
  substatus?: Substatus;

  /** An enumeration. */
  bank_status?: BankStatus;
  children_in_the_household?: number;
  children_in_the_household_fulltime?: number;
  other_properties_to_keep?: OtherProperty[];

  /** An enumeration. */
  co_relationship_to_main_applicant?: RelationshipStatus;

  /** An enumeration. */
  guarantor_relationship_to_main_applicant?: RelationshipStatus;
  cars?: AppsmgrMortgageSeSpecCommonDefinitionsCars;
  brokerage?: Brokerage;

  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;
  internal_comment?: string;
  new_app_options?: Option[];
  new_app_checklist?: string[];

  /** An enumeration. */
  source?: ApplicationSource;
  aml?: AMLInsertion;
}

export interface CreateCampaignData {
  name: string;
  description?: string;
  exclusion_rules: ExclusionRules;
  retry_policy: RetryPolicy;
  source: SheetCampaignSource | BigQueryCampaignSource;
  auto_dial?: boolean;
  daily_extraction_limit?: number;
  personal_callbacks?: boolean;
  no_contact_outcomes?: string[];
  failure_outcomes?: string[];
  comment_template?: string;
  file_id?: string;
  show_call_history?: boolean;

  /** An enumeration. */
  type: CampaignType;

  /** An enumeration. */
  country: Country;

  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  department: ZDepartment;
}

/**
 * Create application and applicant payload extended with fields for ZRM
 */
export interface CreateCreditCardApplicationApplicantPayloadExt {
  /** An enumeration. */
  country: Country;
  data: CreditCardApplicationDataCreate;
  applicant: CreateApplicantNO;
  internal_comment?: string;
  new_app_options?: Option[];
  new_app_checklist?: string[];

  /** An enumeration. */
  source?: ApplicationSource;
  aml?: AMLInsertion;
}

/**
 * Create application payload extended with fields for ZRM
 */
export interface CreateCreditCardApplicationPayloadExt {
  /** An enumeration. */
  country: Country;
  data: CreditCardApplicationData;
  internal_comment?: string;
  new_app_options?: Option[];
  new_app_checklist?: string[];

  /** An enumeration. */
  source?: ApplicationSource;
  aml?: AMLInsertion;
}

/**
 * Payload to send to apps-mgr - create application and applicant
 */
export interface CreateCreditCardApplicationPayloadWithApplicant {
  /** An enumeration. */
  country: Country;
  data: CreditCardApplicationDataCreate;
  applicant: CreateApplicantNO;
}

export interface CreateCustomerPayload {
  /** @example Creating a customer for an application */
  reason: string;

  /** An enumeration. */
  country: Country;

  /** @example 194907011813 */
  pni: string;
  data: CustomerData;
}

export interface CreateDocumentPayload {
  /**
   * A base64 encoded string of the data
   * @example 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
   */
  data: string;

  /**
   * Name of the document
   * @example A proof of employment.pdf
   */
  name: string;

  /**
   * MIME type of the document
   * @example application/png
   */
  mime_type: string;

  /**
   * The type of document you're uploading.
   * @example AMORTIZATION_PLAN
   */
  document_type: DocumentType;

  /**
   * ID of the customer to attach the document to
   * @example dc684b46-4893-11ec-bb64-fbaa98179196
   */
  customer_id: string;
}

export interface CreateDocumentPayloadResp {
  /**
   * ID of the created document
   * @example bc1b1e48-269e-45f3-9e96-e9c61f68e73c
   */
  document_id: string;
}

export interface CreateLeadPayload {
  loan?: NewMortgageLoan;

  /**
   * In SE we can only refinance one existing mortgage so this object is the loan to be refinanced,
   * not used in NO
   */
  refinance_info?: RefinanceInfo;
  buying_info?: BuyingInfo;
  selling_info?: SellingInfo;
  applicants?: BareApplicantWithRole[];

  /** @example 79975430-f34c-4c78-addd-ac7d978106aa */
  property_id?: string;
  discount?: Discount;
  loans?: Loan[];
  other_mortgages?: MortgageLoan[];

  /** An enumeration. */
  status?: AppsmgrModelsStatusStatus;

  /** An enumeration. */
  substatus?: Substatus;

  /** An enumeration. */
  bank_status?: BankStatus;
  children_in_the_household?: number;
  children_in_the_household_fulltime?: number;
  other_properties_to_keep?: OtherProperty[];

  /** An enumeration. */
  co_relationship_to_main_applicant?: RelationshipStatus;

  /** An enumeration. */
  guarantor_relationship_to_main_applicant?: RelationshipStatus;
  cars?: AppsmgrMortgageSeSpecCommonDefinitionsCars;
  brokerage?: Brokerage;
  applicant: LimitedApplicantSE | LimitedApplicantNO;
  co_applicant?: LimitedApplicantSE | LimitedApplicantNO | (LimitedApplicantSE & LimitedApplicantNO);
  property?: ExternalProperty;
  comment: string;

  /** An enumeration. */
  source: ApplicationSource;

  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;
}

export interface CreateMeetingPayload {
  /** @format date-time */
  meeting_start: string;

  /** @format date-time */
  meeting_end: string;

  /** @example sms|5ce26c2450d832460390f580 */
  handler_id?: string;

  /** @example Please bring some paper of some sort */
  meeting_notes?: string;

  /** @example Introduction to the Zensum Way */
  meeting_subject: string;

  /** @example 73f670d8-4893-11ec-a8c1-2bcfc7bae96a */
  customer_id?: string;

  /** @example MOSE000001 */
  application_id: string | string;
}

export interface CreateTMCampaign {
  query: string;

  /** An enumeration. */
  country: Country;

  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  department: ZDepartment;
  description: string;

  /** Number of days since last extraction to ignore customer_id */
  ignore_days_since_last_extraction?: number;
}

export interface CreateUser {
  /** @example Glenn */
  first_name: string;

  /** @example Hysén */
  last_name: string;

  /**
   * @format email
   * @example glenn.hysen@banken.se
   */
  username: string;
  banks: IntegrationId[];
}

export interface CreateUserResp {
  /** @example PK839FUkGrPmSdRJNdXSRtjisB3TjCJt */
  token: string;
}

export interface Credit {
  sum: number;
  monthly_payment: number;
  bank_id: number;
  liable?: string;
  rate: number;
  refinance_amount?: number;
  monthly_amortisation?: number;

  /** An enumeration. */
  responsibility?: CreditResponsibility;
}

export interface CreditCardApplicationData {
  desired_credit_limit: number;
  car: boolean;
  student_loans_amount?: number;
  student_loans_monthly_payment?: number;
  car_boat_mc_loans_amount?: number;
  car_boat_mc_loans_monthly_payment?: number;
  total_consumer_loans_amount?: number;
  total_consumer_loans_monthly_payment?: number;
  mortgage_loans_amount?: number;
  mortgage_loans_monthly_payment?: number;
  credit_card_debt_amount?: number;
  credit_card_debt_monthly_payment?: number;
  children_in_the_household_fulltime?: number;

  /** @format uuid */
  applicant_id: string;
}

export interface CreditCardApplicationDataCreate {
  desired_credit_limit: number;
  car: boolean;
  student_loans_amount?: number;
  student_loans_monthly_payment?: number;
  car_boat_mc_loans_amount?: number;
  car_boat_mc_loans_monthly_payment?: number;
  total_consumer_loans_amount?: number;
  total_consumer_loans_monthly_payment?: number;
  mortgage_loans_amount?: number;
  mortgage_loans_monthly_payment?: number;
  credit_card_debt_amount?: number;
  credit_card_debt_monthly_payment?: number;
  children_in_the_household_fulltime?: number;
}

export interface CreditCardApplicationExtended {
  application_id: string;

  /** @format date-time */
  timestamp: string;
  data: CreditCardApplicationData;
  active?: boolean;
  state?: AppState;
  applicant: ApplicantSE | ApplicantNO;
}

export interface CreditCardApplicationWithNamesInComments {
  application_id: string;

  /** @format date-time */
  timestamp: string;
  data: CreditCardApplicationData;
  active?: boolean;
  state?: AppState;
  applicant: ApplicantSE | ApplicantNO;
  meta: ApplicationMappingWithNamesInComments;
}

export interface CreditCardBankEventsResponse {
  bank_events: BankEventsCreditCardOffer[];
}

export interface CreditCardOffer {
  amortizationRule?: AmortizationPlan;
  offeredAmount?: number;
  minOfferedAmount?: number;
  maxOfferedAmount?: number;
  mustRefinance?: number;
  monthlyPayment?: number;
  termMonths?: number;
  termFee?: number;
  arrangementFee?: number;
  invoiceFee?: number;
  ratePercent?: number;
}

/**
 * General terms for credit card offers.
 */
export interface CreditCardTerms {
  withdrawal_fee: string;
  currency_surcharge: number;
  annual_fee: number;
  apr: number;
  apr_calculation_description?: string;
  grace_period_days: number;
  purchase_fee?: number;
  e_invoice_fee?: number;
}

export interface CreditCheckNO {
  earnedIncome: number;

  /** @format date-time */
  mostRecentNoteDate?: string;
  creditNotes?: number;
  expired?: boolean;

  /** @format date-time */
  expiration_date?: string;
  debt_equity_ratio?: number;
  debt_equtiy_year?: number;
  remarks?: Debt;
}

export interface CreditCheckSE {
  earnedIncome: number;

  /** @format date-time */
  mostRecentNoteDate?: string;
  creditNotes?: number;
  expired?: boolean;

  /** @format date-time */
  expiration_date?: string;
  riskAssessment?: number;
  kfmDebt?: number;
  kfmDebtPublic?: number;
  kfmDebtPrivate?: number;
  numPrevious?: number;
  score?: number;
  inquiries?: number;
  issuers?: string[];
}

export interface CreditRegulation {
  accounting_controlls_summary?: string;
  allow_casuation_storage?: string;
  cause_table?: string;
  risk?: string;
  risk_applicant?: string;
  risk_applicant_2?: string;
  template_description?: string;
  uc_internal_information?: string;
  year?: string;
}

export interface CreditRegulationInformation {
  account_number?: string;
  decision_template?: string;
  no_decimals?: string;
  order_template?: string;
  template_name?: string;
  template_response?: string;
  year?: string;
}

/**
 * An enumeration.
 */
export enum CreditResponsibility {
  MAIN_APPLICANT = "MAIN_APPLICANT",
  CO_APPLICANT = "CO_APPLICANT",
  SHARED = "SHARED",
  GUARANTOR = "GUARANTOR",
}

export interface CreditorOfferCreditCardOfferCreditCardTerms {
  /** An enumeration. */
  country: Country;
  bank_id: number;
  creditor_name: string;

  /** @format uuid4 */
  offer_id: string;
  offer: CreditCardOffer;

  /** General terms for credit card offers. */
  terms: CreditCardTerms;
  acceptable: boolean;
  is_accepted?: boolean;

  /** @format date-time */
  timestamp: string;
  app_identifier: string;
}

/**
 * An enumeration.
 */
export enum Currency {
  EUR = "EUR",
  SEK = "SEK",
  NOK = "NOK",
}

export interface CurrentFrameItem {
  frame_information?: string;
  uc_divisions?: string;
  uc_post_type_current?: string;
  uc_quick_choice?: any;
  year?: string;
}

export interface CurrentSectionOfCaseItem {
  additional_order?: string;
  editor_program?: string;
  order_date?: string;
  person_name_stored?: string;
  report_language?: string;
  subscriber_name?: string;
  uc_archive?: string;
  uc_divisions_1?: string;
  uc_divisions_2?: string;
  uc_divisions_3?: string;
  uc_divisions_4?: string;
  uc_divisions_5?: string;
  uc_divisions_6?: string;
  uc_divisions_7?: string;
  uc_divisions_8?: string;
  uc_more_info?: string;
  uc_role?: string;
  uc_type?: string;
  uc_type_internal?: string;
  uc_type_text?: string;
  year?: string;
}

export interface CustomerApplication {
  /** An enumeration. */
  country: Country;

  /** An enumeration. */
  product: Product;
  offers?: CustomerOffer[];
  application_id: string;
  credits: Credit[];
  applicant: CustomerCustomer;
  co_applicant?: CustomerCustomer;
  is_deactivated: boolean;
}

export interface CustomerCustomer {
  customer_id?: string;

  /** An enumeration. */
  country: Country;
  pni: string;
  first_name: string;
  last_name: string;
  sverker_id?: number;
  email?: string;
  phone_number?: string;
  bank_account?: Account;
  employer?: object;
}

export interface CustomerData {
  /** @example +46761234567 */
  phone_number?: string;

  /** @format email */
  email?: string;
  account?: Account;

  /** @min 0 */
  children?: number;
  employer?: EmployerSE | EmployerNO | (EmployerSE & EmployerNO);
  incomes?: Income[];
  net_monthly_income?: number;

  /** @min 0 */
  monthly_property_cost?: number;
  housing_type?: HousingTypeSE | HousingTypeNO | (HousingTypeSE & HousingTypeNO);

  /**
   * @min 0
   * @max 10
   */
  paying_child_support?: number;

  /**
   * @min 0
   * @max 10
   */
  receiving_child_support?: number;

  /** Marital status of a person */
  marital_status?: MaritalStatus;

  /** Official marital status of a person */
  registered_marital_status?: MaritalStatus;

  /** An enumeration. */
  education?: EducationType;
}

export interface CustomerIDGetCustomerPayload {
  /** @example Creating a customer for an application */
  reason: string;

  /** @example 9bc32a3e-4893-11ec-8dcd-2f8b16112bbb */
  customer_id: string;
}

export interface CustomerIDsGetCustomerPayload {
  /** @example Creating a customer for an application */
  reason: string;

  /** @example ["e82a9fa8-7963-46af-a4d4-fce389194476"] */
  customer_ids: string[];
}

export interface CustomerOffer {
  id: string;
  bank_id: number;
  status_id: number;
  rate?: number;
  sum?: number;
  status_name: string;
  external_offer_id?: string;
  amortization_plan: string;
  sum_to_solve?: number;
  monthly_payment: number;
  admin_fee?: number;
  setup_fee?: number;
  apr?: number;

  /** @format date-time */
  created_at: string;
  need_more_info?: boolean;

  /** Payback time in months */
  payback_time: number;
  direct_debit_fee?: number;
  is_accepted?: boolean;
}

export interface DMLead {
  /** @format uuid */
  id: string;
  version: number;
  data: DMLeadData;

  /** @format uuid */
  campaign_id?: string;

  /** @format uuid */
  extraction_id?: string;

  /** An enumeration. */
  status: LeadStatus;
  call_outcomes: (CallOutcomeSuccess | CallOutcomeCallBack | CallOutcomeNoContact | CallOutcomeFailure)[];

  /** Extraction of this lead */
  extraction: ModelsDialMaker2LeadDataModelsLeadExtraction;
  assigned_to?: string;

  /** @format date-time */
  assigned_at?: string;

  /** @format date-time */
  extracted_at?: string;

  /** @format date-time */
  updated_at: string;
  retry_policy?: RetryPolicy;

  /** @format date-time */
  call_at?: string;
  personal_callback?: PersonalCallback;

  /** @format uuid */
  export_id?: string;

  /** @format date-time */
  exported_at?: string;

  /** An enumeration. */
  last_call_outcome?: OutcomeType;

  /** @format date-time */
  last_call_outcome_at?: string;
}

export interface DMLeadCampaignData {
  campaign_name?: string;
  image_id?: string;
  campaign_color?: number;
  auto_dial?: boolean;
  show_call_history?: boolean;
}

export interface DMLeadData {
  phone?: string | File;
  other_phones?: (string | File)[];
  pni?: string | File;
  name?: string | File;

  /** @format uuid */
  customer_id?: string;
  other_properties?: object;
  comment_vars?: object;
  tags?: object;
  application_id?: string;
  comment?: string;
  customer_cluster?: string;

  /** Number of times this customer/phone number was extracted. */
  extraction_count?: number;
  sorting_order?: number;
}

export interface DMLeadExt {
  /** @format uuid */
  id: string;
  version: number;
  data: DMLeadData;

  /** @format uuid */
  campaign_id?: string;

  /** @format uuid */
  extraction_id?: string;

  /** An enumeration. */
  status: LeadStatus;
  call_outcomes: (CallOutcomeSuccess | CallOutcomeCallBack | CallOutcomeNoContact | CallOutcomeFailure)[];

  /** Extraction of this lead */
  extraction: ModelsDialMaker2LeadDataModelsLeadExtraction;
  assigned_to?: string;

  /** @format date-time */
  assigned_at?: string;

  /** @format date-time */
  extracted_at?: string;

  /** @format date-time */
  updated_at: string;
  retry_policy?: RetryPolicy;

  /** @format date-time */
  call_at?: string;
  personal_callback?: PersonalCallback;

  /** @format uuid */
  export_id?: string;

  /** @format date-time */
  exported_at?: string;

  /** An enumeration. */
  last_call_outcome?: OutcomeType;

  /** @format date-time */
  last_call_outcome_at?: string;
  campaign_data?: DMLeadCampaignData;
}

export interface DashboardPayload {
  user_ids?: string[];
  sverker_usernames?: string[];

  /** @format date-time */
  start_date: string;

  /** @format date-time */
  end_date: string;
}

/**
 * ISO 8601 CET date time: 2021-09-22T16:16:16.9910526+02:00
 */
export type DateTime = string;

export interface DaySlotDoc {
  /**
   * @min 0
   * @max 6
   */
  day: number;

  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;

  /** @format date-time */
  starts_at: string;

  /** @format date-time */
  ends_at?: string;
  slots: ScheduleSlot[];
  id: string;

  /** @format date-time */
  timestamp: string;
  user_id: string;
  request_id: string;
}

export interface DaySlotDocPayload {
  /**
   * @min 0
   * @max 6
   */
  day: number;

  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;

  /** @format date-time */
  starts_at: string;

  /** @format date-time */
  ends_at?: string;
  slots: ScheduleSlot[];
}

export interface DeactivatePayload {
  application_id: string;
  review: DeactivationReview;
}

export interface DeactivateUserPayload {
  user_id: string;
}

export interface DeactivationReview {
  /** An enumeration. */
  reason: AppsmgrBlancoModelsApplicationDeactivationReason;

  /** An enumeration. */
  review: ApplicationReview;
}

export interface DeactivationReviewsPayload {
  /** An enumeration. */
  country: Country;
}

export interface DeactivationReviewsResponse {
  reviews: DeactivationReview[];
}

export interface Debt {
  debt?: DebtItem[];
}

export interface DebtItem {
  /** @format date-time */
  date?: string;
  type?: string;
  source?: string;
  status?: string;
  saksnr?: string;
  amount?: number;

  /** @format date-time */
  oppgjort?: string;
  creditor?: string;
  art?: string;
  amount_percentage?: number;
  currency?: string;
  code?: string;
}

/**
 * An enumeration.
 */
export enum DefaultCalendarView {
  DayGridMonth = "dayGridMonth",
  AppViewWeek = "appViewWeek",
  AppViewDay = "appViewDay",
}

export interface Discount {
  occupational_pension_in_banks?: number[];
}

export interface DocumentAssignation {
  customer_id: string;
  document_id: string;
}

export interface DocumentMeta {
  /**
   * Name of the document
   * @example A proof of employment.pdf
   */
  name: string;

  /**
   * MIME type of the document
   * @example application/png
   */
  mime_type: string;

  /**
   * The type of document you're uploading.
   * @example AMORTIZATION_PLAN
   */
  document_type: DocumentType;

  /**
   * ID of the customer that owns the document
   * @example d3a51af2-4893-11ec-b66a-8f469c7d5dde
   */
  customer_id: string;

  /**
   * When the document was added to db
   * @format date-time
   */
  timestamp: string;
}

export interface DocumentToBank {
  documents: AppsmgrModelsBankCommunicationDocument[];
  application_id: string;
  bank_id: number;
}

/**
 * An enumeration.
 */
export enum DocumentType {
  AMORTIZATION_PLAN = "AMORTIZATION_PLAN",
  PETITION_FOR_DIVORCE = "PETITION_FOR_DIVORCE",
  CERTIFICATE_OF_EMPLOYMENT = "CERTIFICATE_OF_EMPLOYMENT",
  DIVISION_OF_PROPERTY_AGREEMENT = "DIVISION_OF_PROPERTY_AGREEMENT",
  VERIFY_ESCROW_AGREEMENT = "VERIFY_ESCROW_AGREEMENT",
  FINANCIAL_FORECASTING_FOR_TENANT_OWNERSHIP_ASSOCIATION = "FINANCIAL_FORECASTING_FOR_TENANT_OWNERSHIP_ASSOCIATION",
  POWER_OF_ATTORNEY = "POWER_OF_ATTORNEY",
  PHYSICAL_MORTGAGE_DEEDS = "PHYSICAL_MORTGAGE_DEEDS",
  INTERMEDIATION_AGREEMENT_INCLUDING_STARTING_PRICE = "INTERMEDIATION_AGREEMENT_INCLUDING_STARTING_PRICE",
  DEED_OF_GIFT = "DEED_OF_GIFT",
  PURCHASE_AGREEMENT = "PURCHASE_AGREEMENT",
  CONTRACTORS_AGREEMENT = "CONTRACTORS_AGREEMENT",
  APARTMENT_CERTIFICATE = "APARTMENT_CERTIFICATE",
  COLLATERAL_OBJECT_DESCRIPTION = "COLLATERAL_OBJECT_DESCRIPTION",
  PENSION_PROJECTION = "PENSION_PROJECTION",
  PENSION_SPECIFICATION = "PENSION_SPECIFICATION",
  AUDITORS_CERTIFICATE = "AUDITORS_CERTIFICATE",
  LATESTAPPROVEDINCOMESTATEMENTANDNE3APPENDIX = "LATEST_APPROVED_INCOME_STATEMENT_AND_NE3_APPENDIX",
  LATEST_APPROVED_INCOME_STATEMENT_AND_NE_APPENDIX = "LATEST_APPROVED_INCOME_STATEMENT_AND_NE_APPENDIX",
  FINAL_INVOICE = "FINAL_INVOICE",
  SALES_AGREEMENT = "SALES_AGREEMENT",
  INFORMATION_TO_CONTACT_PERSON = "INFORMATION_TO_CONTACT_PERSON",
  TENURE_AGREEMENT = "TENURE_AGREEMENT",
  VALUATION = "VALUATION",
  VALUATION_OF_COMPLETED_PROPERTY = "VALUATION_OF_COMPLETED_PROPERTY",
  VALUATION_FROM_INDEPENDENT_BROKER = "VALUATION_FROM_INDEPENDENT_BROKER",
  TRANSFER_AGREEMENT = "TRANSFER_AGREEMENT",
  VALUATION_CERTIFICATE = "VALUATION_CERTIFICATE",
  CASH_DEPOSIT_DOCUMENTATION = "CASH_DEPOSIT_DOCUMENTATION",
  PRELIMINARY_SETTLEMENT_NOTE = "PRELIMINARY_SETTLEMENT_NOTE",
  ORIGINAL_BILL_OF_PURCHASE = "ORIGINAL_BILL_OF_PURCHASE",
  TITLE_DEED = "TITLE_DEED",
  FINAL_SERVEYING_PROTOCOL = "FINAL_SERVEYING_PROTOCOL",
  FINAL_CLEARANCE = "FINAL_CLEARANCE",
  INVOICES = "INVOICES",
  STATEMENT_OF_ACCOUNT = "STATEMENT_OF_ACCOUNT",
  PAYSLIP = "PAYSLIP",
  ANNUAL_REPORT_HOUSING_SOCIETY = "ANNUAL_REPORT_HOUSING_SOCIETY",
  ANNUAL_REPORT_SELF_EMPLOYED = "ANNUAL_REPORT_SELF_EMPLOYED",
  SPOUSE_CONSENT = "SPOUSE_CONSENT",
  OTHER_INCOME_CERTIFICATES = "OTHER_INCOME_CERTIFICATES",
  ESTATE_INVENTORY = "ESTATE_INVENTORY",
  LOAN_TERMS_OPTIONS = "LOAN_TERMS_OPTIONS",
  INSTRUMENT_OF_DEBT = "INSTRUMENT_OF_DEBT",
  KNOW_YOUR_CUSTOMER_QUESTIONS = "KNOW_YOUR_CUSTOMER_QUESTIONS",
  COPY_OF_IDENTIFICATION_CARD = "COPY_OF_IDENTIFICATION_CARD",
  INCOME_TAX_RETURN = "INCOME_TAX_RETURN",
  ENERGY_DECLARATION = "ENERGY_DECLARATION",
  OTHER = "OTHER",
}

export interface DuplicateFormPreferencePayload {
  form_id: string;

  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;
  copy_from_preference_id: string;
}

export interface EditUser {
  /** @example Glenn */
  first_name: string;

  /** @example Hysén */
  last_name: string;

  /**
   * @format email
   * @example glenn.hysen@banken.se
   */
  username: string;
  banks: IntegrationId[];
}

/**
 * An enumeration.
 */
export enum EducationType {
  ElementarySchool = "elementarySchool",
  HighSchool = "highSchool",
  Type1YearUniversity = "1yearUniversity",
  Type2YearsUniversity = "2yearsUniversity",
  Type3YearsUniversity = "3yearsUniversity",
  MoreThan3YearsUniversity = "moreThan3yearsUniversity",
}

export interface Elk46CallResponse {
  /** @example +46766860001 */
  connect: string;
}

export interface EmailGetCustomerPayload {
  /** @example Creating a customer for an application */
  reason: string;

  /** @format email */
  email: string;
}

export interface EmailTemplate {
  name: string;
  message_type?: MessageType;

  /** @format date-time */
  timestamp?: string;
  comment?: string;
  deleted?: boolean;
  attachment_ids?: string[];
  mandrill_name: string;
  subject: string;
  from_name?: string;

  /** @format email */
  from_email?: string;
  reply_to?: string;
}

export interface Employee {
  /**
   * @format email
   * @example employee@zensum.se
   */
  email?: string;

  /** @example Sven */
  first_name?: string;

  /** @example Svensson */
  last_name?: string;

  /** @example [{"Product":"MO","Country":"SE","Office":"ST","EmploymentType":"FU","Department":"SK"}] */
  zoordinates: Zoordinates[];
  phone_number?: string;
  telavox_ids?: string[];
  sverker_usernames?: SverkerUsername[];

  /** @example ["employee:admin","partner:admin"] */
  roles: RoleType[];

  /** @example sms|5ce26c2450d832460390f580 */
  user_id: string;

  /** @example https://s.gravatar.com/avatar/f900a71f2bcbc2c65a42958724378bb3?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fte.png */
  avatar: string;

  /** @example false */
  deactivated?: boolean;

  /** @format date-time */
  last_login?: string;

  /** @format date-time */
  created_at?: string;
}

export interface EmployerNO {
  /** @example Zensum AB */
  name: string;

  /** An enumeration. */
  type: EmploymentTypeNO;

  /**
   * @format date
   * @example 2019-01-20
   */
  start_date: string;

  /**
   * @format date
   * @example 2021-01-19
   */
  end_date?: string;

  /** @example 0771-30 44 47 */
  phone?: string;

  /** @example 65 */
  retirement_age?: number;

  /** @example 556953-5742 */
  organization_number?: string;
  profession?: string;
}

export interface EmployerSE {
  /** @example Zensum AB */
  name: string;

  /** An enumeration. */
  type: EmploymentTypeSE;

  /**
   * @format date
   * @example 2019-01-20
   */
  start_date: string;

  /**
   * @format date
   * @example 2021-01-19
   */
  end_date?: string;

  /** @example 0771-30 44 47 */
  phone?: string;

  /** @example 65 */
  retirement_age?: number;

  /** @example 556953-5742 */
  organization_number?: string;
  profession?: string;
}

/**
 * An enumeration.
 */
export enum EmploymentType {
  Full = "full",
  Trial = "trial",
  Retired = "retired",
  Hourly = "hourly",
  EarlyRetired = "earlyRetired",
  Project = "project",
  SelfEmployed = "selfEmployed",
  CompanyOwner = "companyOwner",
  NoWork = "noWork",
  TemporarilyDischarged = "temporarilyDischarged",
  Student = "student",
  StandIn = "standIn",
  NorwegianSickLeave = "norwegianSickLeave",
  Disabled = "disabled",
  Other = "other",
}

/**
 * An enumeration.
 */
export type EmploymentTypeBase = string;

/**
 * An enumeration.
 */
export enum EmploymentTypeNO {
  Full = "full",
  SelfEmployed = "selfEmployed",
  Retired = "retired",
  TemporarilyDischarged = "temporarilyDischarged",
  Other = "other",
  Disabled = "disabled",
  Trial = "trial",
  Hourly = "hourly",
  Student = "student",
  NoWork = "noWork",
  StandIn = "standIn",
  Project = "project",
  NorwegianSickLeave = "norwegianSickLeave",
}

/**
 * An enumeration.
 */
export enum EmploymentTypeSE {
  Full = "full",
  Trial = "trial",
  Retired = "retired",
  Hourly = "hourly",
  EarlyRetired = "earlyRetired",
  Project = "project",
  SelfEmployed = "selfEmployed",
  CompanyOwner = "companyOwner",
  NoWork = "noWork",
}

/**
 * An enumeration.
 */
export enum EnqueuedJobStatus {
  Success = "success",
  Failure = "failure",
  Pending = "pending",
  InProgress = "in_progress",
}

export interface EnqueuedSubmissionJobResult {
  submission_id: string;

  /** An enumeration. */
  status: EnqueuedJobStatus;
  checklist?: Checklist;
}

export interface EnumDescription {
  /** The value of the enum */
  value: string | number;

  /** The English label of the enum */
  en_label: string;

  /** The Swedish label of the enum */
  sv_label: string;

  /** The Norwegian label of the enum */
  nb_label: string;
}

export interface EvCheckPayload {
  pnis: string[];
  reason: string;
}

export interface EvEstate {
  municipality?: string;
  municipality_number?: number;
  cadastralUnitNumber?: number;
  unitNumber?: number;
  leaseholdUnitNumber?: number;
  sectionNumber?: number;
  apartmentReference?: string;
  organizationNumber?: string;
  estimatedValue?: number;
  commonDebt?: number;
  estateType?: string;
  address?: EvEstateAddress;
}

export interface EvEstateAddress {
  streetName?: string;
  streetNumber?: number;
  streetLetter?: string;
  postCodeArea?: string;
  postCode?: string;
}

export interface EvPartialCommon {
  area_market_score?: number;
  municipality_score?: number;
  net_value_estimate?: number;
  last_known_common_debt?: number;
  cadastral_unit_number?: number;
  unit_number?: number;
  leasehold_unit_number?: number;
  section_number?: number;
}

export interface Event {
  /** An enumeration. */
  action: Action;

  /** @format date-time */
  timestamp: string;

  /** @example sms|5ce26c2450d832460390f580 */
  user_id?: string;
  data: ModelsApplicationMappingApplicationMappingData;

  /** @example MOSE000002 */
  application_id: string;

  /** @example 8b9c6b34-4893-11ec-90ad-774ba627c689 */
  event_id: string;
  request_id: string;
  zoordinates?: Zoordinates;
}

export interface EventsResponse {
  integrations: BankCommunication[];
}

export interface ExclusionRules {
  /** days to exclude lead since last extraction */
  global_extraction_policy_days?: number;

  /** days to exclude lead for same campaign extraction */
  local_extraction_policy_days?: number;

  /** days since customer was contacted in any campaign */
  global_contact_policy_days?: number;

  /** days since customer was contacted in same campaign */
  local_contact_policy_days?: number;
  exclude_blocked_numbers?: boolean;
  exclude_blocked_customers?: boolean;
  exclude_blocked_pnis?: boolean;

  /** An enumeration. */
  reservation_register_policy?: PolicyPreference;
}

export interface ExternalBlockCheckNO {
  email?: boolean;
  phone?: boolean;
  humanitarian?: boolean;
}

export interface ExternalProperty {
  estimatedValue?: number;
  marketValueUC?: number;
  marketValueBooli?: number;

  /** An enumeration. */
  propertyType?: AppsmgrMortgageSeSpecCommonDefinitionsPropertyType;

  /** If applicant is the only owner of the property. Required when propertyType is CONDOMINIUM and applicant is applying alone but has marital status MARRIED or REGISTERED_PARTNERSHIP */
  otherOwner?: boolean;

  /** Cadastral Designation. Only for propertyType HOUSE and VACATION_HOME, otherwise null */
  houseCadastralDesignation?: string;
  housingMonthlyCost?: number;
  squareMeters?: number;
  rooms?: number;

  /** If the property is a new production */
  newProduction?: boolean;

  /** If the applicant is the first owner of new production. Required if 'newProduction' is true. */
  firstOwner?: boolean;
  address: OptionalPropertyAddress;
  condominium?: CondominiumItem;
  external_id?: string;
}

export interface ExternallyVerifiedCredit {
  balance?: number;
  creditType?: string;
  creditLimit?: number;
  currency?: Currency;
  dataOld?: boolean;
  financialInstitutionId?: string;
  financialInstitutionName?: string;
  gjeldsregisteret_type?: string;
  hasCoBorrower?: boolean;
  installmentChargePeriod?: string;
  installmentCharges?: number;
  nonInterestBearingBalance?: number;
  interestBearingBalance?: number;
  isCoBorrower?: boolean;
  nominalInterestRate?: number;
  originalBalance?: number;

  /** @format date-time */
  processedTime?: string;

  /** @format date-time */
  receivedTime?: string;
  terms?: number;
}

export interface ExternallyVerifiedCreditWithRole {
  balance?: number;
  creditType?: string;
  creditLimit?: number;
  currency?: Currency;
  dataOld?: boolean;
  financialInstitutionId?: string;
  financialInstitutionName?: string;
  gjeldsregisteret_type?: string;
  hasCoBorrower?: boolean;
  installmentChargePeriod?: string;
  installmentCharges?: number;
  nonInterestBearingBalance?: number;
  interestBearingBalance?: number;
  isCoBorrower?: boolean;
  nominalInterestRate?: number;
  originalBalance?: number;

  /** @format date-time */
  processedTime?: string;

  /** @format date-time */
  receivedTime?: string;
  terms?: number;

  /** An enumeration. */
  role: ApplicantRole;
}

/**
 * An enumeration.
 */
export enum FailureOutcomes {
  IrrelevantLoans = "irrelevant_loans",
  OnlyMortgage = "only_mortgage",
  DebtFree = "debt_free",
  Click = "click",
  DoesNotWantToListen = "does_not_want_to_listen",
  WrongNumber = "wrong_number",
  NotInterested = "not_interested",
  LanguageBarrier = "language_barrier",
  FutureCallback = "future_callback",
  NotQualified = "not_qualified",
  Unemployed = "unemployed",
  CreditCheck = "credit_check",
  DebtRestructuring = "debt_restructuring",
  SwedishEnforcementAuthority = "swedish_enforcement_authority",
  PaymentRemarks = "payment_remarks",
  Deceased = "deceased",
  DoNotCall = "do_not_call",
}

export interface FieldMapping {
  lead_field: string;
  jotform_field: string;
  options_map?: any[][];
}

export interface FieldMappingExt {
  lead_field: string;
  jotform_field: string;
  options_map?: any[][];
  error?: string;
}

export interface Filter {
  /** An enumeration. */
  product?: Product;

  /** An enumeration. */
  country?: Country;

  /** An enumeration. */
  department?: ZDepartment;
  active?: boolean;
  creator_id?: string;
  campaign_ids?: string[];

  /** @format uuid */
  extraction_id?: string;

  /** @format uuid */
  exported_extraction_id?: string;
  reservation_register_policy?: PolicyPreference[];

  /** An enumeration. */
  campaign_type?: CampaignType;
}

export interface FilterBy {
  active?: boolean;
  state?: AppState[];
}

export interface FilterByPayload {
  filter_by?: FilterBy;
}

/**
 * An enumeration.
 */
export enum FilteringReason {
  BLOCK_LIST = "BLOCK_LIST",
  ALREADY_CONSUMED = "ALREADY_CONSUMED",
  EXTRACTION_LIMIT = "EXTRACTION_LIMIT",
}

export interface FilteringResult {
  reason: string;
  number_of_leads_before_filtering: number;
  number_of_leads_after_filtering: number;

  /** An enumeration. */
  filtering_reason: FilteringReason;
}

export interface Form {
  name: string;
  form_id: string;
  preferences: string[];
}

export interface FormApplicationSubmissionResult {
  /** @example true */
  ok: boolean;

  /** @example 53c6d004-a131-43dd-8118-69c5ba47fac5 */
  submission_id: string;
}

export interface FormCredit {
  amount: number;

  /** Bank ID */
  bankName: number;

  /** Loan type ID */
  loanType: number;

  /** @min 0 */
  monthlyCost: number;
  rate?: number;
  owner?: string;
}

export interface FormMapping {
  lead_fields: LeadField[];
  jotform_fields: JotformField[];
  mapping: FieldMappingExt[];
}

export interface FormPreference {
  form_preference_id: string;
  jotform_id: string;

  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;

  /** @format date-time */
  timestamp: string;

  /** @format date-time */
  deactivation_date?: string;
  mapping?: FieldMapping[];
}

export interface FormPreferenceExt {
  form_preference_id: string;
  jotform_id: string;

  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;

  /** @format date-time */
  timestamp: string;

  /** @format date-time */
  deactivation_date?: string;
  mapping?: FieldMappingExt[];
  valid?: boolean;
  unmapped?: string[];
  form_name?: string;
  has_webhook?: boolean;
}

export interface FormPreferencePayload {
  form_id: string;

  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;
  mapping: FieldMapping[];
}

export interface FormWebhookPayload {
  preference_id: string;
}

export interface GRIframeURL {
  url: string;
}

export interface GeneralMessage {
  type: "GENERAL_MESSAGE_RECEIVED";

  /**
   * @format date-time
   * @example 2022-01-19T13:13:52.541833
   */
  timestamp: string;

  /** An enumeration. */
  status: NotificationEvent;
  data: GeneralMessageData;

  /** @example a9eb4560-9628-4c84-9cd6-0b605ae2f5ee */
  notification_id: string;

  /** @example sms|5ce26c2450d832460390f580 */
  user_id?: string;
}

export interface GeneralMessageData {
  /** @example Hello there! */
  message: string;
}

export interface GetApplicationMessagesPayload {
  /** @example MOSE000001 */
  application_id?: string;
  limit?: number;

  /** @min 0 */
  page?: number;
}

export interface GetApplicationPayload {
  /** @example MOSE000001 */
  application_id: string;
}

export interface GetApplications {
  /** @min 0 */
  page: number;

  /** @min 0 */
  limit: number;

  /** An enumeration. */
  product?: Product;

  /** An enumeration. */
  country?: Country;
  bank_statuses?: BankStatus[];
  loan_purposes?: MortgageLoanType[];
}

export interface GetApplicationsByApplicantIdentifierPayload {
  /** @example 194907011813 */
  text?: string;
}

export interface GetApplicationsByCustomerIdentifierPayload {
  /** An enumeration. */
  country?: Country;

  /** An enumeration. */
  product?: Product;

  /** @example 194907011813 */
  pni?: string;

  /** @example +46761234567 */
  phone_number?: string;

  /** @example glenn.hysen@zensum.se */
  email?: string;
  pagination?: Pagination;
}

export interface GetApplicationsByCustomerIdentifierPayloadV2 {
  /** An enumeration. */
  country?: Country;

  /** An enumeration. */
  product?: Product;

  /** @example adbe81ae-4465-4103-9e6b-8d364aa4ca39 */
  customer_id: string;

  /** @example +46761234567 */
  phone_number?: string;

  /** @example glenn.hysen@zensum.se */
  email?: string;
  pagination?: Pagination;
}

export interface GetBanksPayload {
  /** @example 42 */
  bank_id?: number;

  /** An enumeration. */
  country?: Country;
}

export interface GetLeads {
  /**
   * @min 0
   * @example 0
   */
  page?: number;

  /** @example 10 */
  limit?: number;

  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;
  include_handled?: boolean;
  include_failed?: boolean;
  unassigned_only?: boolean;
}

export interface GetMeetings {
  /** @format date-time */
  gt?: string;

  /** @format date-time */
  lt?: string;

  /**
   * @min 0
   * @example 0
   */
  page?: number;

  /** @example 10 */
  limit?: number;

  /** @example mortgage */
  product?: Product;

  /** @example SE */
  country?: Country;

  /**
   * If true, will return apps and leads
   * @example false
   */
  with_apps?: boolean;

  /**
   * If true, will return customer name
   * @example false
   */
  with_customer_name?: boolean;

  /** @example MOSE000001 */
  application_id?: string | string;

  /** @example ["MOSE000001"] */
  application_ids?: (string | string)[];

  /** @example sms|5ce26c2450d832460390f580 */
  handler_id?: string;

  /** @example 641dbb08-4893-11ec-a1f0-c74a069a00b3 */
  customer_id?: string;

  /** @example true */
  with_handler_name?: boolean;
}

export interface GetMessages {
  customer_id?: string;
  phone_number?: string;
  pni?: string;
}

export interface GetMessagesPayload {
  limit?: number;

  /** @min 0 */
  page?: number;
}

export interface GetMyApplicationsPayload {
  /** An enumeration. */
  country?: Country;

  /** An enumeration. */
  product?: Product;
  statuses?: AppsmgrModelsStatusStatus[];
  substatuses?: Substatus[];
  loan_purposes?: MortgageLoanType[];
  unassigned_only?: boolean;
}

export interface GetMyLeads {
  /**
   * @min 0
   * @example 0
   */
  page?: number;

  /** @example 10 */
  limit?: number;

  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;
  include_handled?: boolean;
}

export interface GetMyMeetings {
  /** @format date-time */
  gt?: string;

  /** @format date-time */
  lt?: string;

  /**
   * @min 0
   * @example 0
   */
  page?: number;

  /** @example 10 */
  limit?: number;

  /** @example mortgage */
  product?: Product;

  /** @example SE */
  country?: Country;

  /**
   * If true, will return apps and leads
   * @example false
   */
  with_apps?: boolean;

  /**
   * If true, will return customer name
   * @example false
   */
  with_customer_name?: boolean;
}

export interface GetNameByPNIPayload {
  pni: string;
}

export interface GetRecentApplicationsPayload {
  /** An enumeration. */
  country?: Country;

  /** An enumeration. */
  product?: Product;
  statuses?: AppsmgrModelsStatusStatus[];
  substatuses?: Substatus[];
  loan_purposes?: MortgageLoanType[];
  unassigned_only?: boolean;
}

export interface GetTaxPayload {
  monthly_salary: number;
  key: string;

  /** An enumeration. */
  country: Country;
}

export interface GetTaxPayloadResponse {
  monthly_tax: number;
}

export interface GetUserMessagesPayload {
  customer_id: string;
  limit?: number;

  /** @min 0 */
  page?: number;
}

export interface GetUsersPayload {
  limit?: number;

  /** @min 0 */
  page?: number;
  bank_id?: number;
  without_deactivated?: boolean;
}

export interface GoalPayload {
  /**
   * What year the goal is set for
   * @example 2022
   */
  year: number;

  /**
   * Month from 1-12
   * @example 12
   */
  month: number;
  user_ids?: string[];
}

/**
 * An enumeration.
 */
export enum GoalType {
  BLANCO = "BLANCO",
  MORTGAGE = "MORTGAGE",
  INITIAL_BLANCO = "INITIAL_BLANCO",
  BLANCO_MB = "BLANCO_MB",
  BUDGET_HL = "BUDGET_HL",
  BUDGET_KA = "BUDGET_KA",
  BUDGET_SK = "BUDGET_SK",
  BUDGET_SP = "BUDGET_SP",
}

/**
* HTTP status codes and reason phrases

Status codes from the following RFCs are all observed:

    * RFC 7231: Hypertext Transfer Protocol (HTTP/1.1), obsoletes 2616
    * RFC 6585: Additional HTTP Status Codes
    * RFC 3229: Delta encoding in HTTP
    * RFC 4918: HTTP Extensions for WebDAV, obsoletes 2518
    * RFC 5842: Binding Extensions to WebDAV
    * RFC 7238: Permanent Redirect
    * RFC 2295: Transparent Content Negotiation in HTTP
    * RFC 2774: An HTTP Extension Framework
    * RFC 7725: An HTTP Status Code to Report Legal Obstacles
    * RFC 7540: Hypertext Transfer Protocol Version 2 (HTTP/2)
    * RFC 2324: Hyper Text Coffee Pot Control Protocol (HTCPCP/1.0)
    * RFC 8297: An HTTP Status Code for Indicating Hints
    * RFC 8470: Using Early Data in HTTP
*/
export type HTTPStatus =
  | 100
  | 101
  | 102
  | 103
  | 200
  | 201
  | 202
  | 203
  | 204
  | 205
  | 206
  | 207
  | 208
  | 226
  | 300
  | 301
  | 302
  | 303
  | 304
  | 305
  | 307
  | 308
  | 400
  | 401
  | 402
  | 403
  | 404
  | 405
  | 406
  | 407
  | 408
  | 409
  | 410
  | 411
  | 412
  | 413
  | 414
  | 415
  | 416
  | 417
  | 418
  | 421
  | 422
  | 423
  | 424
  | 425
  | 426
  | 428
  | 429
  | 431
  | 451
  | 500
  | 501
  | 502
  | 503
  | 504
  | 505
  | 506
  | 507
  | 508
  | 510
  | 511;

export interface HTTPValidationError {
  detail?: ValidationError[];
}

export interface HandledSubmission {
  submission_id: string;
  handled?: boolean;
  reviews?: Reviewer[];
}

export interface HeimdallCounterPair {
  /** @example 150 */
  allowed_count: number;

  /** @example 99 */
  current_count: number;
}

export interface HeimdallReportingPayload {
  /** @example apps */
  tracking_type: HeimdallTrackingType;

  /** @example [123,321] */
  ids: string[];
}

export interface HeimdallReportingResponse {
  /** @example false */
  rate_limit_exceeded: boolean;
}

export interface HeimdallResponse {
  /** @example sms|5ce26c2450d832460390f580 */
  user_id: string;

  /** @example 2022-08-25 */
  date: string;
  apps: HeimdallCounterPair;
  leads: HeimdallCounterPair;
  customers: HeimdallCounterPair;
  insurances: HeimdallCounterPair;
}

/**
 * An enumeration.
 */
export enum HeimdallTrackingType {
  Apps = "apps",
  Customers = "customers",
  Insurances = "insurances",
  Leads = "leads",
}

export interface House {
  property_id: string;

  /** @example 3600000 */
  value?: number;

  /** @example 3500000 */
  booli_value?: number;
  external_id?: string;

  /** @example HOUSE */
  property_type: "HOUSE";

  /** An enumeration. */
  country: Country;

  /** @example Storgatan 11A */
  street_address?: string;

  /** @example 12453 */
  post_code?: string;

  /** @example Bandhagen */
  city?: string;

  /** @example true */
  other_owner?: boolean;

  /** @example 9999 */
  monthly_cost?: number;

  /** @example 56 */
  square_meter_living_area?: number;

  /** @example Stockholm */
  municipality?: string;

  /** @example 018027 */
  municipality_code?: string;

  /** @example 6000000 */
  estimated_value?: number;
  latitude?: number;
  longitude?: number;
  ev_partial?: EvPartialCommon;

  /** @example 3:2 */
  cadastral_designation?: string;
}

/**
 * An enumeration.
 */
export enum HousingTypeNO {
  RENTED = "RENTED",
  OWN_HOUSE = "OWN_HOUSE",
  PARENTS = "PARENTS",
  CONDOMINIUM = "CONDOMINIUM",
  OWN_APARTMENT = "OWN_APARTMENT",
}

/**
 * An enumeration.
 */
export enum HousingTypeSE {
  RENTED = "RENTED",
  CONDOMINIUM = "CONDOMINIUM",
  LIVE_IN = "LIVE_IN",
  OWN_HOUSE = "OWN_HOUSE",
}

export interface IDCheckGetCustomerPayload {
  /** @example Creating a customer for an application */
  reason: string;

  /** An enumeration. */
  country?: Country;

  /** @example 194907011813 */
  pni: string;
  force_id_check?: boolean;
}

export interface IDCheckedPerson {
  /** An enumeration. */
  country: Country;

  /** @example 194907011813 */
  pni: string;

  /** @example Glenn */
  first_name?: string;

  /** @example Hysén */
  last_name?: string;

  /** @example Kungsgatan 31 */
  street_address?: string;

  /** @example 42132 */
  post_code?: string;

  /** @example Göteborg */
  city?: string;

  /** @example married */
  marital_status?: MaritalStatus;
  blocked?: boolean;

  /**
   * @min 1
   * @example 73
   */
  age?: number;
  block_list?: BlockList;
}

export interface IDKollenCallbackRequestSE {
  /** An enumeration. */
  result: CallbackResult;
  orderRef: string;
  pno?: string;
  name: string;
  checksum: string;
  refID: string;

  /** @format date */
  certStartDate?: string;
  givenName?: string;
  surname?: string;
  message?: string;
}

export interface ImpersonateCustomerPayload {
  /** @example 194808132221 */
  pni?: string;

  /** @example e6b0c1d2-3f4a-5b6c-7d8e-9f0a1b2c3d4e */
  customer_id?: string;
}

/**
 * An enumeration.
 */
export enum ImportStatus {
  NOT_STARTED = "NOT_STARTED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

export interface Income {
  /**
   * Monthly amount
   * @min 0
   * @example 10000
   */
  amount?: number;

  /**
   * Yearly amount
   * @min 0
   */
  yearly_amount?: number;

  /** @example SEK */
  currency?: Currency;

  /** @example employment */
  type: IncomeType;

  /** @example Zensum AB */
  name: string;
}

/**
 * An enumeration.
 */
export enum IncomeType {
  Rent = "rent",
  Other = "other",
  Employment = "employment",
  Partner = "partner",
}

/**
 * An enumeration.
 */
export enum IncomingInsuranceEvent {
  MANDATE_CANCELLED = "MANDATE_CANCELLED",
}

export interface IncomingSMS {
  message_id: string;

  /** @format date-time */
  timestamp: string;
  sender: string;
  message: string;
  customer_ids: string[];
  application_id?: string;
  message_type?: MessageType;
  direction?: ModelsMessageCommonDirection;
  phone_number?: string;
}

export interface InsuranceNotification {
  /** An enumeration. */
  type: IncomingInsuranceEvent;
  insurance_id: string;

  /** @format date-time */
  timestamp: string;

  /** An enumeration. */
  country: Country;
  customer_id: string;
}

export interface Integration {
  /** @example 42 */
  bank_id: number;

  /** @example SE */
  country: Country;

  /** @example mortgage */
  product: Product;

  /** @example Nordax */
  name: string;

  /** Allowed actions to be performed on this integration */
  actions: IntegrationAction[];
}

/**
 * An enumeration.
 */
export enum IntegrationAction {
  INVITE = "INVITE",
  AUTO_INVITE = "AUTO_INVITE",
  COMMENTS = "COMMENTS",
  DOCUMENTS = "DOCUMENTS",
  ACCEPT = "ACCEPT",
  CANCEL = "CANCEL",
}

export interface IntegrationId {
  /** @example 42 */
  bank_id: number;

  /** @example SE */
  country: Country;

  /** @example mortgage */
  product: Product;
}

export interface IntegrationQuery {
  /** An enumeration. */
  country?: Country;
  bank_id?: number;

  /** An enumeration. */
  product?: Product;
}

/**
 * An enumeration.
 */
export enum IntentionOfExcessAmount {
  BUYING_PROPERTY = "BUYING_PROPERTY",
  REPAYMENT_OTHER_LOANS = "REPAYMENT_OTHER_LOANS",
  RENOVATION_OF_PROPERTY = "RENOVATION_OF_PROPERTY",
  BUYING_CAPITAL_GOODS = "BUYING_CAPITAL_GOODS",
  OTHER_CONSUMPTION = "OTHER_CONSUMPTION",
}

export interface InterimLead {
  /** @format uuid */
  id?: string;
  data: DMLeadData;

  /** @format uuid */
  campaign_id: string;

  /** @format uuid */
  file_id?: string;

  /** @format uuid */
  job_id?: string;
  lead_type?: "COLD";

  /** @format date-time */
  imported_at?: string;

  /** @format date-time */
  extracted_at?: string;

  /** @format uuid */
  extraction_id?: string;
}

export interface InterimLeadJob {
  /** @format uuid */
  job_id: string;
  is_finished?: boolean;
  is_failed?: boolean;
}

export interface InterimLeadsInsertion {
  not_normalized_count?: number;
  duplicated_count?: number;
  inserted_count?: number;
}

export interface InternalCommentData {
  /** @example MOSE0000511 */
  application_id: string;
  from_user_id: string;
}

export interface InternalCommentWithName {
  /** @example sms|5ce26c2450d832460390f580 */
  user_id: string;

  /** @example The customer said that they wanted to do that */
  comment: string;

  /** @format date-time */
  timestamp: string;
  comment_id: string;
  action?: "INTERNAL_COMMENT_ADDED";

  /** @example Hamza Sabljaković */
  user_name: string;

  /** @example https://s.gravatar.com/avatar/f900a71f2bcbc2c65a42958724378bb3?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fte.png */
  user_avatar: string;
}

export interface InvitePayloadBase {
  /** @example MOSE000001 */
  application_id: string;

  /** @example 42 */
  bank_id: number;
  comment?: string;
  force?: boolean;
}

/**
 * An enumeration.
 */
export enum JobType {
  Scheduled = "scheduled",
  Failed = "failed",
  Started = "started",
}

export interface JoinedCampaignExt {
  /** @format uuid */
  campaign_id: string;

  /** @format date-time */
  joined_at: string;
  playing: boolean;

  /** @max 16 */
  color: number;
  stats: CampaignStats;
  campaign_data: ModelsDialMaker2CampaignDataModelsCampaignData;
}

export interface JotformCCApplication {
  /** An enumeration. */
  country: Country;
  data: OptionalCreditCardApplicationDataCreate;

  /** Model used only for mapping jotform data to Applicant model, allowing some more fields to be optional */
  applicant: OptionalCreateApplicantNO;
}

export interface JotformField {
  name: string;
  options?: string[];
}

export interface JotformLeadSource {
  type?: "JOTFORM";
  form_id: string;
  submission_id: string;
  error?: string;
}

export interface KDLTCallbackPayload {
  /** An enumeration. */
  event: KDLTEvent;
  customer_id: string;
  event_id: string;

  /** @format date-time */
  timestamp: string;
}

/**
 * An enumeration.
 */
export enum KDLTEvent {
  CUSTOMER_CREATED = "CUSTOMER_CREATED",
  CUSTOMER_UPDATED = "CUSTOMER_UPDATED",
  UC_ID_CHECK = "UC_ID_CHECK",
  UC_CREDIT_CHECK = "UC_CREDIT_CHECK",
  EXPERIAN_ID_CHECK = "EXPERIAN_ID_CHECK",
  EXPERIAN_CREDIT_CHECK = "EXPERIAN_CREDIT_CHECK",
  CM1PEPCHECK = "CM1_PEP_CHECK",
  GJELDSREGISTERET_CREDITS = "GJELDSREGISTERET_CREDITS",
  CUSTOMER_DELETED = "CUSTOMER_DELETED",
  CUSTOMER_ACCESSED = "CUSTOMER_ACCESSED",
  PEP_SANCTION_WHITELISTING = "PEP_SANCTION_WHITELISTING",
  DOCUMENT_ADDED = "DOCUMENT_ADDED",
  PROPERTY_EV_CHECK = "PROPERTY_EV_CHECK",
  MANUALLY_BLOCKED = "MANUALLY_BLOCKED",
}

export interface LastQuery {
  issuer_business_type?: string;
  issuer_name?: string;
  query_date?: string;
  uc_internal_information?: string;
  year?: string;
}

export interface Lead {
  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;
  lead_id: string;
  creator?: string;

  /** @format date-time */
  created_at: string;

  /** @format date-time */
  updated_at: string;
  handled: boolean;
  reprocessable?: boolean;
  create_source?:
    | JotformLeadSource
    | ApiLeadSource
    | AffiliateApiLeadSource
    | (JotformLeadSource & ApiLeadSource & AffiliateApiLeadSource);
  create_sources?: (
    | JotformLeadSource
    | ApiLeadSource
    | AffiliateApiLeadSource
    | (JotformLeadSource & ApiLeadSource & AffiliateApiLeadSource)
  )[];
  converted?: string[];
  data?: LeadCreationData;

  /** An enumeration. */
  source?: ApplicationSource;

  /** An enumeration. */
  deactivation_reason?: AppsmgrMortgageModelsApplicationDeactivationReason;
}

export interface LeadAssigned {
  type: "LEAD_ASSIGNED";

  /**
   * @format date-time
   * @example 2022-01-19T13:13:52.541833
   */
  timestamp: string;

  /** An enumeration. */
  status: NotificationEvent;
  data: LeadAssignedData;

  /** @example a9eb4560-9628-4c84-9cd6-0b605ae2f5ee */
  notification_id: string;

  /** @example sms|5ce26c2450d832460390f580 */
  user_id?: string;
}

export interface LeadAssignedData {
  /** @example LEADMOSE0000511 */
  lead_id: string;
}

export interface LeadComment {
  type: "LEAD_COMMENT_RECEIVED";

  /**
   * @format date-time
   * @example 2022-01-19T13:13:52.541833
   */
  timestamp: string;

  /** An enumeration. */
  status: NotificationEvent;
  data: LeadCommentData;

  /** @example a9eb4560-9628-4c84-9cd6-0b605ae2f5ee */
  notification_id: string;

  /** @example sms|5ce26c2450d832460390f580 */
  user_id?: string;
}

export interface LeadCommentData {
  /** @example LEADMOSE0000511 */
  lead_id: string;
}

export interface LeadCreationData {
  loan?: NewMortgageLoan;

  /**
   * In SE we can only refinance one existing mortgage so this object is the loan to be refinanced,
   * not used in NO
   */
  refinance_info?: RefinanceInfo;
  buying_info?: BuyingInfo;
  selling_info?: SellingInfo;
  applicants?: BareApplicantWithRole[];

  /** @example 79975430-f34c-4c78-addd-ac7d978106aa */
  property_id?: string;
  discount?: Discount;
  loans?: Loan[];
  other_mortgages?: MortgageLoan[];

  /** An enumeration. */
  status?: AppsmgrModelsStatusStatus;

  /** An enumeration. */
  substatus?: Substatus;

  /** An enumeration. */
  bank_status?: BankStatus;
  children_in_the_household?: number;
  children_in_the_household_fulltime?: number;
  other_properties_to_keep?: OtherProperty[];

  /** An enumeration. */
  co_relationship_to_main_applicant?: RelationshipStatus;

  /** An enumeration. */
  guarantor_relationship_to_main_applicant?: RelationshipStatus;
  cars?: AppsmgrMortgageSeSpecCommonDefinitionsCars;
  brokerage?: Brokerage;
  applicant?: LimitedApplicantSE | LimitedApplicantNO | (LimitedApplicantSE & LimitedApplicantNO);
  co_applicant?: LimitedApplicantSE | LimitedApplicantNO | (LimitedApplicantSE & LimitedApplicantNO);
  property?: ExternalProperty;
  comment?: string;

  /** @format ipvanyaddress */
  ip_address?: string;
}

export interface LeadField {
  name: string;
  options?: string[];
}

export interface LeadHandledPayload {
  lead_id: string;

  /** An enumeration. */
  deactivation_reason: AppsmgrMortgageModelsApplicationDeactivationReason;
}

/**
 * An enumeration.
 */
export enum LeadStatus {
  SUCCESS = "SUCCESS",
  PENDING = "PENDING",
  FAILED = "FAILED",
}

export interface LeadUpdatePayload {
  loan?: NewMortgageLoan;

  /**
   * In SE we can only refinance one existing mortgage so this object is the loan to be refinanced,
   * not used in NO
   */
  refinance_info?: RefinanceInfo;
  buying_info?: BuyingInfo;
  selling_info?: SellingInfo;
  applicants?: BareApplicantWithRole[];

  /** @example 79975430-f34c-4c78-addd-ac7d978106aa */
  property_id?: string;
  discount?: Discount;
  loans?: Loan[];
  other_mortgages?: MortgageLoan[];

  /** An enumeration. */
  status?: AppsmgrModelsStatusStatus;

  /** An enumeration. */
  substatus?: Substatus;

  /** An enumeration. */
  bank_status?: BankStatus;
  children_in_the_household?: number;
  children_in_the_household_fulltime?: number;
  other_properties_to_keep?: OtherProperty[];

  /** An enumeration. */
  co_relationship_to_main_applicant?: RelationshipStatus;

  /** An enumeration. */
  guarantor_relationship_to_main_applicant?: RelationshipStatus;
  cars?: AppsmgrMortgageSeSpecCommonDefinitionsCars;
  brokerage?: Brokerage;
  applicant?: LimitedApplicantSE | LimitedApplicantNO | (LimitedApplicantSE & LimitedApplicantNO);
  co_applicant?: LimitedApplicantSE | LimitedApplicantNO | (LimitedApplicantSE & LimitedApplicantNO);
  property?: ExternalProperty;
  comment?: string;
}

/**
 * An enumeration.
 */
export enum LeftToLiveFields {
  ExistingMortgage = "existing_mortgage",
  BuyingInfo = "buying_info",
  BooliValuation = "booli_valuation",
  GuarantorEmployer = "guarantor_employer",
  CoApplicantEmployer = "co_applicant_employer",
  MainApplicantEmployer = "main_applicant_employer",
  LoanPurpose = "loan_purpose",
  MortgageLoanAmount = "mortgage_loan_amount",
  NewMortgageLoan = "new_mortgage_loan",
  Property = "property",
  Applicant = "applicant",
  Municipality = "municipality",
  ExistingLoanAmount = "existing_loan_amount",
  ExistingLoanRefinance = "existing_loan_refinance",
  ExistingLoanResponsibility = "existing_loan_responsibility",
  ExistingLoanType = "existing_loan_type",
}

export interface LeftToLiveOutcome {
  /** TODO */
  message?: string;

  /** TODO */
  success?: boolean;

  /** TODO */
  loans?: LeftToLiveOutcomeLoan[];

  /** TODO */
  leftToLiveOriginalResult?: number;

  /** TODO */
  leftToLiveValue?: number;

  /** TODO */
  leftToLiveBudget?: number;

  /** TODO */
  leftToLiveResult?: number;

  /** TODO */
  requestedLoanAmount?: number;

  /** TODO */
  loanAmountAdjusted?: boolean;

  /** TODO */
  offeredLoanAmount?: number;

  /** TODO */
  debtToIncomeRatio?: number;
}

export interface LeftToLiveOutcomeLoan {
  /** TODO */
  monthlyPayment?: number;

  /** TODO */
  interestRate?: number;

  /** TODO */
  loanAmount?: number;

  /** TODO */
  loanType?: LoanTypeEnum;

  /** TODO */
  monthlyAmortization?: number;
}

export interface LeftToLivePayload {
  application_id: string;
  bank_id: number;
  force?: boolean;
}

export interface LeftToLiveResponse {
  outcome?: LeftToLiveOutcome;
  pre_offer?: MortgageRates;
  missing_required_fields?: LeftToLiveFields[];
  missing_optional_fields?: LeftToLiveFields[];
}

export interface LimitedApplicantNO {
  zid?: string;
  maklarpartner?: string;
  session_zid?: string;
  gid?: string;
  country?: "NO";

  /** @example 198001011234 */
  pni?: string;

  /** @example John */
  first_name?: string;

  /** @example Doe */
  last_name?: string;

  /** @example john@example.com */
  email?: string;

  /** @example +46701234567 */
  phone_number?: string;

  /**
   * @min 0
   * @example 10000
   */
  monthly_property_cost?: number;

  /** @example unmarried */
  marital_status?: MaritalStatus;

  /**
   * Official marital status from ID check; should not be modified; marital_status has higher priority
   * @example unmarried
   */
  registered_marital_status?: MaritalStatus;

  /** @example 12345 */
  post_code?: string;

  /** @example Stockholm */
  city?: string;
  incomes?: Income[];

  /** @example 10000 */
  net_monthly_income?: number;
  account?: Account;

  /** @example Street 1 */
  street_address?: string;

  /**
   * Number of children to pay child support for
   * @min 0
   * @max 10
   * @example 0
   */
  paying_child_support?: number;

  /**
   * Number of children to receive child support for
   * @min 0
   * @max 10
   * @example 0
   */
  receiving_child_support?: number;
  consents?: Consents;

  /** @example 198001011234 */
  partner_pni?: string;

  /** @example John Doe */
  partner_name?: string;

  /** @example 0115 */
  municipality_code?: string;

  /** @example Stockholm */
  municipality?: string;

  /** @example false */
  is_pep?: boolean;

  /**
   * @min 1
   * @example 73
   */
  age?: number;

  /** @example {"home":"+46701234567"} */
  other_phones?: PhoneNumber[];

  /** @example RENTED */
  housing_type?: HousingTypeNO;
  employer?: OptionalEmployerNO;

  /**
   * @format uuid
   * @example 123e4567-e89b-12d3-a456-426614174000
   */
  customer_id?: string;
}

export interface LimitedApplicantSE {
  zid?: string;
  maklarpartner?: string;
  session_zid?: string;
  gid?: string;
  country?: "SE";

  /** @example 198001011234 */
  pni?: string;

  /** @example John */
  first_name?: string;

  /** @example Doe */
  last_name?: string;

  /** @example john@example.com */
  email?: string;

  /** @example +46701234567 */
  phone_number?: string;

  /**
   * @min 0
   * @example 10000
   */
  monthly_property_cost?: number;

  /** @example unmarried */
  marital_status?: MaritalStatus;

  /**
   * Official marital status from ID check; should not be modified; marital_status has higher priority
   * @example unmarried
   */
  registered_marital_status?: MaritalStatus;

  /** @example 12345 */
  post_code?: string;

  /** @example Stockholm */
  city?: string;
  incomes?: Income[];

  /** @example 10000 */
  net_monthly_income?: number;
  account?: Account;

  /** @example Street 1 */
  street_address?: string;

  /**
   * Number of children to pay child support for
   * @min 0
   * @max 10
   * @example 0
   */
  paying_child_support?: number;

  /**
   * Number of children to receive child support for
   * @min 0
   * @max 10
   * @example 0
   */
  receiving_child_support?: number;
  consents?: Consents;

  /** @example 198001011234 */
  partner_pni?: string;

  /** @example John Doe */
  partner_name?: string;

  /** @example 0115 */
  municipality_code?: string;

  /** @example Stockholm */
  municipality?: string;

  /** @example false */
  is_pep?: boolean;

  /**
   * @min 1
   * @example 73
   */
  age?: number;

  /** @example {"home":"+46701234567"} */
  other_phones?: PhoneNumber[];

  /** @example RENTED */
  housing_type?: HousingTypeSE;
  employer?: OptionalEmployerSE;

  /**
   * @format uuid
   * @example 123e4567-e89b-12d3-a456-426614174000
   */
  customer_id?: string;
}

export interface Loan {
  /** An enumeration. */
  currency: Currency;

  /**
   * @format uuid4
   * @example f0f5749d-cfbc-4966-8640-457ed9971685
   */
  loan_id: string;

  /** @example 100000 */
  amount?: number;

  /** @example 21 */
  bank_id?: number;

  /** @example true */
  refinance?: boolean;

  /**
   * @min 0
   * @example 100000
   */
  refinanceAmount?: number;

  /** An enumeration. */
  loan_type?: LoanType;

  /**
   * @min 0
   * @example 3000
   */
  monthly_payment?: number;

  /** @example 3.3 */
  rate?: number;

  /**
   * @min 0
   * @example 2000
   */
  monthly_amortisation?: number;

  /** An enumeration. */
  responsibility?: AppsmgrMortgageSeSpecCommonDefinitionsResponsibility;

  /** @min 0 */
  credit_limit?: number;

  /**
   * @min 0
   * @example 49
   */
  monthly_administrative_fee?: number;
}

export interface LoanAndExternallyVerifiedCredit {
  externally_verified_credits: ExternallyVerifiedCreditWithRole[];
  loans: Loan[];
}

/**
 * An enumeration.
 */
export enum LoanPurpose {
  Refinance = "refinance",
  HomeRemodelling = "homeRemodelling",
  HealthcareExpenses = "healthcareExpenses",
  DivorceProceeding = "divorceProceeding",
  HomeDownpayment = "homeDownpayment",
  Investment = "investment",
  Education = "education",
  Travel = "travel",
  Car = "car",
  Other = "other",
  DriversLicense = "driversLicense",
  Wedding = "wedding",
  Relocation = "relocation",
  Interior = "interior",
  Consumption = "consumption",
  DebtCollection = "debtCollection",
  LoanOnBehalfOfOther = "loan-on-behalf-of-other",
  InvestmentAbroad = "investment-abroad",
}

/**
 * An enumeration.
 */
export enum LoanPurposeNO {
  Refinance = "refinance",
  HomeRemodelling = "homeRemodelling",
  HealthcareExpenses = "healthcareExpenses",
  DivorceProceeding = "divorceProceeding",
  HomeDownpayment = "homeDownpayment",
  Investment = "investment",
  Education = "education",
  Travel = "travel",
  Car = "car",
  Other = "other",
  DriversLicense = "driversLicense",
  Wedding = "wedding",
  Relocation = "relocation",
  Interior = "interior",
  Consumption = "consumption",
  DebtCollection = "debtCollection",
}

/**
 * An enumeration.
 */
export enum LoanPurposeSE {
  Refinance = "refinance",
  HomeRemodelling = "homeRemodelling",
  HealthcareExpenses = "healthcareExpenses",
  DivorceProceeding = "divorceProceeding",
  HomeDownpayment = "homeDownpayment",
  Investment = "investment",
  Education = "education",
  Travel = "travel",
  Car = "car",
  Other = "other",
  DriversLicense = "driversLicense",
  Wedding = "wedding",
  Relocation = "relocation",
  Interior = "interior",
  Consumption = "consumption",
  DebtCollection = "debtCollection",
  LoanOnBehalfOfOther = "loan-on-behalf-of-other",
  InvestmentAbroad = "investment-abroad",
}

/**
 * An enumeration.
 */
export enum LoanType {
  CREDIT_CARD = "CREDIT_CARD",
  UNSECURED_LOAN = "UNSECURED_LOAN",
  CAR_LOAN = "CAR_LOAN",
  CHECK_CREDIT = "CHECK_CREDIT",
  OTHER = "OTHER",
  STUDENT_LOAN = "STUDENT_LOAN",
  INSTALLMENT = "INSTALLMENT",
  TOP_MORTGAGE_LOAN = "TOP_MORTGAGE_LOAN",
  MEMBER_LOAN = "MEMBER_LOAN",
  MORTGAGE = "MORTGAGE",
}

/**
 * An enumeration.
 */
export enum LoanTypeEnum {
  UNSECURED_LOAN = "UNSECURED_LOAN",
  MORTGAGE = "MORTGAGE",
}

export interface Login {
  /**
   * @format email
   * @example glenn.hysen@banken.se
   */
  username: string;

  /**
   * @format password
   * @example wi2sES6EFNmPc1YP
   */
  password: string;
}

export interface LoginPayload {
  pni?: string;
  callback_url?: string;
  callback_fail_url?: string;
  country?: Country;
  product?: Product;
}

export interface LoginResp {
  /** @example w1csQgJwd97PKQ6x44b3zUFxldJtyS71 */
  session_id: string;
}

/**
 * An enumeration.
 */
export enum MaritalStatus {
  Unmarried = "unmarried",
  Married = "married",
  Divorced = "divorced",
  WidowWidower = "widow/widower",
  Deceased = "deceased",
  ChildUnder18Years = "child under 18 years",
  PreviouslyMarried = "previously married",
  RegisteredPartnership = "registered partnership",
  Partner = "partner",
}

export interface MeetingWithApp {
  /** @format date-time */
  meeting_start: string;

  /** @format date-time */
  meeting_end: string;

  /** @example sms|5ce26c2450d832460390f580 */
  handler_id?: string;

  /** @example Please bring some paper of some sort */
  meeting_notes?: string;

  /** @example Introduction to the Zensum Way */
  meeting_subject?: string;

  /** @example 73f670d8-4893-11ec-a8c1-2bcfc7bae96a */
  customer_id?: string;

  /** @example MOSE000001 */
  application_id: string | string;

  /** @example a479492e-4893-11ec-97fc-43be61ad8715 */
  meeting_id: string;

  /** @format date-time */
  last_updated: string;

  /** @format date-time */
  date_created: string;

  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;

  /** @example Glenn Hysén */
  customer_name?: string;

  /** @example John Doe */
  handler_name?: string;
  application?: AppBase | Lead | (AppBase & Lead);
}

export interface MeetingWithHandlerName {
  /** @format date-time */
  meeting_start: string;

  /** @format date-time */
  meeting_end: string;

  /** @example sms|5ce26c2450d832460390f580 */
  handler_id?: string;

  /** @example Please bring some paper of some sort */
  meeting_notes?: string;

  /** @example Introduction to the Zensum Way */
  meeting_subject?: string;

  /** @example 73f670d8-4893-11ec-a8c1-2bcfc7bae96a */
  customer_id?: string;

  /** @example MOSE000001 */
  application_id: string | string;

  /** @example a479492e-4893-11ec-97fc-43be61ad8715 */
  meeting_id: string;

  /** @format date-time */
  last_updated: string;

  /** @format date-time */
  date_created: string;

  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;

  /** @example Glenn Hysén */
  customer_name?: string;

  /** @example John Doe */
  handler_name?: string;
}

/**
 * An enumeration.
 */
export enum MessageType {
  SMS = "SMS",
  EMAIL = "EMAIL",
}

export interface MinimalApplicant {
  /** An enumeration. */
  role: ApplicantRole;
  pni: string;
}

export interface MortgageBankEventsResponse {
  bank_events: BankEventsMortgageOfferExt[];
}

export interface MortgageDeactivatePayload {
  application_id: string;

  /** An enumeration. */
  reason: AppsmgrMortgageModelsApplicationDeactivationReason;
}

export interface MortgageDeactivationReviewsResponse {
  reasons: AppsmgrMortgageModelsApplicationDeactivationReason[];
}

export interface MortgageFormPayload {
  /** @example John */
  givenName: string;

  /** @example Doe */
  lastName: string;

  /** @example 0772244466 */
  phoneNumber: string;

  /**
   * @format email
   * @example name@mail.com
   */
  email: string;

  /** @example SampleBank */
  bankName: string;

  /** @example 100000 */
  loanAmount: number;
}

export interface MortgageGoal {
  /** An enumeration. */
  type_event: GoalType;
  user_id?: string[];

  /** An enumeration. */
  country: Country;

  /**
   * What year the goal is set for
   * @example 2022
   */
  year: number;

  /**
   * Month from 1-12
   * @example 12
   */
  month: number;

  /** @format date-time */
  timestamp: string;
}

export interface MortgageLeads {
  amount: number;
}

export interface MortgageLoan {
  bank_id?: number;
  monthly_cost?: number;
  loan_amount?: number;
  refinance?: boolean;
  responsibility?:
    | AppsmgrMortgageSeSpecCommonDefinitionsResponsibility
    | AppsmgrMortgageNoSpecCommonDefinitionsResponsibility
    | (AppsmgrMortgageSeSpecCommonDefinitionsResponsibility & AppsmgrMortgageNoSpecCommonDefinitionsResponsibility);
  rate?: number;
}

/**
 * An enumeration.
 */
export enum MortgageLoanType {
  REFINANCE = "REFINANCE",
  PRE_APPROVAL = "PRE_APPROVAL",
  BUY = "BUY",
  BUY_AND_SELL = "BUY_AND_SELL",
}

export interface MortgageOfferExt {
  offeredAmount: number;

  /** An enumeration. */
  currency: Currency;
  bindingPeriodMonth: number;
  interestRate: number;
  discount: number;

  /** An enumeration. */
  amortizationRule: AmortizationRule;
  monthlyAmortization: number;
  invoiceFee?: number;
  setupFee?: number;
  autogiroFee?: number;
  amortizationLength?: number;
  maxOfferedAmount?: number;
  mustRefinance?: number;
  effectiveInterestRate?: number;
  monthlyPayment?: number;
  arrangementFee?: number;
  termFee?: number;
  termMonths?: number;
  downPaymentLoanAmount?: number;
  downPaymentLoanInterestRate?: number;
  bridgeLoanAmount?: number;
  bridgeLoanInterestRate?: number;
  firstMonthlyPayment?: number;
}

/**
 * An enumeration.
 */
export enum MortgagePropertyType {
  HOUSE = "HOUSE",
  CONDOMINIUM = "CONDOMINIUM",
  VACATION_HOME = "VACATION_HOME",
}

export interface MortgageRates {
  /** TODO */
  loanAmount?: number;

  /** TODO */
  marketValue?: number;

  /** TODO */
  bindingPeriodMonth?: number;

  /** TODO */
  interestRateAfterDiscount?: number;

  /** TODO */
  interestRate?: number;

  /** TODO */
  monthlyAmortization?: number;
}

export interface Municipality {
  /** @example 12312312312312 */
  id: string;

  /**
   * Used to get the correct table
   * @example 32
   */
  key: string;

  /** @example VALLENTUNA */
  description: string;

  /** @example 0115 */
  municipality_code: string;

  /** An enumeration. */
  country: Country;
}

export interface MyDisbursedLoans {
  amount: number;
  sum: number;
  average_sum: number;

  /** An enumeration. */
  currency: Currency;
  average_rate?: number;
  average_year?: number;
  average_disbursed_time?: number;
}

export interface MyStats {
  accepted?: AcceptedLoans;
  disbursed?: MyDisbursedLoans;
  insurance?: AllInsurances;
  mortgage_leads?: MortgageLeads;
}

export interface MyStatsMb {
  applications: number;
  applications_per_day: number;
  sent_loans: number;
  signed: number;
  disbursed: number;
  co_applicants: number;
  disbursed_amount: number;
  signed_amount: number;
  sent_amount: number;
  co_applicant_percentage: number;
  disbursement_rate: number;
  average_team_applications: number;
  average_team_disbursed: number;

  /** An enumeration. */
  currency: Currency;
}

export type MyStatsShared = MyStats | MyStatsMb | (MyStats & MyStatsMb);

export interface NOApplicationForm {
  /**
   * @min 0
   * @example 8
   */
  "example-loan-payback-time"?: number;

  /**
   * @min 0
   * @example 150 000
   */
  "loan-amount-text-field"?: number;

  /**
   * @min 0
   * @example 190 000
   */
  "total-loan-amount"?: number;

  /**
   * @min 0
   * @example 150000
   */
  slider?: number;

  /** @example true */
  "refinance-question"?: boolean;

  /** @example 150 000 */
  "refinance-amount"?: number;
  "original-loan-purpose"?: string;

  /** @example unmarried */
  "marital-status"?: MaritalStatus;

  /** @example 3 */
  "number-of-children"?: number;

  /** @example 15000 kr */
  "rent-part"?: string;

  /** @example full */
  "employment-type"?: EmploymentType;

  /** @example EmployerName */
  employer?: string;

  /** @example 2020 */
  "employed-year"?: string;

  /** @example 03 */
  "employed-month"?: string;

  /** @example  */
  "employed-to-year"?: string;

  /** @example  */
  "employed-to-month"?: string;

  /** @example Mining */
  "company-industry"?: string;

  /**
   * @format email
   * @example name@mail.com
   */
  email?: string;

  /** @example 450909-9802 */
  ssn?: string;

  /** @example false */
  "email-marketing"?: boolean;

  /** @example false */
  "sms-marketing"?: boolean;

  /** @example false */
  "customer-club-marketing"?: boolean;

  /** @example false */
  "applicant-pep"?: boolean;

  /** @example true */
  "ms-enabled"?: boolean;

  /** @example unmarried */
  "ms-marital-status"?: MaritalStatus;

  /** @example 2 */
  "ms-number-of-children"?: string;

  /**
   * @min 0
   * @example 10 000 kr
   */
  "ms-rent-part"?: number;

  /** @example full */
  "ms-employment-type"?: EmploymentType;

  /** @example EmployerName */
  "ms-employer"?: string;

  /** @example 2010 */
  "ms-employed-year"?: string;

  /** @example 05 */
  "ms-employed-month"?: string;

  /** @example  */
  "ms-employed-to-year"?: string;

  /** @example  */
  "ms-employed-to-month"?: string;

  /** @example  */
  "ms-company-industry"?: string;

  /**
   * @format email
   * @example ms_name@mail.com
   */
  "ms-email"?: string;

  /** @example 630214-0410 */
  "ms-ssn"?: string;

  /** @example false */
  "ms-applicant-pep"?: boolean;

  /** @example true */
  "is-new-loan-form"?: boolean;
  credits?: FormCredit[];

  /** @example other */
  "loan-purpose"?: LoanPurposeNO;

  /** @example 0 */
  "norsk-statsborger"?: boolean;

  /** @example 2001 */
  "lived-in-country-since-year"?: string;

  /** @example 09 */
  "lived-in-country-since-month"?: string;

  /** @example OWN_HOUSE */
  "housing-status"?: AppsmgrBlancoNoSpecPrivateUnsecuredLoanApplicationCreatedHousingType;

  /** @example OWN_HOUSE */
  "housing-type"?: HousingTypeNO;

  /** @example 0763222000 */
  "phone-number"?: string;

  /**
   * @min 0
   * @example 300 000 kr
   */
  "salary-yearly"?: number;

  /**
   * @min 0
   * @example 20000 kr
   */
  "other-income"?: number;

  /**
   * @min 0
   * @example 20000 kr
   */
  "partners-income-amount"?: number;
  "ms-norsk-statsborger"?: boolean;
  "ms-lived-in-country-since-year"?: string;
  "ms-lived-in-country-since-month"?: string;

  /** @example OWN_HOUSE */
  "ms-housing-status"?: AppsmgrBlancoNoSpecPrivateUnsecuredLoanApplicationCreatedHousingType;

  /** @example OWN_HOUSE */
  "ms-housing-type"?: HousingTypeNO;

  /** @example 0763222000 */
  "ms-phone-number"?: string;

  /**
   * @min 0
   * @example 300 000 kr
   */
  "ms-salary-yearly"?: number;

  /**
   * @min 0
   * @example 20000 kr
   */
  "ms-other-income"?: number;
}

export interface Name {
  /** @example Pelle Jönsson */
  name: string;
}

export interface NewAppOption {
  /** @example Mål med jämförelse */
  id: string;

  /** @example ["Sänkt ränta","Sänkt månadsbetalning"] */
  options: string[];
}

export interface NewMortgageLoan {
  mortgage_loan_amount?: number;
  down_payment?: number;
  down_payment_loan_amount?: number;
  bridge_loan_amount?: number;
  disbursement_date?: string;

  /** An enumeration. */
  applying_with?: ApplyingWith;

  /** An enumeration. */
  loan_purpose?: MortgageLoanType;

  /** An enumeration. */
  intention_of_excess_amount?: IntentionOfExcessAmount;
  monthly_cost_of_excess_amount?: number;
  max_amount?: boolean;

  /** An enumeration. */
  situation?: Situation;
  private_loan_amount?: number;
}

export interface NewPartialProperty {
  /** An enumeration. */
  property_type: MortgagePropertyType;
  country?: string;
  monthly_cost?: number;
  square_meter_living_area?: number;
  estimated_value?: number;
  municipality?: string;
  municipality_code?: string;
}

/**
 * An enumeration.
 */
export enum NoContactOutcomes {
  NotConnected = "not_connected",
  Busy = "busy",
  AnsweringMachine = "answering_machine",
  NoAnswer = "no_answer",
}

export interface Note {
  cause_description?: string;
  year?: string;
}

/**
 * An enumeration.
 */
export enum NotificationEvent {
  CREATED = "CREATED",
  RECEIVED = "RECEIVED",
  READ = "READ",
  DELETED = "DELETED",
}

export interface OTPValidation {
  /**
   * @format password
   * @example 6UgJgSycUoI6r7J7QppGBywZw4T6VtUn
   */
  session_id: string;

  /**
   * @format password
   * @example 250267
   */
  otp: string;
}

export interface OTPValidationResp {
  /** @example eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImdsZW5uLmh5c2VuQGJhbmtlbi5zZSIsImJhbmtfaWQiOjIxLCJ1c2VyX2lkIjoiOGUwZjQwOTYtZDNiNS00MGQwLTg0YWYtYjc5M2QzNjVhNWQzIiwiZXhwIjoxNjE5NDI3Mjk0fQ.MYuTwf_kvXZ0zt9P4VM4OMzYiUU17k5cShzfEOFPwRQ */
  token: string;
}

export interface Offer {
  id: string;
  bank_id: number;
  status_id: number;
  rate?: number;
  sum?: number;
  status_name: string;
  external_offer_id?: string;
  amortization_plan: string;
  sum_to_solve?: number;
  monthly_payment: number;
  admin_fee?: number;
  setup_fee?: number;
  apr?: number;

  /** @format date-time */
  created_at: string;
  need_more_info?: boolean;

  /** Payback time in months */
  payback_time: number;
  direct_debit_fee?: number;
  is_accepted?: boolean;
}

export interface OfferReceived {
  type: "OFFER_RECEIVED";

  /**
   * @format date-time
   * @example 2022-01-19T13:13:52.541833
   */
  timestamp: string;

  /** An enumeration. */
  status: NotificationEvent;
  data: OfferReceivedData;

  /** @example a9eb4560-9628-4c84-9cd6-0b605ae2f5ee */
  notification_id: string;

  /** @example sms|5ce26c2450d832460390f580 */
  user_id?: string;
}

export interface OfferReceivedData {
  /** @example MOSE0000511 */
  application_id: string;
}

export interface Option {
  /** @example Mål med jämförelse */
  id: string;

  /** @example Sänkt ränta */
  option: string;
}

export interface OptionalAffiliateApplicant {
  /**
   * Personal national identifier fo the customer
   * @example 196103018039
   */
  pni: string;

  /** @example MAIN_APPLICANT */
  role: AffiliateApplicantRole;
  occupation: AffiliateEmployer | AffiliateNotEmployed;
  incomes: AffiliateIncome[];

  /** @example +46761234567 */
  phone_number: string;

  /** @format email */
  email: string;

  /**
   * How does the person live
   * @example RENTED
   */
  currently_living_in?: AffiliateHousingType;

  /**
   * Marital status of a person
   * @example MARRIED
   */
  marital_status: AffiliateMaritalStatus;
}

export interface OptionalAffiliateApplicantBlanco {
  /**
   * Personal national identifier fo the customer
   * @example 196103018039
   */
  pni: string;

  /** @example MAIN_APPLICANT */
  role: AffiliateApplicantRole;
  occupation: AffiliateEmployer | AffiliateNotEmployed;
  incomes: AffiliateIncome[];

  /** @example +46761234567 */
  phone_number: string;

  /** @format email */
  email: string;

  /**
   * How does the person live
   * @example RENTED
   */
  currently_living_in: AffiliateHousingType;

  /**
   * Marital status of a person
   * @example MARRIED
   */
  marital_status: AffiliateMaritalStatus;

  /**
   * How much does the person pay for their housing, full SEK
   * @min 0
   * @example 5500
   */
  currently_living_in_cost: number;
}

/**
 * Model used only for mapping jotform data to Applicant model, allowing some more fields to be optional
 */
export interface OptionalCreateApplicantNO {
  country?: "NO";

  /** @example 198001011234 */
  pni: string;

  /** @example John */
  first_name?: string;

  /** @example Doe */
  last_name?: string;

  /** @example john@example.com */
  email?: string;

  /** @example +46701234567 */
  phone_number?: string;

  /**
   * @min 0
   * @example 10000
   */
  monthly_property_cost?: number;

  /** @example unmarried */
  marital_status?: MaritalStatus;

  /**
   * Official marital status from ID check; should not be modified; marital_status has higher priority
   * @example unmarried
   */
  registered_marital_status?: MaritalStatus;

  /** @example 12345 */
  post_code?: string;

  /** @example Stockholm */
  city?: string;
  incomes?: Income[];

  /** @example 10000 */
  net_monthly_income?: number;
  account?: Account;

  /** @example Street 1 */
  street_address?: string;

  /**
   * Number of children to pay child support for
   * @min 0
   * @max 10
   * @example 0
   */
  paying_child_support?: number;

  /**
   * Number of children to receive child support for
   * @min 0
   * @max 10
   * @example 0
   */
  receiving_child_support?: number;
  consents?: Consents;

  /** @example 198001011234 */
  partner_pni?: string;

  /** @example John Doe */
  partner_name?: string;

  /** @example 0115 */
  municipality_code?: string;

  /** @example Stockholm */
  municipality?: string;

  /** @example false */
  is_pep?: boolean;

  /**
   * @min 1
   * @example 73
   */
  age?: number;

  /** @example {"home":"+46701234567"} */
  other_phones?: PhoneNumber[];

  /** @example 123456 */
  sverker_id?: number;

  /** @example 1 */
  children?: number;

  /** @example 1 */
  citizen?: number;

  /** @example elementarySchool */
  education?: EducationType;

  /** @example 10000 */
  monthly_partner_income?: number;

  /** @format date */
  immigrated_at?: string;

  /** @example John Doe */
  fullname?: string;
  documents?: ApplicantDocument[];
  verified_credits?: boolean;

  /** @example 2019-01-01 */
  housing_since?: string;

  /** @example false */
  deceased?: boolean;

  /** @example false */
  emigrated?: boolean;

  /** @example false */
  is_sanction?: boolean;

  /** @example false */
  is_rca?: boolean;

  /** @format date-time */
  date_created?: string;

  /** @format date-time */
  date_updated?: string;

  /** @format date-time */
  last_credit_check?: string;

  /** @format date-time */
  last_externally_verified_credits?: string;
  pep_quality?: boolean;

  /** A cluster is a group of customers displayed with a color */
  cluster?: string;

  /** @example RENTED */
  housing_type?: HousingTypeNO;
  employer?: OptionalEmployerNO;
}

export interface OptionalCreditCardApplicationDataCreate {
  desired_credit_limit?: number;
  car?: boolean;
  student_loans_amount?: number;
  student_loans_monthly_payment?: number;
  car_boat_mc_loans_amount?: number;
  car_boat_mc_loans_monthly_payment?: number;
  total_consumer_loans_amount?: number;
  total_consumer_loans_monthly_payment?: number;
  mortgage_loans_amount?: number;
  mortgage_loans_monthly_payment?: number;
  credit_card_debt_amount?: number;
  credit_card_debt_monthly_payment?: number;
  children_in_the_household_fulltime?: number;
}

export interface OptionalEmployerNO {
  name?: string;

  /** An enumeration. */
  type?: EmploymentTypeNO;

  /** @format date */
  start_date?: string;

  /**
   * @format date
   * @example 2021-01-19
   */
  end_date?: string;

  /** @example 0771-30 44 47 */
  phone?: string;

  /** @example 65 */
  retirement_age?: number;

  /** @example 556953-5742 */
  organization_number?: string;
  profession?: string;
}

export interface OptionalEmployerSE {
  name?: string;

  /** An enumeration. */
  type?: EmploymentTypeSE;

  /** @format date */
  start_date?: string;

  /**
   * @format date
   * @example 2021-01-19
   */
  end_date?: string;

  /** @example 0771-30 44 47 */
  phone?: string;

  /** @example 65 */
  retirement_age?: number;

  /** @example 556953-5742 */
  organization_number?: string;
  profession?: string;
}

export interface OptionalPropertyAddress {
  /** Street address of property  */
  streetAddress?: string;

  /** City of the property */
  city?: string;

  /** Postal code of the property */
  postalCode?: string;
  municipality?: string;
}

export interface OptionalQuickApplicant {
  /**
   * Personal national identifier fo the customer
   * @example 196103018039
   */
  pni?: string;

  /** An enumeration. */
  role?: ApplicantRole;
  employer?: OptionalQuickApplicantEmployer;
  incomes?: Income[];

  /** @example +46761234567 */
  phone_number?: string;

  /** @format email */
  email?: string;

  /**
   * How does the person live
   * @example OWN_HOUSE
   */
  housing_type?: HousingTypeSE | HousingTypeNO | (HousingTypeSE & HousingTypeNO);

  /**
   * How much does the person pay for their housing, full SEK
   * @min 0
   * @example 5500
   */
  currently_living_in_cost?: number;

  /** Marital status of a person */
  marital_status?: MaritalStatus;

  /** An enumeration. */
  education?: EducationType;

  /**
   * NORWAY only - when immigrated to Norway
   * @format date
   */
  immigrated_at?: string;

  /** NORWAY only - is applicant Norway citizen or not */
  citizenship?: boolean;
}

export interface OptionalQuickApplicantEmployer {
  name?: string;

  /** @example full */
  type?: EmploymentType | EmploymentTypeBase | (EmploymentType & EmploymentTypeBase);

  /** @format date */
  start_date?: string;

  /**
   * @format date
   * @example 2021-01-19
   */
  end_date?: string;

  /** @example 0771-30 44 47 */
  phone?: string;

  /** @example 65 */
  retirement_age?: number;

  /** @example 556953-5742 */
  organization_number?: string;
  profession?: string;
}

export interface OptionalQuickChildren {
  childrenBelow18?: number;

  /**
   * @min 0
   * @max 10
   */
  childrenBelow18FullTime?: number;

  /**
   * @min 0
   * @max 10
   */
  receivingChildSupport?: number;

  /**
   * @min 0
   * @max 10
   */
  payingChildSupport?: number;
}

export type OptionalQuickCreateApplication =
  | OptionalQuickCreateMortgageApplication
  | OptionalQuickCreateBlancoApplication;

export interface OptionalQuickCreateBlancoApplication {
  product: "blanco";
  new_loan?: BlancoLoan;

  /** Sverker user when creating a legacy blanco app */
  sverker_user?: SverkerUsername;
  aml?: BlancoAMLPatchPayload;

  /**
   * Desired loan amount
   * @example 100000
   */
  desired_amount?: number;

  /** An enumeration. */
  country: Country;

  /** @format date-time */
  meeting_start?: string;

  /** @format date-time */
  meeting_end?: string;
  meeting_subject?: string;
  should_remind_about_meeting?: boolean;
  applicants: OptionalQuickApplicant[];
  loans?: Loan[];
  children?: OptionalQuickChildren;
  internal_comment?: string;
  comments?: string[];
  new_app_options?: Option[];
  new_app_checklist?: string[];

  /** An enumeration. */
  source?: ApplicationSource;
  desired_payback_time?: number;
  consents?: Consents;
}

export interface OptionalQuickCreateMortgageApplication {
  product: "mortgage";
  new_loan?: BlancoLoan;

  /**
   * Desired loan amount
   * @example 100000
   */
  desired_amount?: number;

  /** An enumeration. */
  country: Country;

  /** @format date-time */
  meeting_start?: string;

  /** @format date-time */
  meeting_end?: string;
  meeting_subject?: string;
  should_remind_about_meeting?: boolean;
  applicants: OptionalQuickApplicant[];
  loans?: Loan[];
  children?: OptionalQuickChildren;
  internal_comment?: string;
  comments?: string[];
  new_app_options?: Option[];
  new_app_checklist?: string[];

  /** An enumeration. */
  source?: ApplicationSource;
  desired_payback_time?: number;
  consents?: Consents;
}

export interface Order {
  created_at?: "asc" | "desc";
  updated_at?: "asc" | "desc";
}

export interface OtherProperty {
  monthly_cost: number;
  mortgage_amount?: number;

  /** An enumeration. */
  property_type: AppsmgrModelsApplicationPropertyType;
  estimated_value?: number;
  property_ownership_share?: number;
  loan_ownership_share?: number;
  interest_rate?: number;
  monthly_amortization?: number;
  lender?: string;
}

export interface OutcomeCount {
  users: UserOutcomeCount[];
  total: UserOutcomeCount;
}

/**
 * An enumeration.
 */
export enum OutcomeType {
  SUCCESS = "SUCCESS",
  CALL_BACK = "CALL_BACK",
  NO_CONTACT = "NO_CONTACT",
  FAILURE = "FAILURE",
}

export interface Outcomes {
  no_contact: string[];
  failure: string[];
}

export interface PageCampaignExtraction {
  items: CampaignExtraction[];

  /** @min 0 */
  total: number;

  /** @min 1 */
  page?: number;

  /** @min 1 */
  size?: number;

  /** @min 0 */
  pages?: number;
}

export interface PageCampaign {
  items: ModelsDialMaker2CampaignAggregateCampaign[];

  /** @min 0 */
  total: number;

  /** @min 1 */
  page?: number;

  /** @min 1 */
  size?: number;

  /** @min 0 */
  pages?: number;
}

export interface PageCreditCardApplicationExtended {
  items: CreditCardApplicationExtended[];

  /** @min 0 */
  total: number;

  /** @min 1 */
  page?: number;

  /** @min 1 */
  size?: number;

  /** @min 0 */
  pages?: number;
}

export interface PageDMLead {
  items: DMLead[];

  /** @min 0 */
  total: number;

  /** @min 1 */
  page?: number;

  /** @min 1 */
  size?: number;

  /** @min 0 */
  pages?: number;
}

export interface PageSheet {
  items: Sheet[];

  /** @min 0 */
  total: number;

  /** @min 1 */
  page?: number;

  /** @min 1 */
  size?: number;

  /** @min 0 */
  pages?: number;
}

export interface Pagination {
  /** @min 0 */
  page?: number;

  /** @min 0 */
  limit?: number;
}

export interface PartialCondominium {
  /** @example CONDOMINIUM */
  property_type: "CONDOMINIUM";

  /** An enumeration. */
  country: Country;

  /** @example Storgatan 11A */
  street_address?: string;

  /** @example 12453 */
  post_code?: string;

  /** @example Bandhagen */
  city?: string;

  /** @example true */
  other_owner?: boolean;

  /** @example 9999 */
  monthly_cost?: number;

  /** @example 56 */
  square_meter_living_area?: number;

  /** @example Stockholm */
  municipality?: string;

  /** @example 018027 */
  municipality_code?: string;

  /** @example 6000000 */
  estimated_value?: number;
  external_id?: string;
  latitude?: number;
  longitude?: number;
  ev_partial?: EvPartialCommon;

  /** @example 1001 */
  apartment_number?: string;

  /** @example true */
  elevator?: boolean;

  /** @example 556953-5742 */
  organization_number?: string;

  /** @example Brf Svanen */
  organization_name?: string;

  /** @example 3 */
  floor?: number;

  /** @example PATIO */
  balcony_type?: BalconyType;
  rooms?: number;
}

export interface PartialHouse {
  /** @example HOUSE */
  property_type: "HOUSE";

  /** An enumeration. */
  country: Country;

  /** @example Storgatan 11A */
  street_address?: string;

  /** @example 12453 */
  post_code?: string;

  /** @example Bandhagen */
  city?: string;

  /** @example true */
  other_owner?: boolean;

  /** @example 9999 */
  monthly_cost?: number;

  /** @example 56 */
  square_meter_living_area?: number;

  /** @example Stockholm */
  municipality?: string;

  /** @example 018027 */
  municipality_code?: string;

  /** @example 6000000 */
  estimated_value?: number;
  external_id?: string;
  latitude?: number;
  longitude?: number;
  ev_partial?: EvPartialCommon;

  /** @example 3:2 */
  cadastral_designation?: string;
}

export interface PartialProperty {
  property_id: string;

  /** An enumeration. */
  property_type: MortgagePropertyType;
  country?: string;
  monthly_cost?: number;
  square_meter_living_area?: number;
  estimated_value?: number;
  municipality?: string;
  municipality_code?: string;
}

export interface PartialVacationHome {
  /** @example VACATION_HOME */
  property_type: "VACATION_HOME";

  /** An enumeration. */
  country: Country;

  /** @example Storgatan 11A */
  street_address?: string;

  /** @example 12453 */
  post_code?: string;

  /** @example Bandhagen */
  city?: string;

  /** @example true */
  other_owner?: boolean;

  /** @example 9999 */
  monthly_cost?: number;

  /** @example 56 */
  square_meter_living_area?: number;

  /** @example Stockholm */
  municipality?: string;

  /** @example 018027 */
  municipality_code?: string;

  /** @example 6000000 */
  estimated_value?: number;
  external_id?: string;
  latitude?: number;
  longitude?: number;
  ev_partial?: EvPartialCommon;

  /** @example 3:2 */
  cadastral_designation?: string;
}

/**
 * These fields only appear in pipeline
 */
export interface Person {
  zid: string;
  session_zid?: string;
  pni?: string | File;
  customer_id?: string;
  gid?: string;
  affiliate_id?: string;

  /** An enumeration. */
  product?: Product;

  /** An enumeration. */
  country?: Country;
  landing_params?: object;
  landing_url?: string;
  cookie_consent?: object;

  /** An enumeration. */
  status: PersonStatus;

  /** @format date-time */
  last_activity: string;

  /** @format date-time */
  initialized_at: string;

  /** @format date-time */
  last_application_created_at?: string;

  /** @format date-time */
  last_disbursed_at?: string;
}

/**
 * An enumeration.
 */
export enum PersonStatus {
  INITIALIZED = "INITIALIZED",
  WEBSITE_VISIT = "WEBSITE_VISIT",
  LEAD_CREATED = "LEAD_CREATED",
  APPLICATION_CREATED = "APPLICATION_CREATED",
  INVITE = "INVITE",
  OFFER_ACCEPTED = "OFFER_ACCEPTED",
  OFFER = "OFFER",
  DISBURSED = "DISBURSED",
  DISCARDED = "DISCARDED",
}

export interface PersonalCallback {
  /** @format date-time */
  first_at: string;

  /** @format date-time */
  last_at: string;
  count: number;
}

export interface PhoneGetCustomerPayload {
  /** @example Creating a customer for an application */
  reason: string;

  /** @example +46761234567 */
  phone_number: string;
}

export interface PhoneNumber {
  number: string;

  /** An enumeration. */
  type: PhoneNumberType;
}

/**
 * An enumeration.
 */
export enum PhoneNumberType {
  Home = "home",
  Day = "day",
  Work = "work",
  Other = "other",
}

export interface PniGetCustomerPayload {
  /** @example Creating a customer for an application */
  reason: string;

  /** An enumeration. */
  country?: Country;

  /** @example 194907011813 */
  pni: string;
}

/**
 * An enumeration.
 */
export enum PolicyPreference {
  EXCLUDE = "EXCLUDE",
  INCLUDE = "INCLUDE",
  DONTCARE = "DONTCARE",
}

export interface PollResp {
  verified: boolean;

  /** @format date-time */
  timestamp?: string;
}

export interface PrefsResponse {
  statuses?: AppsmgrModelsStatusStatus[];
  substatuses?: Substatus[];
  countries?: Country[];
  property_types?: MortgagePropertyType[];
  new_app_checklist: Record<string, Record<string, string[]>>;
  new_app_options: Record<string, Record<string, NewAppOption[]>>;
  loan_types?: LoanType[];
}

export interface PreviousApplication {
  application_id: string;
  status?: Substatus | AppState | (Substatus & AppState);

  /** An enumeration. */
  role?: ApplicantRole;

  /** @format date-time */
  created_at?: string;

  /** @format date-time */
  completed_at?: string;
}

export interface PreviousApplicationsList {
  mortgage: PreviousApplication[];
  blanco: PreviousApplication[];
  credit_card: PreviousApplication[];
}

/**
 * An enumeration.
 */
export enum Product {
  Blanco = "blanco",
  Mortgage = "mortgage",
  CreditCard = "credit_card",
}

export interface PropertyBeingSold {
  selling_contract_signed?: boolean;
  property_price?: number;
  existing_mortgage_amount?: number;
  real_estate_agent_fee?: number;
}

export interface PropertyInfo {
  /** An enumeration. */
  property_type: MortgagePropertyType;

  /** @example YmMwOGM1YjQtYmI5ZC00NTk4LWEzZGEtNWE0MTlkMGM2NTY4OkNPTkRPTUlOSVVN */
  id: string;
  apartments?: Apartment[];

  /** @example Storgatan 11A */
  street_address: string;

  /** @example 12453 */
  post_code: string;

  /** @example Bandhagen */
  city: string;

  /** An enumeration. */
  country: Country;
  municipality_code: string;

  /** @example Stockholm */
  municipality: string;
  organization_name?: string;
  organization_number?: string;
  external_id?: string;
}

export interface PropertySearchResult {
  /** @example 4f27c7de-4893-11ec-b7e6-43cc8d62d663 */
  id: string;

  /** @example Storgatan 11A, Billdal, Brf 30082 */
  description: string;
}

export interface PropertyValuation {
  /** An enumeration. */
  property_type: MortgagePropertyType;

  /** @example 71872518-4489-497a-82e4-88a6c938a4a2 */
  property_id: string;

  /** @example 58 */
  living_area?: number;

  /** @example 1001 */
  apartment_number?: string;

  /** @example 40ba7c00-4893-11ec-aa78-1336c1c3c76c */
  external_id?: string;

  /** @example Stockholm */
  municipality: string;

  /** @example 018027 */
  municipality_code: string;

  /** @example 85 */
  square_meter_living_area: number;
  latitude?: number;
  longitude?: number;

  /** @example 3600000 */
  value?: number;

  /** @example 3500000 */
  booli_value?: number;
}

export interface PublisherData {
  publisher_id: string;

  /** An enumeration. */
  callback_trigger: PersonStatus;

  /** An enumeration. */
  touch: Touch;
  callback_time_limit_in_days: number;

  /** An enumeration. */
  callback_trigger_blanco?: PersonStatus;

  /** An enumeration. */
  callback_trigger_mortgage?: PersonStatus;

  /** An enumeration. */
  callback_trigger_credit_card?: PersonStatus;
}

export interface QuickApplicant {
  /**
   * Personal national identifier fo the customer
   * @example 196103018039
   */
  pni: string;

  /** An enumeration. */
  role: ApplicantRole;
  employer: QuickApplicantEmployer;
  incomes: Income[];

  /** @example +46761234567 */
  phone_number: string;

  /** @format email */
  email: string;

  /**
   * How does the person live
   * @example OWN_HOUSE
   */
  housing_type: HousingTypeSE | HousingTypeNO | (HousingTypeSE & HousingTypeNO);

  /**
   * How much does the person pay for their housing, full SEK
   * @min 0
   * @example 5500
   */
  currently_living_in_cost: number;

  /** Marital status of a person */
  marital_status: MaritalStatus;

  /** An enumeration. */
  education?: EducationType;

  /**
   * NORWAY only - when immigrated to Norway
   * @format date
   */
  immigrated_at?: string;

  /** NORWAY only - is applicant Norway citizen or not */
  citizenship?: boolean;

  /** @example 30000 */
  net_monthly_income?: number;
}

export interface QuickApplicantEmployer {
  /** @example Zensum AB */
  name: string;

  /** @example full */
  type?: EmploymentType | EmploymentTypeBase | (EmploymentType & EmploymentTypeBase);

  /** @format date */
  start_date?: string;

  /**
   * @format date
   * @example 2021-01-19
   */
  end_date?: string;

  /** @example 0771-30 44 47 */
  phone?: string;

  /** @example 65 */
  retirement_age?: number;

  /** @example 556953-5742 */
  organization_number?: string;
  profession?: string;
}

export interface QuickChildren {
  /**
   * Number of children under the age of 18
   * @min 0
   * @max 10
   */
  childrenBelow18: number;

  /**
   * @min 0
   * @max 10
   */
  childrenBelow18FullTime?: number;

  /**
   * @min 0
   * @max 10
   */
  receivingChildSupport?: number;

  /**
   * @min 0
   * @max 10
   */
  payingChildSupport?: number;
}

export type QuickCreateApplication = QuickCreateMortgageApplication | QuickCreateBlancoApplication;

export interface QuickCreateBlancoApplication {
  product: "blanco";
  new_loan?: BlancoLoan;

  /** Sverker user when creating a legacy blanco app */
  sverker_user?: SverkerUsername;
  aml?: BlancoAMLPatchPayload;

  /**
   * Desired loan amount
   * @example 100000
   */
  desired_amount?: number;

  /** An enumeration. */
  country: Country;

  /** @format date-time */
  meeting_start?: string;

  /** @format date-time */
  meeting_end?: string;
  meeting_subject?: string;
  should_remind_about_meeting?: boolean;
  applicants: QuickApplicant[];
  loans: Loan[];
  children: QuickChildren;
  internal_comment?: string;

  /** @example ["Good luck!"] */
  comments?: string[];
  new_app_options: Option[];

  /** @example ["Jag har kontrollerat att kunden är folkbokförd i sverige? (Bosatt i sverige i minst ett år)","Kunden har bekräftat att hen inte är PEP","Medgivande kreditupplysning","Bekräftat identitet på huvudsökande","Kund samtycker att vi sparar hens kontaktuppgifter","Jag har informerat kunden att samtalet spelas in för kundens säkerhet och utbildningssyfte"] */
  new_app_checklist: string[];

  /** An enumeration. */
  source: ApplicationSource;
  desired_payback_time?: number;
  consents?: Consents;
}

export interface QuickCreateMortgageApplication {
  product: "mortgage";
  new_loan?: BlancoLoan;

  /**
   * Desired loan amount
   * @example 100000
   */
  desired_amount?: number;

  /** An enumeration. */
  country: Country;

  /** @format date-time */
  meeting_start?: string;

  /** @format date-time */
  meeting_end?: string;
  meeting_subject?: string;
  should_remind_about_meeting?: boolean;
  applicants: QuickApplicant[];
  loans: Loan[];
  children: QuickChildren;
  internal_comment?: string;

  /** @example ["Good luck!"] */
  comments?: string[];
  new_app_options: Option[];

  /** @example ["Jag har kontrollerat att kunden är folkbokförd i sverige? (Bosatt i sverige i minst ett år)","Kunden har bekräftat att hen inte är PEP","Medgivande kreditupplysning","Bekräftat identitet på huvudsökande","Kund samtycker att vi sparar hens kontaktuppgifter","Jag har informerat kunden att samtalet spelas in för kundens säkerhet och utbildningssyfte"] */
  new_app_checklist: string[];

  /** An enumeration. */
  source: ApplicationSource;
  desired_payback_time?: number;
  consents?: Consents;
}

export interface RatePart {
  /** An enumeration. */
  rate_type: RateType;
  amount?: number;
  rate?: number;
  monthly_payment?: number;

  /** @format date */
  until?: string;
  loanNumber?: string;

  /** @format date */
  conditionRolloverDate?: string;
  monthlyAmortisation?: number;
}

/**
 * An enumeration.
 */
export enum RateType {
  Fixed = "fixed",
  Flexible = "flexible",
  Mixed = "mixed",
}

export interface ReactivatePayload {
  application_id: string;
  comment: string;
}

/**
* In SE we can only refinance one existing mortgage so this object is the loan to be refinanced,
not used in NO
*/
export interface RefinanceInfo {
  current_bank_id: number;
  amount?: number;
  rate?: number;
  monthly_payment?: number;
  rate_parts?: RatePart[];

  /** An enumeration. */
  rate_type?: RateType;
  ownershipShareOfLoan?: number;
  mortgageBank?: string;
  amortisationRuleBeforeMarch2018?: boolean;
}

/**
 * An enumeration.
 */
export enum RelationshipStatus {
  Spouse = "spouse",
  Child = "child",
  Parent = "parent",
  Partner = "partner",
}

export interface ReprocessResult {
  lead_id: string;

  /** An enumeration. */
  status: ReprocessStatus;
  error?: string;
  details?: string;
}

/**
 * An enumeration.
 */
export enum ReprocessStatus {
  Success = "success",
  Failure = "failure",
  Pending = "pending",
}

export interface ReprocessSubmissionPayload {
  lead_ids: string[];
}

export interface RequestNewOTP {
  /** @example Hp4csHxr9a4xTFsih7g3BqemfFdVGwql2qieU_3EwJwdgc_21itLPAAacRIn_XMjtIGbZA */
  token: string;
}

export interface ResetPasswordPayload {
  user_id: string;
}

export interface ResubmitPayload {
  submission_id: string;

  /** An enumeration. */
  country: Country;
  parsed_form:
    | (QuickCreateBlancoApplication | QuickCreateMortgageApplication)
    | CreateCreditCardApplicationPayloadWithApplicant
    | ((QuickCreateBlancoApplication | QuickCreateMortgageApplication) &
        CreateCreditCardApplicationPayloadWithApplicant);
}

export interface RetryPolicy {
  retry_count?: number;
  retry_interval_minutes?: number;
}

export interface ReviewSubmissions {
  /**
   * List of submission ids
   * @example ["7dc06e65-63e4-4aa5-9e2e-1a7c3b8eb640","0b4915ad-b220-4cea-a4e6-65f352097f26"]
   */
  submission_ids: string[];

  /**
   * Mark submissions as handled or not
   * @example true
   */
  handled?: boolean;
}

export interface Reviewer {
  user_id: string;

  /** @format date-time */
  timestamp: string;
}

/**
 * An enumeration.
 */
export enum RoleType {
  EmployeeAdmin = "employee:admin",
  PartnerAdmin = "partner:admin",
  MortgageAdmin = "mortgage:admin",
  LegalAdmin = "legal:admin",
  ZensumSakerReadSalesStats = "zensum-saker:read:sales-stats",
  ZakerInsuranceCreate = "zaker:insurance:create",
  Admin = "admin",
  ImpersonateCustomer = "impersonate-customer",
  REMOTE_ACCESS = "REMOTE_ACCESS",
  READ_BLANCO_SALES_STATS = "READ_BLANCO_SALES_STATS",
  READ_MORTGAGE_SALES_STATS = "READ_MORTGAGE_SALES_STATS",
  InsuranceAdmin = "insurance:admin",
  OnlineAdmin = "online:admin",
  MbAdmin = "mb:admin",
  KdltAdmin = "kdlt:admin",
  DataAdmin = "data:admin",
  TemplateAdmin = "template:admin",
  AffiliateAdmin = "affiliate:admin",
  Developer = "developer",
  TmCampaignAdmin = "tm-campaign:admin",
  TmCampaignRead = "tm-campaign:read",
  DialmakerAdmin = "dialmaker:admin",
  TeamLead = "team-lead",
}

export interface RqJobStatusResponse {
  job_id?: string;
  queue?: string;

  /** @format date-time */
  created_at?: string;
  description?: string;
  exception_info?: string;
  retries_left?: number;
  retry_intervals?: number[];
  retry_at?: string[];
  status?: string;
}

export interface SEApplicationForm {
  /**
   * @min 0
   * @example 8
   */
  "example-loan-payback-time"?: number;

  /**
   * @min 0
   * @example 150 000
   */
  "loan-amount-text-field"?: number;

  /**
   * @min 0
   * @example 190 000
   */
  "total-loan-amount"?: number;

  /**
   * @min 0
   * @example 150000
   */
  slider?: number;

  /** @example true */
  "refinance-question"?: boolean;

  /** @example 150 000 */
  "refinance-amount"?: number;
  "original-loan-purpose"?: string;

  /** @example unmarried */
  "marital-status"?: MaritalStatus;

  /** @example 3 */
  "number-of-children"?: number;

  /** @example 15000 kr */
  "rent-part"?: string;

  /** @example full */
  "employment-type"?: EmploymentType;

  /** @example EmployerName */
  employer?: string;

  /** @example 2020 */
  "employed-year"?: string;

  /** @example 03 */
  "employed-month"?: string;

  /** @example  */
  "employed-to-year"?: string;

  /** @example  */
  "employed-to-month"?: string;

  /** @example Mining */
  "company-industry"?: string;

  /**
   * @format email
   * @example name@mail.com
   */
  email?: string;

  /** @example 450909-9802 */
  ssn?: string;

  /** @example false */
  "email-marketing"?: boolean;

  /** @example false */
  "sms-marketing"?: boolean;

  /** @example false */
  "customer-club-marketing"?: boolean;

  /** @example false */
  "applicant-pep"?: boolean;

  /** @example true */
  "ms-enabled"?: boolean;

  /** @example unmarried */
  "ms-marital-status"?: MaritalStatus;

  /** @example 2 */
  "ms-number-of-children"?: string;

  /**
   * @min 0
   * @example 10 000 kr
   */
  "ms-rent-part"?: number;

  /** @example full */
  "ms-employment-type"?: EmploymentType;

  /** @example EmployerName */
  "ms-employer"?: string;

  /** @example 2010 */
  "ms-employed-year"?: string;

  /** @example 05 */
  "ms-employed-month"?: string;

  /** @example  */
  "ms-employed-to-year"?: string;

  /** @example  */
  "ms-employed-to-month"?: string;

  /** @example  */
  "ms-company-industry"?: string;

  /**
   * @format email
   * @example ms_name@mail.com
   */
  "ms-email"?: string;

  /** @example 630214-0410 */
  "ms-ssn"?: string;

  /** @example false */
  "ms-applicant-pep"?: boolean;

  /** @example true */
  "is-new-loan-form"?: boolean;
  credits?: FormCredit[];

  /** @example other */
  "loan-purpose"?: LoanPurpose;

  /** @example OWN_HOUSE */
  "housing-status"?: AppsmgrBlancoSeSpecPrivateUnsecuredLoanApplicationCreatedHousingType;

  /** @example OWN_HOUSE */
  "housing-type"?: HousingTypeSE;

  /** @example 0763222000 */
  "phone-number"?: string;

  /**
   * @min 0
   * @example 25 000 kr
   */
  salary?: number;

  /** @example OWN_HOUSE */
  "ms-housing-status"?: AppsmgrBlancoSeSpecPrivateUnsecuredLoanApplicationCreatedHousingType;

  /** @example OWN_HOUSE */
  "ms-housing-type"?: HousingTypeSE;

  /** @example 0763222000 */
  "ms-phone-number"?: string;

  /**
   * @min 0
   * @example 25 000 kr
   */
  "ms-salary"?: number;
}

export interface SMSReceived {
  type: "SMS_RECEIVED";

  /**
   * @format date-time
   * @example 2022-01-19T13:13:52.541833
   */
  timestamp: string;

  /** An enumeration. */
  status: NotificationEvent;
  data: SMSReceivedData;

  /** @example a9eb4560-9628-4c84-9cd6-0b605ae2f5ee */
  notification_id: string;

  /** @example sms|5ce26c2450d832460390f580 */
  user_id?: string;
}

export interface SMSReceivedData {
  /** @example MOSE0000511 */
  application_id?: string;

  /** @example ["e4dae345-1109-49e7-bb18-b76efe3f104f"] */
  customer_ids: string[];
}

export interface SavedAttachment {
  file_id: string;
  name?: string;
}

export interface SavedMessage {
  /** An enumeration. */
  message_type: MessageType;
  message_id: string;
  customer_id?: string;
  application_id?: string | string;
  request_id?: string;

  /** @format date-time */
  timestamp: string;

  /** An enumeration. */
  direction: ModelsMessageCommonDirection;
  user_id?: string;
  message?: string;
  sender?: string;
  template_name?: string;
  template_vars?: object;
  customer_ids?: string[];
}

export interface SavedMessageWithName {
  /** An enumeration. */
  message_type: MessageType;
  message_id: string;
  customer_id?: string;
  application_id?: string | string;
  request_id?: string;

  /** @format date-time */
  timestamp: string;

  /** An enumeration. */
  direction: ModelsMessageCommonDirection;
  user_id?: string;
  message?: string;
  sender?: string;
  template_name?: string;
  template_vars?: object;
  customer_ids?: string[];
  sender_name: string;
}

export interface ScheduleSlot {
  /**
   * @format time
   * @example 09:00
   */
  start: string;

  /**
   * @format time
   * @example 12:00
   */
  end: string;

  /** @min 0 */
  available_slots_per_hour: number;
}

export interface SearchLeadsPayload {
  campaign_ids?: string[];

  /** An enumeration. */
  country?: Country;

  /** An enumeration. */
  product?: Product;

  /** An enumeration. */
  department?: ZDepartment;
  user_ids?: string[];

  /** @format date-time */
  start?: string;

  /** @format date-time */
  end?: string;
  outcomes?: OutcomeType[];
  failure_sub_outcomes?: FailureOutcomes[];
  no_contact_sub_outcomes?: NoContactOutcomes[];

  /** An enumeration. */
  status?: LeadStatus;
  order?: "asc" | "desc";
  search?: string;
}

/**
 * An enumeration.
 */
export enum SearchType {
  APPLICATION_ID = "APPLICATION_ID",
  PORTAL_APP_ID = "PORTAL_APP_ID",
  PERSONAL_DATA = "PERSONAL_DATA",
  EXTERNAL_ID = "EXTERNAL_ID",
}

export interface SellingInfo {
  property_being_sold: PropertyBeingSold[];
}

export interface SendRawPayload {
  /** When MessageType.SMS, pass either phone_number or customer_id */
  customer_id?: string;

  /** Only for MessageType.SMS, pass either phone_number or customer_id */
  phone_number?: string;
  application_id_or_lead_id?: string | string;
  message: string;
  data?: RoutersMessagePayloadData;
  subject?: string;

  /**
   * Only for MessageType.SMS without customer_id
   * @example SE
   */
  country?: Country;
}

export interface SendTemplatePayload {
  /** When MessageType.SMS, pass either phone_number or customer_id */
  customer_id?: string;

  /** Only for MessageType.SMS, pass either phone_number or customer_id */
  phone_number?: string;

  /** @example ULSE000001 */
  application_id?: string;
  data?: RoutersMessagePayloadData;

  /**
   * Only for MessageType.SMS without customer_id
   * @example SE
   */
  country?: Country;
}

export interface SetPassword {
  /**
   * @format password
   * @example 127018
   */
  otp: string;

  /** @example Hp4csHxr9a4xTFsih7g3BqemfFdVGwql2qieU_3EwJwdgc_21itLPAAacRIn_XMjtIGbZA */
  token: string;

  /**
   * @format password
   * @example cKDeXQeVV22a4DLI
   */
  password: string;
}

export interface SetPasswordResp {
  success: true;
}

/**
 * An enumeration.
 */
export enum ShareNameConsent {
  NO_CONSENT = "NO_CONSENT",
  INITIALS_ONLY = "INITIALS_ONLY",
  FULL_NAMES = "FULL_NAMES",
}

export type SharedTemplate = EmailTemplate | SmsTemplate | (EmailTemplate & SmsTemplate);

export interface Sheet {
  /** @format date-time */
  uploaded_at: string;

  /** An enumeration. */
  type: SheetType;
  name?: string;

  /** @format uuid */
  sheet_id: string;
  separator?: string;

  /** @example {"sheet_header":"DMLeadData_field"} */
  mapping?: Record<string, string>;
  uploaded_sheet_preview?: SheetPreviewBase;
  import_status?: ImportStatus;
  import_details?: InterimLeadsInsertion;
  import_error_msg?: string;

  /** @format date-time */
  imported_at?: string;
}

/**
* Helper class that provides a standard way to create an ABC using
inheritance.
*/
export interface SheetCampaignSource {
  type?: "SHEET";
  sheets: Sheet[];
}

export interface SheetPreview {
  headers: string[];
  model_fields: string[];
  preview: Record<string, string | Record<string, string>>[];

  /**
   * Sheet ID which is needed in extraction endpoint.
   * @format uuid
   */
  sheet_id: string;
  file_name: string;

  /** An enumeration. */
  file_type: SheetType;

  /**
   * Date when file was uploaded.
   * @format date-time
   */
  uploaded_at: string;
}

export interface SheetPreviewBase {
  headers: string[];
  model_fields: string[];
  preview: Record<string, string | Record<string, string>>[];
}

/**
 * An enumeration.
 */
export enum SheetType {
  XLSX = "XLSX",
  CSV = "CSV",
}

/**
 * An enumeration.
 */
export enum SigningStatus {
  SIGNING_INITIATED = "SIGNING_INITIATED",
  SIGNING_REQUESTED = "SIGNING_REQUESTED",
  SIGNING_SUCCEEDED = "SIGNING_SUCCEEDED",
  SIGNING_FAILED = "SIGNING_FAILED",
  UNKNOWN = "UNKNOWN",
}

/**
 * An enumeration.
 */
export enum Situation {
  SOLD = "SOLD",
  WILL_SELL = "WILL_SELL",
  ONLY_BUY = "ONLY_BUY",
}

export interface Slots {
  /**
   * @format date-time
   * @example 2022-01-19T13:14:52.247222
   */
  start_date: string;
}

export interface SmsTemplate {
  name: string;
  message_type?: MessageType;

  /** @format date-time */
  timestamp?: string;
  comment?: string;
  deleted?: boolean;
  attachment_ids?: string[];
  body: string;
}

export interface SubmissionReview {
  submission_id: string;
  handled?: boolean;
  reviews?: Reviewer[];
  success?: boolean;
  ongoing?: boolean;

  /** @format date-time */
  submission_timestamp: string;
  raw_data: object;

  /** An enumeration. */
  country: Country;

  /** An enumeration. */
  product: Product;
  request_id: string;
  checklist?: Checklist;
  parsed_form?: NOApplicationForm | SEApplicationForm | (NOApplicationForm & SEApplicationForm);
  quick_application?: OptionalQuickCreateApplication;
  parsed_application?: JotformCCApplication;
  application_id?: string;
  gid?: string;
  zid?: string;
  session_zid?: string;
  gid_list?: string;
  affiliate_id?: string;
  http_request_metadata?: object;
  cc_converted_blanco_app_id?: string;

  /** An enumeration. */
  cc_conversion_status?: ConvertToBlancoStatus;
}

export interface SubmissionReviewResponse {
  submissions: BasicSubmissionReview[];
  count: number;
}

/**
 * An enumeration.
 */
export enum SubmissionStatus {
  Error = "error",
  AppCreated = "app_created",
  AppNotAllowed = "app_not_allowed",
}

/**
 * An enumeration.
 */
export enum Substatus {
  DRAFT = "DRAFT",
  UNKNOWN = "UNKNOWN",
  OFFERED = "OFFERED",
  ACCEPTED = "ACCEPTED",
  DISBURSED = "DISBURSED",
  ACTIVE = "ACTIVE",
  DEACTIVATED = "DEACTIVATED",
}

export interface SummarizedView {
  accepted?: AcceptedLoans;
  disbursed?: AllDisbursedLoans;
  insurance?: AllInsurances;
  mortgage_leads?: MortgageLeads;
}

export type SummarizedViewShared = SummarizedView | MyStatsMb | (SummarizedView & MyStatsMb);

/**
 * An enumeration.
 */
export enum SverkerClearanceID {
  Type1 = "1",
  Type2 = "2",
  Type3 = "3",
  Type5 = "5",
  Type6 = "6",
  Type9 = "9",
  Type10 = "10",
}

export interface SverkerSearchApplicationResponse {
  id: number;
  created_at: string;
}

export interface SverkerSearchResponse {
  applications: SverkerSearchApplicationResponse[];
}

export interface SverkerUsername {
  /** @example 2 */
  clearance_id?: SverkerClearanceID;

  /** @example pontusr */
  username: string;
}

export interface TMCampaign {
  query: string;

  /** An enumeration. */
  country: Country;

  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  department: ZDepartment;
  description: string;

  /** Number of days since last extraction to ignore customer_id */
  ignore_days_since_last_extraction?: number;
  campaign_id: string;

  /** @format date-time */
  created_at: string;
  created_by: string;

  /** @format date-time */
  updated_at: string;
  updated_by: string;
  active: boolean;
}

export interface TMCampaignList {
  total: number;
  data: TMCampaign[];
}

export interface TMLead {
  customer_id: string;
  tags?: object;
  app_id: string;
}

export interface TMLeadsExtraction {
  leads: TMLead[];
  filtering_reasons: FilteringResult[];
  campaign_id: string;
  job_id: string;

  /** @format date-time */
  extraction_date: string;
  user_id: string;
  request_id: string;
}

export interface TMLeadsJob {
  job_id: string;
  is_finished?: boolean;
  is_failed?: boolean;
}

export interface TakeCreditCheck {
  /** @example bc2561f2-4893-11ec-b61b-6379094ad600 */
  customer_id: string;

  /** @example Taking credit check for mortgage application */
  reason: string;
}

export interface Tax {
  /** @example 12312312312312 */
  id: string;

  /**
   * Used to get the correct table
   * @example 32
   */
  key: string;

  /** @example VALLENTUNA */
  description: string;

  /** @example 0115 */
  municipality_code: string;

  /** An enumeration. */
  country: Country;
}

export interface TaxDeduction {
  /** @example 0.3 */
  lower: number;

  /** @example 100000 */
  upper_yearly_limit: number;

  /** @example 0.2 */
  upper: number;
}

export interface TaxItem {
  assessed_income?: string;
  assessed_wages?: string;
  capital_gains?: string;
  final_tax?: string;
  income_year?: string;
  remaining_tax?: string;
  total_income?: string;
  year?: string;
}

export interface TaxThousand {
  assessed_income_thousand?: string;
  assessed_wages_thousand?: string;
  capital_gains_thousand?: string;
  final_tax_thousand?: string;
  income_year?: string;
  remaining_tax_thousand?: string;
  taxed_income?: string;
  year?: string;
}

export interface TelavoxMismatch {
  no_id_set: TelavoxNoUserWithId[];
  no_name_match: TelavoxZrmMismatch[];
}

export interface TelavoxNoUserWithId {
  telavox_user: string;
  telavox_id: string;
}

export interface TelavoxZrmMismatch {
  full_name: string;
  telavox_full_name: string;
  user_id: string;
}

export interface TokenResp {
  token: string;
}

/**
 * An enumeration.
 */
export enum Touch {
  FIRST = "FIRST",
  LAST = "LAST",
}

export interface UpdateApplicationPayloadExt {
  loan?: NewMortgageLoan;

  /**
   * In SE we can only refinance one existing mortgage so this object is the loan to be refinanced,
   * not used in NO
   */
  refinance_info?: RefinanceInfo;
  buying_info?: BuyingInfo;
  selling_info?: SellingInfo;
  applicants?: BareApplicantWithRole[];

  /** @example 79975430-f34c-4c78-addd-ac7d978106aa */
  property_id?: string;
  discount?: Discount;
  loans?: Loan[];
  other_mortgages?: MortgageLoan[];

  /** An enumeration. */
  status?: AppsmgrModelsStatusStatus;

  /** An enumeration. */
  substatus?: Substatus;

  /** An enumeration. */
  bank_status?: BankStatus;
  children_in_the_household?: number;
  children_in_the_household_fulltime?: number;
  other_properties_to_keep?: OtherProperty[];

  /** An enumeration. */
  co_relationship_to_main_applicant?: RelationshipStatus;

  /** An enumeration. */
  guarantor_relationship_to_main_applicant?: RelationshipStatus;
  cars?: AppsmgrMortgageSeSpecCommonDefinitionsCars;
  brokerage?: Brokerage;
  new_app_options?: Option[];
  new_app_checklist?: string[];
  internal_comment?: string;

  /** An enumeration. */
  source?: ApplicationSource;
  aml?: AMLInsertion;
}

export interface UpdateCampaignData {
  name: string;
  description?: string;
  exclusion_rules: ExclusionRules;
  retry_policy: RetryPolicy;
  source: SheetCampaignSource | BigQueryCampaignSource;
  auto_dial?: boolean;
  daily_extraction_limit?: number;
  personal_callbacks?: boolean;
  no_contact_outcomes?: string[];
  failure_outcomes?: string[];
  comment_template?: string;
  file_id?: string;
  show_call_history?: boolean;
}

export interface UpdateCreditCardApplicationPayload {
  application_id: string;
  data: OptionalCreditCardApplicationDataCreate;
}

export interface UpdateCustomerConsentsPayload {
  /** @example Creating a customer for an application */
  reason: string;

  /** @example 944081ee-4893-11ec-8249-4b6c3b407f15 */
  customer_id: string;
  consents: Consents;
}

export interface UpdateCustomerPayload {
  /** @example Creating a customer for an application */
  reason: string;

  /** @example 944081ee-4893-11ec-8249-4b6c3b407f15 */
  customer_id: string;
  data: CustomerData;
}

export interface UpdateDMLeadData {
  phone?: string | File;
  other_phones?: (string | File)[];
  pni?: string | File;
}

export interface UpdateFormPreferencePayload {
  form_id: string;

  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;
  mapping: FieldMapping[];
  preference_id: string;
}

export interface UpdateMeetingPayload {
  /** @format date-time */
  meeting_start?: string;

  /** @format date-time */
  meeting_end?: string;

  /** @example sms|5ce26c2450d832460390f580 */
  handler_id?: string;

  /** @example Please bring some paper of some sort */
  meeting_notes?: string;

  /** @example Introduction to the Zensum Way */
  meeting_subject?: string;

  /** @example 73f670d8-4893-11ec-a8c1-2bcfc7bae96a */
  customer_id?: string;
}

export interface UserCampaignsExt {
  /** @format uuid */
  id: string;
  version: number;
  user_id: string;
  joined_campaigns: JoinedCampaignExt[];
}

export interface UserOutcomeCount {
  user_id?: string;

  /** @format uuid */
  campaign_id?: string;

  /** Number of unique customers */
  unique?: number;

  /** Number of all outcomes excluding personal_callbacks */
  all?: number;

  /** Number of outcomes with first outcome set by user */
  first?: number;

  /** Number of successful outcomes */
  success?: number;
}

export interface UserSettings {
  compact?: boolean;
  direction?: "ltr" | "rtl" | ("ltr" & "rtl");
  responsiveFontSizes?: boolean;
  roundedCorners?: boolean;
  theme?: string;
  zoordinates: string;
  debug?: boolean;
  shareNameConsent?: ShareNameConsent;
  sverkerUsername?: SverkerUsername;
  default_calender_view?: DefaultCalendarView;
}

export interface VacationHome {
  property_id: string;

  /** @example 3600000 */
  value?: number;

  /** @example 3500000 */
  booli_value?: number;
  external_id?: string;

  /** @example VACATION_HOME */
  property_type: "VACATION_HOME";

  /** An enumeration. */
  country: Country;

  /** @example Storgatan 11A */
  street_address?: string;

  /** @example 12453 */
  post_code?: string;

  /** @example Bandhagen */
  city?: string;

  /** @example true */
  other_owner?: boolean;

  /** @example 9999 */
  monthly_cost?: number;

  /** @example 56 */
  square_meter_living_area?: number;

  /** @example Stockholm */
  municipality?: string;

  /** @example 018027 */
  municipality_code?: string;

  /** @example 6000000 */
  estimated_value?: number;
  latitude?: number;
  longitude?: number;
  ev_partial?: EvPartialCommon;

  /** @example 3:2 */
  cadastral_designation?: string;
}

export interface ValidatePayload {
  form_id: string;

  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;
  mapping: FieldMapping[];
  add_defaults?: boolean;
}

export interface ValidationError {
  loc: (string | number)[];
  msg: string;
  type: string;
}

export interface ValuationPayload {
  /** @example ODU0MjhiY2ItYzEwMS00OTQzLWIwNjEtNmZkMDUwYjNlODBjOkNPTkRPTUlOSVVN */
  search_id: string;

  /** @example 1001 */
  apartment_number?: string;

  /** @example 58 */
  living_area?: number;
}

export interface ValuationPayloadV2 {
  /** @example 6c98d7a9-22ff-4a2d-84c5-6ea1ba5c4ae5 */
  external_id: string;

  /** @example d98671ea-bd3e-4746-a115-691ca11ebab8 */
  property_id: string;

  /** @example 1001 */
  apartment_number?: string;

  /** @example 58 */
  living_area?: number;
}

export interface WebsiteVisitPayload {
  landing_params?: string;
  landing_url?: string;
  cookie_consent?: string;
}

export interface WorkingDays {
  working_days: number;
  worked_days: number;
}

/**
 * An enumeration.
 */
export enum ZCountry {
  SE = "SE",
  NO = "NO",
  FI = "FI",
}

/**
 * An enumeration.
 */
export enum ZDepartment {
  HL = "HL",
  KA = "KA",
  SK = "SK",
  SP = "SP",
  KH = "KH",
  ON = "ON",
}

/**
 * An enumeration.
 */
export enum ZEmploymentType {
  FU = "FU",
  PA = "PA",
  UN = "UN",
}

/**
 * An enumeration.
 */
export enum ZOffice {
  ST = "ST",
  UP = "UP",
}

/**
 * An enumeration.
 */
export enum ZProduct {
  MO = "MO",
  UL = "UL",
  CC = "CC",
}

export interface Zoordinates {
  /** An enumeration. */
  Product: ZProduct;

  /** An enumeration. */
  Country: ZCountry;

  /** An enumeration. */
  Office: ZOffice;

  /** An enumeration. */
  EmploymentType: ZEmploymentType;

  /** An enumeration. */
  Department: ZDepartment;
}

/**
 * An enumeration.
 */
export enum AppsmgrBlancoModelsApplicationDeactivationReason {
  Other = "other",
  Moved = "moved",
  FailedCreditCheck = "failedCreditCheck",
  HighRent = "highRent",
  MiddleRent = "middleRent",
  LowRent = "lowRent",
  NoUC = "noUC",
  CallInSix = "callInSix",
  PossibleCreditCard = "possibleCreditCard",
  SentSB = "sentSB",
  Dontcall = "dontcall",
  HighRentBid = "highRentBid",
  HighRentNoBid = "highRentNoBid",
  NoReach = "noReach",
  Duplicate = "duplicate",
  MemberOrCarLoan = "memberOrCarLoan",
  Double = "double",
  UcAlreadyProtected = "ucAlreadyProtected",
  UcNoInterest = "ucNoInterest",
  UcNoTOC = "ucNoTOC",
  UcTooExpensive = "ucTooExpensive",
  UcTookLoanProtection = "ucTookLoanProtection",
  UcTryAgainLater = "ucTryAgainLater",
  PpmNoTime = "ppmNoTime",
  PpmNoInterest = "ppmNoInterest",
  PpmAlreadyHappy = "ppmAlreadyHappy",
}

/**
 * An enumeration.
 */
export enum AppsmgrBlancoNoSpecPrivateUnsecuredLoanApplicationCreatedHousingType {
  COOPERATIVE = "COOPERATIVE",
  LODGER = "LODGER",
  OTHER = "OTHER",
  OWN_APARTMENT = "OWN_APARTMENT",
  OWN_HOUSE = "OWN_HOUSE",
  PARENTS = "PARENTS",
  RENTED = "RENTED",
}

/**
 * An enumeration.
 */
export enum AppsmgrBlancoSeSpecPrivateUnsecuredLoanApplicationCreatedHousingType {
  RENTED = "RENTED",
  OWN_APARTMENT = "OWN_APARTMENT",
  OWN_HOUSE = "OWN_HOUSE",
  LIVE_IN = "LIVE_IN",
}

/**
 * An enumeration.
 */
export enum AppsmgrModelsApi2BankEventsDirection {
  INCOMING = "INCOMING",
  OUTGOING = "OUTGOING",
}

export interface AppsmgrModelsApi2BankEventsDocRequest {
  customer_id?: string;
  type: DocumentType | string;
  status: "RECEIVED" | "REQUESTED" | "APPROVED" | "DECLINED" | "WITHDRAWN";
  document_id?: string;
  comment?: string;
}

/**
 * An enumeration.
 */
export enum AppsmgrModelsApplicationPropertyType {
  HOUSE = "HOUSE",
  CONDOMINIUM = "CONDOMINIUM",
  VACATION_HOME = "VACATION_HOME",
  RENTING = "RENTING",
}

export interface AppsmgrModelsBankCommunicationDocument {
  document_id: string;
  customer_id: string;
}

export interface AppsmgrModelsNotificationsNotification {
  /** An enumeration. */
  type: AppsmgrModelsNotificationsNotificationType;
  state_labels?: AppStateLabel[];
  app_id: string;

  /** @format date-time */
  when: string;

  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;
  bank_id: number;
  customer_ids?: string[];
  pni?: string;
}

/**
 * An enumeration.
 */
export enum AppsmgrModelsNotificationsNotificationType {
  OFFER = "OFFER",
  REJECTION = "REJECTION",
  OFFER_ACCEPTED = "OFFER_ACCEPTED",
  INVITE = "INVITE",
  BANK_COMMENT = "BANK_COMMENT",
  BROKER_COMMENT = "BROKER_COMMENT",
  SIGN_STATUS = "SIGN_STATUS",
  FIRST_INVITE = "FIRST_INVITE",
  DISBURSED = "DISBURSED",
  DEACTIVATED = "DEACTIVATED",
}

/**
 * An enumeration.
 */
export enum AppsmgrModelsStatusStatus {
  LEAD = "LEAD",
  DRAFT = "DRAFT",
  ACTIVE = "ACTIVE",
  DEACTIVATED = "DEACTIVATED",
}

/**
 * An enumeration.
 */
export enum AppsmgrMortgageModelsApplicationDeactivationReason {
  CUSTOMER_NOT_REACHABLE = "CUSTOMER_NOT_REACHABLE",
  CUSTOMER_NOT_INTERESTED = "CUSTOMER_NOT_INTERESTED",
  NO_IMPROVEMENT = "NO_IMPROVEMENT",
  NEGATIVE_CALCULATION = "NEGATIVE_CALCULATION",
  LOAN_TO_VALUE_TOO_HIGH = "LOAN_TO_VALUE_TOO_HIGH",
  INSECURE_EMPLOYMENT = "INSECURE_EMPLOYMENT",
  CREDIT_RATING_TOO_LOW = "CREDIT_RATING_TOO_LOW",
  TOO_SMALL_BRF = "TOO_SMALL_BRF",
  HOUS_IN_POOR_CONTITION = "HOUS_IN_POOR_CONTITION",
  RED_MUNICIPALITY = "RED_MUNICIPALITY",
  FIXEDINTEREST1YEAR = "FIXED_INTEREST_1_YEAR",
  FIXEDINTEREST3YEAR = "FIXED_INTEREST_3_YEAR",
  FIXEDINTEREST5YEAR = "FIXED_INTEREST_5_YEAR",
  AGRICULTURAL_PROPERTY = "AGRICULTURAL_PROPERTY",
  MIDDLE_OF_SALES = "MIDDLE_OF_SALES",
  TOO_SMALL_CASH_CONTRIBUTION = "TOO_SMALL_CASH_CONTRIBUTION",
  INCOME_REQUIREMENTS_NOT_MET = "INCOME_REQUIREMENTS_NOT_MET",
  NOT_COMMUNICABLE = "NOT_COMMUNICABLE",
  ONGOING_COMPETITOR = "ONGOING_COMPETITOR",
  ONGOING_DIVORCE = "ONGOING_DIVORCE",
  CONSTRUCTION_CREDIT = "CONSTRUCTION_CREDIT",
  BLANCO_APPLICATION = "BLANCO_APPLICATION",
  DUPLICATE = "DUPLICATE",
  OTHER = "OTHER",
}

/**
 * An enumeration.
 */
export enum AppsmgrMortgageNoSpecCommonDefinitionsResponsibility {
  MAIN_APPLICANT = "MAIN_APPLICANT",
  CO_APPLICANT = "CO_APPLICANT",
  SHARED = "SHARED",
}

export interface AppsmgrMortgageSeSpecCommonDefinitionsCars {
  /** @min 0 */
  owned?: number;
  leased?: Car[];
}

/**
 * An enumeration.
 */
export enum AppsmgrMortgageSeSpecCommonDefinitionsPropertyType {
  CONDOMINIUM = "CONDOMINIUM",
  HOUSE = "HOUSE",
  VACATION_HOME = "VACATION_HOME",
}

/**
 * An enumeration.
 */
export enum AppsmgrMortgageSeSpecCommonDefinitionsResponsibility {
  MAIN_APPLICANT = "MAIN_APPLICANT",
  CO_APPLICANT = "CO_APPLICANT",
  SHARED = "SHARED",
  GUARANTOR = "GUARANTOR",
}

/**
 * An enumeration.
 */
export enum ModelsAffiliateAffiliateAffiliateStatus {
  ACTIVE = "ACTIVE",
  DEACTIVATED = "DEACTIVATED",
}

export interface ModelsAffiliateAffiliateCampaign {
  /** An enumeration. */
  url_target: Product;

  /** @format date-time */
  valid_to?: string;

  /** @format uri */
  url?: string;
  campaign_id: string | string;
}

export interface ModelsAffiliateAffiliateCampaignData {
  /** An enumeration. */
  url_target: Product;

  /** @format date-time */
  valid_to?: string;

  /** @format uri */
  url?: string;
}

/**
 * An enumeration.
 */
export enum ModelsAffiliatePartnerApplicationAffiliateStatus {
  APP_CREATED = "APP_CREATED",
  OFFER_ACCEPTED = "OFFER_ACCEPTED",
  OFFER_SIGNED = "OFFER_SIGNED",
  APP_DISBURSED = "APP_DISBURSED",
  APP_DEACTIVATED = "APP_DEACTIVATED",
  LEAD_CREATED = "LEAD_CREATED",
  LEAD_DEACTIVATED = "LEAD_DEACTIVATED",
  APP_NOT_CREATED = "APP_NOT_CREATED",
  SUBMITTED = "SUBMITTED",
}

export interface ModelsApplicationApplicationDocRequest {
  customer_id?: string;
  type: DocumentType | string;
  status: "RECEIVED" | "REQUESTED" | "APPROVED" | "DECLINED" | "WITHDRAWN";
  document_id?: string;
  comment?: string;
}

export interface ModelsApplicationMappingApplicationMappingData {
  handler_id?: string;
  creator_id?: string;
  property_id?: string;
  new_app_checklist?: string[];
  new_app_options?: Option[];
  internal_comment?: string;
  document?: DocumentAssignation;
  customer_id?: string;
  external_id?: string;

  /** An enumeration. */
  source?: ApplicationSource;
  duplicate_of?: string;
  lead_id?: string;
  aml?: AMLInsertion;
  aml_review?: AMLReviewPayload;
}

export interface ModelsApplicationMappingCommentsInternalComment {
  /** @example sms|5ce26c2450d832460390f580 */
  user_id: string;

  /** @example The customer said that they wanted to do that */
  comment: string;

  /** @format date-time */
  timestamp: string;
  comment_id: string;
  action?: "INTERNAL_COMMENT_ADDED";
}

export interface ModelsDialMaker2LeadDataModelsLeadExtraction {
  /** @format date-time */
  timestamp: string;

  /** @format uuid */
  extraction_id: string;

  /** @format uuid */
  campaign_id: string;

  /** Number of times this customer/phone number was extracted. */
  count?: number;
}

export interface ModelsDialMaker2CampaignAggregateCampaign {
  /** @format uuid */
  id: string;
  version: number;

  /** @format date-time */
  created_at: string;

  /** @format date-time */
  updated_at: string;
  created_by: string;
  updated_by: string;
  active: boolean;
  data: ModelsDialMaker2CampaignDataModelsCampaignData;
  extractions: CampaignExtraction[];
  exports: CampaignExport[];
}

export interface ModelsDialMaker2CampaignDataModelsCampaignData {
  name: string;
  description?: string;
  exclusion_rules: ExclusionRules;
  retry_policy: RetryPolicy;
  source: SheetCampaignSource | BigQueryCampaignSource;
  auto_dial?: boolean;
  daily_extraction_limit?: number;
  personal_callbacks?: boolean;
  no_contact_outcomes?: string[];
  failure_outcomes?: string[];
  comment_template?: string;
  file_id?: string;
  show_call_history?: boolean;

  /** An enumeration. */
  type: CampaignType;

  /** An enumeration. */
  country: Country;

  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  department: ZDepartment;
}

export interface ModelsDocumentDocumentDocument {
  /**
   * A base64 encoded string of the data
   * @example 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
   */
  data: string;

  /**
   * Name of the document
   * @example A proof of employment.pdf
   */
  name: string;

  /**
   * MIME type of the document
   * @example application/png
   */
  mime_type: string;

  /**
   * The type of document you're uploading.
   * @example AMORTIZATION_PLAN
   */
  document_type: DocumentType;

  /**
   * ID of the customer that owns the document
   * @example d3a51af2-4893-11ec-b66a-8f469c7d5dde
   */
  customer_id: string;

  /**
   * When the document was added to db
   * @format date-time
   */
  timestamp: string;
}

export interface ModelsMeetingMeeting {
  /** @format date-time */
  meeting_start: string;

  /** @format date-time */
  meeting_end: string;

  /** @example sms|5ce26c2450d832460390f580 */
  handler_id?: string;

  /** @example Please bring some paper of some sort */
  meeting_notes?: string;

  /** @example Introduction to the Zensum Way */
  meeting_subject?: string;

  /** @example 73f670d8-4893-11ec-a8c1-2bcfc7bae96a */
  customer_id?: string;

  /** @example MOSE000001 */
  application_id: string | string;

  /** @example a479492e-4893-11ec-97fc-43be61ad8715 */
  meeting_id: string;

  /** @format date-time */
  last_updated: string;

  /** @format date-time */
  date_created: string;

  /** An enumeration. */
  product: Product;

  /** An enumeration. */
  country: Country;

  /** @example Glenn Hysén */
  customer_name?: string;
}

/**
 * An enumeration.
 */
export enum ModelsMessageCommonDirection {
  INCOMING = "INCOMING",
  OUTGOING = "OUTGOING",
}

export interface ModelsMortgageKALPCars {
  per_leased: CarCost;
  per_owned: CarCost;
}

export interface ModelsNotificationsNotificationInternalComment {
  type: "INTERNAL_COMMENT_RECEIVED";

  /**
   * @format date-time
   * @example 2022-01-19T13:13:52.541833
   */
  timestamp: string;

  /** An enumeration. */
  status: NotificationEvent;
  data: InternalCommentData;

  /** @example a9eb4560-9628-4c84-9cd6-0b605ae2f5ee */
  notification_id: string;

  /** @example sms|5ce26c2450d832460390f580 */
  user_id?: string;
}

export type ModelsNotificationsNotificationNotification =
  | SMSReceived
  | BankMessageReceived
  | OfferReceived
  | ModelsNotificationsNotificationInternalComment
  | ApplicationAssigned
  | GeneralMessage
  | LeadAssigned
  | LeadComment
  | ApplicationDisbursed
  | (SMSReceived &
      BankMessageReceived &
      OfferReceived &
      ModelsNotificationsNotificationInternalComment &
      ApplicationAssigned &
      GeneralMessage &
      LeadAssigned &
      LeadComment &
      ApplicationDisbursed);

/**
 * An enumeration.
 */
export enum ModelsNotificationsNotificationTypesNotificationType {
  SMS_RECEIVED = "SMS_RECEIVED",
  OFFER_RECEIVED = "OFFER_RECEIVED",
  BANK_MESSAGE_RECEIVED = "BANK_MESSAGE_RECEIVED",
  INTERNAL_COMMENT_RECEIVED = "INTERNAL_COMMENT_RECEIVED",
  GENERAL_MESSAGE_RECEIVED = "GENERAL_MESSAGE_RECEIVED",
  APPLICATION_ASSIGNED = "APPLICATION_ASSIGNED",
  LEAD_ASSIGNED = "LEAD_ASSIGNED",
  LEAD_COMMENT_RECEIVED = "LEAD_COMMENT_RECEIVED",
  APPLICATION_DISBURSED = "APPLICATION_DISBURSED",
}

export interface ModelsOnlineLoanApplicationStatus {
  success: boolean;
  error?: string;
}

export interface RoutersApplicationApplicationPayloadSearchPayload {
  /** An enumeration. */
  country?: Country;

  /** An enumeration. */
  product?: Product;
  string: string;
  search_types?: SearchType[];
}

export interface RoutersBankPayloadsSearchPayload {
  /** An enumeration. */
  country?: Country;

  /** An enumeration. */
  product?: Product;
  string: string;
}

export interface RoutersBankIdModelsBankIDResp {
  ticket_id: string;
}

export interface RoutersBankIdLoginPayloadBankIDResp {
  autostart_token?: string;
  ticket_id: string;
  polling_endpoint: string;
  login_url?: string;
}

export interface RoutersDialMaker2PayloadsSignedUrl {
  signed_url: string;
}

export interface RoutersDialMakerPayloadsLeadExtraction {
  leads_to_extract: number;
}

export interface RoutersDialMakerPayloadsSignedUrl {
  signed_url: string;
  file_name: string;
}

export interface RoutersEmployeeModelsSearchPayload {
  /** @example pelle */
  string: string;
}

export interface RoutersLeadPayloadSearchPayload {
  /** @example LEADMOSE000001 */
  string: string;
}

export interface RoutersMessagePayloadData {
  meeting_id?: string;
}

export interface RoutersPropertyPayloadSearchPayload {
  /** @example SE */
  country: Country;

  /** @example storg 1 */
  search_string: string;
}

export interface ServicesSverkerResponsesMeeting {
  /** @format date-time */
  id: string;
  time: string;
  booked: boolean;
  format: string;
}

export namespace Application {
  /**
   * No description
   * @tags Application
   * @name QuickCreateApplicationApplicationQuickCreatePost
   * @summary Quick Create Application
   * @request POST:/application/quick-create
   * @secure
   */
  export namespace QuickCreateApplicationApplicationQuickCreatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = QuickCreateApplication;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ApplicationCreatedResponse;
  }
  /**
   * No description
   * @tags Application
   * @name CreateApplicationApplicationCreatePost
   * @summary Create Application
   * @request POST:/application/create
   * @secure
   */
  export namespace CreateApplicationApplicationCreatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateApplicationPayloadExt;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ApplicationCreatedResponseExt;
  }
  /**
   * No description
   * @tags Application
   * @name UpdateApplicationApplicationUpdateApplicationIdPost
   * @summary Update Application
   * @request POST:/application/update/{application_id}
   * @secure
   */
  export namespace UpdateApplicationApplicationUpdateApplicationIdPost {
    export type RequestParams = { applicationId: string };
    export type RequestQuery = {};
    export type RequestBody = UpdateApplicationPayloadExt;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ApplicationWithNamesInComments;
  }
  /**
   * No description
   * @tags Application
   * @name GetApplicationApplicationGetPost
   * @summary Get Application
   * @request POST:/application/get
   * @secure
   */
  export namespace GetApplicationApplicationGetPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetApplicationPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ApplicationWithNamesInComments;
  }
  /**
   * No description
   * @tags Application
   * @name GetApplicationsApplicationGetsPost
   * @summary Get Applications
   * @request POST:/application/gets
   * @deprecated
   * @secure
   */
  export namespace GetApplicationsApplicationGetsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetApplicationsByCustomerIdentifierPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Application[];
  }
  /**
   * No description
   * @tags Application
   * @name GetApplicationsV2ApplicationV2GetsPost
   * @summary Get Applications V2
   * @request POST:/application/v2/gets
   * @secure
   */
  export namespace GetApplicationsV2ApplicationV2GetsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetApplicationsByCustomerIdentifierPayloadV2;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Application[];
  }
  /**
   * No description
   * @tags Application
   * @name GetApplicationsAssignedToMeApplicationGetMinePost
   * @summary Get Applications Assigned To Me
   * @request POST:/application/get/mine
   * @secure
   */
  export namespace GetApplicationsAssignedToMeApplicationGetMinePost {
    export type RequestParams = {};
    export type RequestQuery = { page?: number; limit?: number };
    export type RequestBody = GetMyApplicationsPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Application[];
  }
  /**
   * No description
   * @tags Application
   * @name GetRecentApplicationsApplicationGetRecentPost
   * @summary Get Recent Applications
   * @request POST:/application/get/recent
   * @secure
   */
  export namespace GetRecentApplicationsApplicationGetRecentPost {
    export type RequestParams = {};
    export type RequestQuery = { page?: number; limit?: number };
    export type RequestBody = GetRecentApplicationsPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Application[];
  }
  /**
   * No description
   * @tags Application
   * @name SearchApplicationsApplicationSearchPost
   * @summary Search Applications
   * @request POST:/application/search
   * @secure
   */
  export namespace SearchApplicationsApplicationSearchPost {
    export type RequestParams = {};
    export type RequestQuery = { page?: number; limit?: number };
    export type RequestBody = RoutersApplicationApplicationPayloadSearchPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Application[];
  }
  /**
   * No description
   * @tags Application
   * @name SearchApplications2ApplicationSearch2Post
   * @summary Search Applications2
   * @request POST:/application/search2
   * @secure
   */
  export namespace SearchApplications2ApplicationSearch2Post {
    export type RequestParams = {};
    export type RequestQuery = { page?: number; limit?: number };
    export type RequestBody = RoutersApplicationApplicationPayloadSearchPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = AppsSearchResult;
  }
  /**
   * No description
   * @tags Application
   * @name GetLeftToLiveApplicationLeftToLivePost
   * @summary Get Left To Live
   * @request POST:/application/left_to_live
   * @secure
   */
  export namespace GetLeftToLiveApplicationLeftToLivePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = LeftToLivePayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = LeftToLiveResponse;
  }
  /**
   * No description
   * @tags Application
   * @name DuplicateApplicationApplicationDuplicatePost
   * @summary Duplicate Application
   * @request POST:/application/duplicate
   * @secure
   */
  export namespace DuplicateApplicationApplicationDuplicatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApplicationPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ApplicationPayload;
  }
  /**
   * No description
   * @tags Application
   * @name DeactivateApplicationApplicationDeactivateProductPost
   * @summary Deactivate Application
   * @request POST:/application/deactivate/{product}
   * @secure
   */
  export namespace DeactivateApplicationApplicationDeactivateProductPost {
    export type RequestParams = { product: Product };
    export type RequestQuery = {};
    export type RequestBody =
      | MortgageDeactivatePayload
      | DeactivatePayload
      | (MortgageDeactivatePayload & DeactivatePayload);
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags Application
   * @name ReactivateApplicationReactivatePost
   * @summary Reactivate
   * @request POST:/application/reactivate
   * @secure
   */
  export namespace ReactivateApplicationReactivatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ReactivatePayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags CreditCard Application
   * @name GetApplicationApplicationCcNoGetPost
   * @summary Get Application
   * @request POST:/application/cc/no/get
   * @secure
   */
  export namespace GetApplicationApplicationCcNoGetPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetApplicationPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = CreditCardApplicationWithNamesInComments;
  }
  /**
   * No description
   * @tags CreditCard Application
   * @name CreateApplicationApplicationCcNoCreatePost
   * @summary Create Application
   * @request POST:/application/cc/no/create
   * @secure
   */
  export namespace CreateApplicationApplicationCcNoCreatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateCreditCardApplicationPayloadExt;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ApplicationCreatedResponseExt;
  }
  /**
   * No description
   * @tags CreditCard Application
   * @name UpdateApplicationApplicationCcNoUpdatePost
   * @summary Update Application
   * @request POST:/application/cc/no/update
   * @secure
   */
  export namespace UpdateApplicationApplicationCcNoUpdatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UpdateCreditCardApplicationPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = BaseModel;
  }
  /**
   * No description
   * @tags CreditCard Application
   * @name UpdateAndGetApplicationApplicationCcNoUpdateAndGetPost
   * @summary Update And Get Application
   * @request POST:/application/cc/no/update-and-get
   * @secure
   */
  export namespace UpdateAndGetApplicationApplicationCcNoUpdateAndGetPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UpdateCreditCardApplicationPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = CreditCardApplicationExtended;
  }
  /**
   * No description
   * @tags CreditCard Application
   * @name CreateApplicationApplicantApplicationCcNoCreateWithApplicantPost
   * @summary Create Application Applicant
   * @request POST:/application/cc/no/create-with-applicant
   * @secure
   */
  export namespace CreateApplicationApplicantApplicationCcNoCreateWithApplicantPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateCreditCardApplicationApplicantPayloadExt;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ApplicationCreatedResponseExt;
  }
  /**
   * No description
   * @tags CreditCard Application
   * @name GetRecentApplicationsApplicationCcNoGetRecentPost
   * @summary Get Recent Applications
   * @request POST:/application/cc/no/get_recent
   * @secure
   */
  export namespace GetRecentApplicationsApplicationCcNoGetRecentPost {
    export type RequestParams = {};
    export type RequestQuery = { page?: number; size?: number };
    export type RequestBody = FilterByPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = PageCreditCardApplicationExtended;
  }
  /**
   * No description
   * @tags CreditCard Application
   * @name GetApplicationBankEventsApplicationCcNoBankEventsPost
   * @summary Get Application Bank Events
   * @request POST:/application/cc/no/bank-events
   * @secure
   */
  export namespace GetApplicationBankEventsApplicationCcNoBankEventsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApplicationQuery;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = CreditCardBankEventsResponse;
  }
  /**
   * No description
   * @tags CreditCard Application
   * @name SearchApplicationsApplicationCcNoSearchApplicationsPost
   * @summary Search Applications
   * @request POST:/application/cc/no/search_applications
   * @secure
   */
  export namespace SearchApplicationsApplicationCcNoSearchApplicationsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetApplicationsByApplicantIdentifierPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = CreditCardApplicationExtended[];
  }
  /**
   * No description
   * @tags CreditCard Application
   * @name AcceptOfferApplicationCcNoAcceptOfferPost
   * @summary Accept Offer
   * @request POST:/application/cc/no/accept_offer
   * @secure
   */
  export namespace AcceptOfferApplicationCcNoAcceptOfferPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AcceptOffer;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = CreditorOfferCreditCardOfferCreditCardTerms;
  }
  /**
   * No description
   * @tags Mortgage SE Application
   * @name GetApplicationBankEventsApplicationMoSeBankEventsPost
   * @summary Get Application Bank Events
   * @request POST:/application/mo/se/bank-events
   * @secure
   */
  export namespace GetApplicationBankEventsApplicationMoSeBankEventsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApplicationQuery;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = MortgageBankEventsResponse;
  }
  /**
   * No description
   * @tags Bank Communication
   * @name InviteApplicationApplicationInvitePost
   * @summary Invite Application
   * @request POST:/application/invite
   * @secure
   */
  export namespace InviteApplicationApplicationInvitePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = InvitePayloadBase;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = BankCommunicationData;
  }
  /**
   * No description
   * @tags Bank Communication
   * @name InviteApplicationIdApplicationInviteApplicationIdPost
   * @summary Invite Application Id
   * @request POST:/application/invite/{application_id}
   * @secure
   */
  export namespace InviteApplicationIdApplicationInviteApplicationIdPost {
    export type RequestParams = { applicationId: string };
    export type RequestQuery = {};
    export type RequestBody = InvitePayloadBase;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = BankCommunicationData;
  }
  /**
   * No description
   * @tags Bank Communication
   * @name GetAppEventsApplicationGetAppEventsApplicationIdGet
   * @summary Get App Events
   * @request GET:/application/get_app_events/{application_id}
   * @secure
   */
  export namespace GetAppEventsApplicationGetAppEventsApplicationIdGet {
    export type RequestParams = { applicationId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = EventsResponse;
  }
  /**
   * No description
   * @tags Bank Communication
   * @name GetAppEventsOldApplicationGetAppEventsPost
   * @summary Get App Events Old
   * @request POST:/application/get_app_events
   * @secure
   */
  export namespace GetAppEventsOldApplicationGetAppEventsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags Bank Communication
   * @name SendCommentToIntegrationApplicationCommentToBankPost
   * @summary Send Comment To Integration
   * @request POST:/application/comment_to_bank
   * @secure
   */
  export namespace SendCommentToIntegrationApplicationCommentToBankPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BaseComment;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = EventsResponse;
  }
  /**
   * No description
   * @tags Bank Communication
   * @name AcceptOfferApplicationAcceptOfferPost
   * @summary Accept Offer
   * @request POST:/application/accept_offer
   * @secure
   */
  export namespace AcceptOfferApplicationAcceptOfferPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AcceptOffer;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = EventsResponse;
  }
  /**
   * No description
   * @tags Bank Communication
   * @name CancelApplicationCancelPost
   * @summary Cancel
   * @request POST:/application/cancel
   * @secure
   */
  export namespace CancelApplicationCancelPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CancelOfferPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = EventsResponse;
  }
  /**
   * No description
   * @tags Bank Communication
   * @name SendDocumentToIntegrationApplicationDocumentToBankPost
   * @summary Send Document To Integration
   * @request POST:/application/document_to_bank
   * @secure
   */
  export namespace SendDocumentToIntegrationApplicationDocumentToBankPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DocumentToBank;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = EventsResponse;
  }
  /**
   * No description
   * @tags Application Meta
   * @name AssignApplicationToHandlerApplicationAssignApplicationIdPost
   * @summary Assign Application To Handler
   * @request POST:/application/assign/{application_id}
   * @secure
   */
  export namespace AssignApplicationToHandlerApplicationAssignApplicationIdPost {
    export type RequestParams = { applicationId: string };
    export type RequestQuery = {};
    export type RequestBody = AssignApplicationPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags Application Meta
   * @name ListInternalCommentsApplicationCommentApplicationIdGet
   * @summary List Internal Comments
   * @request GET:/application/comment/{application_id}
   * @secure
   */
  export namespace ListInternalCommentsApplicationCommentApplicationIdGet {
    export type RequestParams = { applicationId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = (
      | BankIDSignedWithNames
      | InternalCommentWithName
      | (BankIDSignedWithNames & InternalCommentWithName)
    )[];
  }
  /**
   * No description
   * @tags Application Meta
   * @name AddInternalCommentApplicationCommentApplicationIdPost
   * @summary Add Internal Comment
   * @request POST:/application/comment/{application_id}
   * @secure
   */
  export namespace AddInternalCommentApplicationCommentApplicationIdPost {
    export type RequestParams = { applicationId: string };
    export type RequestQuery = {};
    export type RequestBody = CommentPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = (
      | BankIDSignedWithNames
      | InternalCommentWithName
      | (BankIDSignedWithNames & InternalCommentWithName)
    )[];
  }
  /**
   * No description
   * @tags Application Meta
   * @name GetPossibleStatusesApplicationPrefsGet
   * @summary Get Possible Statuses
   * @request GET:/application/prefs
   * @secure
   */
  export namespace GetPossibleStatusesApplicationPrefsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = PrefsResponse;
  }
  /**
   * No description
   * @tags Application Meta
   * @name GetPossibleLoanTypesApplicationLoanTypesCountryGet
   * @summary Get Possible Loan Types
   * @request GET:/application/loan-types/{country}
   * @secure
   */
  export namespace GetPossibleLoanTypesApplicationLoanTypesCountryGet {
    export type RequestParams = { country: Country };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = string[];
  }
  /**
   * No description
   * @tags Application Meta
   * @name SearchBlancoSverkerApplicationBlancoSearchCountryGet
   * @summary Search Blanco Sverker
   * @request GET:/application/blanco/search/{country}
   * @secure
   */
  export namespace SearchBlancoSverkerApplicationBlancoSearchCountryGet {
    export type RequestParams = { country: Country };
    export type RequestQuery = { s: string };
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = SverkerSearchResponse;
  }
  /**
   * No description
   * @tags AML
   * @name AmlReviewApplicationAmlReviewPost
   * @summary Aml Review
   * @request POST:/application/aml/review
   * @secure
   */
  export namespace AmlReviewApplicationAmlReviewPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AMLReviewPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ApplicationWithNamesInComments;
  }
  /**
   * No description
   * @tags AML
   * @name GetBlancoAmlApplicationBlancoAmlApplicationIdGet
   * @summary Get Blanco Aml
   * @request GET:/application/blanco/aml/{application_id}
   * @secure
   */
  export namespace GetBlancoAmlApplicationBlancoAmlApplicationIdGet {
    export type RequestParams = { applicationId: number };
    export type RequestQuery = { country: Country };
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = AMLBlancoResponse;
  }
  /**
   * No description
   * @tags AML
   * @name PatchBlancoAmlApplicationBlancoAmlApplicationIdPatch
   * @summary Patch Blanco Aml
   * @request PATCH:/application/blanco/aml/{application_id}
   * @secure
   */
  export namespace PatchBlancoAmlApplicationBlancoAmlApplicationIdPatch {
    export type RequestParams = { applicationId: number };
    export type RequestQuery = {};
    export type RequestBody = BlancoAMLPatchPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = AMLBlancoResponse;
  }
  /**
   * No description
   * @tags AML
   * @name ReviewBlancoAmlApplicationBlancoAmlReviewApplicationIdPatch
   * @summary Review Blanco Aml
   * @request PATCH:/application/blanco/aml/review/{application_id}
   * @secure
   */
  export namespace ReviewBlancoAmlApplicationBlancoAmlReviewApplicationIdPatch {
    export type RequestParams = { applicationId: number };
    export type RequestQuery = {};
    export type RequestBody = BlancoAMLReviewPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags AML
   * @name MortgageDeactivationReviewsApplicationDeactivationReviewsMortgagePost
   * @summary Mortgage Deactivation Reviews
   * @request POST:/application/deactivation_reviews/mortgage
   * @secure
   */
  export namespace MortgageDeactivationReviewsApplicationDeactivationReviewsMortgagePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DeactivationReviewsPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = MortgageDeactivationReviewsResponse;
  }
  /**
   * No description
   * @tags AML
   * @name BlancoDeactivationReviewsApplicationDeactivationReviewsBlancoPost
   * @summary Blanco Deactivation Reviews
   * @request POST:/application/deactivation_reviews/blanco
   * @secure
   */
  export namespace BlancoDeactivationReviewsApplicationDeactivationReviewsBlancoPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DeactivationReviewsPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = DeactivationReviewsResponse;
  }
}

export namespace Customer {
  /**
   * No description
   * @tags Customer
   * @name GetCustomerCustomerGetPost
   * @summary Get Customer
   * @request POST:/customer/get
   * @secure
   */
  export namespace GetCustomerCustomerGetPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      | PniGetCustomerPayload
      | EmailGetCustomerPayload
      | PhoneGetCustomerPayload
      | CustomerIDGetCustomerPayload
      | CustomerIDsGetCustomerPayload
      | (PniGetCustomerPayload &
          EmailGetCustomerPayload &
          PhoneGetCustomerPayload &
          CustomerIDGetCustomerPayload &
          CustomerIDsGetCustomerPayload);
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ApplicantSE | ApplicantNO | (ApplicantSE & ApplicantNO);
  }
  /**
   * No description
   * @tags Customer
   * @name GetCustomersCustomerGetsPost
   * @summary Get Customers
   * @request POST:/customer/gets
   * @secure
   */
  export namespace GetCustomersCustomerGetsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CustomerIDsGetCustomerPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = (ApplicantSE | ApplicantNO)[];
  }
  /**
   * No description
   * @tags Customer
   * @name CreateCustomerCustomerCreatePost
   * @summary Create Customer
   * @request POST:/customer/create
   * @secure
   */
  export namespace CreateCustomerCustomerCreatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateCustomerPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ApplicantSE | ApplicantNO | (ApplicantSE & ApplicantNO);
  }
  /**
   * No description
   * @tags Customer
   * @name UpdateCustomerCustomerUpdatePost
   * @summary Update Customer
   * @request POST:/customer/update
   * @secure
   */
  export namespace UpdateCustomerCustomerUpdatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UpdateCustomerPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ApplicantSE | ApplicantNO | (ApplicantSE & ApplicantNO);
  }
  /**
   * No description
   * @tags Customer
   * @name UpdateConsentsCustomerUpdateConsentsPost
   * @summary Update Consents
   * @request POST:/customer/update_consents
   * @secure
   */
  export namespace UpdateConsentsCustomerUpdateConsentsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UpdateCustomerConsentsPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ApplicantSE | ApplicantNO | (ApplicantSE & ApplicantNO);
  }
  /**
   * No description
   * @tags Customer
   * @name IdCheckOrGetCustomerCustomerIdCheckPost
   * @summary Id Check Or Get Customer
   * @request POST:/customer/id-check
   * @secure
   */
  export namespace IdCheckOrGetCustomerCustomerIdCheckPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = IDCheckGetCustomerPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody =
      | (ApplicantSE | ApplicantNO)
      | IDCheckedPerson
      | ((ApplicantSE | ApplicantNO) & IDCheckedPerson);
  }
  /**
   * No description
   * @tags Customer
   * @name TakeCreditCheckCustomerCreditCheckPost
   * @summary Take Credit Check
   * @request POST:/customer/credit-check
   * @secure
   */
  export namespace TakeCreditCheckCustomerCreditCheckPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TakeCreditCheck;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ApplicantSE | ApplicantNO | (ApplicantSE & ApplicantNO);
  }
  /**
   * No description
   * @tags Customer
   * @name GetNameByPniCustomerNameByPniPost
   * @summary Get Name By Pni
   * @request POST:/customer/name/by-pni
   * @secure
   */
  export namespace GetNameByPniCustomerNameByPniPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetNameByPNIPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Name;
  }
  /**
   * No description
   * @tags Customer
   * @name GetNameCustomerNameCustomerIdGet
   * @summary Get Name
   * @request GET:/customer/name/{customer_id}
   * @secure
   */
  export namespace GetNameCustomerNameCustomerIdGet {
    export type RequestParams = { customerId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Name;
  }
  /**
   * No description
   * @tags Customer, Application Meta
   * @name EmploymentTypesCustomerEmploymentTypesCountryGet
   * @summary Employment Types
   * @request GET:/customer/employment-types/{country}
   * @secure
   */
  export namespace EmploymentTypesCustomerEmploymentTypesCountryGet {
    export type RequestParams = { country: Country };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = string[];
  }
  /**
   * No description
   * @tags Customer, Application Meta
   * @name HousingTypesCustomerHousingTypesCountryGet
   * @summary Housing Types
   * @request GET:/customer/housing-types/{country}
   * @secure
   */
  export namespace HousingTypesCustomerHousingTypesCountryGet {
    export type RequestParams = { country: Country };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = string[];
  }
  /**
   * No description
   * @tags Customer
   * @name GetExternallyVerifiedCreditsCustomerExternallyVerifiedCreditsPost
   * @summary Get Externally Verified Credits
   * @request POST:/customer/externally-verified-credits
   * @secure
   */
  export namespace GetExternallyVerifiedCreditsCustomerExternallyVerifiedCreditsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = MinimalApplicant[];
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = LoanAndExternallyVerifiedCredit;
  }
}

export namespace Meeting {
  /**
   * No description
   * @tags Meeting
   * @name GetMeetingMeetingGetMeetingIdGet
   * @summary Get Meeting
   * @request GET:/meeting/get/{meeting_id}
   * @secure
   */
  export namespace GetMeetingMeetingGetMeetingIdGet {
    export type RequestParams = { meetingId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ModelsMeetingMeeting;
  }
  /**
   * No description
   * @tags Meeting
   * @name GetMeetingsMeetingGetPost
   * @summary Get Meetings
   * @request POST:/meeting/get
   * @secure
   */
  export namespace GetMeetingsMeetingGetPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetMeetings;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody =
      | MeetingWithApp[]
      | MeetingWithHandlerName[]
      | ModelsMeetingMeeting[]
      | (MeetingWithApp[] & MeetingWithHandlerName[] & ModelsMeetingMeeting[]);
  }
  /**
   * No description
   * @tags Meeting
   * @name GetMyMeetingsMeetingMinePost
   * @summary Get My Meetings
   * @request POST:/meeting/mine
   * @secure
   */
  export namespace GetMyMeetingsMeetingMinePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetMyMeetings;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = (
      | MeetingWithApp
      | MeetingWithHandlerName
      | ModelsMeetingMeeting
      | (MeetingWithApp & MeetingWithHandlerName & ModelsMeetingMeeting)
    )[];
  }
  /**
   * No description
   * @tags Meeting
   * @name CreateMeetingMeetingCreatePost
   * @summary Create Meeting
   * @request POST:/meeting/create
   * @secure
   */
  export namespace CreateMeetingMeetingCreatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateMeetingPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ModelsMeetingMeeting;
  }
  /**
   * No description
   * @tags Meeting
   * @name UpdateMeetingMeetingUpdateMeetingIdPost
   * @summary Update Meeting
   * @request POST:/meeting/update/{meeting_id}
   * @secure
   */
  export namespace UpdateMeetingMeetingUpdateMeetingIdPost {
    export type RequestParams = { meetingId: string };
    export type RequestQuery = {};
    export type RequestBody = UpdateMeetingPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ModelsMeetingMeeting;
  }
  /**
   * No description
   * @tags Meeting
   * @name CancelMeetingsMeetingCancelMeetingIdDelete
   * @summary Cancel Meetings
   * @request DELETE:/meeting/cancel/{meeting_id}
   * @secure
   */
  export namespace CancelMeetingsMeetingCancelMeetingIdDelete {
    export type RequestParams = { meetingId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags Meeting
   * @name GetBookableTimesMeetingAvailableDayGet
   * @summary Get Bookable Times
   * @request GET:/meeting/available/{day}
   * @secure
   */
  export namespace GetBookableTimesMeetingAvailableDayGet {
    export type RequestParams = { day: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = BookableSlot[];
  }
}

export namespace Document {
  /**
   * No description
   * @tags Document
   * @name GetDocumentMetaDocumentGetMetaCustomerIdDocumentIdGet
   * @summary Get Document Meta
   * @request GET:/document/get/meta/{customer_id}/{document_id}
   * @secure
   */
  export namespace GetDocumentMetaDocumentGetMetaCustomerIdDocumentIdGet {
    export type RequestParams = { customerId: string; documentId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = DocumentMeta;
  }
  /**
   * No description
   * @tags Document
   * @name GetDocumentDocumentGetCustomerIdDocumentIdGet
   * @summary Get Document
   * @request GET:/document/get/{customer_id}/{document_id}
   * @secure
   */
  export namespace GetDocumentDocumentGetCustomerIdDocumentIdGet {
    export type RequestParams = { customerId: string; documentId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ModelsDocumentDocumentDocument;
  }
  /**
   * No description
   * @tags Document
   * @name CreateDocumentDocumentSavePost
   * @summary Create Document
   * @request POST:/document/save
   * @secure
   */
  export namespace CreateDocumentDocumentSavePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateDocumentPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = CreateDocumentPayloadResp;
  }
  /**
   * No description
   * @tags Document
   * @name DocumentTypesDocumentTypesGet
   * @summary Document Types
   * @request GET:/document/types
   * @secure
   */
  export namespace DocumentTypesDocumentTypesGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = DocumentType[];
  }
  /**
   * No description
   * @tags Document
   * @name GetAttachedDocumentsOfApplicationDocumentAttachedApplicationIdGet
   * @summary Get Attached Documents Of Application
   * @request GET:/document/attached/{application_id}
   * @secure
   */
  export namespace GetAttachedDocumentsOfApplicationDocumentAttachedApplicationIdGet {
    export type RequestParams = { applicationId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = DocumentAssignation[];
  }
  /**
   * No description
   * @tags Document
   * @name AttachDocumentToApplicationDocumentAttachApplicationIdPost
   * @summary Attach Document To Application
   * @request POST:/document/attach/{application_id}
   * @secure
   */
  export namespace AttachDocumentToApplicationDocumentAttachApplicationIdPost {
    export type RequestParams = { applicationId: string };
    export type RequestQuery = {};
    export type RequestBody = DocumentAssignation;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = DocumentAssignation[];
  }
}

export namespace Banks {
  /**
   * No description
   * @tags Banks
   * @name GetAllBanksBanksAllGet
   * @summary Get All Banks
   * @request GET:/banks/all
   * @secure
   */
  export namespace GetAllBanksBanksAllGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Bank[];
  }
  /**
   * No description
   * @tags Banks
   * @name GetBanksBanksGetPost
   * @summary Get Banks
   * @request POST:/banks/get
   * @secure
   */
  export namespace GetBanksBanksGetPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetBanksPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Bank[];
  }
  /**
   * No description
   * @tags Banks
   * @name GetAllIntegrationsBanksAllIntegrationsGet
   * @summary Get All Integrations
   * @request GET:/banks/all_integrations
   * @secure
   */
  export namespace GetAllIntegrationsBanksAllIntegrationsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Integration[];
  }
  /**
   * No description
   * @tags Banks
   * @name GetIntegrationsBanksGetIntegrationsPost
   * @summary Get Integrations
   * @request POST:/banks/get_integrations
   * @secure
   */
  export namespace GetIntegrationsBanksGetIntegrationsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = IntegrationQuery;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Integration[];
  }
}

export namespace Schedule {
  /**
   * No description
   * @tags Advisor Schedule
   * @name ScheduleDaySchedulePost
   * @summary Schedule Day
   * @request POST:/schedule/
   * @secure
   */
  export namespace ScheduleDaySchedulePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DaySlotDocPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags Advisor Schedule
   * @name GetScheduleOfDayScheduleDayGet
   * @summary Get Schedule Of Day
   * @request GET:/schedule/{day}
   * @secure
   */
  export namespace GetScheduleOfDayScheduleDayGet {
    export type RequestParams = { day: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = DaySlotDoc;
  }
  /**
   * No description
   * @tags Advisor Schedule
   * @name GetScheduleOfDayByCountryAndProductScheduleDayProductCountryGet
   * @summary Get Schedule Of Day By Country And Product
   * @request GET:/schedule/{day}/{product}/{country}
   * @secure
   */
  export namespace GetScheduleOfDayByCountryAndProductScheduleDayProductCountryGet {
    export type RequestParams = { day: string; product: Product; country: Country };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = DaySlotDoc;
  }
}

export namespace Employee {
  /**
   * No description
   * @tags Employee
   * @name GetAllEmployeesEmployeeAllGet
   * @summary Get All Employees
   * @request GET:/employee/all
   * @secure
   */
  export namespace GetAllEmployeesEmployeeAllGet {
    export type RequestParams = {};
    export type RequestQuery = { page?: number; limit?: number; without_deactivated?: boolean };
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Employee[];
  }
  /**
   * No description
   * @tags Employee
   * @name GetSverkerUsersEmployeeGetSverkerUsersGet
   * @summary Get Sverker Users
   * @request GET:/employee/get_sverker_users
   * @secure
   */
  export namespace GetSverkerUsersEmployeeGetSverkerUsersGet {
    export type RequestParams = {};
    export type RequestQuery = { user_name: string };
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = string[];
  }
  /**
   * No description
   * @tags Employee
   * @name GetEmployeesByZoordinatesEmployeeByZoordinatesPost
   * @summary Get Employees By Zoordinates
   * @request POST:/employee/by_zoordinates
   * @secure
   */
  export namespace GetEmployeesByZoordinatesEmployeeByZoordinatesPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AllOptionalZoordinates;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Employee[];
  }
  /**
   * No description
   * @tags Employee
   * @name GetMyInfoEmployeeMeGet
   * @summary Get My Info
   * @request GET:/employee/me
   * @secure
   */
  export namespace GetMyInfoEmployeeMeGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Employee;
  }
  /**
   * No description
   * @tags Employee
   * @name DeactivateUserByIdEmployeeActionsBlockOrUnblockUserIdPatch
   * @summary Deactivate User By Id
   * @request PATCH:/employee/actions/block-or-unblock/{user_id}
   * @secure
   */
  export namespace DeactivateUserByIdEmployeeActionsBlockOrUnblockUserIdPatch {
    export type RequestParams = { userId: string };
    export type RequestQuery = { block?: boolean };
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags Employee
   * @name GetAllZoordinatesEmployeeZoordinatesGet
   * @summary Get All Zoordinates
   * @request GET:/employee/zoordinates
   * @secure
   */
  export namespace GetAllZoordinatesEmployeeZoordinatesGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Zoordinates[];
  }
  /**
   * No description
   * @tags Employee
   * @name GetAllRolesEmployeeRolesGet
   * @summary Get All Roles
   * @request GET:/employee/roles
   * @secure
   */
  export namespace GetAllRolesEmployeeRolesGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = RoleType[];
  }
  /**
   * No description
   * @tags Employee
   * @name GetMySettingsEmployeeMySettingsGet
   * @summary Get My Settings
   * @request GET:/employee/my-settings
   * @secure
   */
  export namespace GetMySettingsEmployeeMySettingsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = UserSettings;
  }
  /**
   * No description
   * @tags Employee
   * @name SaveMySettingsEmployeeMySettingsPost
   * @summary Save My Settings
   * @request POST:/employee/my-settings
   * @secure
   */
  export namespace SaveMySettingsEmployeeMySettingsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UserSettings;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags Employee
   * @name CreateEmployeeEmployeePost
   * @summary Create Employee
   * @request POST:/employee/
   * @secure
   */
  export namespace CreateEmployeeEmployeePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateAndUpdateEmployeeRequest;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Employee;
  }
  /**
   * No description
   * @tags Employee
   * @name GetByIdEmployeeUserIdGet
   * @summary Get By Id
   * @request GET:/employee/{user_id}
   * @secure
   */
  export namespace GetByIdEmployeeUserIdGet {
    export type RequestParams = { userId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Employee;
  }
  /**
   * No description
   * @tags Employee
   * @name UpdateEmployeeEmployeeUserIdPut
   * @summary Update Employee
   * @request PUT:/employee/{user_id}
   * @secure
   */
  export namespace UpdateEmployeeEmployeeUserIdPut {
    export type RequestParams = { userId: string };
    export type RequestQuery = {};
    export type RequestBody = CreateAndUpdateEmployeeRequest;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Employee;
  }
  /**
   * No description
   * @tags Employee
   * @name SearchEmployeeSearchPost
   * @summary Search
   * @request POST:/employee/search
   * @secure
   */
  export namespace SearchEmployeeSearchPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RoutersEmployeeModelsSearchPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Employee[];
  }
}

export namespace Property {
  /**
   * No description
   * @tags Property
   * @name GetPropertyPropertyGetPropertyIdGet
   * @summary Get Property
   * @request GET:/property/get/{property_id}
   * @secure
   */
  export namespace GetPropertyPropertyGetPropertyIdGet {
    export type RequestParams = { propertyId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = House | VacationHome | Condominium | (House & VacationHome & Condominium);
  }
  /**
   * No description
   * @tags Property
   * @name GetPartialPropertyPropertyPartialGetPropertyIdGet
   * @summary Get Partial Property
   * @request GET:/property/partial/get/{property_id}
   * @secure
   */
  export namespace GetPartialPropertyPropertyPartialGetPropertyIdGet {
    export type RequestParams = { propertyId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = PartialProperty;
  }
  /**
   * No description
   * @tags Property
   * @name CreatePropertyPropertyCreateApplicationIdPost
   * @summary Create Property
   * @request POST:/property/create/{application_id}
   * @secure
   */
  export namespace CreatePropertyPropertyCreateApplicationIdPost {
    export type RequestParams = { applicationId: string };
    export type RequestQuery = {};
    export type RequestBody =
      | PartialHouse
      | PartialCondominium
      | PartialVacationHome
      | (PartialHouse & PartialCondominium & PartialVacationHome);
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = House | VacationHome | Condominium | (House & VacationHome & Condominium);
  }
  /**
   * No description
   * @tags Property
   * @name CreatePartialPropertyPropertyPartialCreateApplicationIdPost
   * @summary Create Partial Property
   * @request POST:/property/partial/create/{application_id}
   * @secure
   */
  export namespace CreatePartialPropertyPropertyPartialCreateApplicationIdPost {
    export type RequestParams = { applicationId: string };
    export type RequestQuery = {};
    export type RequestBody = NewPartialProperty;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = PartialProperty;
  }
  /**
   * No description
   * @tags Property
   * @name UpdatePropertyPropertyUpdatePropertyIdPut
   * @summary Update Property
   * @request PUT:/property/update/{property_id}
   * @secure
   */
  export namespace UpdatePropertyPropertyUpdatePropertyIdPut {
    export type RequestParams = { propertyId: string };
    export type RequestQuery = {};
    export type RequestBody =
      | PartialHouse
      | PartialCondominium
      | PartialVacationHome
      | (PartialHouse & PartialCondominium & PartialVacationHome);
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = House | VacationHome | Condominium | (House & VacationHome & Condominium);
  }
  /**
   * No description
   * @tags Property
   * @name UpdatePartialPropertyPropertyPartialUpdatePropertyIdPut
   * @summary Update Partial Property
   * @request PUT:/property/partial/update/{property_id}
   * @secure
   */
  export namespace UpdatePartialPropertyPropertyPartialUpdatePropertyIdPut {
    export type RequestParams = { propertyId: string };
    export type RequestQuery = {};
    export type RequestBody = NewPartialProperty;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = PartialProperty;
  }
  /**
   * No description
   * @tags Property Valuation
   * @name SearchPropertyValuationSearchPropertyIdPost
   * @summary Search
   * @request POST:/property/valuation/search/{property_id}
   * @secure
   */
  export namespace SearchPropertyValuationSearchPropertyIdPost {
    export type RequestParams = { propertyId: string };
    export type RequestQuery = {};
    export type RequestBody = RoutersPropertyPayloadSearchPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = PropertySearchResult[];
  }
  /**
   * No description
   * @tags Property Creation
   * @name SearchForAddressPropertyV2SearchPropertyTypePost
   * @summary Search For Address
   * @request POST:/property/v2/search/{property_type}
   * @secure
   */
  export namespace SearchForAddressPropertyV2SearchPropertyTypePost {
    export type RequestParams = { propertyType: MortgagePropertyType };
    export type RequestQuery = {};
    export type RequestBody = RoutersPropertyPayloadSearchPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = PropertySearchResult[];
  }
  /**
   * No description
   * @tags Property Creation
   * @name GetPropertyInfoForCreationPropertyV2InfoSearchIdGet
   * @summary Get Property Info For Creation
   * @request GET:/property/v2/info/{search_id}
   * @secure
   */
  export namespace GetPropertyInfoForCreationPropertyV2InfoSearchIdGet {
    export type RequestParams = { searchId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = PropertyInfo;
  }
  /**
   * No description
   * @tags Property Creation
   * @name GetPropertyInfoByExternalIdPropertyV2InfoByExternalIdExternalIdGet
   * @summary Get Property Info By External Id
   * @request GET:/property/v2/info-by-external-id/{external_id}
   * @secure
   */
  export namespace GetPropertyInfoByExternalIdPropertyV2InfoByExternalIdExternalIdGet {
    export type RequestParams = { externalId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = PropertyInfo;
  }
  /**
   * No description
   * @tags Property Valuation
   * @name GetPropertyValuationV2PropertyValuationV2Post
   * @summary Get Property Valuation V2
   * @request POST:/property/valuation/v2
   * @secure
   */
  export namespace GetPropertyValuationV2PropertyValuationV2Post {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ValuationPayloadV2;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = PropertyValuation;
  }
  /**
   * No description
   * @tags Property Valuation
   * @name GetPropertyInfoPropertyValuationInfoSearchIdGet
   * @summary Get Property Info
   * @request GET:/property/valuation/info/{search_id}
   * @secure
   */
  export namespace GetPropertyInfoPropertyValuationInfoSearchIdGet {
    export type RequestParams = { searchId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = PropertyInfo;
  }
  /**
   * No description
   * @tags Property Valuation
   * @name GetPropertyValuationPropertyValuationValuationPost
   * @summary Get Property Valuation
   * @request POST:/property/valuation/valuation
   * @secure
   */
  export namespace GetPropertyValuationPropertyValuationValuationPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ValuationPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = PropertyValuation;
  }
  /**
   * No description
   * @tags Property Creation
   * @name BooliSearchForAddressPropertyV2BooliSearchPost
   * @summary Booli Search For Address
   * @request POST:/property/v2/booli/search
   * @deprecated
   * @secure
   */
  export namespace BooliSearchForAddressPropertyV2BooliSearchPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BooliSearchPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = BooliPropertySearchResult[];
  }
  /**
   * No description
   * @tags Property Valuation
   * @name GetPropertyBooliValuationPropertyValuationBooliPost
   * @summary Get Property Booli Valuation
   * @request POST:/property/valuation/booli
   * @deprecated
   * @secure
   */
  export namespace GetPropertyBooliValuationPropertyValuationBooliPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BooliValuationPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = PropertyValuation;
  }
  /**
   * No description
   * @name GetPropertyByPniPropertyEvcheckCachePost
   * @summary Get Property By Pni
   * @request POST:/property/evcheck/cache
   * @secure
   */
  export namespace GetPropertyByPniPropertyEvcheckCachePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = EvCheckPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = (PartialHouse | PartialCondominium | (PartialHouse & PartialCondominium))[];
  }
}

export namespace Message {
  /**
   * No description
   * @tags Message
   * @name RemoveTemplateMessageTemplateMessageTypeTemplateNameDelete
   * @summary Remove Template
   * @request DELETE:/message/template/{message_type}/{template_name}
   * @secure
   */
  export namespace RemoveTemplateMessageTemplateMessageTypeTemplateNameDelete {
    export type RequestParams = { messageType: MessageType; templateName: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags Message
   * @name GetOneTemplateMessageTemplateGetMessageTypeTemplateNameGet
   * @summary Get One Template
   * @request GET:/message/template/get/{message_type}/{template_name}
   * @secure
   */
  export namespace GetOneTemplateMessageTemplateGetMessageTypeTemplateNameGet {
    export type RequestParams = { messageType: MessageType; templateName: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = SharedTemplate;
  }
  /**
   * No description
   * @tags Message
   * @name CreateTemplateMessageTemplateAddPost
   * @summary Create Template
   * @request POST:/message/template/add
   * @secure
   */
  export namespace CreateTemplateMessageTemplateAddPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SharedTemplate;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags Message
   * @name TemplateListMessageTemplateListMessageTypeGet
   * @summary Template List
   * @request GET:/message/template/list/{message_type}
   * @secure
   */
  export namespace TemplateListMessageTemplateListMessageTypeGet {
    export type RequestParams = { messageType: MessageType };
    export type RequestQuery = { cutoff_date?: string };
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = (EmailTemplate | SmsTemplate | (EmailTemplate & SmsTemplate))[];
  }
  /**
   * No description
   * @tags Message
   * @name SendTemplateMessageMessageSendTemplateMessageTypeTemplateNamePost
   * @summary Send Template Message
   * @request POST:/message/send/template/{message_type}/{template_name}
   * @secure
   */
  export namespace SendTemplateMessageMessageSendTemplateMessageTypeTemplateNamePost {
    export type RequestParams = { messageType: MessageType; templateName: string };
    export type RequestQuery = {};
    export type RequestBody = SendTemplatePayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags Message
   * @name SendRawMessageMessageSendRawMessageTypePost
   * @summary Send Raw Message
   * @request POST:/message/send/raw/{message_type}
   * @secure
   */
  export namespace SendRawMessageMessageSendRawMessageTypePost {
    export type RequestParams = { messageType: MessageType };
    export type RequestQuery = {};
    export type RequestBody = SendRawPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags Message
   * @name GetUnknownSenderSmsMessageSmsUnknownSenderPost
   * @summary Get Unknown Sender Sms
   * @request POST:/message/sms/unknown-sender
   * @secure
   */
  export namespace GetUnknownSenderSmsMessageSmsUnknownSenderPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetMessagesPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = IncomingSMS[];
  }
  /**
   * No description
   * @tags Message
   * @name GetMessagesForUserMessageUserPost
   * @summary Get Messages For User
   * @request POST:/message/user
   * @secure
   */
  export namespace GetMessagesForUserMessageUserPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetUserMessagesPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = SavedMessage[];
  }
  /**
   * No description
   * @tags Message
   * @name GetMessagesForApplicationMessageApplicationPost
   * @summary Get Messages For Application
   * @request POST:/message/application
   * @secure
   */
  export namespace GetMessagesForApplicationMessageApplicationPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetApplicationMessagesPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = SavedMessage[];
  }
  /**
   * No description
   * @tags Message
   * @name GetMessagesByCustomerIdMessageByCustomerPost
   * @summary Get Messages By Customer Id
   * @request POST:/message/by-customer
   * @secure
   */
  export namespace GetMessagesByCustomerIdMessageByCustomerPost {
    export type RequestParams = {};
    export type RequestQuery = { page?: number; limit?: number };
    export type RequestBody = GetMessages;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = SavedMessageWithName[];
  }
  /**
   * No description
   * @tags Message
   * @name GetConversationsMessageConversationsGet
   * @summary Get Conversations
   * @request GET:/message/conversations
   * @secure
   */
  export namespace GetConversationsMessageConversationsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Conversation[];
  }
  /**
   * No description
   * @tags Message
   * @name SaveConversationsMessageConversationsPost
   * @summary Save Conversations
   * @request POST:/message/conversations
   * @secure
   */
  export namespace SaveConversationsMessageConversationsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = Conversation[];
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Conversation[];
  }
  /**
   * No description
   * @tags Message
   * @name StreamConversationsMessageConversationsStreamGet
   * @summary Stream Conversations
   * @request GET:/message/conversations/stream
   * @secure
   */
  export namespace StreamConversationsMessageConversationsStreamGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags Message
   * @name UploadAttachmentMessageAttachmentsUploadPost
   * @summary Upload Attachment
   * @request POST:/message/attachments/upload
   * @secure
   */
  export namespace UploadAttachmentMessageAttachmentsUploadPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyUploadAttachmentMessageAttachmentsUploadPost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = DateTime;
  }
  /**
   * No description
   * @tags Message
   * @name GetAttachmentsMessageAttachmentsAllGet
   * @summary Get Attachments
   * @request GET:/message/attachments/all
   * @secure
   */
  export namespace GetAttachmentsMessageAttachmentsAllGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = SavedAttachment[];
  }
  /**
   * No description
   * @tags ELK46 Callbacks
   * @name Elk46SmsWebhookMessageElk46ConfirmationPost
   * @summary Elk46 Sms Webhook
   * @request POST:/message/elk46/confirmation
   */
  export namespace Elk46SmsWebhookMessageElk46ConfirmationPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-forwarded-for": string };
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags ELK46 Callbacks
   * @name Elk46CallWebhookMessageElk46CallPost
   * @summary Elk46 Call Webhook
   * @request POST:/message/elk46/call
   */
  export namespace Elk46CallWebhookMessageElk46CallPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyElk46CallWebhookMessageElk46CallPost;
    export type RequestHeaders = {};
    export type ResponseBody = Elk46CallResponse;
  }
}

export namespace Mortgage {
  /**
   * No description
   * @tags Mortgage
   * @name GetKalpSettingsMortgageKalpCountryGet
   * @summary Get Kalp Settings
   * @request GET:/mortgage/kalp/{country}
   * @secure
   */
  export namespace GetKalpSettingsMortgageKalpCountryGet {
    export type RequestParams = { country: Country };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = (BankKALP | BankAPIDrivenKALP | (BankKALP & BankAPIDrivenKALP))[];
  }
}

export namespace Other {
  /**
   * No description
   * @tags Other
   * @name GetAllTaxesForCountryOtherTaxesCountryGet
   * @summary Get All Taxes For Country
   * @request GET:/other/taxes/{country}
   * @secure
   */
  export namespace GetAllTaxesForCountryOtherTaxesCountryGet {
    export type RequestParams = { country: Country };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Tax[];
  }
  /**
   * No description
   * @tags Other
   * @name TaxesForIdentifierOtherTaxesCalculationPost
   * @summary Taxes For Identifier
   * @request POST:/other/taxes/calculation
   * @secure
   */
  export namespace TaxesForIdentifierOtherTaxesCalculationPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetTaxPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = GetTaxPayloadResponse;
  }
  /**
   * No description
   * @tags Other
   * @name GetAllMunicipalitiesForCountryOtherMunicipalityCountryGet
   * @summary Get All Municipalities For Country
   * @request GET:/other/municipality/{country}
   * @secure
   */
  export namespace GetAllMunicipalitiesForCountryOtherMunicipalityCountryGet {
    export type RequestParams = { country: Country };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Municipality[];
  }
  /**
   * No description
   * @tags Other
   * @name DeactivationReasonsOtherDeactivationReasonsGet
   * @summary Deactivation Reasons
   * @request GET:/other/deactivation-reasons
   * @secure
   */
  export namespace DeactivationReasonsOtherDeactivationReasonsGet {
    export type RequestParams = {};
    export type RequestQuery = { product: Product };
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = string[];
  }
  /**
   * No description
   * @tags Other, websocket
   * @name GetTokenOtherWsTokenForWebsocketGet
   * @summary Get Token
   * @request GET:/other/ws/token-for-websocket
   * @secure
   */
  export namespace GetTokenOtherWsTokenForWebsocketGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = TokenResp;
  }
}

export namespace BankId {
  /**
   * No description
   * @tags BankID
   * @name VerifyCustomerBankIdVerifyPost
   * @summary Verify Customer
   * @request POST:/bank-id/verify
   * @secure
   */
  export namespace VerifyCustomerBankIdVerifyPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BankIDPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = RoutersBankIdModelsBankIDResp;
  }
  /**
   * No description
   * @tags BankID
   * @name IsAlreadyVerifiedBankIdVerifiedPost
   * @summary Is Already Verified
   * @request POST:/bank-id/verified
   * @secure
   */
  export namespace IsAlreadyVerifiedBankIdVerifiedPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BankIDPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = PollResp;
  }
  /**
   * No description
   * @tags BankID
   * @name GetTicketStatusBankIdVerifyTicketIdGet
   * @summary Get Ticket Status
   * @request GET:/bank-id/verify/{ticket_id}
   * @secure
   */
  export namespace GetTicketStatusBankIdVerifyTicketIdGet {
    export type RequestParams = { ticketId: string };
    export type RequestQuery = { redirect?: boolean };
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = PollResp;
  }
  /**
   * No description
   * @tags BankID
   * @name IdKollenRedirectNoBankIdIdKollenCallbackGet
   * @summary Id Kollen Redirect No
   * @request GET:/bank-id/id-kollen/callback
   */
  export namespace IdKollenRedirectNoBankIdIdKollenCallbackGet {
    export type RequestParams = {};
    export type RequestQuery = { refID?: string; code?: string; error?: string };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags BankID
   * @name IdKollenCallbackSeBankIdIdKollenCallbackPost
   * @summary Id Kollen Callback Se
   * @request POST:/bank-id/id-kollen/callback
   */
  export namespace IdKollenCallbackSeBankIdIdKollenCallbackPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = IDKollenCallbackRequestSE;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags BankID
   * @name BankIdSignupStatusBankIdSignStatusGet
   * @summary Bank Id Signup Status
   * @request GET:/bank-id/sign/status
   */
  export namespace BankIdSignupStatusBankIdSignStatusGet {
    export type RequestParams = {};
    export type RequestQuery = { a: string; c: string };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ClientAutostartToken;
  }
  /**
   * No description
   * @tags BankID
   * @name AutostartTokenBankIdSignGet
   * @summary Autostart Token
   * @request GET:/bank-id/sign
   */
  export namespace AutostartTokenBankIdSignGet {
    export type RequestParams = {};
    export type RequestQuery = { a: string; c: string };
    export type RequestBody = never;
    export type RequestHeaders = { "x-forwarded-for": string };
    export type ResponseBody = ClientAutostartToken;
  }
  /**
   * No description
   * @tags BankID Login
   * @name LoginBankIdAuthPost
   * @summary Login
   * @request POST:/bank-id/auth
   */
  export namespace LoginBankIdAuthPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = LoginPayload;
    export type RequestHeaders = {};
    export type ResponseBody = RoutersBankIdLoginPayloadBankIDResp;
  }
  /**
   * No description
   * @tags BankID Login
   * @name PollTicketBankIdTicketIdGet
   * @summary Poll Ticket
   * @request GET:/bank-id/{ticket_id}
   */
  export namespace PollTicketBankIdTicketIdGet {
    export type RequestParams = { ticketId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BankIDLoginResponse;
  }
}

export namespace Notification {
  /**
   * No description
   * @tags Notifications
   * @name UserNotificationsNotificationGet
   * @summary User Notifications
   * @request GET:/notification/
   * @secure
   */
  export namespace UserNotificationsNotificationGet {
    export type RequestParams = {};
    export type RequestQuery = {
      status?: NotificationEvent[];
      notification_type?: ModelsNotificationsNotificationTypesNotificationType;
      page?: number;
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ModelsNotificationsNotificationNotification[];
  }
  /**
   * No description
   * @tags Notifications
   * @name GetNotificationNotificationByIdNotificationIdGet
   * @summary Get Notification
   * @request GET:/notification/by-id/{notification_id}
   * @secure
   */
  export namespace GetNotificationNotificationByIdNotificationIdGet {
    export type RequestParams = { notificationId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ModelsNotificationsNotificationNotification;
  }
  /**
   * No description
   * @tags Notifications
   * @name NotifyNotificationNotifyIncomingPost
   * @summary Notify
   * @request POST:/notification/notify/incoming
   * @secure
   */
  export namespace NotifyNotificationNotifyIncomingPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AppsmgrModelsNotificationsNotification;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags Notifications
   * @name NotifyInsuranceNotificationNotifyInsurancePost
   * @summary Notify Insurance
   * @request POST:/notification/notify/insurance
   * @secure
   */
  export namespace NotifyInsuranceNotificationNotifyInsurancePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = InsuranceNotification;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags Notifications
   * @name AcknowledgeNotificationNotificationActionPost
   * @summary Acknowledge Notification
   * @request POST:/notification/action
   * @secure
   */
  export namespace AcknowledgeNotificationNotificationActionPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ActionPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags Notifications
   * @name CustomAuthUserNotificationsNotificationNotificationIdReceivedPatch
   * @summary Custom Auth User Notifications
   * @request PATCH:/notification/{notification_id}/received
   */
  export namespace CustomAuthUserNotificationsNotificationNotificationIdReceivedPatch {
    export type RequestParams = { notificationId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { token?: string };
    export type ResponseBody = void;
  }
}

export namespace Ponytail {
  /**
   * No description
   * @tags Ponytail
   * @name GetDisbursedStatsPonytailDisbursedAllPost
   * @summary Get Disbursed Stats
   * @request POST:/ponytail/disbursed/all
   * @secure
   */
  export namespace GetDisbursedStatsPonytailDisbursedAllPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DashboardPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = AllDisbursedLoans;
  }
  /**
   * No description
   * @tags Ponytail
   * @name GetMyDisbursedPonytailDisbursedMePost
   * @summary Get My Disbursed
   * @request POST:/ponytail/disbursed/me
   * @secure
   */
  export namespace GetMyDisbursedPonytailDisbursedMePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DashboardPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = MyDisbursedLoans;
  }
  /**
   * No description
   * @tags Ponytail
   * @name GetAcceptedPonytailAcceptedAllPost
   * @summary Get Accepted
   * @request POST:/ponytail/accepted/all
   * @secure
   */
  export namespace GetAcceptedPonytailAcceptedAllPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DashboardPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = AcceptedLoans;
  }
  /**
   * No description
   * @tags Ponytail
   * @name GetMyAcceptedPonytailAcceptedMePost
   * @summary Get My Accepted
   * @request POST:/ponytail/accepted/me
   * @secure
   */
  export namespace GetMyAcceptedPonytailAcceptedMePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DashboardPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = AcceptedLoans;
  }
  /**
   * No description
   * @tags Ponytail
   * @name GetAllInsurancePonytailInsuranceAllPost
   * @summary Get All Insurance
   * @request POST:/ponytail/insurance/all
   * @secure
   */
  export namespace GetAllInsurancePonytailInsuranceAllPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DashboardPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = AllInsurances;
  }
  /**
   * No description
   * @tags Ponytail
   * @name GetMyInsurancePonytailInsuranceMePost
   * @summary Get My Insurance
   * @request POST:/ponytail/insurance/me
   * @secure
   */
  export namespace GetMyInsurancePonytailInsuranceMePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DashboardPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = AllInsurances;
  }
  /**
   * No description
   * @tags Ponytail
   * @name GetAllMyStatsPonytailMyStatsPost
   * @summary Get All My Stats
   * @request POST:/ponytail/my-stats
   * @secure
   */
  export namespace GetAllMyStatsPonytailMyStatsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DashboardPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = MyStatsShared;
  }
  /**
   * No description
   * @tags Ponytail
   * @name SummarizedViewPonytailSummarizedPost
   * @summary Summarized View
   * @request POST:/ponytail/summarized
   * @secure
   */
  export namespace SummarizedViewPonytailSummarizedPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DashboardPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = SummarizedViewShared;
  }
  /**
   * No description
   * @tags Ponytail
   * @name GetWorkingDaysPonytailWorkingDaysPost
   * @summary Get Working Days
   * @request POST:/ponytail/working-days
   * @secure
   */
  export namespace GetWorkingDaysPonytailWorkingDaysPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GoalPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = WorkingDays;
  }
  /**
   * No description
   * @tags Ponytail
   * @name PostBlancoGoalPonytailGoalsCreateBlancoPost
   * @summary Post Blanco Goal
   * @request POST:/ponytail/goals/create/blanco
   * @secure
   */
  export namespace PostBlancoGoalPonytailGoalsCreateBlancoPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BlancoGoalPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = BlancoGoal;
  }
  /**
   * No description
   * @tags Ponytail
   * @name PostBlancoGoalMbPonytailGoalsCreateBlancoMbPost
   * @summary Post Blanco Goal Mb
   * @request POST:/ponytail/goals/create/blanco-mb
   * @secure
   */
  export namespace PostBlancoGoalMbPonytailGoalsCreateBlancoMbPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BlancoGoalMbPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = BlancoGoalMb;
  }
  /**
   * No description
   * @tags Ponytail
   * @name PostInitialBlancoGoalPonytailGoalsCreateInitialBlancoPost
   * @summary Post Initial Blanco Goal
   * @request POST:/ponytail/goals/create/initial-blanco
   * @secure
   */
  export namespace PostInitialBlancoGoalPonytailGoalsCreateInitialBlancoPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BlancoGoalPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = BlancoGoal;
  }
  /**
   * No description
   * @tags Ponytail
   * @name PostInitialBudgetPonytailGoalsCreateInitialBlancoMbPost
   * @summary Post Initial Budget
   * @request POST:/ponytail/goals/create/initial-blanco-mb
   * @secure
   */
  export namespace PostInitialBudgetPonytailGoalsCreateInitialBlancoMbPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BudgetPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Budget;
  }
  /**
   * No description
   * @tags Ponytail
   * @name GetMyGoalsPonytailGoalsPost
   * @summary Get My Goals
   * @request POST:/ponytail/goals
   * @secure
   */
  export namespace GetMyGoalsPonytailGoalsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GoalPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = BlancoGoalMb | BlancoGoal | MortgageGoal | (BlancoGoalMb & BlancoGoal & MortgageGoal);
  }
  /**
   * No description
   * @tags Ponytail
   * @name GetInitialGoalPonytailGoalsInitialGoalPost
   * @summary Get Initial Goal
   * @request POST:/ponytail/goals/initial-goal
   * @secure
   */
  export namespace GetInitialGoalPonytailGoalsInitialGoalPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GoalPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Budget | BlancoGoal | MortgageGoal | (Budget & BlancoGoal & MortgageGoal);
  }
}

export namespace Lead {
  /**
   * No description
   * @tags Lead
   * @name GetLeadLeadGetLeadIdGet
   * @summary Get Lead
   * @request GET:/lead/get/{lead_id}
   * @secure
   */
  export namespace GetLeadLeadGetLeadIdGet {
    export type RequestParams = { leadId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Lead;
  }
  /**
   * No description
   * @tags Lead
   * @name GetLeadsLeadListPost
   * @summary Get Leads
   * @request POST:/lead/list
   * @secure
   */
  export namespace GetLeadsLeadListPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetLeads;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Lead[];
  }
  /**
   * No description
   * @tags Lead
   * @name CreateLeadLeadCreatePost
   * @summary Create Lead
   * @request POST:/lead/create
   * @secure
   */
  export namespace CreateLeadLeadCreatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateLeadPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Lead;
  }
  /**
   * No description
   * @tags Lead
   * @name SearchLeadSearchPost
   * @summary Search
   * @request POST:/lead/search
   * @secure
   */
  export namespace SearchLeadSearchPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RoutersLeadPayloadSearchPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Lead[];
  }
  /**
   * No description
   * @tags Lead
   * @name ConvertAndCloseLeadConvertAndMarkHandledPost
   * @summary Convert And Close
   * @request POST:/lead/convert_and_mark_handled
   * @secure
   */
  export namespace ConvertAndCloseLeadConvertAndMarkHandledPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ConvertPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ConvertResult;
  }
  /**
   * No description
   * @tags Lead
   * @name CloseLeadMarkHandledPost
   * @summary Close
   * @request POST:/lead/mark_handled
   * @secure
   */
  export namespace CloseLeadMarkHandledPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = LeadHandledPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags Lead
   * @name UnhandleLeadLeadUnhandlePost
   * @summary Unhandle Lead
   * @request POST:/lead/unhandle
   * @secure
   */
  export namespace UnhandleLeadLeadUnhandlePost {
    export type RequestParams = {};
    export type RequestQuery = { lead_id: string };
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags Lead
   * @name UpdateLeadLeadUpdateLeadIdPost
   * @summary Update Lead
   * @request POST:/lead/update/{lead_id}
   * @secure
   */
  export namespace UpdateLeadLeadUpdateLeadIdPost {
    export type RequestParams = { leadId: string };
    export type RequestQuery = {};
    export type RequestBody = LeadUpdatePayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Lead;
  }
  /**
   * No description
   * @tags Lead
   * @name ReprocessSubmissionLeadReprocessSubmissionLeadIdPost
   * @summary Reprocess Submission
   * @request POST:/lead/reprocess_submission/{lead_id}
   * @secure
   */
  export namespace ReprocessSubmissionLeadReprocessSubmissionLeadIdPost {
    export type RequestParams = { leadId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags Lead
   * @name ReprocessSubmissionsLeadReprocessSubmissionsPost
   * @summary Reprocess Submissions
   * @request POST:/lead/reprocess_submissions
   * @secure
   */
  export namespace ReprocessSubmissionsLeadReprocessSubmissionsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ReprocessSubmissionPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ReprocessResult[];
  }
  /**
   * No description
   * @tags Lead
   * @name GetCommentsLeadCommentLeadIdGet
   * @summary Get Comments
   * @request GET:/lead/comment/{lead_id}
   * @secure
   */
  export namespace GetCommentsLeadCommentLeadIdGet {
    export type RequestParams = { leadId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = InternalCommentWithName[];
  }
  /**
   * No description
   * @tags Lead
   * @name AddInternalCommentLeadCommentLeadIdPost
   * @summary Add Internal Comment
   * @request POST:/lead/comment/{lead_id}
   * @secure
   */
  export namespace AddInternalCommentLeadCommentLeadIdPost {
    export type RequestParams = { leadId: string };
    export type RequestQuery = {};
    export type RequestBody = CommentPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = InternalCommentWithName[];
  }
  /**
   * No description
   * @tags Lead
   * @name AssignLeadToHandlerLeadAssignLeadIdPost
   * @summary Assign Lead To Handler
   * @request POST:/lead/assign/{lead_id}
   * @secure
   */
  export namespace AssignLeadToHandlerLeadAssignLeadIdPost {
    export type RequestParams = { leadId: string };
    export type RequestQuery = {};
    export type RequestBody = AssignApplicationPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags Lead
   * @name GetAssignedHandlerLeadAssigneeLeadIdGet
   * @summary Get Assigned Handler
   * @request GET:/lead/assignee/{lead_id}
   * @secure
   */
  export namespace GetAssignedHandlerLeadAssigneeLeadIdGet {
    export type RequestParams = { leadId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Assignee;
  }
  /**
   * No description
   * @tags Lead
   * @name GetLeadsLeadListMinePost
   * @summary Get Leads
   * @request POST:/lead/list/mine
   * @secure
   */
  export namespace GetLeadsLeadListMinePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetMyLeads;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Lead[];
  }
}

export namespace Formprefs {
  /**
   * No description
   * @tags Jotform
   * @name UpdatePreferenceFormprefsPut
   * @summary Update Preference
   * @request PUT:/formprefs/
   * @secure
   */
  export namespace UpdatePreferenceFormprefsPut {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UpdateFormPreferencePayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = FormPreferenceExt;
  }
  /**
   * No description
   * @tags Jotform
   * @name CreatePreferenceFormprefsPost
   * @summary Create Preference
   * @request POST:/formprefs/
   * @secure
   */
  export namespace CreatePreferenceFormprefsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = FormPreferencePayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = FormPreferenceExt;
  }
  /**
   * No description
   * @tags Jotform
   * @name DuplicatePreferenceFormprefsDuplicatePost
   * @summary Duplicate Preference
   * @request POST:/formprefs/duplicate
   * @secure
   */
  export namespace DuplicatePreferenceFormprefsDuplicatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DuplicateFormPreferencePayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = FormPreferenceExt;
  }
  /**
   * No description
   * @tags Jotform
   * @name ValidatePreferenceFormprefsValidatePost
   * @summary Validate Preference
   * @request POST:/formprefs/validate
   * @secure
   */
  export namespace ValidatePreferenceFormprefsValidatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ValidatePayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = FormPreferenceExt;
  }
  /**
   * No description
   * @tags Jotform
   * @name GetMappingFormprefsGetMappingPost
   * @summary Get Mapping
   * @request POST:/formprefs/get_mapping
   * @secure
   */
  export namespace GetMappingFormprefsGetMappingPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BaseFormPreferencePayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = FormMapping;
  }
  /**
   * No description
   * @tags Jotform
   * @name ListPreferencesFormprefsListGet
   * @summary List Preferences
   * @request GET:/formprefs/list
   * @secure
   */
  export namespace ListPreferencesFormprefsListGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = FormPreference[];
  }
  /**
   * No description
   * @tags Jotform
   * @name ListPreferencesExtFormprefsListExtGet
   * @summary List Preferences Ext
   * @request GET:/formprefs/list_ext
   * @secure
   */
  export namespace ListPreferencesExtFormprefsListExtGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = FormPreferenceExt[];
  }
  /**
   * No description
   * @tags Jotform
   * @name ListFormsFormprefsFormsGet
   * @summary List Forms
   * @request GET:/formprefs/forms
   * @secure
   */
  export namespace ListFormsFormprefsFormsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Form[];
  }
  /**
   * No description
   * @tags Jotform
   * @name CheckAllSubmissionsFormprefsCheckAllGet
   * @summary Check All Submissions
   * @request GET:/formprefs/check-all
   * @secure
   */
  export namespace CheckAllSubmissionsFormprefsCheckAllGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags Jotform
   * @name GetAllSubmissionsFormprefsSubmissionsGet
   * @summary Get All Submissions
   * @request GET:/formprefs/submissions
   * @secure
   */
  export namespace GetAllSubmissionsFormprefsSubmissionsGet {
    export type RequestParams = {};
    export type RequestQuery = { form_id?: string };
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags Jotform
   * @name GetFormPreferenceFormprefsFormPreferenceIdGet
   * @summary Get Form Preference
   * @request GET:/formprefs/{form_preference_id}
   * @secure
   */
  export namespace GetFormPreferenceFormprefsFormPreferenceIdGet {
    export type RequestParams = { formPreferenceId: string };
    export type RequestQuery = { add_defaults?: boolean };
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = FormPreferenceExt;
  }
  /**
   * No description
   * @tags Jotform
   * @name CreateWebhookFormprefsWebhookPost
   * @summary Create Webhook
   * @request POST:/formprefs/webhook
   * @secure
   */
  export namespace CreateWebhookFormprefsWebhookPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = FormWebhookPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags Jotform
   * @name DeleteWebhookFormprefsWebhookDelete
   * @summary Delete Webhook
   * @request DELETE:/formprefs/webhook
   * @secure
   */
  export namespace DeleteWebhookFormprefsWebhookDelete {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = FormWebhookPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = any;
  }
}

export namespace Heimdall {
  /**
   * No description
   * @tags Heimdall
   * @name GetAllHeimdallRecordsForDateHeimdallDateGet
   * @summary Get All Heimdall Records For Date
   * @request GET:/heimdall/{date}
   * @secure
   */
  export namespace GetAllHeimdallRecordsForDateHeimdallDateGet {
    export type RequestParams = { date: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = HeimdallResponse[];
  }
  /**
   * No description
   * @tags Heimdall
   * @name ReportAndVerifyUsageToHeimdallHeimdallUserIdPatch
   * @summary Report And Verify Usage To Heimdall
   * @request PATCH:/heimdall/{user_id}
   * @secure
   */
  export namespace ReportAndVerifyUsageToHeimdallHeimdallUserIdPatch {
    export type RequestParams = { userId: string };
    export type RequestQuery = {};
    export type RequestBody = HeimdallReportingPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = HeimdallReportingResponse;
  }
  /**
   * No description
   * @tags Heimdall
   * @name ResetHeimdallRateLimitHeimdallUserIdToResetResetPatch
   * @summary Reset Heimdall Rate Limit
   * @request PATCH:/heimdall/{user_id_to_reset}/reset
   * @secure
   */
  export namespace ResetHeimdallRateLimitHeimdallUserIdToResetResetPatch {
    export type RequestParams = { userIdToReset: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = void;
  }
}

export namespace LarsMagnus {
  /**
   * No description
   * @tags Lars Magnus
   * @name CheckTelavoxIdsLarsMagnusTelavoxCheckGet
   * @summary Check Telavox Ids
   * @request GET:/lars-magnus/telavox-check
   * @secure
   */
  export namespace CheckTelavoxIdsLarsMagnusTelavoxCheckGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = TelavoxMismatch;
  }
}

export namespace MyPages {
  /**
   * No description
   * @tags My Pages
   * @name ImpersonateCustomerMyPagesImpersonatePost
   * @summary Impersonate Customer
   * @request POST:/my-pages/impersonate
   * @secure
   */
  export namespace ImpersonateCustomerMyPagesImpersonatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ImpersonateCustomerPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = BankIDLoginResponse;
  }
  /**
   * No description
   * @tags My Pages
   * @name GetLatestActiveApplicationMyPagesApplicationLatestGet
   * @summary Get Latest Active Application
   * @request GET:/my-pages/application/latest
   * @secure
   */
  export namespace GetLatestActiveApplicationMyPagesApplicationLatestGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CustomerApplication;
  }
  /**
   * No description
   * @tags My Pages
   * @name GetCreditCardOffersMyPagesCreditCardOffersGet
   * @summary Get Credit Card Offers
   * @request GET:/my-pages/credit_card/offers
   * @secure
   */
  export namespace GetCreditCardOffersMyPagesCreditCardOffersGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CreditorOfferCreditCardOfferCreditCardTerms[];
  }
  /**
   * No description
   * @tags My Pages
   * @name GetApplicantMyPagesApplicantMeGet
   * @summary Get Applicant
   * @request GET:/my-pages/applicant/me
   * @secure
   */
  export namespace GetApplicantMyPagesApplicantMeGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApplicantSE | ApplicantNO | (ApplicantSE & ApplicantNO);
  }
  /**
   * No description
   * @tags My Pages
   * @name ValidateClearingMyPagesOffersClearingValidateClearingGet
   * @summary Validate Clearing
   * @request GET:/my-pages/offers/clearing/validate/{clearing}
   * @secure
   */
  export namespace ValidateClearingMyPagesOffersClearingValidateClearingGet {
    export type RequestParams = { clearing: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BankCommunicationData;
  }
  /**
   * @description Legacy blanco endpoint (Sverker)
   * @tags My Pages
   * @name AcceptOfferLegacyMyPagesOfferAcceptPost
   * @summary Accept Offer Legacy
   * @request POST:/my-pages/offer/accept
   * @secure
   */
  export namespace AcceptOfferLegacyMyPagesOfferAcceptPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AcceptOfferPayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags My Pages
   * @name AcceptOfferMyPagesOfferAccept2Post
   * @summary Accept Offer
   * @request POST:/my-pages/offer/accept2
   * @secure
   */
  export namespace AcceptOfferMyPagesOfferAccept2Post {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AcceptOffer;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags My Pages
   * @name BanksToExcludeFromInsuranceOfferingForMyPagesInsurancesBanksExcludedGet
   * @summary Banks To Exclude From Insurance Offering For
   * @request GET:/my-pages/insurances/banks/excluded
   * @secure
   */
  export namespace BanksToExcludeFromInsuranceOfferingForMyPagesInsurancesBanksExcludedGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BanksToExcludeInsuranceOfferingFor;
  }
  /**
   * No description
   * @tags My Pages
   * @name InsurancesRulesMyPagesInsurancesRulesGet
   * @summary Insurances Rules
   * @request GET:/my-pages/insurances/rules
   * @secure
   */
  export namespace InsurancesRulesMyPagesInsurancesRulesGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = object[];
  }
  /**
   * No description
   * @tags My Pages
   * @name ActiveInsuranceByPniMyPagesInsurancesGet
   * @summary Active Insurance By Pni
   * @request GET:/my-pages/insurances
   * @secure
   */
  export namespace ActiveInsuranceByPniMyPagesInsurancesGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = object[];
  }
  /**
   * No description
   * @tags My Pages
   * @name CreateInsuranceMyPagesInsurancesPost
   * @summary Create Insurance
   * @request POST:/my-pages/insurances
   * @secure
   */
  export namespace CreateInsuranceMyPagesInsurancesPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BankCommunicationData;
    export type RequestHeaders = {};
    export type ResponseBody = BankCommunicationData;
  }
  /**
   * No description
   * @tags My Pages
   * @name GetGrIframeMyPagesGrIframeGet
   * @summary Get Gr Iframe
   * @request GET:/my-pages/gr/iframe
   * @secure
   */
  export namespace GetGrIframeMyPagesGrIframeGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GRIframeURL;
  }
}

export namespace Affiliates {
  /**
   * No description
   * @tags Affiliate
   * @name GetAffiliatesAffiliatesGet
   * @summary Get Affiliates
   * @request GET:/affiliates/
   * @secure
   */
  export namespace GetAffiliatesAffiliatesGet {
    export type RequestParams = {};
    export type RequestQuery = {
      page?: number;
      limit?: number;
      status?: string;
      network?: boolean;
      publisher?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Affiliate[];
  }
  /**
   * No description
   * @tags Affiliate
   * @name CreateAffiliateAffiliatesPost
   * @summary Create Affiliate
   * @request POST:/affiliates/
   * @secure
   */
  export namespace CreateAffiliateAffiliatesPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AffiliateData;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Affiliate;
  }
  /**
   * No description
   * @tags Affiliate
   * @name SearchAffiliatesAffiliatesSearchGet
   * @summary Search Affiliates
   * @request GET:/affiliates/search
   * @secure
   */
  export namespace SearchAffiliatesAffiliatesSearchGet {
    export type RequestParams = {};
    export type RequestQuery = { keyword: string; page?: number; limit?: number };
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Affiliate[];
  }
  /**
   * No description
   * @tags Affiliate
   * @name GetAffiliateAffiliatesAffiliateIdGet
   * @summary Get Affiliate
   * @request GET:/affiliates/{affiliate_id}
   * @secure
   */
  export namespace GetAffiliateAffiliatesAffiliateIdGet {
    export type RequestParams = { affiliateId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Affiliate;
  }
  /**
   * No description
   * @tags Affiliate
   * @name UpdateAffiliateAffiliatesAffiliateIdPut
   * @summary Update Affiliate
   * @request PUT:/affiliates/{affiliate_id}
   * @secure
   */
  export namespace UpdateAffiliateAffiliatesAffiliateIdPut {
    export type RequestParams = { affiliateId: string };
    export type RequestQuery = {};
    export type RequestBody = AffiliateData;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Affiliate;
  }
  /**
   * No description
   * @tags Affiliate
   * @name DeactivateAffiliateAffiliatesAffiliateIdDelete
   * @summary Deactivate Affiliate
   * @request DELETE:/affiliates/{affiliate_id}
   * @secure
   */
  export namespace DeactivateAffiliateAffiliatesAffiliateIdDelete {
    export type RequestParams = { affiliateId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = DateTime;
  }
  /**
   * No description
   * @tags Affiliate
   * @name GetCampaignsAffiliatesAffiliateIdCampaignsGet
   * @summary Get Campaigns
   * @request GET:/affiliates/{affiliate_id}/campaigns
   * @secure
   */
  export namespace GetCampaignsAffiliatesAffiliateIdCampaignsGet {
    export type RequestParams = { affiliateId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ModelsAffiliateAffiliateCampaign[];
  }
  /**
   * No description
   * @tags Affiliate
   * @name CreateCampaignAffiliatesAffiliateIdCampaignsPost
   * @summary Create Campaign
   * @request POST:/affiliates/{affiliate_id}/campaigns
   * @secure
   */
  export namespace CreateCampaignAffiliatesAffiliateIdCampaignsPost {
    export type RequestParams = { affiliateId: string };
    export type RequestQuery = {};
    export type RequestBody = ModelsAffiliateAffiliateCampaignData;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Affiliate;
  }
  /**
   * No description
   * @tags Affiliate
   * @name UpdateCampaignAffiliatesAffiliateIdCampaignsCampaignIdPut
   * @summary Update Campaign
   * @request PUT:/affiliates/{affiliate_id}/campaigns/{campaign_id}
   * @secure
   */
  export namespace UpdateCampaignAffiliatesAffiliateIdCampaignsCampaignIdPut {
    export type RequestParams = { campaignId: string; affiliateId: string };
    export type RequestQuery = {};
    export type RequestBody = ModelsAffiliateAffiliateCampaignData;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Affiliate;
  }
  /**
   * No description
   * @tags Affiliate
   * @name RemoveCampaignAffiliatesAffiliateIdCampaignsCampaignIdDelete
   * @summary Remove Campaign
   * @request DELETE:/affiliates/{affiliate_id}/campaigns/{campaign_id}
   * @secure
   */
  export namespace RemoveCampaignAffiliatesAffiliateIdCampaignsCampaignIdDelete {
    export type RequestParams = { campaignId: string; affiliateId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags Affiliate
   * @name GetPersonEventAffiliatesPersonsZidGet
   * @summary Get Person Event
   * @request GET:/affiliates/persons/{zid}
   * @secure
   */
  export namespace GetPersonEventAffiliatesPersonsZidGet {
    export type RequestParams = { zid: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Person;
  }
  /**
   * No description
   * @tags Affiliate
   * @name GetAffiliatePersonEventsAffiliatesAffiliateIdPersonsGet
   * @summary Get Affiliate Person Events
   * @request GET:/affiliates/{affiliate_id}/persons
   * @secure
   */
  export namespace GetAffiliatePersonEventsAffiliatesAffiliateIdPersonsGet {
    export type RequestParams = { affiliateId: string };
    export type RequestQuery = { page?: number; limit?: number };
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Person[];
  }
  /**
   * No description
   * @tags Affiliate
   * @name GetAffiliateCallbacksAffiliatesAffiliateNetworkIdCallbacksPost
   * @summary Get Affiliate Callbacks
   * @request POST:/affiliates/{affiliate_network_id}/callbacks
   * @secure
   */
  export namespace GetAffiliateCallbacksAffiliatesAffiliateNetworkIdCallbacksPost {
    export type RequestParams = { affiliateNetworkId: string };
    export type RequestQuery = {
      page?: number;
      limit?: number;
      publisher?: string;
      start_date?: string;
      end_date?: string;
    };
    export type RequestBody = AffiliateNetworkCallbackStatus[];
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = AffiliateNetworkCallbackEvent[];
  }
  /**
   * No description
   * @tags Affiliate
   * @name GetAffiliatePublishersAffiliatesAffiliateIdPublishersGet
   * @summary Get Affiliate Publishers
   * @request GET:/affiliates/{affiliate_id}/publishers
   * @secure
   */
  export namespace GetAffiliatePublishersAffiliatesAffiliateIdPublishersGet {
    export type RequestParams = { affiliateId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Affiliate[];
  }
  /**
   * No description
   * @tags Affiliate
   * @name AdtractionNetworkCallbackAffiliatesDevAdtractionCallbackSiteTtGet
   * @summary Adtraction Network Callback
   * @request GET:/affiliates/dev/adtraction/callback/{site}/t/t
   * @secure
   */
  export namespace AdtractionNetworkCallbackAffiliatesDevAdtractionCallbackSiteTtGet {
    export type RequestParams = { site: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = HTTPStatus;
  }
  /**
   * No description
   * @tags Affiliate
   * @name AdserviceNetworkCallbackAffiliatesDevAdserviceCallbackCgiBinApiConversionServiceCallbackGet
   * @summary Adservice Network Callback
   * @request GET:/affiliates/dev/adservice/callback/cgi-bin/API/ConversionService/Callback
   * @secure
   */
  export namespace AdserviceNetworkCallbackAffiliatesDevAdserviceCallbackCgiBinApiConversionServiceCallbackGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = HTTPStatus;
  }
  /**
   * No description
   * @tags Affiliate
   * @name SmartresponseNetworkCallbackAffiliatesDevSmartresponseCallbackPAshxGet
   * @summary Smartresponse Network Callback
   * @request GET:/affiliates/dev/smartresponse/callback/p.ashx
   * @secure
   */
  export namespace SmartresponseNetworkCallbackAffiliatesDevSmartresponseCallbackPAshxGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = HTTPStatus;
  }
}

export namespace Online {
  /**
   * @description Get all submissions for a country
   * @tags Online
   * @name GetAllSubmissionsOnlineSubmissionsGet
   * @summary Get All Submissions
   * @request GET:/online/submissions
   * @secure
   */
  export namespace GetAllSubmissionsOnlineSubmissionsGet {
    export type RequestParams = {};
    export type RequestQuery = {
      failed?: boolean;
      handled?: boolean;
      form_validation?: boolean;
      quick_application?: boolean;
      get_customers?: boolean;
      has_recent_app_check?: boolean;
      created_application?: boolean;
      limit?: number;
      page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = SubmissionReviewResponse;
  }
  /**
   * @description Get submission by id
   * @tags Online
   * @name GetASubmissionOnlineSubmissionsSubmissionIdGet
   * @summary Get A Submission
   * @request GET:/online/submissions/{submission_id}
   * @secure
   */
  export namespace GetASubmissionOnlineSubmissionsSubmissionIdGet {
    export type RequestParams = { submissionId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = SubmissionReview;
  }
  /**
   * @description Retry processing of submissions in case of temporary error
   * @tags Online
   * @name PostReprocessSubmissionsOnlineSubmissionsReprocessPost
   * @summary Post Reprocess Submissions
   * @request POST:/online/submissions/reprocess
   * @secure
   */
  export namespace PostReprocessSubmissionsOnlineSubmissionsReprocessPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = string[];
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = EnqueuedSubmissionJobResult[];
  }
  /**
   * @description Retry processing of submission in case of temporary error
   * @tags Online
   * @name PostReprocessSubmissionOnlineSubmissionsSubmissionIdReprocessPost
   * @summary Post Reprocess Submission
   * @request POST:/online/submissions/{submission_id}/reprocess
   * @secure
   */
  export namespace PostReprocessSubmissionOnlineSubmissionsSubmissionIdReprocessPost {
    export type RequestParams = { submissionId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = EnqueuedSubmissionJobResult;
  }
  /**
   * No description
   * @tags Online
   * @name PostResubmitSubmissionOnlineSubmissionsSubmissionIdResubmitPost
   * @summary Post Resubmit Submission
   * @request POST:/online/submissions/{submission_id}/resubmit
   * @secure
   */
  export namespace PostResubmitSubmissionOnlineSubmissionsSubmissionIdResubmitPost {
    export type RequestParams = { submissionId: string };
    export type RequestQuery = {};
    export type RequestBody = ResubmitPayload;
    export type RequestHeaders = { "x-zid"?: string; "x-gid"?: string; "x-zoordinates": string };
    export type ResponseBody = EnqueuedSubmissionJobResult;
  }
  /**
   * No description
   * @tags Online
   * @name PostReviewSubmissionOnlineSubmissionsSubmissionIdReviewPost
   * @summary Post Review Submission
   * @request POST:/online/submissions/{submission_id}/review
   * @secure
   */
  export namespace PostReviewSubmissionOnlineSubmissionsSubmissionIdReviewPost {
    export type RequestParams = { submissionId: string };
    export type RequestQuery = { handled?: boolean };
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = HandledSubmission;
  }
  /**
   * No description
   * @tags Online
   * @name PostReviewSubmissionsOnlineSubmissionsReviewPost
   * @summary Post Review Submissions
   * @request POST:/online/submissions/review
   * @secure
   */
  export namespace PostReviewSubmissionsOnlineSubmissionsReviewPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ReviewSubmissions;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = HandledSubmission[];
  }
  /**
   * @description Converts a credit card submission to a blanco submission
   * @tags Online
   * @name PostConvertToBlancoOnlineSubmissionsSubmissionIdConvertToBlancoPost
   * @summary Post Convert To Blanco
   * @request POST:/online/submissions/{submission_id}/convert_to_blanco
   * @secure
   */
  export namespace PostConvertToBlancoOnlineSubmissionsSubmissionIdConvertToBlancoPost {
    export type RequestParams = { submissionId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = EnqueuedSubmissionJobResult;
  }
  /**
   * No description
   * @tags Online
   * @name GetBookingsOnlineBookingsCountryGet
   * @summary Get Bookings
   * @request GET:/online/bookings/{country}
   */
  export namespace GetBookingsOnlineBookingsCountryGet {
    export type RequestParams = { country: Country };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BankCommunicationData;
  }
  /**
   * No description
   * @tags Online
   * @name BookMeetingOnlineBookingsCountryPost
   * @summary Book Meeting
   * @request POST:/online/bookings/{country}
   */
  export namespace BookMeetingOnlineBookingsCountryPost {
    export type RequestParams = { country: Country };
    export type RequestQuery = {};
    export type RequestBody = BookingPayload;
    export type RequestHeaders = {};
    export type ResponseBody = ServicesSverkerResponsesMeeting;
  }
  /**
   * No description
   * @tags Online
   * @name ContactFormOnlineContactCountryPost
   * @summary Contact Form
   * @request POST:/online/contact/{country}
   */
  export namespace ContactFormOnlineContactCountryPost {
    export type RequestParams = { country: Country };
    export type RequestQuery = {};
    export type RequestBody = ContactFormPayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags Online
   * @name MortgageFormOnlineMortgageCountryPost
   * @summary Mortgage Form
   * @request POST:/online/mortgage/{country}
   */
  export namespace MortgageFormOnlineMortgageCountryPost {
    export type RequestParams = { country: Country };
    export type RequestQuery = {};
    export type RequestBody = MortgageFormPayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags Online
   * @name BlancoApplicationOnlineBlancoApplicationCountryPost
   * @summary Blanco Application
   * @request POST:/online/blanco-application/{country}
   */
  export namespace BlancoApplicationOnlineBlancoApplicationCountryPost {
    export type RequestParams = { country: Country };
    export type RequestQuery = {};
    export type RequestBody = BankCommunicationData;
    export type RequestHeaders = {
      "x-forwarded-for"?: string;
      "user-agent"?: string;
      origin?: string;
      "x-zid"?: string;
      "x-s-zid"?: string;
      "x-gid"?: string;
      "x-google-ids"?: string;
    };
    export type ResponseBody = FormApplicationSubmissionResult;
  }
  /**
   * @description Norway only
   * @tags Online
   * @name NorwegianMortgageApplicationOnlineNorwegianMortgageApplicationPost
   * @summary Norwegian Mortgage Application
   * @request POST:/online/norwegian-mortgage-application
   */
  export namespace NorwegianMortgageApplicationOnlineNorwegianMortgageApplicationPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BankCommunicationData;
    export type RequestHeaders = {
      "x-forwarded-for"?: string;
      "user-agent"?: string;
      origin?: string;
      "x-zid"?: string;
      "x-gid"?: string;
      "x-s-zid"?: string;
      "x-google-ids"?: string;
    };
    export type ResponseBody = FormApplicationSubmissionResult;
  }
}

export namespace Rq {
  /**
   * No description
   * @tags Monitor
   * @name GetListOfJobsRqJobsGet
   * @summary Get List Of Jobs
   * @request GET:/rq/jobs
   * @secure
   */
  export namespace GetListOfJobsRqJobsGet {
    export type RequestParams = {};
    export type RequestQuery = { job_type: JobType };
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = RqJobStatusResponse[];
  }
  /**
   * No description
   * @tags Monitor
   * @name GetFailedJobsRqManualFailGet
   * @summary Get Failed Jobs
   * @request GET:/rq/manual-fail
   * @secure
   */
  export namespace GetFailedJobsRqManualFailGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags Monitor
   * @name ClearFailedJobRqDeleteJobJobIdGet
   * @summary Clear Failed Job
   * @request GET:/rq/delete-job/{job_id}
   * @secure
   */
  export namespace ClearFailedJobRqDeleteJobJobIdGet {
    export type RequestParams = { jobId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags Monitor
   * @name GetSingleJobRqJobIdGet
   * @summary Get Single Job
   * @request GET:/rq/{job_id}
   * @secure
   */
  export namespace GetSingleJobRqJobIdGet {
    export type RequestParams = { jobId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = RqJobStatusResponse;
  }
}

export namespace Kdlt {
  /**
   * No description
   * @tags kdlt
   * @name CallbackKdltCallbackPost
   * @summary Callback
   * @request POST:/kdlt/callback
   * @secure
   */
  export namespace CallbackKdltCallbackPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = KDLTCallbackPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = void;
  }
}

export namespace DialMaker {
  /**
   * No description
   * @tags Dial Maker
   * @name GetLeadsForCampaignDialMakerTmLeadsCampaignIdPost
   * @summary Get Leads For Campaign
   * @request POST:/dial-maker/tm-leads/{campaign_id}
   * @secure
   */
  export namespace GetLeadsForCampaignDialMakerTmLeadsCampaignIdPost {
    export type RequestParams = { campaignId: string };
    export type RequestQuery = {};
    export type RequestBody = RoutersDialMakerPayloadsLeadExtraction;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = TMLeadsJob;
  }
  /**
   * No description
   * @tags Dial Maker
   * @name GetJobStatusOrResultDialMakerJobStatusJobIdGet
   * @summary Get Job Status Or Result
   * @request GET:/dial-maker/job-status/{job_id}
   * @secure
   */
  export namespace GetJobStatusOrResultDialMakerJobStatusJobIdGet {
    export type RequestParams = { jobId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = TMLeadsExtraction | TMLeadsJob | (TMLeadsExtraction & TMLeadsJob);
  }
  /**
   * No description
   * @tags Dial Maker
   * @name GetDownloadUrlDialMakerJobResultJobIdDownloadUrlGet
   * @summary Get Download Url
   * @request GET:/dial-maker/job-result/{job_id}/download-url
   * @secure
   */
  export namespace GetDownloadUrlDialMakerJobResultJobIdDownloadUrlGet {
    export type RequestParams = { jobId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = RoutersDialMakerPayloadsSignedUrl;
  }
  /**
   * No description
   * @tags Dial Maker
   * @name GetCampaignsDialMakerCampaignsGet
   * @summary Get Campaigns
   * @request GET:/dial-maker/campaigns
   * @secure
   */
  export namespace GetCampaignsDialMakerCampaignsGet {
    export type RequestParams = {};
    export type RequestQuery = {
      page: number;
      limit: number;
      department?: ZDepartment;
      country?: Country;
      product?: Product;
    };
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = TMCampaignList;
  }
  /**
   * No description
   * @tags Dial Maker
   * @name CreateCampaignDialMakerCampaignsPost
   * @summary Create Campaign
   * @request POST:/dial-maker/campaigns
   * @secure
   */
  export namespace CreateCampaignDialMakerCampaignsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateTMCampaign;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = TMCampaign;
  }
  /**
   * No description
   * @tags Dial Maker
   * @name GetCampaignDialMakerCampaignsCampaignIdGet
   * @summary Get Campaign
   * @request GET:/dial-maker/campaigns/{campaign_id}
   * @secure
   */
  export namespace GetCampaignDialMakerCampaignsCampaignIdGet {
    export type RequestParams = { campaignId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = TMCampaign;
  }
  /**
   * No description
   * @tags Dial Maker
   * @name UpdateCampaignDialMakerCampaignsCampaignIdPut
   * @summary Update Campaign
   * @request PUT:/dial-maker/campaigns/{campaign_id}
   * @secure
   */
  export namespace UpdateCampaignDialMakerCampaignsCampaignIdPut {
    export type RequestParams = { campaignId: string };
    export type RequestQuery = {};
    export type RequestBody = CreateTMCampaign;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = TMCampaign;
  }
  /**
   * No description
   * @tags Dial Maker
   * @name DeleteCampaignDialMakerCampaignsCampaignIdDelete
   * @summary Delete Campaign
   * @request DELETE:/dial-maker/campaigns/{campaign_id}
   * @secure
   */
  export namespace DeleteCampaignDialMakerCampaignsCampaignIdDelete {
    export type RequestParams = { campaignId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = boolean;
  }
  /**
   * No description
   * @tags Dial Maker
   * @name GetCampaignExtractionsDialMakerCampaignsCampaignIdExtractionsGet
   * @summary Get Campaign Extractions
   * @request GET:/dial-maker/campaigns/{campaign_id}/extractions
   * @secure
   */
  export namespace GetCampaignExtractionsDialMakerCampaignsCampaignIdExtractionsGet {
    export type RequestParams = { campaignId: string };
    export type RequestQuery = { page: number; limit: number };
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = TMLeadsExtraction[];
  }
  /**
   * No description
   * @tags Dial Maker
   * @name DownloadXlsxDialMakerDownloadSignatureGet
   * @summary Download Xlsx
   * @request GET:/dial-maker/download/{signature}
   */
  export namespace DownloadXlsxDialMakerDownloadSignatureGet {
    export type RequestParams = { signature: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace Dialmaker {
  /**
   * No description
   * @tags Dial Maker 2
   * @name CreateCampaignDialmakerCampaignPost
   * @summary Create Campaign
   * @request POST:/dialmaker/campaign
   * @secure
   */
  export namespace CreateCampaignDialmakerCampaignPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateCampaignData;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name GetCampaignDialmakerCampaignCampaignIdGet
   * @summary Get Campaign
   * @request GET:/dialmaker/campaign/{campaign_id}
   * @secure
   */
  export namespace GetCampaignDialmakerCampaignCampaignIdGet {
    export type RequestParams = { campaignId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name UpdateCampaignDialmakerCampaignCampaignIdPut
   * @summary Update Campaign
   * @request PUT:/dialmaker/campaign/{campaign_id}
   * @secure
   */
  export namespace UpdateCampaignDialmakerCampaignCampaignIdPut {
    export type RequestParams = { campaignId: string };
    export type RequestQuery = {};
    export type RequestBody = UpdateCampaignData;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name GetCampaignSourceDialmakerCampaignCampaignIdDataSourceGet
   * @summary Get Campaign Source
   * @request GET:/dialmaker/campaign/{campaign_id}/data/source
   * @secure
   */
  export namespace GetCampaignSourceDialmakerCampaignCampaignIdDataSourceGet {
    export type RequestParams = { campaignId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody =
      | SheetCampaignSource
      | BigQueryCampaignSource
      | (SheetCampaignSource & BigQueryCampaignSource);
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name GetCampaignExtractionsDialmakerCampaignCampaignIdExtractionsGet
   * @summary Get Campaign Extractions
   * @request GET:/dialmaker/campaign/{campaign_id}/extractions
   * @secure
   */
  export namespace GetCampaignExtractionsDialmakerCampaignCampaignIdExtractionsGet {
    export type RequestParams = { campaignId: string };
    export type RequestQuery = { page?: number; size?: number };
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = PageCampaignExtraction;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name GetCampaignSheetsDialmakerCampaignCampaignIdDataSheetsGet
   * @summary Get Campaign Sheets
   * @request GET:/dialmaker/campaign/{campaign_id}/data/sheets
   * @secure
   */
  export namespace GetCampaignSheetsDialmakerCampaignCampaignIdDataSheetsGet {
    export type RequestParams = { campaignId: string };
    export type RequestQuery = { page?: number; size?: number };
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = PageSheet;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name DeactivateCampaignDialmakerCampaignDeactivatePost
   * @summary Deactivate Campaign
   * @request POST:/dialmaker/campaign/deactivate
   * @secure
   */
  export namespace DeactivateCampaignDialmakerCampaignDeactivatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyDeactivateCampaignDialmakerCampaignDeactivatePost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name ActivateCampaignDialmakerCampaignActivatePost
   * @summary Activate Campaign
   * @request POST:/dialmaker/campaign/activate
   * @secure
   */
  export namespace ActivateCampaignDialmakerCampaignActivatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyActivateCampaignDialmakerCampaignActivatePost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name ExtractCampaignsDialmakerCampaignExtractPost
   * @summary Extract Campaigns
   * @request POST:/dialmaker/campaign/extract
   * @secure
   */
  export namespace ExtractCampaignsDialmakerCampaignExtractPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyExtractCampaignsDialmakerCampaignExtractPost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name DeleteExtractionDialmakerCampaignExtractionDelete
   * @summary Delete Extraction
   * @request DELETE:/dialmaker/campaign/extraction
   * @secure
   */
  export namespace DeleteExtractionDialmakerCampaignExtractionDelete {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyDeleteExtractionDialmakerCampaignExtractionDelete;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name FindCampaignsDialmakerCampaignFindPost
   * @summary Find Campaigns
   * @request POST:/dialmaker/campaign/find
   * @secure
   */
  export namespace FindCampaignsDialmakerCampaignFindPost {
    export type RequestParams = {};
    export type RequestQuery = { page?: number; size?: number };
    export type RequestBody = BodyFindCampaignsDialmakerCampaignFindPost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = PageCampaign;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name GetLeadsDialmakerCampaignLeadsCampaignIdGet
   * @summary Get Leads
   * @request GET:/dialmaker/campaign/leads/{campaign_id}
   * @secure
   */
  export namespace GetLeadsDialmakerCampaignLeadsCampaignIdGet {
    export type RequestParams = { campaignId: string };
    export type RequestQuery = { page?: number; size?: number };
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = PageDMLead;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name ImportLeadsDialmakerCampaignImportPost
   * @summary Import Leads
   * @request POST:/dialmaker/campaign/import
   * @secure
   */
  export namespace ImportLeadsDialmakerCampaignImportPost {
    export type RequestParams = {};
    export type RequestQuery = { synchronous?: boolean };
    export type RequestBody = BodyImportLeadsDialmakerCampaignImportPost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign | string;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name GetJobStatusOrResultDialmakerCampaignJobStatusJobIdGet
   * @summary Get Job Status Or Result
   * @request GET:/dialmaker/campaign/job-status/{job_id}
   * @secure
   */
  export namespace GetJobStatusOrResultDialmakerCampaignJobStatusJobIdGet {
    export type RequestParams = { jobId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = InterimLeadJob | InterimLead[] | (InterimLeadJob & InterimLead[]);
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name UploadAttachmentDialmakerCampaignImageUploadPost
   * @summary Upload Attachment
   * @request POST:/dialmaker/campaign/image/upload
   * @secure
   */
  export namespace UploadAttachmentDialmakerCampaignImageUploadPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyUploadAttachmentDialmakerCampaignImageUploadPost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = DateTime;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name ExportAndExtractLeadsUrlDialmakerCampaignExportPost
   * @summary Export And Extract Leads Url
   * @request POST:/dialmaker/campaign/export
   * @secure
   */
  export namespace ExportAndExtractLeadsUrlDialmakerCampaignExportPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyExportAndExtractLeadsUrlDialmakerCampaignExportPost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = RoutersDialMaker2PayloadsSignedUrl;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name ExportAndExtractLeadsUrlDownloadDialmakerCampaignExtractionExportPost
   * @summary Export And Extract Leads Url Download
   * @request POST:/dialmaker/campaign/extraction/export
   * @secure
   */
  export namespace ExportAndExtractLeadsUrlDownloadDialmakerCampaignExtractionExportPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyExportAndExtractLeadsUrlDownloadDialmakerCampaignExtractionExportPost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = RoutersDialMaker2PayloadsSignedUrl;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name GetOngoingExtractionsDialmakerCampaignCampaignIdOngoingExtractionsPost
   * @summary Get Ongoing Extractions
   * @request POST:/dialmaker/campaign/{campaign_id}/ongoing_extractions
   * @secure
   */
  export namespace GetOngoingExtractionsDialmakerCampaignCampaignIdOngoingExtractionsPost {
    export type RequestParams = { campaignId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = CampaignOngoingExtraction[];
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name GetOutcomesReportDialmakerCampaignSearchLeadsPost
   * @summary Get Outcomes Report
   * @request POST:/dialmaker/campaign/search-leads
   * @secure
   */
  export namespace GetOutcomesReportDialmakerCampaignSearchLeadsPost {
    export type RequestParams = {};
    export type RequestQuery = { page?: number; size?: number };
    export type RequestBody = SearchLeadsPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = PageDMLead;
  }
  /**
   * @description This endpoint is used to get statistics: - Leads with 0 outcomes - Available leads to call - Already extracted count - Leads left to extract (cold campaigns only)
   * @tags Dial Maker 2
   * @name GetExtractionsStatsDialmakerCampaignCampaignIdExtractionsStatsGet
   * @summary Get Extractions Stats
   * @request GET:/dialmaker/campaign/{campaign_id}/extractions_stats
   * @secure
   */
  export namespace GetExtractionsStatsDialmakerCampaignCampaignIdExtractionsStatsGet {
    export type RequestParams = { campaignId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = CampaignExtractionsStats;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name GetUserCampaignsDialmakerCampaignsGet
   * @summary Get User Campaigns
   * @request GET:/dialmaker/campaigns
   * @deprecated
   * @secure
   */
  export namespace GetUserCampaignsDialmakerCampaignsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = UserCampaignsExt;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name AvailableCampaignsDialmakerCampaignsAvailablePost
   * @summary Available Campaigns
   * @request POST:/dialmaker/campaigns/available
   * @secure
   */
  export namespace AvailableCampaignsDialmakerCampaignsAvailablePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Available;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name JoinCampaignDialmakerCampaignsJoinPost
   * @summary Join Campaign
   * @request POST:/dialmaker/campaigns/join
   * @secure
   */
  export namespace JoinCampaignDialmakerCampaignsJoinPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyJoinCampaignDialmakerCampaignsJoinPost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Available;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name LeaveCampaignDialmakerCampaignsLeavePost
   * @summary Leave Campaign
   * @request POST:/dialmaker/campaigns/leave
   * @secure
   */
  export namespace LeaveCampaignDialmakerCampaignsLeavePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyLeaveCampaignDialmakerCampaignsLeavePost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Available;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name PlayCampaignDialmakerCampaignsPlayPost
   * @summary Play Campaign
   * @request POST:/dialmaker/campaigns/play
   * @secure
   */
  export namespace PlayCampaignDialmakerCampaignsPlayPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyPlayCampaignDialmakerCampaignsPlayPost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Available;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name PauseCampaignDialmakerCampaignsPausePost
   * @summary Pause Campaign
   * @request POST:/dialmaker/campaigns/pause
   * @secure
   */
  export namespace PauseCampaignDialmakerCampaignsPausePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyPauseCampaignDialmakerCampaignsPausePost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Available;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name GetCardDialmakerCardNextPost
   * @summary Get Card
   * @request POST:/dialmaker/card/next
   * @secure
   */
  export namespace GetCardDialmakerCardNextPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = DMLeadExt;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name ViewDialmakerCardViewPost
   * @summary View
   * @request POST:/dialmaker/card/view
   * @secure
   */
  export namespace ViewDialmakerCardViewPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyViewDialmakerCardViewPost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = DMLeadExt;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name UpdateDialmakerCardUpdatePost
   * @summary Update
   * @request POST:/dialmaker/card/update
   * @secure
   */
  export namespace UpdateDialmakerCardUpdatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyUpdateDialmakerCardUpdatePost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = DMLead;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name HangupDialmakerCardHangupPost
   * @summary Hangup
   * @request POST:/dialmaker/card/hangup
   * @secure
   */
  export namespace HangupDialmakerCardHangupPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyHangupDialmakerCardHangupPost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name CallSuccessDialmakerCardOutcomeSuccessPost
   * @summary Call Success
   * @request POST:/dialmaker/card/outcome/success
   * @secure
   */
  export namespace CallSuccessDialmakerCardOutcomeSuccessPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyCallSuccessDialmakerCardOutcomeSuccessPost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = DMLeadExt;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name CallBackDialmakerCardOutcomeCallBackPost
   * @summary Call Back
   * @request POST:/dialmaker/card/outcome/call_back
   * @secure
   */
  export namespace CallBackDialmakerCardOutcomeCallBackPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyCallBackDialmakerCardOutcomeCallBackPost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = DMLeadExt;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name CallBackDialmakerCardOutcomeLaterPost
   * @summary Call Back
   * @request POST:/dialmaker/card/outcome/later
   * @secure
   */
  export namespace CallBackDialmakerCardOutcomeLaterPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyCallBackDialmakerCardOutcomeLaterPost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = DMLeadExt;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name CallNoContactDialmakerCardOutcomeNoContactPost
   * @summary Call No Contact
   * @request POST:/dialmaker/card/outcome/no_contact
   * @secure
   */
  export namespace CallNoContactDialmakerCardOutcomeNoContactPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyCallNoContactDialmakerCardOutcomeNoContactPost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = DMLeadExt;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name CallFailureDialmakerCardOutcomeFailurePost
   * @summary Call Failure
   * @request POST:/dialmaker/card/outcome/failure
   * @secure
   */
  export namespace CallFailureDialmakerCardOutcomeFailurePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyCallFailureDialmakerCardOutcomeFailurePost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = DMLeadExt;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name GetOutcomesDialmakerCardOutcomesPost
   * @summary Get Outcomes
   * @request POST:/dialmaker/card/outcomes
   * @secure
   */
  export namespace GetOutcomesDialmakerCardOutcomesPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyGetOutcomesDialmakerCardOutcomesPost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Outcomes;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name SearchDialmakerCardSearchPost
   * @summary Search
   * @request POST:/dialmaker/card/search
   * @secure
   */
  export namespace SearchDialmakerCardSearchPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodySearchDialmakerCardSearchPost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = DMLeadExt[];
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name LockDialmakerCardLockPost
   * @summary Lock
   * @request POST:/dialmaker/card/lock
   * @secure
   */
  export namespace LockDialmakerCardLockPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyLockDialmakerCardLockPost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = DMLead;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name PersonalCallbacksDialmakerCardPersonalCallbacksPost
   * @summary Personal Callbacks
   * @request POST:/dialmaker/card/personal_callbacks
   * @secure
   */
  export namespace PersonalCallbacksDialmakerCardPersonalCallbacksPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = DMLeadExt[];
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name GetSlotsDialmakerCardSlotsGet
   * @summary Get Slots
   * @request GET:/dialmaker/card/slots
   * @secure
   */
  export namespace GetSlotsDialmakerCardSlotsGet {
    export type RequestParams = {};
    export type RequestQuery = { date: string };
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = BookableSlot[];
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name GetPreviousAppsDialmakerCardPreviousAppsPost
   * @summary Get Previous Apps
   * @request POST:/dialmaker/card/previous_apps
   * @secure
   */
  export namespace GetPreviousAppsDialmakerCardPreviousAppsPost {
    export type RequestParams = {};
    export type RequestQuery = { customer_id: string };
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = PreviousApplicationsList;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name MineDialmakerCardOutcomesMineTodayPost
   * @summary Mine
   * @request POST:/dialmaker/card/outcomes/mine_today
   * @secure
   */
  export namespace MineDialmakerCardOutcomesMineTodayPost {
    export type RequestParams = {};
    export type RequestQuery = { start_date: string; end_date: string };
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = OutcomeCount;
  }
  /**
   * @description Upload file and return a preview of sheet, together with the file id needed to import leads. Uploaded file whether it's csv or xlsx should have headers in the first row to be able to map the columns to the lead data model.
   * @tags Dial Maker 2
   * @name UploadDialmakerSheetCampaignIdUploadWithPreviewPost
   * @summary Upload
   * @request POST:/dialmaker/sheet/{campaign_id}/upload_with_preview
   * @secure
   */
  export namespace UploadDialmakerSheetCampaignIdUploadWithPreviewPost {
    export type RequestParams = { campaignId: string };
    export type RequestQuery = {};
    export type RequestBody = BodyUploadDialmakerSheetCampaignIdUploadWithPreviewPost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = SheetPreview;
  }
  /**
   * @description This endpoint is used to import leads from a file to a global leads collection with campaign_id and file_id metadata
   * @tags Dial Maker 2
   * @name ImportFromFileDialmakerSheetCampaignIdImportFromFileIdPost
   * @summary Import From File
   * @request POST:/dialmaker/sheet/{campaign_id}/import_from/{file_id}
   * @secure
   */
  export namespace ImportFromFileDialmakerSheetCampaignIdImportFromFileIdPost {
    export type RequestParams = { campaignId: string; fileId: string };
    export type RequestQuery = { synchronous?: boolean };
    export type RequestBody = Record<string, string>;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign | string;
  }
  /**
   * @description This endpoint is used to delete a file from the database if it was not imported yet
   * @tags Dial Maker 2
   * @name DeleteCampaignSheetDialmakerSheetCampaignIdDeleteFileFileIdDelete
   * @summary Delete Campaign Sheet
   * @request DELETE:/dialmaker/sheet/{campaign_id}/delete_file/{file_id}
   * @secure
   */
  export namespace DeleteCampaignSheetDialmakerSheetCampaignIdDeleteFileFileIdDelete {
    export type RequestParams = { campaignId: string; fileId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign;
  }
  /**
   * @description This endpoint is used to delete import of a given sheet_id with all interim leads
   * @tags Dial Maker 2
   * @name DeleteInterimLeadsDialmakerSheetCampaignIdImportSheetIdDelete
   * @summary Delete Interim Leads
   * @request DELETE:/dialmaker/sheet/{campaign_id}/import/{sheet_id}
   * @secure
   */
  export namespace DeleteInterimLeadsDialmakerSheetCampaignIdImportSheetIdDelete {
    export type RequestParams = { campaignId: string; sheetId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name GetOutcomesDialmakerMiscOutcomesGet
   * @summary Get Outcomes
   * @request GET:/dialmaker/misc/outcomes
   * @secure
   */
  export namespace GetOutcomesDialmakerMiscOutcomesGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Outcomes;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name SaveOutcomesDialmakerMiscOutcomesPost
   * @summary Save Outcomes
   * @request POST:/dialmaker/misc/outcomes
   * @secure
   */
  export namespace SaveOutcomesDialmakerMiscOutcomesPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodySaveOutcomesDialmakerMiscOutcomesPost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = Outcomes;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name AdminDialmakerAdminOutcomesPost
   * @summary Admin
   * @request POST:/dialmaker/admin/outcomes
   * @secure
   */
  export namespace AdminDialmakerAdminOutcomesPost {
    export type RequestParams = {};
    export type RequestQuery = { start_date: string; end_date: string };
    export type RequestBody = BodyAdminDialmakerAdminOutcomesPost;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = OutcomeCount;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name BlockFieldsDialmakerAdminBlockPost
   * @summary Block Fields
   * @request POST:/dialmaker/admin/block
   * @secure
   */
  export namespace BlockFieldsDialmakerAdminBlockPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BlockCustomerFieldManuallyPayload;
    export type RequestHeaders = { "x-zoordinates": string };
    export type ResponseBody = any;
  }
}

export namespace Bank {
  /**
   * No description
   * @tags Bank Login
   * @name LoginBankLoginPost
   * @summary Login
   * @request POST:/bank/login
   */
  export namespace LoginBankLoginPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = Login;
    export type RequestHeaders = {};
    export type ResponseBody = LoginResp;
  }
  /**
   * No description
   * @tags Bank Login
   * @name ValidateOtpCodeBankLoginValidatePost
   * @summary Validate Otp Code
   * @request POST:/bank/login/validate
   */
  export namespace ValidateOtpCodeBankLoginValidatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = OTPValidation;
    export type RequestHeaders = {};
    export type ResponseBody = OTPValidationResp;
  }
  /**
   * No description
   * @tags Bank Login
   * @name SetNewPasswordBankSetPasswordPost
   * @summary Set New Password
   * @request POST:/bank/set-password
   */
  export namespace SetNewPasswordBankSetPasswordPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetPassword;
    export type RequestHeaders = {};
    export type ResponseBody = SetPasswordResp;
  }
  /**
   * No description
   * @tags Bank Login
   * @name RequestNewOtpBankNewOtpPost
   * @summary Request New Otp
   * @request POST:/bank/new-otp
   */
  export namespace RequestNewOtpBankNewOtpPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RequestNewOTP;
    export type RequestHeaders = {};
    export type ResponseBody = SetPasswordResp;
  }
  /**
   * No description
   * @tags Bank User Administration
   * @name CreateNewBankUserBankCreateUserPost
   * @summary Create New Bank User
   * @request POST:/bank/create-user
   * @secure
   */
  export namespace CreateNewBankUserBankCreateUserPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateUser;
    export type RequestHeaders = {};
    export type ResponseBody = CreateUserResp;
  }
  /**
   * No description
   * @tags Bank User Administration
   * @name GetBankUsersBankGetPost
   * @summary Get Bank Users
   * @request POST:/bank/get
   * @secure
   */
  export namespace GetBankUsersBankGetPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetUsersPayload;
    export type RequestHeaders = {};
    export type ResponseBody = BankUserWithBankNames[];
  }
  /**
   * No description
   * @tags Bank User Administration
   * @name GetBankUserBankUserIdGet
   * @summary Get Bank User
   * @request GET:/bank/{user_id}
   * @secure
   */
  export namespace GetBankUserBankUserIdGet {
    export type RequestParams = { userId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BankUserWithBankNames;
  }
  /**
   * No description
   * @tags Bank User Administration
   * @name EditBankUserBankUserIdPut
   * @summary Edit Bank User
   * @request PUT:/bank/{user_id}
   * @secure
   */
  export namespace EditBankUserBankUserIdPut {
    export type RequestParams = { userId: string };
    export type RequestQuery = {};
    export type RequestBody = EditUser;
    export type RequestHeaders = {};
    export type ResponseBody = BankUserWithBankNames;
  }
  /**
   * No description
   * @tags Bank User Administration
   * @name ResetBankUserPasswordBankResetPasswordPost
   * @summary Reset Bank User Password
   * @request POST:/bank/reset-password
   * @secure
   */
  export namespace ResetBankUserPasswordBankResetPasswordPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ResetPasswordPayload;
    export type RequestHeaders = {};
    export type ResponseBody = CreateUserResp;
  }
  /**
   * No description
   * @tags Bank User Administration
   * @name DeactivateBankUserBankDeactivatePut
   * @summary Deactivate Bank User
   * @request PUT:/bank/deactivate
   * @secure
   */
  export namespace DeactivateBankUserBankDeactivatePut {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DeactivateUserPayload;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags Bank
   * @name GetApplicationsBankApplicationsPost
   * @summary Get Applications
   * @request POST:/bank/applications
   * @secure
   */
  export namespace GetApplicationsBankApplicationsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetApplications;
    export type RequestHeaders = {};
    export type ResponseBody = BankBaseApp[];
  }
  /**
   * No description
   * @tags Bank
   * @name GetApplicationBankApplicationApplicationIdGet
   * @summary Get Application
   * @request GET:/bank/application/{application_id}
   * @secure
   */
  export namespace GetApplicationBankApplicationApplicationIdGet {
    export type RequestParams = { applicationId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BankBaseApp;
  }
  /**
   * No description
   * @tags Bank
   * @name GetDocumentMetaBankDocumentMetaCustomerIdDocumentIdGet
   * @summary Get Document Meta
   * @request GET:/bank/document/meta/{customer_id}/{document_id}
   * @secure
   */
  export namespace GetDocumentMetaBankDocumentMetaCustomerIdDocumentIdGet {
    export type RequestParams = { customerId: string; documentId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DocumentMeta;
  }
  /**
   * No description
   * @tags Bank
   * @name GetDocumentBankGetCustomerIdDocumentIdGet
   * @summary Get Document
   * @request GET:/bank/get/{customer_id}/{document_id}
   * @secure
   */
  export namespace GetDocumentBankGetCustomerIdDocumentIdGet {
    export type RequestParams = { customerId: string; documentId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ModelsDocumentDocumentDocument;
  }
  /**
   * No description
   * @tags Bank
   * @name GetAllBanksBankGetBanksPost
   * @summary Get All Banks
   * @request POST:/bank/get-banks
   * @secure
   */
  export namespace GetAllBanksBankGetBanksPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetBanksPayload;
    export type RequestHeaders = {};
    export type ResponseBody = Bank[];
  }
  /**
   * No description
   * @tags Bank
   * @name GetAppEventsBankGetAppEventsApplicationIdGet
   * @summary Get App Events
   * @request GET:/bank/get_app_events/{application_id}
   * @secure
   */
  export namespace GetAppEventsBankGetAppEventsApplicationIdGet {
    export type RequestParams = { applicationId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = EventsResponse;
  }
  /**
   * No description
   * @tags Bank
   * @name AddCommentBankCommentPost
   * @summary Add Comment
   * @request POST:/bank/comment
   * @secure
   */
  export namespace AddCommentBankCommentPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BankComment;
    export type RequestHeaders = {};
    export type ResponseBody = EventsResponse;
  }
  /**
   * No description
   * @tags Bank
   * @name PostOfferBankOfferPost
   * @summary Post Offer
   * @request POST:/bank/offer
   * @secure
   */
  export namespace PostOfferBankOfferPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BankOfferPayload;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags Bank, Application
   * @name RejectBankRejectPost
   * @summary Reject
   * @request POST:/bank/reject
   * @secure
   */
  export namespace RejectBankRejectPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BankRejectPayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags Bank, Application
   * @name DisburseBankDisbursePost
   * @summary Disburse
   * @request POST:/bank/disburse
   * @secure
   */
  export namespace DisburseBankDisbursePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BankDisbursePayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags Bank
   * @name SearchApplicationsBankSearchPost
   * @summary Search Applications
   * @request POST:/bank/search
   * @secure
   */
  export namespace SearchApplicationsBankSearchPost {
    export type RequestParams = {};
    export type RequestQuery = { page?: number; limit?: number };
    export type RequestBody = RoutersBankPayloadsSearchPayload;
    export type RequestHeaders = {};
    export type ResponseBody = BankBaseApp[];
  }
}

export namespace Jotform {
  /**
   * No description
   * @tags Jotform
   * @name SubmissionJotformWebhookFormIdPost
   * @summary Submission
   * @request POST:/jotform/webhook/{form_id}
   */
  export namespace SubmissionJotformWebhookFormIdPost {
    export type RequestParams = { formId: string };
    export type RequestQuery = {};
    export type RequestBody = BodySubmissionJotformWebhookFormIdPost;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace Campaign {
  /**
   * No description
   * @tags Affiliate
   * @name CreateCampaignInitializedEventCampaignCampaignIdGet
   * @summary Create Campaign Initialized Event
   * @request GET:/campaign/{campaign_id}
   */
  export namespace CreateCampaignInitializedEventCampaignCampaignIdGet {
    export type RequestParams = { campaignId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace Visit {
  /**
   * No description
   * @tags Affiliate
   * @name CreateVisitEventVisitCountryZidPost
   * @summary Create Visit Event
   * @request POST:/visit/{country}/{zid}
   */
  export namespace CreateVisitEventVisitCountryZidPost {
    export type RequestParams = { country: Country; zid: string };
    export type RequestQuery = {};
    export type RequestBody = WebsiteVisitPayload;
    export type RequestHeaders = { "x-s-zid"?: string; "x-gid"?: string };
    export type ResponseBody = any;
  }
}

export namespace Slack {
  /**
   * No description
   * @tags Slack
   * @name SlackCallbackSlackCallbackPost
   * @summary Slack Callback
   * @request POST:/slack/callback
   */
  export namespace SlackCallbackSlackCallbackPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodySlackCallbackSlackCallbackPost;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace DialMaker2 {
  /**
   * No description
   * @tags Dial Maker 2
   * @name GetImageDialMaker2ImageGet
   * @summary Get Image
   * @request GET:/dial-maker2/image
   */
  export namespace GetImageDialMaker2ImageGet {
    export type RequestParams = {};
    export type RequestQuery = { file_id: string };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * No description
   * @tags Dial Maker 2
   * @name DownloadLeadsXlsxDialMaker2ExportDownloadSignatureGet
   * @summary Download Leads Xlsx
   * @request GET:/dial-maker2/export/download/{signature}
   */
  export namespace DownloadLeadsXlsxDialMaker2ExportDownloadSignatureGet {
    export type RequestParams = { signature: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace WellKnown {
  /**
   * No description
   * @tags Well known
   * @name GetJwksWellKnownJwksJsonGet
   * @summary Get Jwks
   * @request GET:/.well-known/jwks.json
   */
  export namespace GetJwksWellKnownJwksJsonGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BankCommunicationData;
  }
}

export namespace Infra {
  /**
   * No description
   * @tags Other
   * @name Auth0EventsProxyInfraAuth0EventsPost
   * @summary Auth0 Events Proxy
   * @request POST:/infra/auth0/events
   * @secure
   */
  export namespace Auth0EventsProxyInfraAuth0EventsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = object[];
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace Callmaker {
  /**
   * No description
   * @tags Callmaker Callbacks
   * @name GetCallmakerDataCallmakerCallbackCallPost
   * @summary Get Callmaker Data
   * @request POST:/callmaker/callback/call
   * @secure
   */
  export namespace GetCallmakerDataCallmakerCallbackCallPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BankCommunicationData;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags Callmaker Callbacks
   * @name GetProcessedDataCallmakerCallbackProcessPost
   * @summary Get Processed Data
   * @request POST:/callmaker/callback/process
   * @secure
   */
  export namespace GetProcessedDataCallmakerCallbackProcessPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BankCommunicationData;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace V1 {
  /**
   * No description
   * @tags V1 Affiliate API
   * @name CreateBlancoApplicationV1AffiliateApplicationsBlancoPost
   * @summary Create Blanco Application
   * @request POST:/v1/affiliate/applications/blanco
   * @secure
   */
  export namespace CreateBlancoApplicationV1AffiliateApplicationsBlancoPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AffiliateCreateBlancoApplication;
    export type RequestHeaders = {};
    export type ResponseBody = AffiliateResponse;
  }
  /**
   * No description
   * @tags V1 Affiliate API
   * @name GetBookingsBlancoV1AffiliateBookingsBlancoGet
   * @summary Get Bookings Blanco
   * @request GET:/v1/affiliate/bookings/blanco
   * @secure
   */
  export namespace GetBookingsBlancoV1AffiliateBookingsBlancoGet {
    export type RequestParams = {};
    export type RequestQuery = { start_date: string; end_date: string; country: Country };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AvailableBookings;
  }
  /**
   * No description
   * @tags V1 Affiliate API
   * @name CreateMortgageLeadV1AffiliateLeadsMortgagePost
   * @summary Create Mortgage Lead
   * @request POST:/v1/affiliate/leads/mortgage
   * @secure
   */
  export namespace CreateMortgageLeadV1AffiliateLeadsMortgagePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AffiliateLeadCreationPayload;
    export type RequestHeaders = {};
    export type ResponseBody = AffiliateResponse;
  }
  /**
   * No description
   * @tags V1 Affiliate API
   * @name GetBookingsMortgageV1AffiliateBookingsMortgageGet
   * @summary Get Bookings Mortgage
   * @request GET:/v1/affiliate/bookings/mortgage
   * @secure
   */
  export namespace GetBookingsMortgageV1AffiliateBookingsMortgageGet {
    export type RequestParams = {};
    export type RequestQuery = { start_date: string; end_date: string; country: Country };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AvailableBookings;
  }
  /**
   * @description Returns all allowed enum values
   * @tags V1 Affiliate API
   * @name GetOptionsV1AffiliateOptionsCountryProductGet
   * @summary Get Options
   * @request GET:/v1/affiliate/options/{country}/{product}
   * @secure
   */
  export namespace GetOptionsV1AffiliateOptionsCountryProductGet {
    export type RequestParams = { country: Country; product: Product };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AffiliateOptionsResponse;
  }
  /**
   * No description
   * @tags V1 Affiliate API
   * @name GetBlancoStatusV1AffiliateApplicationsBlancoSubmissionIdGet
   * @summary Get Blanco Status
   * @request GET:/v1/affiliate/applications/blanco/{submission_id}
   * @secure
   */
  export namespace GetBlancoStatusV1AffiliateApplicationsBlancoSubmissionIdGet {
    export type RequestParams = { submissionId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AffiliateCallback;
  }
  /**
   * No description
   * @tags V1 Affiliate API
   * @name GetMortgageStatusV1AffiliateLeadsMortgageSubmissionIdGet
   * @summary Get Mortgage Status
   * @request GET:/v1/affiliate/leads/mortgage/{submission_id}
   * @secure
   */
  export namespace GetMortgageStatusV1AffiliateLeadsMortgageSubmissionIdGet {
    export type RequestParams = { submissionId: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AffiliateCallback;
  }
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends globalThis.Response {
  data: D;
  error: E;
  requestId: string;
}

export interface HttpErrorResponse<E> extends globalThis.Response {
  error: E;
  requestId: string;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  private encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  private addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  private addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  private mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  private createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  private generateUUID() {
    // Public Domain/MIT
    var d = new Date().getTime(); //Timestamp
    var d2 = (typeof performance !== "undefined" && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = Math.random() * 16; //random number between 0 and 16
      if (d > 0) {
        //Use timestamp until depleted
        r = (d + r) % 16 | 0;
        d = Math.floor(d / 16);
      } else {
        //Use microseconds since page-load if supported
        r = (d2 + r) % 16 | 0;
        d2 = Math.floor(d2 / 16);
      }
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    // We need to generate new RequestID for every request
    let requestId = requestParams.headers["X-Request-ID"];
    if (!requestId) {
      requestId = this.generateUUID();
      requestParams.headers["X-Request-ID"] = requestId;
    }

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
        ...(requestParams.headers || {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : void 0,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;
      r.requestId = requestId;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data as HttpErrorResponse<E>;
      return data;
    });
  };
}

/**
 * @title The ZRM
 * @version 0.1.0
 *
 *
 * A __ZRM__ _(please say it out loud and you shall understand)_ for the products at Zensum.
 *
 * ---
 * ### Code
 *
 * You can find this code [here on Github](https://github.com/zensum/zrm) if you're a part of the Zensum organization.
 *
 * ---
 *
 * ### Features
 *  - handling/booking meetings
 *  - sending messages to customer
 *  - proxying requests for customer data to kunddatalagringstjänsten
 *  - proxying requests for applications data to applications manager
 *
 * ---
 *
 * ### Authorization
 *
 * In order to authorize you need a token with the audience `API_TEST_WEB` from the issuer `zensum-test.eu.auth0.com`.
 * Easiest way of getting a token is to look in Auth0 and get a token with a curl similar to this
 *
 * ```sh
 * curl --request POST \
 *      --url https://zensum-test.eu.auth0.com/oauth/token \
 *      --header 'content-type: application/json' \
 *      --data '{"client_id":"{CLIENT_ID}","client_secret":"{CLIENT_SECRET}", \
 *         "audience":"API_TEST_WEB","grant_type":"client_credentials"}'
 * ```
 * _Remember to replace {CLIENT_ID} and {CLIENT_SECRET}!_
 *
 * ---
 *
 * ### Zoordinates
 * Please add one of your allowed Zoordinates to the header `X-Zoordinates`.
 *
 * ---
 *
 * ### Request ID
 * Please add a value to the header `X-Request-ID` with a UUID4 value to be able to track
 * the request between services. 🙏🏼
 *
 * _Otherwise Heroku will take care of it and we'd loose control._
 *
 * ---
 *
 * ### Support
 * Look below 😅
 *
 * ---
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  application = {
    /**
     * No description
     *
     * @tags Application
     * @name QuickCreateApplicationApplicationQuickCreatePost
     * @summary Quick Create Application
     * @request POST:/application/quick-create
     * @secure
     */
    quickCreateApplicationApplicationQuickCreatePost: (data: QuickCreateApplication, params: RequestParams = {}) =>
      this.request<ApplicationCreatedResponse, HTTPValidationError>({
        path: `/application/quick-create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name CreateApplicationApplicationCreatePost
     * @summary Create Application
     * @request POST:/application/create
     * @secure
     */
    createApplicationApplicationCreatePost: (data: CreateApplicationPayloadExt, params: RequestParams = {}) =>
      this.request<ApplicationCreatedResponseExt, HTTPValidationError>({
        path: `/application/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name UpdateApplicationApplicationUpdateApplicationIdPost
     * @summary Update Application
     * @request POST:/application/update/{application_id}
     * @secure
     */
    updateApplicationApplicationUpdateApplicationIdPost: (
      applicationId: string,
      data: UpdateApplicationPayloadExt,
      params: RequestParams = {},
    ) =>
      this.request<ApplicationWithNamesInComments, HTTPValidationError>({
        path: `/application/update/${applicationId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name GetApplicationApplicationGetPost
     * @summary Get Application
     * @request POST:/application/get
     * @secure
     */
    getApplicationApplicationGetPost: (data: GetApplicationPayload, params: RequestParams = {}) =>
      this.request<ApplicationWithNamesInComments, HTTPValidationError>({
        path: `/application/get`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name GetApplicationsApplicationGetsPost
     * @summary Get Applications
     * @request POST:/application/gets
     * @deprecated
     * @secure
     */
    getApplicationsApplicationGetsPost: (
      data: GetApplicationsByCustomerIdentifierPayload,
      params: RequestParams = {},
    ) =>
      this.request<Application[], HTTPValidationError>({
        path: `/application/gets`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name GetApplicationsV2ApplicationV2GetsPost
     * @summary Get Applications V2
     * @request POST:/application/v2/gets
     * @secure
     */
    getApplicationsV2ApplicationV2GetsPost: (
      data: GetApplicationsByCustomerIdentifierPayloadV2,
      params: RequestParams = {},
    ) =>
      this.request<Application[], HTTPValidationError>({
        path: `/application/v2/gets`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name GetApplicationsAssignedToMeApplicationGetMinePost
     * @summary Get Applications Assigned To Me
     * @request POST:/application/get/mine
     * @secure
     */
    getApplicationsAssignedToMeApplicationGetMinePost: (
      data: GetMyApplicationsPayload,
      query?: { page?: number; limit?: number },
      params: RequestParams = {},
    ) =>
      this.request<Application[], HTTPValidationError>({
        path: `/application/get/mine`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name GetRecentApplicationsApplicationGetRecentPost
     * @summary Get Recent Applications
     * @request POST:/application/get/recent
     * @secure
     */
    getRecentApplicationsApplicationGetRecentPost: (
      data: GetRecentApplicationsPayload,
      query?: { page?: number; limit?: number },
      params: RequestParams = {},
    ) =>
      this.request<Application[], HTTPValidationError>({
        path: `/application/get/recent`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name SearchApplicationsApplicationSearchPost
     * @summary Search Applications
     * @request POST:/application/search
     * @secure
     */
    searchApplicationsApplicationSearchPost: (
      data: RoutersApplicationApplicationPayloadSearchPayload,
      query?: { page?: number; limit?: number },
      params: RequestParams = {},
    ) =>
      this.request<Application[], HTTPValidationError>({
        path: `/application/search`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name SearchApplications2ApplicationSearch2Post
     * @summary Search Applications2
     * @request POST:/application/search2
     * @secure
     */
    searchApplications2ApplicationSearch2Post: (
      data: RoutersApplicationApplicationPayloadSearchPayload,
      query?: { page?: number; limit?: number },
      params: RequestParams = {},
    ) =>
      this.request<AppsSearchResult, HTTPValidationError>({
        path: `/application/search2`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name GetLeftToLiveApplicationLeftToLivePost
     * @summary Get Left To Live
     * @request POST:/application/left_to_live
     * @secure
     */
    getLeftToLiveApplicationLeftToLivePost: (data: LeftToLivePayload, params: RequestParams = {}) =>
      this.request<LeftToLiveResponse, HTTPValidationError>({
        path: `/application/left_to_live`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name DuplicateApplicationApplicationDuplicatePost
     * @summary Duplicate Application
     * @request POST:/application/duplicate
     * @secure
     */
    duplicateApplicationApplicationDuplicatePost: (data: ApplicationPayload, params: RequestParams = {}) =>
      this.request<ApplicationPayload, HTTPValidationError>({
        path: `/application/duplicate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name DeactivateApplicationApplicationDeactivateProductPost
     * @summary Deactivate Application
     * @request POST:/application/deactivate/{product}
     * @secure
     */
    deactivateApplicationApplicationDeactivateProductPost: (
      product: Product,
      data: MortgageDeactivatePayload | DeactivatePayload | (MortgageDeactivatePayload & DeactivatePayload),
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/application/deactivate/${product}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ReactivateApplicationReactivatePost
     * @summary Reactivate
     * @request POST:/application/reactivate
     * @secure
     */
    reactivateApplicationReactivatePost: (data: ReactivatePayload, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/application/reactivate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CreditCard Application
     * @name GetApplicationApplicationCcNoGetPost
     * @summary Get Application
     * @request POST:/application/cc/no/get
     * @secure
     */
    getApplicationApplicationCcNoGetPost: (data: GetApplicationPayload, params: RequestParams = {}) =>
      this.request<CreditCardApplicationWithNamesInComments, HTTPValidationError>({
        path: `/application/cc/no/get`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CreditCard Application
     * @name CreateApplicationApplicationCcNoCreatePost
     * @summary Create Application
     * @request POST:/application/cc/no/create
     * @secure
     */
    createApplicationApplicationCcNoCreatePost: (
      data: CreateCreditCardApplicationPayloadExt,
      params: RequestParams = {},
    ) =>
      this.request<ApplicationCreatedResponseExt, HTTPValidationError>({
        path: `/application/cc/no/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CreditCard Application
     * @name UpdateApplicationApplicationCcNoUpdatePost
     * @summary Update Application
     * @request POST:/application/cc/no/update
     * @secure
     */
    updateApplicationApplicationCcNoUpdatePost: (
      data: UpdateCreditCardApplicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<BaseModel, HTTPValidationError>({
        path: `/application/cc/no/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CreditCard Application
     * @name UpdateAndGetApplicationApplicationCcNoUpdateAndGetPost
     * @summary Update And Get Application
     * @request POST:/application/cc/no/update-and-get
     * @secure
     */
    updateAndGetApplicationApplicationCcNoUpdateAndGetPost: (
      data: UpdateCreditCardApplicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<CreditCardApplicationExtended, HTTPValidationError>({
        path: `/application/cc/no/update-and-get`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CreditCard Application
     * @name CreateApplicationApplicantApplicationCcNoCreateWithApplicantPost
     * @summary Create Application Applicant
     * @request POST:/application/cc/no/create-with-applicant
     * @secure
     */
    createApplicationApplicantApplicationCcNoCreateWithApplicantPost: (
      data: CreateCreditCardApplicationApplicantPayloadExt,
      params: RequestParams = {},
    ) =>
      this.request<ApplicationCreatedResponseExt, HTTPValidationError>({
        path: `/application/cc/no/create-with-applicant`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CreditCard Application
     * @name GetRecentApplicationsApplicationCcNoGetRecentPost
     * @summary Get Recent Applications
     * @request POST:/application/cc/no/get_recent
     * @secure
     */
    getRecentApplicationsApplicationCcNoGetRecentPost: (
      data: FilterByPayload,
      query?: { page?: number; size?: number },
      params: RequestParams = {},
    ) =>
      this.request<PageCreditCardApplicationExtended, HTTPValidationError>({
        path: `/application/cc/no/get_recent`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CreditCard Application
     * @name GetApplicationBankEventsApplicationCcNoBankEventsPost
     * @summary Get Application Bank Events
     * @request POST:/application/cc/no/bank-events
     * @secure
     */
    getApplicationBankEventsApplicationCcNoBankEventsPost: (data: ApplicationQuery, params: RequestParams = {}) =>
      this.request<CreditCardBankEventsResponse, HTTPValidationError>({
        path: `/application/cc/no/bank-events`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CreditCard Application
     * @name SearchApplicationsApplicationCcNoSearchApplicationsPost
     * @summary Search Applications
     * @request POST:/application/cc/no/search_applications
     * @secure
     */
    searchApplicationsApplicationCcNoSearchApplicationsPost: (
      data: GetApplicationsByApplicantIdentifierPayload,
      params: RequestParams = {},
    ) =>
      this.request<CreditCardApplicationExtended[], HTTPValidationError>({
        path: `/application/cc/no/search_applications`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CreditCard Application
     * @name AcceptOfferApplicationCcNoAcceptOfferPost
     * @summary Accept Offer
     * @request POST:/application/cc/no/accept_offer
     * @secure
     */
    acceptOfferApplicationCcNoAcceptOfferPost: (data: AcceptOffer, params: RequestParams = {}) =>
      this.request<CreditorOfferCreditCardOfferCreditCardTerms, HTTPValidationError>({
        path: `/application/cc/no/accept_offer`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mortgage SE Application
     * @name GetApplicationBankEventsApplicationMoSeBankEventsPost
     * @summary Get Application Bank Events
     * @request POST:/application/mo/se/bank-events
     * @secure
     */
    getApplicationBankEventsApplicationMoSeBankEventsPost: (data: ApplicationQuery, params: RequestParams = {}) =>
      this.request<MortgageBankEventsResponse, HTTPValidationError>({
        path: `/application/mo/se/bank-events`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank Communication
     * @name InviteApplicationApplicationInvitePost
     * @summary Invite Application
     * @request POST:/application/invite
     * @secure
     */
    inviteApplicationApplicationInvitePost: (data: InvitePayloadBase, params: RequestParams = {}) =>
      this.request<BankCommunicationData, HTTPValidationError>({
        path: `/application/invite`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank Communication
     * @name InviteApplicationIdApplicationInviteApplicationIdPost
     * @summary Invite Application Id
     * @request POST:/application/invite/{application_id}
     * @secure
     */
    inviteApplicationIdApplicationInviteApplicationIdPost: (
      applicationId: string,
      data: InvitePayloadBase,
      params: RequestParams = {},
    ) =>
      this.request<BankCommunicationData, HTTPValidationError>({
        path: `/application/invite/${applicationId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank Communication
     * @name GetAppEventsApplicationGetAppEventsApplicationIdGet
     * @summary Get App Events
     * @request GET:/application/get_app_events/{application_id}
     * @secure
     */
    getAppEventsApplicationGetAppEventsApplicationIdGet: (applicationId: string, params: RequestParams = {}) =>
      this.request<EventsResponse, HTTPValidationError>({
        path: `/application/get_app_events/${applicationId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank Communication
     * @name GetAppEventsOldApplicationGetAppEventsPost
     * @summary Get App Events Old
     * @request POST:/application/get_app_events
     * @secure
     */
    getAppEventsOldApplicationGetAppEventsPost: (params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/application/get_app_events`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank Communication
     * @name SendCommentToIntegrationApplicationCommentToBankPost
     * @summary Send Comment To Integration
     * @request POST:/application/comment_to_bank
     * @secure
     */
    sendCommentToIntegrationApplicationCommentToBankPost: (data: BaseComment, params: RequestParams = {}) =>
      this.request<EventsResponse, HTTPValidationError>({
        path: `/application/comment_to_bank`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank Communication
     * @name AcceptOfferApplicationAcceptOfferPost
     * @summary Accept Offer
     * @request POST:/application/accept_offer
     * @secure
     */
    acceptOfferApplicationAcceptOfferPost: (data: AcceptOffer, params: RequestParams = {}) =>
      this.request<EventsResponse, HTTPValidationError>({
        path: `/application/accept_offer`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank Communication
     * @name CancelApplicationCancelPost
     * @summary Cancel
     * @request POST:/application/cancel
     * @secure
     */
    cancelApplicationCancelPost: (data: CancelOfferPayload, params: RequestParams = {}) =>
      this.request<EventsResponse, HTTPValidationError>({
        path: `/application/cancel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank Communication
     * @name SendDocumentToIntegrationApplicationDocumentToBankPost
     * @summary Send Document To Integration
     * @request POST:/application/document_to_bank
     * @secure
     */
    sendDocumentToIntegrationApplicationDocumentToBankPost: (data: DocumentToBank, params: RequestParams = {}) =>
      this.request<EventsResponse, HTTPValidationError>({
        path: `/application/document_to_bank`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application Meta
     * @name AssignApplicationToHandlerApplicationAssignApplicationIdPost
     * @summary Assign Application To Handler
     * @request POST:/application/assign/{application_id}
     * @secure
     */
    assignApplicationToHandlerApplicationAssignApplicationIdPost: (
      applicationId: string,
      data: AssignApplicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/application/assign/${applicationId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application Meta
     * @name ListInternalCommentsApplicationCommentApplicationIdGet
     * @summary List Internal Comments
     * @request GET:/application/comment/{application_id}
     * @secure
     */
    listInternalCommentsApplicationCommentApplicationIdGet: (applicationId: string, params: RequestParams = {}) =>
      this.request<
        (BankIDSignedWithNames | InternalCommentWithName | (BankIDSignedWithNames & InternalCommentWithName))[],
        HTTPValidationError
      >({
        path: `/application/comment/${applicationId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application Meta
     * @name AddInternalCommentApplicationCommentApplicationIdPost
     * @summary Add Internal Comment
     * @request POST:/application/comment/{application_id}
     * @secure
     */
    addInternalCommentApplicationCommentApplicationIdPost: (
      applicationId: string,
      data: CommentPayload,
      params: RequestParams = {},
    ) =>
      this.request<
        (BankIDSignedWithNames | InternalCommentWithName | (BankIDSignedWithNames & InternalCommentWithName))[],
        HTTPValidationError
      >({
        path: `/application/comment/${applicationId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application Meta
     * @name GetPossibleStatusesApplicationPrefsGet
     * @summary Get Possible Statuses
     * @request GET:/application/prefs
     * @secure
     */
    getPossibleStatusesApplicationPrefsGet: (params: RequestParams = {}) =>
      this.request<PrefsResponse, HTTPValidationError>({
        path: `/application/prefs`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application Meta
     * @name GetPossibleLoanTypesApplicationLoanTypesCountryGet
     * @summary Get Possible Loan Types
     * @request GET:/application/loan-types/{country}
     * @secure
     */
    getPossibleLoanTypesApplicationLoanTypesCountryGet: (country: Country, params: RequestParams = {}) =>
      this.request<string[], HTTPValidationError>({
        path: `/application/loan-types/${country}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application Meta
     * @name SearchBlancoSverkerApplicationBlancoSearchCountryGet
     * @summary Search Blanco Sverker
     * @request GET:/application/blanco/search/{country}
     * @secure
     */
    searchBlancoSverkerApplicationBlancoSearchCountryGet: (
      country: Country,
      query: { s: string },
      params: RequestParams = {},
    ) =>
      this.request<SverkerSearchResponse, HTTPValidationError>({
        path: `/application/blanco/search/${country}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AML
     * @name AmlReviewApplicationAmlReviewPost
     * @summary Aml Review
     * @request POST:/application/aml/review
     * @secure
     */
    amlReviewApplicationAmlReviewPost: (data: AMLReviewPayload, params: RequestParams = {}) =>
      this.request<ApplicationWithNamesInComments, HTTPValidationError>({
        path: `/application/aml/review`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AML
     * @name GetBlancoAmlApplicationBlancoAmlApplicationIdGet
     * @summary Get Blanco Aml
     * @request GET:/application/blanco/aml/{application_id}
     * @secure
     */
    getBlancoAmlApplicationBlancoAmlApplicationIdGet: (
      applicationId: number,
      query: { country: Country },
      params: RequestParams = {},
    ) =>
      this.request<AMLBlancoResponse, HTTPValidationError>({
        path: `/application/blanco/aml/${applicationId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AML
     * @name PatchBlancoAmlApplicationBlancoAmlApplicationIdPatch
     * @summary Patch Blanco Aml
     * @request PATCH:/application/blanco/aml/{application_id}
     * @secure
     */
    patchBlancoAmlApplicationBlancoAmlApplicationIdPatch: (
      applicationId: number,
      data: BlancoAMLPatchPayload,
      params: RequestParams = {},
    ) =>
      this.request<AMLBlancoResponse, HTTPValidationError>({
        path: `/application/blanco/aml/${applicationId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AML
     * @name ReviewBlancoAmlApplicationBlancoAmlReviewApplicationIdPatch
     * @summary Review Blanco Aml
     * @request PATCH:/application/blanco/aml/review/{application_id}
     * @secure
     */
    reviewBlancoAmlApplicationBlancoAmlReviewApplicationIdPatch: (
      applicationId: number,
      data: BlancoAMLReviewPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/application/blanco/aml/review/${applicationId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AML
     * @name MortgageDeactivationReviewsApplicationDeactivationReviewsMortgagePost
     * @summary Mortgage Deactivation Reviews
     * @request POST:/application/deactivation_reviews/mortgage
     * @secure
     */
    mortgageDeactivationReviewsApplicationDeactivationReviewsMortgagePost: (
      data: DeactivationReviewsPayload,
      params: RequestParams = {},
    ) =>
      this.request<MortgageDeactivationReviewsResponse, HTTPValidationError>({
        path: `/application/deactivation_reviews/mortgage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AML
     * @name BlancoDeactivationReviewsApplicationDeactivationReviewsBlancoPost
     * @summary Blanco Deactivation Reviews
     * @request POST:/application/deactivation_reviews/blanco
     * @secure
     */
    blancoDeactivationReviewsApplicationDeactivationReviewsBlancoPost: (
      data: DeactivationReviewsPayload,
      params: RequestParams = {},
    ) =>
      this.request<DeactivationReviewsResponse, HTTPValidationError>({
        path: `/application/deactivation_reviews/blanco`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  customer = {
    /**
     * No description
     *
     * @tags Customer
     * @name GetCustomerCustomerGetPost
     * @summary Get Customer
     * @request POST:/customer/get
     * @secure
     */
    getCustomerCustomerGetPost: (
      data:
        | PniGetCustomerPayload
        | EmailGetCustomerPayload
        | PhoneGetCustomerPayload
        | CustomerIDGetCustomerPayload
        | CustomerIDsGetCustomerPayload
        | (PniGetCustomerPayload &
            EmailGetCustomerPayload &
            PhoneGetCustomerPayload &
            CustomerIDGetCustomerPayload &
            CustomerIDsGetCustomerPayload),
      params: RequestParams = {},
    ) =>
      this.request<ApplicantSE | ApplicantNO | (ApplicantSE & ApplicantNO), HTTPValidationError>({
        path: `/customer/get`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name GetCustomersCustomerGetsPost
     * @summary Get Customers
     * @request POST:/customer/gets
     * @secure
     */
    getCustomersCustomerGetsPost: (data: CustomerIDsGetCustomerPayload, params: RequestParams = {}) =>
      this.request<(ApplicantSE | ApplicantNO)[], HTTPValidationError>({
        path: `/customer/gets`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CreateCustomerCustomerCreatePost
     * @summary Create Customer
     * @request POST:/customer/create
     * @secure
     */
    createCustomerCustomerCreatePost: (data: CreateCustomerPayload, params: RequestParams = {}) =>
      this.request<ApplicantSE | ApplicantNO | (ApplicantSE & ApplicantNO), HTTPValidationError>({
        path: `/customer/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name UpdateCustomerCustomerUpdatePost
     * @summary Update Customer
     * @request POST:/customer/update
     * @secure
     */
    updateCustomerCustomerUpdatePost: (data: UpdateCustomerPayload, params: RequestParams = {}) =>
      this.request<ApplicantSE | ApplicantNO | (ApplicantSE & ApplicantNO), HTTPValidationError>({
        path: `/customer/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name UpdateConsentsCustomerUpdateConsentsPost
     * @summary Update Consents
     * @request POST:/customer/update_consents
     * @secure
     */
    updateConsentsCustomerUpdateConsentsPost: (data: UpdateCustomerConsentsPayload, params: RequestParams = {}) =>
      this.request<ApplicantSE | ApplicantNO | (ApplicantSE & ApplicantNO), HTTPValidationError>({
        path: `/customer/update_consents`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name IdCheckOrGetCustomerCustomerIdCheckPost
     * @summary Id Check Or Get Customer
     * @request POST:/customer/id-check
     * @secure
     */
    idCheckOrGetCustomerCustomerIdCheckPost: (data: IDCheckGetCustomerPayload, params: RequestParams = {}) =>
      this.request<
        (ApplicantSE | ApplicantNO) | IDCheckedPerson | ((ApplicantSE | ApplicantNO) & IDCheckedPerson),
        HTTPValidationError
      >({
        path: `/customer/id-check`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name TakeCreditCheckCustomerCreditCheckPost
     * @summary Take Credit Check
     * @request POST:/customer/credit-check
     * @secure
     */
    takeCreditCheckCustomerCreditCheckPost: (data: TakeCreditCheck, params: RequestParams = {}) =>
      this.request<ApplicantSE | ApplicantNO | (ApplicantSE & ApplicantNO), HTTPValidationError>({
        path: `/customer/credit-check`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name GetNameByPniCustomerNameByPniPost
     * @summary Get Name By Pni
     * @request POST:/customer/name/by-pni
     * @secure
     */
    getNameByPniCustomerNameByPniPost: (data: GetNameByPNIPayload, params: RequestParams = {}) =>
      this.request<Name, HTTPValidationError>({
        path: `/customer/name/by-pni`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name GetNameCustomerNameCustomerIdGet
     * @summary Get Name
     * @request GET:/customer/name/{customer_id}
     * @secure
     */
    getNameCustomerNameCustomerIdGet: (customerId: string, params: RequestParams = {}) =>
      this.request<Name, HTTPValidationError>({
        path: `/customer/name/${customerId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer, Application Meta
     * @name EmploymentTypesCustomerEmploymentTypesCountryGet
     * @summary Employment Types
     * @request GET:/customer/employment-types/{country}
     * @secure
     */
    employmentTypesCustomerEmploymentTypesCountryGet: (country: Country, params: RequestParams = {}) =>
      this.request<string[], HTTPValidationError>({
        path: `/customer/employment-types/${country}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer, Application Meta
     * @name HousingTypesCustomerHousingTypesCountryGet
     * @summary Housing Types
     * @request GET:/customer/housing-types/{country}
     * @secure
     */
    housingTypesCustomerHousingTypesCountryGet: (country: Country, params: RequestParams = {}) =>
      this.request<string[], HTTPValidationError>({
        path: `/customer/housing-types/${country}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name GetExternallyVerifiedCreditsCustomerExternallyVerifiedCreditsPost
     * @summary Get Externally Verified Credits
     * @request POST:/customer/externally-verified-credits
     * @secure
     */
    getExternallyVerifiedCreditsCustomerExternallyVerifiedCreditsPost: (
      data: MinimalApplicant[],
      params: RequestParams = {},
    ) =>
      this.request<LoanAndExternallyVerifiedCredit, HTTPValidationError>({
        path: `/customer/externally-verified-credits`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  meeting = {
    /**
     * No description
     *
     * @tags Meeting
     * @name GetMeetingMeetingGetMeetingIdGet
     * @summary Get Meeting
     * @request GET:/meeting/get/{meeting_id}
     * @secure
     */
    getMeetingMeetingGetMeetingIdGet: (meetingId: string, params: RequestParams = {}) =>
      this.request<ModelsMeetingMeeting, HTTPValidationError>({
        path: `/meeting/get/${meetingId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name GetMeetingsMeetingGetPost
     * @summary Get Meetings
     * @request POST:/meeting/get
     * @secure
     */
    getMeetingsMeetingGetPost: (data: GetMeetings, params: RequestParams = {}) =>
      this.request<
        | MeetingWithApp[]
        | MeetingWithHandlerName[]
        | ModelsMeetingMeeting[]
        | (MeetingWithApp[] & MeetingWithHandlerName[] & ModelsMeetingMeeting[]),
        HTTPValidationError
      >({
        path: `/meeting/get`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name GetMyMeetingsMeetingMinePost
     * @summary Get My Meetings
     * @request POST:/meeting/mine
     * @secure
     */
    getMyMeetingsMeetingMinePost: (data: GetMyMeetings, params: RequestParams = {}) =>
      this.request<
        (
          | MeetingWithApp
          | MeetingWithHandlerName
          | ModelsMeetingMeeting
          | (MeetingWithApp & MeetingWithHandlerName & ModelsMeetingMeeting)
        )[],
        HTTPValidationError
      >({
        path: `/meeting/mine`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name CreateMeetingMeetingCreatePost
     * @summary Create Meeting
     * @request POST:/meeting/create
     * @secure
     */
    createMeetingMeetingCreatePost: (data: CreateMeetingPayload, params: RequestParams = {}) =>
      this.request<ModelsMeetingMeeting, HTTPValidationError>({
        path: `/meeting/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name UpdateMeetingMeetingUpdateMeetingIdPost
     * @summary Update Meeting
     * @request POST:/meeting/update/{meeting_id}
     * @secure
     */
    updateMeetingMeetingUpdateMeetingIdPost: (
      meetingId: string,
      data: UpdateMeetingPayload,
      params: RequestParams = {},
    ) =>
      this.request<ModelsMeetingMeeting, HTTPValidationError>({
        path: `/meeting/update/${meetingId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name CancelMeetingsMeetingCancelMeetingIdDelete
     * @summary Cancel Meetings
     * @request DELETE:/meeting/cancel/{meeting_id}
     * @secure
     */
    cancelMeetingsMeetingCancelMeetingIdDelete: (meetingId: string, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/meeting/cancel/${meetingId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name GetBookableTimesMeetingAvailableDayGet
     * @summary Get Bookable Times
     * @request GET:/meeting/available/{day}
     * @secure
     */
    getBookableTimesMeetingAvailableDayGet: (day: string, params: RequestParams = {}) =>
      this.request<BookableSlot[], HTTPValidationError>({
        path: `/meeting/available/${day}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  document = {
    /**
     * No description
     *
     * @tags Document
     * @name GetDocumentMetaDocumentGetMetaCustomerIdDocumentIdGet
     * @summary Get Document Meta
     * @request GET:/document/get/meta/{customer_id}/{document_id}
     * @secure
     */
    getDocumentMetaDocumentGetMetaCustomerIdDocumentIdGet: (
      customerId: string,
      documentId: string,
      params: RequestParams = {},
    ) =>
      this.request<DocumentMeta, HTTPValidationError>({
        path: `/document/get/meta/${customerId}/${documentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document
     * @name GetDocumentDocumentGetCustomerIdDocumentIdGet
     * @summary Get Document
     * @request GET:/document/get/{customer_id}/{document_id}
     * @secure
     */
    getDocumentDocumentGetCustomerIdDocumentIdGet: (
      customerId: string,
      documentId: string,
      params: RequestParams = {},
    ) =>
      this.request<ModelsDocumentDocumentDocument, HTTPValidationError>({
        path: `/document/get/${customerId}/${documentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document
     * @name CreateDocumentDocumentSavePost
     * @summary Create Document
     * @request POST:/document/save
     * @secure
     */
    createDocumentDocumentSavePost: (data: CreateDocumentPayload, params: RequestParams = {}) =>
      this.request<CreateDocumentPayloadResp, HTTPValidationError>({
        path: `/document/save`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document
     * @name DocumentTypesDocumentTypesGet
     * @summary Document Types
     * @request GET:/document/types
     * @secure
     */
    documentTypesDocumentTypesGet: (params: RequestParams = {}) =>
      this.request<DocumentType[], HTTPValidationError>({
        path: `/document/types`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document
     * @name GetAttachedDocumentsOfApplicationDocumentAttachedApplicationIdGet
     * @summary Get Attached Documents Of Application
     * @request GET:/document/attached/{application_id}
     * @secure
     */
    getAttachedDocumentsOfApplicationDocumentAttachedApplicationIdGet: (
      applicationId: string,
      params: RequestParams = {},
    ) =>
      this.request<DocumentAssignation[], HTTPValidationError>({
        path: `/document/attached/${applicationId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document
     * @name AttachDocumentToApplicationDocumentAttachApplicationIdPost
     * @summary Attach Document To Application
     * @request POST:/document/attach/{application_id}
     * @secure
     */
    attachDocumentToApplicationDocumentAttachApplicationIdPost: (
      applicationId: string,
      data: DocumentAssignation,
      params: RequestParams = {},
    ) =>
      this.request<DocumentAssignation[], HTTPValidationError>({
        path: `/document/attach/${applicationId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  banks = {
    /**
     * No description
     *
     * @tags Banks
     * @name GetAllBanksBanksAllGet
     * @summary Get All Banks
     * @request GET:/banks/all
     * @secure
     */
    getAllBanksBanksAllGet: (params: RequestParams = {}) =>
      this.request<Bank[], HTTPValidationError>({
        path: `/banks/all`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Banks
     * @name GetBanksBanksGetPost
     * @summary Get Banks
     * @request POST:/banks/get
     * @secure
     */
    getBanksBanksGetPost: (data: GetBanksPayload, params: RequestParams = {}) =>
      this.request<Bank[], HTTPValidationError>({
        path: `/banks/get`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Banks
     * @name GetAllIntegrationsBanksAllIntegrationsGet
     * @summary Get All Integrations
     * @request GET:/banks/all_integrations
     * @secure
     */
    getAllIntegrationsBanksAllIntegrationsGet: (params: RequestParams = {}) =>
      this.request<Integration[], HTTPValidationError>({
        path: `/banks/all_integrations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Banks
     * @name GetIntegrationsBanksGetIntegrationsPost
     * @summary Get Integrations
     * @request POST:/banks/get_integrations
     * @secure
     */
    getIntegrationsBanksGetIntegrationsPost: (data: IntegrationQuery, params: RequestParams = {}) =>
      this.request<Integration[], HTTPValidationError>({
        path: `/banks/get_integrations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  schedule = {
    /**
     * No description
     *
     * @tags Advisor Schedule
     * @name ScheduleDaySchedulePost
     * @summary Schedule Day
     * @request POST:/schedule/
     * @secure
     */
    scheduleDaySchedulePost: (data: DaySlotDocPayload, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/schedule/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Advisor Schedule
     * @name GetScheduleOfDayScheduleDayGet
     * @summary Get Schedule Of Day
     * @request GET:/schedule/{day}
     * @secure
     */
    getScheduleOfDayScheduleDayGet: (day: string, params: RequestParams = {}) =>
      this.request<DaySlotDoc, HTTPValidationError>({
        path: `/schedule/${day}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Advisor Schedule
     * @name GetScheduleOfDayByCountryAndProductScheduleDayProductCountryGet
     * @summary Get Schedule Of Day By Country And Product
     * @request GET:/schedule/{day}/{product}/{country}
     * @secure
     */
    getScheduleOfDayByCountryAndProductScheduleDayProductCountryGet: (
      day: string,
      product: Product,
      country: Country,
      params: RequestParams = {},
    ) =>
      this.request<DaySlotDoc, HTTPValidationError>({
        path: `/schedule/${day}/${product}/${country}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  employee = {
    /**
     * No description
     *
     * @tags Employee
     * @name GetAllEmployeesEmployeeAllGet
     * @summary Get All Employees
     * @request GET:/employee/all
     * @secure
     */
    getAllEmployeesEmployeeAllGet: (
      query?: { page?: number; limit?: number; without_deactivated?: boolean },
      params: RequestParams = {},
    ) =>
      this.request<Employee[], HTTPValidationError>({
        path: `/employee/all`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name GetSverkerUsersEmployeeGetSverkerUsersGet
     * @summary Get Sverker Users
     * @request GET:/employee/get_sverker_users
     * @secure
     */
    getSverkerUsersEmployeeGetSverkerUsersGet: (query: { user_name: string }, params: RequestParams = {}) =>
      this.request<string[], HTTPValidationError>({
        path: `/employee/get_sverker_users`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name GetEmployeesByZoordinatesEmployeeByZoordinatesPost
     * @summary Get Employees By Zoordinates
     * @request POST:/employee/by_zoordinates
     * @secure
     */
    getEmployeesByZoordinatesEmployeeByZoordinatesPost: (data: AllOptionalZoordinates, params: RequestParams = {}) =>
      this.request<Employee[], HTTPValidationError>({
        path: `/employee/by_zoordinates`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name GetMyInfoEmployeeMeGet
     * @summary Get My Info
     * @request GET:/employee/me
     * @secure
     */
    getMyInfoEmployeeMeGet: (params: RequestParams = {}) =>
      this.request<Employee, HTTPValidationError>({
        path: `/employee/me`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name DeactivateUserByIdEmployeeActionsBlockOrUnblockUserIdPatch
     * @summary Deactivate User By Id
     * @request PATCH:/employee/actions/block-or-unblock/{user_id}
     * @secure
     */
    deactivateUserByIdEmployeeActionsBlockOrUnblockUserIdPatch: (
      userId: string,
      query?: { block?: boolean },
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/employee/actions/block-or-unblock/${userId}`,
        method: "PATCH",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name GetAllZoordinatesEmployeeZoordinatesGet
     * @summary Get All Zoordinates
     * @request GET:/employee/zoordinates
     * @secure
     */
    getAllZoordinatesEmployeeZoordinatesGet: (params: RequestParams = {}) =>
      this.request<Zoordinates[], HTTPValidationError>({
        path: `/employee/zoordinates`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name GetAllRolesEmployeeRolesGet
     * @summary Get All Roles
     * @request GET:/employee/roles
     * @secure
     */
    getAllRolesEmployeeRolesGet: (params: RequestParams = {}) =>
      this.request<RoleType[], HTTPValidationError>({
        path: `/employee/roles`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name GetMySettingsEmployeeMySettingsGet
     * @summary Get My Settings
     * @request GET:/employee/my-settings
     * @secure
     */
    getMySettingsEmployeeMySettingsGet: (params: RequestParams = {}) =>
      this.request<UserSettings, HTTPValidationError>({
        path: `/employee/my-settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name SaveMySettingsEmployeeMySettingsPost
     * @summary Save My Settings
     * @request POST:/employee/my-settings
     * @secure
     */
    saveMySettingsEmployeeMySettingsPost: (data: UserSettings, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/employee/my-settings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name CreateEmployeeEmployeePost
     * @summary Create Employee
     * @request POST:/employee/
     * @secure
     */
    createEmployeeEmployeePost: (data: CreateAndUpdateEmployeeRequest, params: RequestParams = {}) =>
      this.request<Employee, HTTPValidationError>({
        path: `/employee/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name GetByIdEmployeeUserIdGet
     * @summary Get By Id
     * @request GET:/employee/{user_id}
     * @secure
     */
    getByIdEmployeeUserIdGet: (userId: string, params: RequestParams = {}) =>
      this.request<Employee, HTTPValidationError>({
        path: `/employee/${userId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name UpdateEmployeeEmployeeUserIdPut
     * @summary Update Employee
     * @request PUT:/employee/{user_id}
     * @secure
     */
    updateEmployeeEmployeeUserIdPut: (
      userId: string,
      data: CreateAndUpdateEmployeeRequest,
      params: RequestParams = {},
    ) =>
      this.request<Employee, HTTPValidationError>({
        path: `/employee/${userId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name SearchEmployeeSearchPost
     * @summary Search
     * @request POST:/employee/search
     * @secure
     */
    searchEmployeeSearchPost: (data: RoutersEmployeeModelsSearchPayload, params: RequestParams = {}) =>
      this.request<Employee[], HTTPValidationError>({
        path: `/employee/search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  property = {
    /**
     * No description
     *
     * @tags Property
     * @name GetPropertyPropertyGetPropertyIdGet
     * @summary Get Property
     * @request GET:/property/get/{property_id}
     * @secure
     */
    getPropertyPropertyGetPropertyIdGet: (propertyId: string, params: RequestParams = {}) =>
      this.request<House | VacationHome | Condominium | (House & VacationHome & Condominium), HTTPValidationError>({
        path: `/property/get/${propertyId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property
     * @name GetPartialPropertyPropertyPartialGetPropertyIdGet
     * @summary Get Partial Property
     * @request GET:/property/partial/get/{property_id}
     * @secure
     */
    getPartialPropertyPropertyPartialGetPropertyIdGet: (propertyId: string, params: RequestParams = {}) =>
      this.request<PartialProperty, HTTPValidationError>({
        path: `/property/partial/get/${propertyId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property
     * @name CreatePropertyPropertyCreateApplicationIdPost
     * @summary Create Property
     * @request POST:/property/create/{application_id}
     * @secure
     */
    createPropertyPropertyCreateApplicationIdPost: (
      applicationId: string,
      data:
        | PartialHouse
        | PartialCondominium
        | PartialVacationHome
        | (PartialHouse & PartialCondominium & PartialVacationHome),
      params: RequestParams = {},
    ) =>
      this.request<House | VacationHome | Condominium | (House & VacationHome & Condominium), HTTPValidationError>({
        path: `/property/create/${applicationId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property
     * @name CreatePartialPropertyPropertyPartialCreateApplicationIdPost
     * @summary Create Partial Property
     * @request POST:/property/partial/create/{application_id}
     * @secure
     */
    createPartialPropertyPropertyPartialCreateApplicationIdPost: (
      applicationId: string,
      data: NewPartialProperty,
      params: RequestParams = {},
    ) =>
      this.request<PartialProperty, HTTPValidationError>({
        path: `/property/partial/create/${applicationId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property
     * @name UpdatePropertyPropertyUpdatePropertyIdPut
     * @summary Update Property
     * @request PUT:/property/update/{property_id}
     * @secure
     */
    updatePropertyPropertyUpdatePropertyIdPut: (
      propertyId: string,
      data:
        | PartialHouse
        | PartialCondominium
        | PartialVacationHome
        | (PartialHouse & PartialCondominium & PartialVacationHome),
      params: RequestParams = {},
    ) =>
      this.request<House | VacationHome | Condominium | (House & VacationHome & Condominium), HTTPValidationError>({
        path: `/property/update/${propertyId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property
     * @name UpdatePartialPropertyPropertyPartialUpdatePropertyIdPut
     * @summary Update Partial Property
     * @request PUT:/property/partial/update/{property_id}
     * @secure
     */
    updatePartialPropertyPropertyPartialUpdatePropertyIdPut: (
      propertyId: string,
      data: NewPartialProperty,
      params: RequestParams = {},
    ) =>
      this.request<PartialProperty, HTTPValidationError>({
        path: `/property/partial/update/${propertyId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property Valuation
     * @name SearchPropertyValuationSearchPropertyIdPost
     * @summary Search
     * @request POST:/property/valuation/search/{property_id}
     * @secure
     */
    searchPropertyValuationSearchPropertyIdPost: (
      propertyId: string,
      data: RoutersPropertyPayloadSearchPayload,
      params: RequestParams = {},
    ) =>
      this.request<PropertySearchResult[], HTTPValidationError>({
        path: `/property/valuation/search/${propertyId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property Creation
     * @name SearchForAddressPropertyV2SearchPropertyTypePost
     * @summary Search For Address
     * @request POST:/property/v2/search/{property_type}
     * @secure
     */
    searchForAddressPropertyV2SearchPropertyTypePost: (
      propertyType: MortgagePropertyType,
      data: RoutersPropertyPayloadSearchPayload,
      params: RequestParams = {},
    ) =>
      this.request<PropertySearchResult[], HTTPValidationError>({
        path: `/property/v2/search/${propertyType}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property Creation
     * @name GetPropertyInfoForCreationPropertyV2InfoSearchIdGet
     * @summary Get Property Info For Creation
     * @request GET:/property/v2/info/{search_id}
     * @secure
     */
    getPropertyInfoForCreationPropertyV2InfoSearchIdGet: (searchId: string, params: RequestParams = {}) =>
      this.request<PropertyInfo, HTTPValidationError>({
        path: `/property/v2/info/${searchId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property Creation
     * @name GetPropertyInfoByExternalIdPropertyV2InfoByExternalIdExternalIdGet
     * @summary Get Property Info By External Id
     * @request GET:/property/v2/info-by-external-id/{external_id}
     * @secure
     */
    getPropertyInfoByExternalIdPropertyV2InfoByExternalIdExternalIdGet: (
      externalId: string,
      params: RequestParams = {},
    ) =>
      this.request<PropertyInfo, HTTPValidationError>({
        path: `/property/v2/info-by-external-id/${externalId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property Valuation
     * @name GetPropertyValuationV2PropertyValuationV2Post
     * @summary Get Property Valuation V2
     * @request POST:/property/valuation/v2
     * @secure
     */
    getPropertyValuationV2PropertyValuationV2Post: (data: ValuationPayloadV2, params: RequestParams = {}) =>
      this.request<PropertyValuation, HTTPValidationError>({
        path: `/property/valuation/v2`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property Valuation
     * @name GetPropertyInfoPropertyValuationInfoSearchIdGet
     * @summary Get Property Info
     * @request GET:/property/valuation/info/{search_id}
     * @secure
     */
    getPropertyInfoPropertyValuationInfoSearchIdGet: (searchId: string, params: RequestParams = {}) =>
      this.request<PropertyInfo, HTTPValidationError>({
        path: `/property/valuation/info/${searchId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property Valuation
     * @name GetPropertyValuationPropertyValuationValuationPost
     * @summary Get Property Valuation
     * @request POST:/property/valuation/valuation
     * @secure
     */
    getPropertyValuationPropertyValuationValuationPost: (data: ValuationPayload, params: RequestParams = {}) =>
      this.request<PropertyValuation, HTTPValidationError>({
        path: `/property/valuation/valuation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property Creation
     * @name BooliSearchForAddressPropertyV2BooliSearchPost
     * @summary Booli Search For Address
     * @request POST:/property/v2/booli/search
     * @deprecated
     * @secure
     */
    booliSearchForAddressPropertyV2BooliSearchPost: (data: BooliSearchPayload, params: RequestParams = {}) =>
      this.request<BooliPropertySearchResult[], HTTPValidationError>({
        path: `/property/v2/booli/search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property Valuation
     * @name GetPropertyBooliValuationPropertyValuationBooliPost
     * @summary Get Property Booli Valuation
     * @request POST:/property/valuation/booli
     * @deprecated
     * @secure
     */
    getPropertyBooliValuationPropertyValuationBooliPost: (data: BooliValuationPayload, params: RequestParams = {}) =>
      this.request<PropertyValuation, HTTPValidationError>({
        path: `/property/valuation/booli`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetPropertyByPniPropertyEvcheckCachePost
     * @summary Get Property By Pni
     * @request POST:/property/evcheck/cache
     * @secure
     */
    getPropertyByPniPropertyEvcheckCachePost: (data: EvCheckPayload, params: RequestParams = {}) =>
      this.request<(PartialHouse | PartialCondominium | (PartialHouse & PartialCondominium))[], HTTPValidationError>({
        path: `/property/evcheck/cache`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  message = {
    /**
     * No description
     *
     * @tags Message
     * @name RemoveTemplateMessageTemplateMessageTypeTemplateNameDelete
     * @summary Remove Template
     * @request DELETE:/message/template/{message_type}/{template_name}
     * @secure
     */
    removeTemplateMessageTemplateMessageTypeTemplateNameDelete: (
      messageType: MessageType,
      templateName: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/message/template/${messageType}/${templateName}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name GetOneTemplateMessageTemplateGetMessageTypeTemplateNameGet
     * @summary Get One Template
     * @request GET:/message/template/get/{message_type}/{template_name}
     * @secure
     */
    getOneTemplateMessageTemplateGetMessageTypeTemplateNameGet: (
      messageType: MessageType,
      templateName: string,
      params: RequestParams = {},
    ) =>
      this.request<SharedTemplate, HTTPValidationError>({
        path: `/message/template/get/${messageType}/${templateName}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name CreateTemplateMessageTemplateAddPost
     * @summary Create Template
     * @request POST:/message/template/add
     * @secure
     */
    createTemplateMessageTemplateAddPost: (data: SharedTemplate, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/message/template/add`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name TemplateListMessageTemplateListMessageTypeGet
     * @summary Template List
     * @request GET:/message/template/list/{message_type}
     * @secure
     */
    templateListMessageTemplateListMessageTypeGet: (
      messageType: MessageType,
      query?: { cutoff_date?: string },
      params: RequestParams = {},
    ) =>
      this.request<(EmailTemplate | SmsTemplate | (EmailTemplate & SmsTemplate))[], HTTPValidationError>({
        path: `/message/template/list/${messageType}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name SendTemplateMessageMessageSendTemplateMessageTypeTemplateNamePost
     * @summary Send Template Message
     * @request POST:/message/send/template/{message_type}/{template_name}
     * @secure
     */
    sendTemplateMessageMessageSendTemplateMessageTypeTemplateNamePost: (
      messageType: MessageType,
      templateName: string,
      data: SendTemplatePayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/message/send/template/${messageType}/${templateName}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name SendRawMessageMessageSendRawMessageTypePost
     * @summary Send Raw Message
     * @request POST:/message/send/raw/{message_type}
     * @secure
     */
    sendRawMessageMessageSendRawMessageTypePost: (
      messageType: MessageType,
      data: SendRawPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/message/send/raw/${messageType}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name GetUnknownSenderSmsMessageSmsUnknownSenderPost
     * @summary Get Unknown Sender Sms
     * @request POST:/message/sms/unknown-sender
     * @secure
     */
    getUnknownSenderSmsMessageSmsUnknownSenderPost: (data: GetMessagesPayload, params: RequestParams = {}) =>
      this.request<IncomingSMS[], HTTPValidationError>({
        path: `/message/sms/unknown-sender`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name GetMessagesForUserMessageUserPost
     * @summary Get Messages For User
     * @request POST:/message/user
     * @secure
     */
    getMessagesForUserMessageUserPost: (data: GetUserMessagesPayload, params: RequestParams = {}) =>
      this.request<SavedMessage[], HTTPValidationError>({
        path: `/message/user`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name GetMessagesForApplicationMessageApplicationPost
     * @summary Get Messages For Application
     * @request POST:/message/application
     * @secure
     */
    getMessagesForApplicationMessageApplicationPost: (
      data: GetApplicationMessagesPayload,
      params: RequestParams = {},
    ) =>
      this.request<SavedMessage[], HTTPValidationError>({
        path: `/message/application`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name GetMessagesByCustomerIdMessageByCustomerPost
     * @summary Get Messages By Customer Id
     * @request POST:/message/by-customer
     * @secure
     */
    getMessagesByCustomerIdMessageByCustomerPost: (
      data: GetMessages,
      query?: { page?: number; limit?: number },
      params: RequestParams = {},
    ) =>
      this.request<SavedMessageWithName[], HTTPValidationError>({
        path: `/message/by-customer`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name GetConversationsMessageConversationsGet
     * @summary Get Conversations
     * @request GET:/message/conversations
     * @secure
     */
    getConversationsMessageConversationsGet: (params: RequestParams = {}) =>
      this.request<Conversation[], HTTPValidationError>({
        path: `/message/conversations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name SaveConversationsMessageConversationsPost
     * @summary Save Conversations
     * @request POST:/message/conversations
     * @secure
     */
    saveConversationsMessageConversationsPost: (data: Conversation[], params: RequestParams = {}) =>
      this.request<Conversation[], HTTPValidationError>({
        path: `/message/conversations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name StreamConversationsMessageConversationsStreamGet
     * @summary Stream Conversations
     * @request GET:/message/conversations/stream
     * @secure
     */
    streamConversationsMessageConversationsStreamGet: (params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/message/conversations/stream`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name UploadAttachmentMessageAttachmentsUploadPost
     * @summary Upload Attachment
     * @request POST:/message/attachments/upload
     * @secure
     */
    uploadAttachmentMessageAttachmentsUploadPost: (
      data: BodyUploadAttachmentMessageAttachmentsUploadPost,
      params: RequestParams = {},
    ) =>
      this.request<DateTime, HTTPValidationError>({
        path: `/message/attachments/upload`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.UrlEncoded,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name GetAttachmentsMessageAttachmentsAllGet
     * @summary Get Attachments
     * @request GET:/message/attachments/all
     * @secure
     */
    getAttachmentsMessageAttachmentsAllGet: (params: RequestParams = {}) =>
      this.request<SavedAttachment[], HTTPValidationError>({
        path: `/message/attachments/all`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ELK46 Callbacks
     * @name Elk46SmsWebhookMessageElk46ConfirmationPost
     * @summary Elk46 Sms Webhook
     * @request POST:/message/elk46/confirmation
     */
    elk46SmsWebhookMessageElk46ConfirmationPost: (params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/message/elk46/confirmation`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ELK46 Callbacks
     * @name Elk46CallWebhookMessageElk46CallPost
     * @summary Elk46 Call Webhook
     * @request POST:/message/elk46/call
     */
    elk46CallWebhookMessageElk46CallPost: (
      data: BodyElk46CallWebhookMessageElk46CallPost,
      params: RequestParams = {},
    ) =>
      this.request<Elk46CallResponse, HTTPValidationError>({
        path: `/message/elk46/call`,
        method: "POST",
        body: data,
        type: ContentType.UrlEncoded,
        format: "json",
        ...params,
      }),
  };
  mortgage = {
    /**
     * No description
     *
     * @tags Mortgage
     * @name GetKalpSettingsMortgageKalpCountryGet
     * @summary Get Kalp Settings
     * @request GET:/mortgage/kalp/{country}
     * @secure
     */
    getKalpSettingsMortgageKalpCountryGet: (country: Country, params: RequestParams = {}) =>
      this.request<(BankKALP | BankAPIDrivenKALP | (BankKALP & BankAPIDrivenKALP))[], HTTPValidationError>({
        path: `/mortgage/kalp/${country}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  other = {
    /**
     * No description
     *
     * @tags Other
     * @name GetAllTaxesForCountryOtherTaxesCountryGet
     * @summary Get All Taxes For Country
     * @request GET:/other/taxes/{country}
     * @secure
     */
    getAllTaxesForCountryOtherTaxesCountryGet: (country: Country, params: RequestParams = {}) =>
      this.request<Tax[], HTTPValidationError>({
        path: `/other/taxes/${country}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Other
     * @name TaxesForIdentifierOtherTaxesCalculationPost
     * @summary Taxes For Identifier
     * @request POST:/other/taxes/calculation
     * @secure
     */
    taxesForIdentifierOtherTaxesCalculationPost: (data: GetTaxPayload, params: RequestParams = {}) =>
      this.request<GetTaxPayloadResponse, HTTPValidationError>({
        path: `/other/taxes/calculation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Other
     * @name GetAllMunicipalitiesForCountryOtherMunicipalityCountryGet
     * @summary Get All Municipalities For Country
     * @request GET:/other/municipality/{country}
     * @secure
     */
    getAllMunicipalitiesForCountryOtherMunicipalityCountryGet: (country: Country, params: RequestParams = {}) =>
      this.request<Municipality[], HTTPValidationError>({
        path: `/other/municipality/${country}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Other
     * @name DeactivationReasonsOtherDeactivationReasonsGet
     * @summary Deactivation Reasons
     * @request GET:/other/deactivation-reasons
     * @secure
     */
    deactivationReasonsOtherDeactivationReasonsGet: (query: { product: Product }, params: RequestParams = {}) =>
      this.request<string[], HTTPValidationError>({
        path: `/other/deactivation-reasons`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Other, websocket
     * @name GetTokenOtherWsTokenForWebsocketGet
     * @summary Get Token
     * @request GET:/other/ws/token-for-websocket
     * @secure
     */
    getTokenOtherWsTokenForWebsocketGet: (params: RequestParams = {}) =>
      this.request<TokenResp, HTTPValidationError>({
        path: `/other/ws/token-for-websocket`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  bankId = {
    /**
     * No description
     *
     * @tags BankID
     * @name VerifyCustomerBankIdVerifyPost
     * @summary Verify Customer
     * @request POST:/bank-id/verify
     * @secure
     */
    verifyCustomerBankIdVerifyPost: (data: BankIDPayload, params: RequestParams = {}) =>
      this.request<RoutersBankIdModelsBankIDResp, HTTPValidationError>({
        path: `/bank-id/verify`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BankID
     * @name IsAlreadyVerifiedBankIdVerifiedPost
     * @summary Is Already Verified
     * @request POST:/bank-id/verified
     * @secure
     */
    isAlreadyVerifiedBankIdVerifiedPost: (data: BankIDPayload, params: RequestParams = {}) =>
      this.request<PollResp, HTTPValidationError>({
        path: `/bank-id/verified`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BankID
     * @name GetTicketStatusBankIdVerifyTicketIdGet
     * @summary Get Ticket Status
     * @request GET:/bank-id/verify/{ticket_id}
     * @secure
     */
    getTicketStatusBankIdVerifyTicketIdGet: (
      ticketId: string,
      query?: { redirect?: boolean },
      params: RequestParams = {},
    ) =>
      this.request<PollResp, HTTPValidationError>({
        path: `/bank-id/verify/${ticketId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BankID
     * @name IdKollenRedirectNoBankIdIdKollenCallbackGet
     * @summary Id Kollen Redirect No
     * @request GET:/bank-id/id-kollen/callback
     */
    idKollenRedirectNoBankIdIdKollenCallbackGet: (
      query?: { refID?: string; code?: string; error?: string },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/bank-id/id-kollen/callback`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags BankID
     * @name IdKollenCallbackSeBankIdIdKollenCallbackPost
     * @summary Id Kollen Callback Se
     * @request POST:/bank-id/id-kollen/callback
     */
    idKollenCallbackSeBankIdIdKollenCallbackPost: (data: IDKollenCallbackRequestSE, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/bank-id/id-kollen/callback`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags BankID
     * @name BankIdSignupStatusBankIdSignStatusGet
     * @summary Bank Id Signup Status
     * @request GET:/bank-id/sign/status
     */
    bankIdSignupStatusBankIdSignStatusGet: (query: { a: string; c: string }, params: RequestParams = {}) =>
      this.request<ClientAutostartToken, HTTPValidationError>({
        path: `/bank-id/sign/status`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BankID
     * @name AutostartTokenBankIdSignGet
     * @summary Autostart Token
     * @request GET:/bank-id/sign
     */
    autostartTokenBankIdSignGet: (query: { a: string; c: string }, params: RequestParams = {}) =>
      this.request<ClientAutostartToken, HTTPValidationError>({
        path: `/bank-id/sign`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BankID Login
     * @name LoginBankIdAuthPost
     * @summary Login
     * @request POST:/bank-id/auth
     */
    loginBankIdAuthPost: (data: LoginPayload, params: RequestParams = {}) =>
      this.request<RoutersBankIdLoginPayloadBankIDResp, HTTPValidationError>({
        path: `/bank-id/auth`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BankID Login
     * @name PollTicketBankIdTicketIdGet
     * @summary Poll Ticket
     * @request GET:/bank-id/{ticket_id}
     */
    pollTicketBankIdTicketIdGet: (ticketId: string, params: RequestParams = {}) =>
      this.request<BankIDLoginResponse, HTTPValidationError>({
        path: `/bank-id/${ticketId}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  notification = {
    /**
     * No description
     *
     * @tags Notifications
     * @name UserNotificationsNotificationGet
     * @summary User Notifications
     * @request GET:/notification/
     * @secure
     */
    userNotificationsNotificationGet: (
      query?: {
        status?: NotificationEvent[];
        notification_type?: ModelsNotificationsNotificationTypesNotificationType;
        page?: number;
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ModelsNotificationsNotificationNotification[], HTTPValidationError>({
        path: `/notification/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name GetNotificationNotificationByIdNotificationIdGet
     * @summary Get Notification
     * @request GET:/notification/by-id/{notification_id}
     * @secure
     */
    getNotificationNotificationByIdNotificationIdGet: (notificationId: string, params: RequestParams = {}) =>
      this.request<ModelsNotificationsNotificationNotification, HTTPValidationError>({
        path: `/notification/by-id/${notificationId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name NotifyNotificationNotifyIncomingPost
     * @summary Notify
     * @request POST:/notification/notify/incoming
     * @secure
     */
    notifyNotificationNotifyIncomingPost: (data: AppsmgrModelsNotificationsNotification, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/notification/notify/incoming`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name NotifyInsuranceNotificationNotifyInsurancePost
     * @summary Notify Insurance
     * @request POST:/notification/notify/insurance
     * @secure
     */
    notifyInsuranceNotificationNotifyInsurancePost: (data: InsuranceNotification, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/notification/notify/insurance`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name AcknowledgeNotificationNotificationActionPost
     * @summary Acknowledge Notification
     * @request POST:/notification/action
     * @secure
     */
    acknowledgeNotificationNotificationActionPost: (data: ActionPayload, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/notification/action`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name CustomAuthUserNotificationsNotificationNotificationIdReceivedPatch
     * @summary Custom Auth User Notifications
     * @request PATCH:/notification/{notification_id}/received
     */
    customAuthUserNotificationsNotificationNotificationIdReceivedPatch: (
      notificationId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/notification/${notificationId}/received`,
        method: "PATCH",
        ...params,
      }),
  };
  ponytail = {
    /**
     * No description
     *
     * @tags Ponytail
     * @name GetDisbursedStatsPonytailDisbursedAllPost
     * @summary Get Disbursed Stats
     * @request POST:/ponytail/disbursed/all
     * @secure
     */
    getDisbursedStatsPonytailDisbursedAllPost: (data: DashboardPayload, params: RequestParams = {}) =>
      this.request<AllDisbursedLoans, HTTPValidationError>({
        path: `/ponytail/disbursed/all`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name GetMyDisbursedPonytailDisbursedMePost
     * @summary Get My Disbursed
     * @request POST:/ponytail/disbursed/me
     * @secure
     */
    getMyDisbursedPonytailDisbursedMePost: (data: DashboardPayload, params: RequestParams = {}) =>
      this.request<MyDisbursedLoans, HTTPValidationError>({
        path: `/ponytail/disbursed/me`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name GetAcceptedPonytailAcceptedAllPost
     * @summary Get Accepted
     * @request POST:/ponytail/accepted/all
     * @secure
     */
    getAcceptedPonytailAcceptedAllPost: (data: DashboardPayload, params: RequestParams = {}) =>
      this.request<AcceptedLoans, HTTPValidationError>({
        path: `/ponytail/accepted/all`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name GetMyAcceptedPonytailAcceptedMePost
     * @summary Get My Accepted
     * @request POST:/ponytail/accepted/me
     * @secure
     */
    getMyAcceptedPonytailAcceptedMePost: (data: DashboardPayload, params: RequestParams = {}) =>
      this.request<AcceptedLoans, HTTPValidationError>({
        path: `/ponytail/accepted/me`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name GetAllInsurancePonytailInsuranceAllPost
     * @summary Get All Insurance
     * @request POST:/ponytail/insurance/all
     * @secure
     */
    getAllInsurancePonytailInsuranceAllPost: (data: DashboardPayload, params: RequestParams = {}) =>
      this.request<AllInsurances, HTTPValidationError>({
        path: `/ponytail/insurance/all`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name GetMyInsurancePonytailInsuranceMePost
     * @summary Get My Insurance
     * @request POST:/ponytail/insurance/me
     * @secure
     */
    getMyInsurancePonytailInsuranceMePost: (data: DashboardPayload, params: RequestParams = {}) =>
      this.request<AllInsurances, HTTPValidationError>({
        path: `/ponytail/insurance/me`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name GetAllMyStatsPonytailMyStatsPost
     * @summary Get All My Stats
     * @request POST:/ponytail/my-stats
     * @secure
     */
    getAllMyStatsPonytailMyStatsPost: (data: DashboardPayload, params: RequestParams = {}) =>
      this.request<MyStatsShared, HTTPValidationError>({
        path: `/ponytail/my-stats`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name SummarizedViewPonytailSummarizedPost
     * @summary Summarized View
     * @request POST:/ponytail/summarized
     * @secure
     */
    summarizedViewPonytailSummarizedPost: (data: DashboardPayload, params: RequestParams = {}) =>
      this.request<SummarizedViewShared, HTTPValidationError>({
        path: `/ponytail/summarized`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name GetWorkingDaysPonytailWorkingDaysPost
     * @summary Get Working Days
     * @request POST:/ponytail/working-days
     * @secure
     */
    getWorkingDaysPonytailWorkingDaysPost: (data: GoalPayload, params: RequestParams = {}) =>
      this.request<WorkingDays, HTTPValidationError>({
        path: `/ponytail/working-days`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name PostBlancoGoalPonytailGoalsCreateBlancoPost
     * @summary Post Blanco Goal
     * @request POST:/ponytail/goals/create/blanco
     * @secure
     */
    postBlancoGoalPonytailGoalsCreateBlancoPost: (data: BlancoGoalPayload, params: RequestParams = {}) =>
      this.request<BlancoGoal, HTTPValidationError>({
        path: `/ponytail/goals/create/blanco`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name PostBlancoGoalMbPonytailGoalsCreateBlancoMbPost
     * @summary Post Blanco Goal Mb
     * @request POST:/ponytail/goals/create/blanco-mb
     * @secure
     */
    postBlancoGoalMbPonytailGoalsCreateBlancoMbPost: (data: BlancoGoalMbPayload, params: RequestParams = {}) =>
      this.request<BlancoGoalMb, HTTPValidationError>({
        path: `/ponytail/goals/create/blanco-mb`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name PostInitialBlancoGoalPonytailGoalsCreateInitialBlancoPost
     * @summary Post Initial Blanco Goal
     * @request POST:/ponytail/goals/create/initial-blanco
     * @secure
     */
    postInitialBlancoGoalPonytailGoalsCreateInitialBlancoPost: (data: BlancoGoalPayload, params: RequestParams = {}) =>
      this.request<BlancoGoal, HTTPValidationError>({
        path: `/ponytail/goals/create/initial-blanco`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name PostInitialBudgetPonytailGoalsCreateInitialBlancoMbPost
     * @summary Post Initial Budget
     * @request POST:/ponytail/goals/create/initial-blanco-mb
     * @secure
     */
    postInitialBudgetPonytailGoalsCreateInitialBlancoMbPost: (data: BudgetPayload, params: RequestParams = {}) =>
      this.request<Budget, HTTPValidationError>({
        path: `/ponytail/goals/create/initial-blanco-mb`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name GetMyGoalsPonytailGoalsPost
     * @summary Get My Goals
     * @request POST:/ponytail/goals
     * @secure
     */
    getMyGoalsPonytailGoalsPost: (data: GoalPayload, params: RequestParams = {}) =>
      this.request<
        BlancoGoalMb | BlancoGoal | MortgageGoal | (BlancoGoalMb & BlancoGoal & MortgageGoal),
        HTTPValidationError
      >({
        path: `/ponytail/goals`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name GetInitialGoalPonytailGoalsInitialGoalPost
     * @summary Get Initial Goal
     * @request POST:/ponytail/goals/initial-goal
     * @secure
     */
    getInitialGoalPonytailGoalsInitialGoalPost: (data: GoalPayload, params: RequestParams = {}) =>
      this.request<Budget | BlancoGoal | MortgageGoal | (Budget & BlancoGoal & MortgageGoal), HTTPValidationError>({
        path: `/ponytail/goals/initial-goal`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  lead = {
    /**
     * No description
     *
     * @tags Lead
     * @name GetLeadLeadGetLeadIdGet
     * @summary Get Lead
     * @request GET:/lead/get/{lead_id}
     * @secure
     */
    getLeadLeadGetLeadIdGet: (leadId: string, params: RequestParams = {}) =>
      this.request<Lead, HTTPValidationError>({
        path: `/lead/get/${leadId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name GetLeadsLeadListPost
     * @summary Get Leads
     * @request POST:/lead/list
     * @secure
     */
    getLeadsLeadListPost: (data: GetLeads, params: RequestParams = {}) =>
      this.request<Lead[], HTTPValidationError>({
        path: `/lead/list`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name CreateLeadLeadCreatePost
     * @summary Create Lead
     * @request POST:/lead/create
     * @secure
     */
    createLeadLeadCreatePost: (data: CreateLeadPayload, params: RequestParams = {}) =>
      this.request<Lead, HTTPValidationError>({
        path: `/lead/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name SearchLeadSearchPost
     * @summary Search
     * @request POST:/lead/search
     * @secure
     */
    searchLeadSearchPost: (data: RoutersLeadPayloadSearchPayload, params: RequestParams = {}) =>
      this.request<Lead[], HTTPValidationError>({
        path: `/lead/search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name ConvertAndCloseLeadConvertAndMarkHandledPost
     * @summary Convert And Close
     * @request POST:/lead/convert_and_mark_handled
     * @secure
     */
    convertAndCloseLeadConvertAndMarkHandledPost: (data: ConvertPayload, params: RequestParams = {}) =>
      this.request<ConvertResult, HTTPValidationError>({
        path: `/lead/convert_and_mark_handled`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name CloseLeadMarkHandledPost
     * @summary Close
     * @request POST:/lead/mark_handled
     * @secure
     */
    closeLeadMarkHandledPost: (data: LeadHandledPayload, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/lead/mark_handled`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name UnhandleLeadLeadUnhandlePost
     * @summary Unhandle Lead
     * @request POST:/lead/unhandle
     * @secure
     */
    unhandleLeadLeadUnhandlePost: (query: { lead_id: string }, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/lead/unhandle`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name UpdateLeadLeadUpdateLeadIdPost
     * @summary Update Lead
     * @request POST:/lead/update/{lead_id}
     * @secure
     */
    updateLeadLeadUpdateLeadIdPost: (leadId: string, data: LeadUpdatePayload, params: RequestParams = {}) =>
      this.request<Lead, HTTPValidationError>({
        path: `/lead/update/${leadId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name ReprocessSubmissionLeadReprocessSubmissionLeadIdPost
     * @summary Reprocess Submission
     * @request POST:/lead/reprocess_submission/{lead_id}
     * @secure
     */
    reprocessSubmissionLeadReprocessSubmissionLeadIdPost: (leadId: string, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/lead/reprocess_submission/${leadId}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name ReprocessSubmissionsLeadReprocessSubmissionsPost
     * @summary Reprocess Submissions
     * @request POST:/lead/reprocess_submissions
     * @secure
     */
    reprocessSubmissionsLeadReprocessSubmissionsPost: (data: ReprocessSubmissionPayload, params: RequestParams = {}) =>
      this.request<ReprocessResult[], HTTPValidationError>({
        path: `/lead/reprocess_submissions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name GetCommentsLeadCommentLeadIdGet
     * @summary Get Comments
     * @request GET:/lead/comment/{lead_id}
     * @secure
     */
    getCommentsLeadCommentLeadIdGet: (leadId: string, params: RequestParams = {}) =>
      this.request<InternalCommentWithName[], HTTPValidationError>({
        path: `/lead/comment/${leadId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name AddInternalCommentLeadCommentLeadIdPost
     * @summary Add Internal Comment
     * @request POST:/lead/comment/{lead_id}
     * @secure
     */
    addInternalCommentLeadCommentLeadIdPost: (leadId: string, data: CommentPayload, params: RequestParams = {}) =>
      this.request<InternalCommentWithName[], HTTPValidationError>({
        path: `/lead/comment/${leadId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name AssignLeadToHandlerLeadAssignLeadIdPost
     * @summary Assign Lead To Handler
     * @request POST:/lead/assign/{lead_id}
     * @secure
     */
    assignLeadToHandlerLeadAssignLeadIdPost: (
      leadId: string,
      data: AssignApplicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/lead/assign/${leadId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name GetAssignedHandlerLeadAssigneeLeadIdGet
     * @summary Get Assigned Handler
     * @request GET:/lead/assignee/{lead_id}
     * @secure
     */
    getAssignedHandlerLeadAssigneeLeadIdGet: (leadId: string, params: RequestParams = {}) =>
      this.request<Assignee, HTTPValidationError>({
        path: `/lead/assignee/${leadId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name GetLeadsLeadListMinePost
     * @summary Get Leads
     * @request POST:/lead/list/mine
     * @secure
     */
    getLeadsLeadListMinePost: (data: GetMyLeads, params: RequestParams = {}) =>
      this.request<Lead[], HTTPValidationError>({
        path: `/lead/list/mine`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  formprefs = {
    /**
     * No description
     *
     * @tags Jotform
     * @name UpdatePreferenceFormprefsPut
     * @summary Update Preference
     * @request PUT:/formprefs/
     * @secure
     */
    updatePreferenceFormprefsPut: (data: UpdateFormPreferencePayload, params: RequestParams = {}) =>
      this.request<FormPreferenceExt, HTTPValidationError>({
        path: `/formprefs/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jotform
     * @name CreatePreferenceFormprefsPost
     * @summary Create Preference
     * @request POST:/formprefs/
     * @secure
     */
    createPreferenceFormprefsPost: (data: FormPreferencePayload, params: RequestParams = {}) =>
      this.request<FormPreferenceExt, HTTPValidationError>({
        path: `/formprefs/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jotform
     * @name DuplicatePreferenceFormprefsDuplicatePost
     * @summary Duplicate Preference
     * @request POST:/formprefs/duplicate
     * @secure
     */
    duplicatePreferenceFormprefsDuplicatePost: (data: DuplicateFormPreferencePayload, params: RequestParams = {}) =>
      this.request<FormPreferenceExt, HTTPValidationError>({
        path: `/formprefs/duplicate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jotform
     * @name ValidatePreferenceFormprefsValidatePost
     * @summary Validate Preference
     * @request POST:/formprefs/validate
     * @secure
     */
    validatePreferenceFormprefsValidatePost: (data: ValidatePayload, params: RequestParams = {}) =>
      this.request<FormPreferenceExt, HTTPValidationError>({
        path: `/formprefs/validate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jotform
     * @name GetMappingFormprefsGetMappingPost
     * @summary Get Mapping
     * @request POST:/formprefs/get_mapping
     * @secure
     */
    getMappingFormprefsGetMappingPost: (data: BaseFormPreferencePayload, params: RequestParams = {}) =>
      this.request<FormMapping, HTTPValidationError>({
        path: `/formprefs/get_mapping`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jotform
     * @name ListPreferencesFormprefsListGet
     * @summary List Preferences
     * @request GET:/formprefs/list
     * @secure
     */
    listPreferencesFormprefsListGet: (params: RequestParams = {}) =>
      this.request<FormPreference[], HTTPValidationError>({
        path: `/formprefs/list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jotform
     * @name ListPreferencesExtFormprefsListExtGet
     * @summary List Preferences Ext
     * @request GET:/formprefs/list_ext
     * @secure
     */
    listPreferencesExtFormprefsListExtGet: (params: RequestParams = {}) =>
      this.request<FormPreferenceExt[], HTTPValidationError>({
        path: `/formprefs/list_ext`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jotform
     * @name ListFormsFormprefsFormsGet
     * @summary List Forms
     * @request GET:/formprefs/forms
     * @secure
     */
    listFormsFormprefsFormsGet: (params: RequestParams = {}) =>
      this.request<Form[], HTTPValidationError>({
        path: `/formprefs/forms`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jotform
     * @name CheckAllSubmissionsFormprefsCheckAllGet
     * @summary Check All Submissions
     * @request GET:/formprefs/check-all
     * @secure
     */
    checkAllSubmissionsFormprefsCheckAllGet: (params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/formprefs/check-all`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jotform
     * @name GetAllSubmissionsFormprefsSubmissionsGet
     * @summary Get All Submissions
     * @request GET:/formprefs/submissions
     * @secure
     */
    getAllSubmissionsFormprefsSubmissionsGet: (query?: { form_id?: string }, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/formprefs/submissions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jotform
     * @name GetFormPreferenceFormprefsFormPreferenceIdGet
     * @summary Get Form Preference
     * @request GET:/formprefs/{form_preference_id}
     * @secure
     */
    getFormPreferenceFormprefsFormPreferenceIdGet: (
      formPreferenceId: string,
      query?: { add_defaults?: boolean },
      params: RequestParams = {},
    ) =>
      this.request<FormPreferenceExt, HTTPValidationError>({
        path: `/formprefs/${formPreferenceId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jotform
     * @name CreateWebhookFormprefsWebhookPost
     * @summary Create Webhook
     * @request POST:/formprefs/webhook
     * @secure
     */
    createWebhookFormprefsWebhookPost: (data: FormWebhookPayload, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/formprefs/webhook`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jotform
     * @name DeleteWebhookFormprefsWebhookDelete
     * @summary Delete Webhook
     * @request DELETE:/formprefs/webhook
     * @secure
     */
    deleteWebhookFormprefsWebhookDelete: (data: FormWebhookPayload, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/formprefs/webhook`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  heimdall = {
    /**
     * No description
     *
     * @tags Heimdall
     * @name GetAllHeimdallRecordsForDateHeimdallDateGet
     * @summary Get All Heimdall Records For Date
     * @request GET:/heimdall/{date}
     * @secure
     */
    getAllHeimdallRecordsForDateHeimdallDateGet: (date: string, params: RequestParams = {}) =>
      this.request<HeimdallResponse[], HTTPValidationError>({
        path: `/heimdall/${date}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Heimdall
     * @name ReportAndVerifyUsageToHeimdallHeimdallUserIdPatch
     * @summary Report And Verify Usage To Heimdall
     * @request PATCH:/heimdall/{user_id}
     * @secure
     */
    reportAndVerifyUsageToHeimdallHeimdallUserIdPatch: (
      userId: string,
      data: HeimdallReportingPayload,
      params: RequestParams = {},
    ) =>
      this.request<HeimdallReportingResponse, HTTPValidationError>({
        path: `/heimdall/${userId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Heimdall
     * @name ResetHeimdallRateLimitHeimdallUserIdToResetResetPatch
     * @summary Reset Heimdall Rate Limit
     * @request PATCH:/heimdall/{user_id_to_reset}/reset
     * @secure
     */
    resetHeimdallRateLimitHeimdallUserIdToResetResetPatch: (userIdToReset: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/heimdall/${userIdToReset}/reset`,
        method: "PATCH",
        secure: true,
        ...params,
      }),
  };
  larsMagnus = {
    /**
     * No description
     *
     * @tags Lars Magnus
     * @name CheckTelavoxIdsLarsMagnusTelavoxCheckGet
     * @summary Check Telavox Ids
     * @request GET:/lars-magnus/telavox-check
     * @secure
     */
    checkTelavoxIdsLarsMagnusTelavoxCheckGet: (params: RequestParams = {}) =>
      this.request<TelavoxMismatch, HTTPValidationError>({
        path: `/lars-magnus/telavox-check`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  myPages = {
    /**
     * No description
     *
     * @tags My Pages
     * @name ImpersonateCustomerMyPagesImpersonatePost
     * @summary Impersonate Customer
     * @request POST:/my-pages/impersonate
     * @secure
     */
    impersonateCustomerMyPagesImpersonatePost: (data: ImpersonateCustomerPayload, params: RequestParams = {}) =>
      this.request<BankIDLoginResponse, HTTPValidationError>({
        path: `/my-pages/impersonate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name GetLatestActiveApplicationMyPagesApplicationLatestGet
     * @summary Get Latest Active Application
     * @request GET:/my-pages/application/latest
     * @secure
     */
    getLatestActiveApplicationMyPagesApplicationLatestGet: (params: RequestParams = {}) =>
      this.request<CustomerApplication, any>({
        path: `/my-pages/application/latest`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name GetCreditCardOffersMyPagesCreditCardOffersGet
     * @summary Get Credit Card Offers
     * @request GET:/my-pages/credit_card/offers
     * @secure
     */
    getCreditCardOffersMyPagesCreditCardOffersGet: (params: RequestParams = {}) =>
      this.request<CreditorOfferCreditCardOfferCreditCardTerms[], any>({
        path: `/my-pages/credit_card/offers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name GetApplicantMyPagesApplicantMeGet
     * @summary Get Applicant
     * @request GET:/my-pages/applicant/me
     * @secure
     */
    getApplicantMyPagesApplicantMeGet: (params: RequestParams = {}) =>
      this.request<ApplicantSE | ApplicantNO | (ApplicantSE & ApplicantNO), any>({
        path: `/my-pages/applicant/me`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name ValidateClearingMyPagesOffersClearingValidateClearingGet
     * @summary Validate Clearing
     * @request GET:/my-pages/offers/clearing/validate/{clearing}
     * @secure
     */
    validateClearingMyPagesOffersClearingValidateClearingGet: (clearing: string, params: RequestParams = {}) =>
      this.request<BankCommunicationData, HTTPValidationError>({
        path: `/my-pages/offers/clearing/validate/${clearing}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Legacy blanco endpoint (Sverker)
     *
     * @tags My Pages
     * @name AcceptOfferLegacyMyPagesOfferAcceptPost
     * @summary Accept Offer Legacy
     * @request POST:/my-pages/offer/accept
     * @secure
     */
    acceptOfferLegacyMyPagesOfferAcceptPost: (data: AcceptOfferPayload, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/my-pages/offer/accept`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name AcceptOfferMyPagesOfferAccept2Post
     * @summary Accept Offer
     * @request POST:/my-pages/offer/accept2
     * @secure
     */
    acceptOfferMyPagesOfferAccept2Post: (data: AcceptOffer, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/my-pages/offer/accept2`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name BanksToExcludeFromInsuranceOfferingForMyPagesInsurancesBanksExcludedGet
     * @summary Banks To Exclude From Insurance Offering For
     * @request GET:/my-pages/insurances/banks/excluded
     * @secure
     */
    banksToExcludeFromInsuranceOfferingForMyPagesInsurancesBanksExcludedGet: (params: RequestParams = {}) =>
      this.request<BanksToExcludeInsuranceOfferingFor, any>({
        path: `/my-pages/insurances/banks/excluded`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name InsurancesRulesMyPagesInsurancesRulesGet
     * @summary Insurances Rules
     * @request GET:/my-pages/insurances/rules
     * @secure
     */
    insurancesRulesMyPagesInsurancesRulesGet: (params: RequestParams = {}) =>
      this.request<object[], any>({
        path: `/my-pages/insurances/rules`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name ActiveInsuranceByPniMyPagesInsurancesGet
     * @summary Active Insurance By Pni
     * @request GET:/my-pages/insurances
     * @secure
     */
    activeInsuranceByPniMyPagesInsurancesGet: (params: RequestParams = {}) =>
      this.request<object[], any>({
        path: `/my-pages/insurances`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name CreateInsuranceMyPagesInsurancesPost
     * @summary Create Insurance
     * @request POST:/my-pages/insurances
     * @secure
     */
    createInsuranceMyPagesInsurancesPost: (data: BankCommunicationData, params: RequestParams = {}) =>
      this.request<BankCommunicationData, HTTPValidationError>({
        path: `/my-pages/insurances`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name GetGrIframeMyPagesGrIframeGet
     * @summary Get Gr Iframe
     * @request GET:/my-pages/gr/iframe
     * @secure
     */
    getGrIframeMyPagesGrIframeGet: (params: RequestParams = {}) =>
      this.request<GRIframeURL, any>({
        path: `/my-pages/gr/iframe`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  affiliates = {
    /**
     * No description
     *
     * @tags Affiliate
     * @name GetAffiliatesAffiliatesGet
     * @summary Get Affiliates
     * @request GET:/affiliates/
     * @secure
     */
    getAffiliatesAffiliatesGet: (
      query?: { page?: number; limit?: number; status?: string; network?: boolean; publisher?: boolean },
      params: RequestParams = {},
    ) =>
      this.request<Affiliate[], HTTPValidationError>({
        path: `/affiliates/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name CreateAffiliateAffiliatesPost
     * @summary Create Affiliate
     * @request POST:/affiliates/
     * @secure
     */
    createAffiliateAffiliatesPost: (data: AffiliateData, params: RequestParams = {}) =>
      this.request<Affiliate, HTTPValidationError>({
        path: `/affiliates/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name SearchAffiliatesAffiliatesSearchGet
     * @summary Search Affiliates
     * @request GET:/affiliates/search
     * @secure
     */
    searchAffiliatesAffiliatesSearchGet: (
      query: { keyword: string; page?: number; limit?: number },
      params: RequestParams = {},
    ) =>
      this.request<Affiliate[], HTTPValidationError>({
        path: `/affiliates/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name GetAffiliateAffiliatesAffiliateIdGet
     * @summary Get Affiliate
     * @request GET:/affiliates/{affiliate_id}
     * @secure
     */
    getAffiliateAffiliatesAffiliateIdGet: (affiliateId: string, params: RequestParams = {}) =>
      this.request<Affiliate, HTTPValidationError>({
        path: `/affiliates/${affiliateId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name UpdateAffiliateAffiliatesAffiliateIdPut
     * @summary Update Affiliate
     * @request PUT:/affiliates/{affiliate_id}
     * @secure
     */
    updateAffiliateAffiliatesAffiliateIdPut: (affiliateId: string, data: AffiliateData, params: RequestParams = {}) =>
      this.request<Affiliate, HTTPValidationError>({
        path: `/affiliates/${affiliateId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name DeactivateAffiliateAffiliatesAffiliateIdDelete
     * @summary Deactivate Affiliate
     * @request DELETE:/affiliates/{affiliate_id}
     * @secure
     */
    deactivateAffiliateAffiliatesAffiliateIdDelete: (affiliateId: string, params: RequestParams = {}) =>
      this.request<DateTime, HTTPValidationError>({
        path: `/affiliates/${affiliateId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name GetCampaignsAffiliatesAffiliateIdCampaignsGet
     * @summary Get Campaigns
     * @request GET:/affiliates/{affiliate_id}/campaigns
     * @secure
     */
    getCampaignsAffiliatesAffiliateIdCampaignsGet: (affiliateId: string, params: RequestParams = {}) =>
      this.request<ModelsAffiliateAffiliateCampaign[], HTTPValidationError>({
        path: `/affiliates/${affiliateId}/campaigns`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name CreateCampaignAffiliatesAffiliateIdCampaignsPost
     * @summary Create Campaign
     * @request POST:/affiliates/{affiliate_id}/campaigns
     * @secure
     */
    createCampaignAffiliatesAffiliateIdCampaignsPost: (
      affiliateId: string,
      data: ModelsAffiliateAffiliateCampaignData,
      params: RequestParams = {},
    ) =>
      this.request<Affiliate, HTTPValidationError>({
        path: `/affiliates/${affiliateId}/campaigns`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name UpdateCampaignAffiliatesAffiliateIdCampaignsCampaignIdPut
     * @summary Update Campaign
     * @request PUT:/affiliates/{affiliate_id}/campaigns/{campaign_id}
     * @secure
     */
    updateCampaignAffiliatesAffiliateIdCampaignsCampaignIdPut: (
      campaignId: string,
      affiliateId: string,
      data: ModelsAffiliateAffiliateCampaignData,
      params: RequestParams = {},
    ) =>
      this.request<Affiliate, HTTPValidationError>({
        path: `/affiliates/${affiliateId}/campaigns/${campaignId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name RemoveCampaignAffiliatesAffiliateIdCampaignsCampaignIdDelete
     * @summary Remove Campaign
     * @request DELETE:/affiliates/{affiliate_id}/campaigns/{campaign_id}
     * @secure
     */
    removeCampaignAffiliatesAffiliateIdCampaignsCampaignIdDelete: (
      campaignId: string,
      affiliateId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/affiliates/${affiliateId}/campaigns/${campaignId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name GetPersonEventAffiliatesPersonsZidGet
     * @summary Get Person Event
     * @request GET:/affiliates/persons/{zid}
     * @secure
     */
    getPersonEventAffiliatesPersonsZidGet: (zid: string, params: RequestParams = {}) =>
      this.request<Person, HTTPValidationError>({
        path: `/affiliates/persons/${zid}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name GetAffiliatePersonEventsAffiliatesAffiliateIdPersonsGet
     * @summary Get Affiliate Person Events
     * @request GET:/affiliates/{affiliate_id}/persons
     * @secure
     */
    getAffiliatePersonEventsAffiliatesAffiliateIdPersonsGet: (
      affiliateId: string,
      query?: { page?: number; limit?: number },
      params: RequestParams = {},
    ) =>
      this.request<Person[], HTTPValidationError>({
        path: `/affiliates/${affiliateId}/persons`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name GetAffiliateCallbacksAffiliatesAffiliateNetworkIdCallbacksPost
     * @summary Get Affiliate Callbacks
     * @request POST:/affiliates/{affiliate_network_id}/callbacks
     * @secure
     */
    getAffiliateCallbacksAffiliatesAffiliateNetworkIdCallbacksPost: (
      affiliateNetworkId: string,
      data: AffiliateNetworkCallbackStatus[],
      query?: { page?: number; limit?: number; publisher?: string; start_date?: string; end_date?: string },
      params: RequestParams = {},
    ) =>
      this.request<AffiliateNetworkCallbackEvent[], HTTPValidationError>({
        path: `/affiliates/${affiliateNetworkId}/callbacks`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name GetAffiliatePublishersAffiliatesAffiliateIdPublishersGet
     * @summary Get Affiliate Publishers
     * @request GET:/affiliates/{affiliate_id}/publishers
     * @secure
     */
    getAffiliatePublishersAffiliatesAffiliateIdPublishersGet: (affiliateId: string, params: RequestParams = {}) =>
      this.request<Affiliate[], HTTPValidationError>({
        path: `/affiliates/${affiliateId}/publishers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name AdtractionNetworkCallbackAffiliatesDevAdtractionCallbackSiteTtGet
     * @summary Adtraction Network Callback
     * @request GET:/affiliates/dev/adtraction/callback/{site}/t/t
     * @secure
     */
    adtractionNetworkCallbackAffiliatesDevAdtractionCallbackSiteTTGet: (site: string, params: RequestParams = {}) =>
      this.request<HTTPStatus, HTTPValidationError>({
        path: `/affiliates/dev/adtraction/callback/${site}/t/t`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name AdserviceNetworkCallbackAffiliatesDevAdserviceCallbackCgiBinApiConversionServiceCallbackGet
     * @summary Adservice Network Callback
     * @request GET:/affiliates/dev/adservice/callback/cgi-bin/API/ConversionService/Callback
     * @secure
     */
    adserviceNetworkCallbackAffiliatesDevAdserviceCallbackCgiBinApiConversionServiceCallbackGet: (
      params: RequestParams = {},
    ) =>
      this.request<HTTPStatus, HTTPValidationError>({
        path: `/affiliates/dev/adservice/callback/cgi-bin/API/ConversionService/Callback`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name SmartresponseNetworkCallbackAffiliatesDevSmartresponseCallbackPAshxGet
     * @summary Smartresponse Network Callback
     * @request GET:/affiliates/dev/smartresponse/callback/p.ashx
     * @secure
     */
    smartresponseNetworkCallbackAffiliatesDevSmartresponseCallbackPAshxGet: (params: RequestParams = {}) =>
      this.request<HTTPStatus, HTTPValidationError>({
        path: `/affiliates/dev/smartresponse/callback/p.ashx`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  online = {
    /**
     * @description Get all submissions for a country
     *
     * @tags Online
     * @name GetAllSubmissionsOnlineSubmissionsGet
     * @summary Get All Submissions
     * @request GET:/online/submissions
     * @secure
     */
    getAllSubmissionsOnlineSubmissionsGet: (
      query?: {
        failed?: boolean;
        handled?: boolean;
        form_validation?: boolean;
        quick_application?: boolean;
        get_customers?: boolean;
        has_recent_app_check?: boolean;
        created_application?: boolean;
        limit?: number;
        page?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<SubmissionReviewResponse, HTTPValidationError>({
        path: `/online/submissions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get submission by id
     *
     * @tags Online
     * @name GetASubmissionOnlineSubmissionsSubmissionIdGet
     * @summary Get A Submission
     * @request GET:/online/submissions/{submission_id}
     * @secure
     */
    getASubmissionOnlineSubmissionsSubmissionIdGet: (submissionId: string, params: RequestParams = {}) =>
      this.request<SubmissionReview, HTTPValidationError>({
        path: `/online/submissions/${submissionId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retry processing of submissions in case of temporary error
     *
     * @tags Online
     * @name PostReprocessSubmissionsOnlineSubmissionsReprocessPost
     * @summary Post Reprocess Submissions
     * @request POST:/online/submissions/reprocess
     * @secure
     */
    postReprocessSubmissionsOnlineSubmissionsReprocessPost: (data: string[], params: RequestParams = {}) =>
      this.request<EnqueuedSubmissionJobResult[], HTTPValidationError>({
        path: `/online/submissions/reprocess`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retry processing of submission in case of temporary error
     *
     * @tags Online
     * @name PostReprocessSubmissionOnlineSubmissionsSubmissionIdReprocessPost
     * @summary Post Reprocess Submission
     * @request POST:/online/submissions/{submission_id}/reprocess
     * @secure
     */
    postReprocessSubmissionOnlineSubmissionsSubmissionIdReprocessPost: (
      submissionId: string,
      params: RequestParams = {},
    ) =>
      this.request<EnqueuedSubmissionJobResult, HTTPValidationError>({
        path: `/online/submissions/${submissionId}/reprocess`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Online
     * @name PostResubmitSubmissionOnlineSubmissionsSubmissionIdResubmitPost
     * @summary Post Resubmit Submission
     * @request POST:/online/submissions/{submission_id}/resubmit
     * @secure
     */
    postResubmitSubmissionOnlineSubmissionsSubmissionIdResubmitPost: (
      submissionId: string,
      data: ResubmitPayload,
      params: RequestParams = {},
    ) =>
      this.request<EnqueuedSubmissionJobResult, HTTPValidationError>({
        path: `/online/submissions/${submissionId}/resubmit`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Online
     * @name PostReviewSubmissionOnlineSubmissionsSubmissionIdReviewPost
     * @summary Post Review Submission
     * @request POST:/online/submissions/{submission_id}/review
     * @secure
     */
    postReviewSubmissionOnlineSubmissionsSubmissionIdReviewPost: (
      submissionId: string,
      query?: { handled?: boolean },
      params: RequestParams = {},
    ) =>
      this.request<HandledSubmission, HTTPValidationError>({
        path: `/online/submissions/${submissionId}/review`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Online
     * @name PostReviewSubmissionsOnlineSubmissionsReviewPost
     * @summary Post Review Submissions
     * @request POST:/online/submissions/review
     * @secure
     */
    postReviewSubmissionsOnlineSubmissionsReviewPost: (data: ReviewSubmissions, params: RequestParams = {}) =>
      this.request<HandledSubmission[], HTTPValidationError>({
        path: `/online/submissions/review`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Converts a credit card submission to a blanco submission
     *
     * @tags Online
     * @name PostConvertToBlancoOnlineSubmissionsSubmissionIdConvertToBlancoPost
     * @summary Post Convert To Blanco
     * @request POST:/online/submissions/{submission_id}/convert_to_blanco
     * @secure
     */
    postConvertToBlancoOnlineSubmissionsSubmissionIdConvertToBlancoPost: (
      submissionId: string,
      params: RequestParams = {},
    ) =>
      this.request<EnqueuedSubmissionJobResult, HTTPValidationError>({
        path: `/online/submissions/${submissionId}/convert_to_blanco`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Online
     * @name GetBookingsOnlineBookingsCountryGet
     * @summary Get Bookings
     * @request GET:/online/bookings/{country}
     */
    getBookingsOnlineBookingsCountryGet: (country: Country, params: RequestParams = {}) =>
      this.request<BankCommunicationData, HTTPValidationError>({
        path: `/online/bookings/${country}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Online
     * @name BookMeetingOnlineBookingsCountryPost
     * @summary Book Meeting
     * @request POST:/online/bookings/{country}
     */
    bookMeetingOnlineBookingsCountryPost: (country: Country, data: BookingPayload, params: RequestParams = {}) =>
      this.request<ServicesSverkerResponsesMeeting, HTTPValidationError>({
        path: `/online/bookings/${country}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Online
     * @name ContactFormOnlineContactCountryPost
     * @summary Contact Form
     * @request POST:/online/contact/{country}
     */
    contactFormOnlineContactCountryPost: (country: Country, data: ContactFormPayload, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/online/contact/${country}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Online
     * @name MortgageFormOnlineMortgageCountryPost
     * @summary Mortgage Form
     * @request POST:/online/mortgage/{country}
     */
    mortgageFormOnlineMortgageCountryPost: (country: Country, data: MortgageFormPayload, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/online/mortgage/${country}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Online
     * @name BlancoApplicationOnlineBlancoApplicationCountryPost
     * @summary Blanco Application
     * @request POST:/online/blanco-application/{country}
     */
    blancoApplicationOnlineBlancoApplicationCountryPost: (
      country: Country,
      data: BankCommunicationData,
      params: RequestParams = {},
    ) =>
      this.request<FormApplicationSubmissionResult, HTTPValidationError>({
        path: `/online/blanco-application/${country}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Norway only
     *
     * @tags Online
     * @name NorwegianMortgageApplicationOnlineNorwegianMortgageApplicationPost
     * @summary Norwegian Mortgage Application
     * @request POST:/online/norwegian-mortgage-application
     */
    norwegianMortgageApplicationOnlineNorwegianMortgageApplicationPost: (
      data: BankCommunicationData,
      params: RequestParams = {},
    ) =>
      this.request<FormApplicationSubmissionResult, HTTPValidationError>({
        path: `/online/norwegian-mortgage-application`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  rq = {
    /**
     * No description
     *
     * @tags Monitor
     * @name GetListOfJobsRqJobsGet
     * @summary Get List Of Jobs
     * @request GET:/rq/jobs
     * @secure
     */
    getListOfJobsRqJobsGet: (query: { job_type: JobType }, params: RequestParams = {}) =>
      this.request<RqJobStatusResponse[], HTTPValidationError>({
        path: `/rq/jobs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Monitor
     * @name GetFailedJobsRqManualFailGet
     * @summary Get Failed Jobs
     * @request GET:/rq/manual-fail
     * @secure
     */
    getFailedJobsRqManualFailGet: (params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/rq/manual-fail`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Monitor
     * @name ClearFailedJobRqDeleteJobJobIdGet
     * @summary Clear Failed Job
     * @request GET:/rq/delete-job/{job_id}
     * @secure
     */
    clearFailedJobRqDeleteJobJobIdGet: (jobId: string, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/rq/delete-job/${jobId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Monitor
     * @name GetSingleJobRqJobIdGet
     * @summary Get Single Job
     * @request GET:/rq/{job_id}
     * @secure
     */
    getSingleJobRqJobIdGet: (jobId: string, params: RequestParams = {}) =>
      this.request<RqJobStatusResponse, HTTPValidationError>({
        path: `/rq/${jobId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  kdlt = {
    /**
     * No description
     *
     * @tags kdlt
     * @name CallbackKdltCallbackPost
     * @summary Callback
     * @request POST:/kdlt/callback
     * @secure
     */
    callbackKdltCallbackPost: (data: KDLTCallbackPayload, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/kdlt/callback`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  dialMaker = {
    /**
     * No description
     *
     * @tags Dial Maker
     * @name GetLeadsForCampaignDialMakerTmLeadsCampaignIdPost
     * @summary Get Leads For Campaign
     * @request POST:/dial-maker/tm-leads/{campaign_id}
     * @secure
     */
    getLeadsForCampaignDialMakerTmLeadsCampaignIdPost: (
      campaignId: string,
      data: RoutersDialMakerPayloadsLeadExtraction,
      params: RequestParams = {},
    ) =>
      this.request<TMLeadsJob, HTTPValidationError>({
        path: `/dial-maker/tm-leads/${campaignId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker
     * @name GetJobStatusOrResultDialMakerJobStatusJobIdGet
     * @summary Get Job Status Or Result
     * @request GET:/dial-maker/job-status/{job_id}
     * @secure
     */
    getJobStatusOrResultDialMakerJobStatusJobIdGet: (jobId: string, params: RequestParams = {}) =>
      this.request<TMLeadsExtraction | TMLeadsJob | (TMLeadsExtraction & TMLeadsJob), HTTPValidationError>({
        path: `/dial-maker/job-status/${jobId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker
     * @name GetDownloadUrlDialMakerJobResultJobIdDownloadUrlGet
     * @summary Get Download Url
     * @request GET:/dial-maker/job-result/{job_id}/download-url
     * @secure
     */
    getDownloadUrlDialMakerJobResultJobIdDownloadUrlGet: (jobId: string, params: RequestParams = {}) =>
      this.request<RoutersDialMakerPayloadsSignedUrl, HTTPValidationError>({
        path: `/dial-maker/job-result/${jobId}/download-url`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker
     * @name GetCampaignsDialMakerCampaignsGet
     * @summary Get Campaigns
     * @request GET:/dial-maker/campaigns
     * @secure
     */
    getCampaignsDialMakerCampaignsGet: (
      query: { page: number; limit: number; department?: ZDepartment; country?: Country; product?: Product },
      params: RequestParams = {},
    ) =>
      this.request<TMCampaignList, HTTPValidationError>({
        path: `/dial-maker/campaigns`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker
     * @name CreateCampaignDialMakerCampaignsPost
     * @summary Create Campaign
     * @request POST:/dial-maker/campaigns
     * @secure
     */
    createCampaignDialMakerCampaignsPost: (data: CreateTMCampaign, params: RequestParams = {}) =>
      this.request<TMCampaign, HTTPValidationError>({
        path: `/dial-maker/campaigns`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker
     * @name GetCampaignDialMakerCampaignsCampaignIdGet
     * @summary Get Campaign
     * @request GET:/dial-maker/campaigns/{campaign_id}
     * @secure
     */
    getCampaignDialMakerCampaignsCampaignIdGet: (campaignId: string, params: RequestParams = {}) =>
      this.request<TMCampaign, HTTPValidationError>({
        path: `/dial-maker/campaigns/${campaignId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker
     * @name UpdateCampaignDialMakerCampaignsCampaignIdPut
     * @summary Update Campaign
     * @request PUT:/dial-maker/campaigns/{campaign_id}
     * @secure
     */
    updateCampaignDialMakerCampaignsCampaignIdPut: (
      campaignId: string,
      data: CreateTMCampaign,
      params: RequestParams = {},
    ) =>
      this.request<TMCampaign, HTTPValidationError>({
        path: `/dial-maker/campaigns/${campaignId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker
     * @name DeleteCampaignDialMakerCampaignsCampaignIdDelete
     * @summary Delete Campaign
     * @request DELETE:/dial-maker/campaigns/{campaign_id}
     * @secure
     */
    deleteCampaignDialMakerCampaignsCampaignIdDelete: (campaignId: string, params: RequestParams = {}) =>
      this.request<boolean, HTTPValidationError>({
        path: `/dial-maker/campaigns/${campaignId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker
     * @name GetCampaignExtractionsDialMakerCampaignsCampaignIdExtractionsGet
     * @summary Get Campaign Extractions
     * @request GET:/dial-maker/campaigns/{campaign_id}/extractions
     * @secure
     */
    getCampaignExtractionsDialMakerCampaignsCampaignIdExtractionsGet: (
      campaignId: string,
      query: { page: number; limit: number },
      params: RequestParams = {},
    ) =>
      this.request<TMLeadsExtraction[], HTTPValidationError>({
        path: `/dial-maker/campaigns/${campaignId}/extractions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker
     * @name DownloadXlsxDialMakerDownloadSignatureGet
     * @summary Download Xlsx
     * @request GET:/dial-maker/download/{signature}
     */
    downloadXlsxDialMakerDownloadSignatureGet: (signature: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/dial-maker/download/${signature}`,
        method: "GET",
        ...params,
      }),
  };
  dialmaker = {
    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name CreateCampaignDialmakerCampaignPost
     * @summary Create Campaign
     * @request POST:/dialmaker/campaign
     * @secure
     */
    createCampaignDialmakerCampaignPost: (data: CreateCampaignData, params: RequestParams = {}) =>
      this.request<ModelsDialMaker2CampaignAggregateCampaign, HTTPValidationError>({
        path: `/dialmaker/campaign`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetCampaignDialmakerCampaignCampaignIdGet
     * @summary Get Campaign
     * @request GET:/dialmaker/campaign/{campaign_id}
     * @secure
     */
    getCampaignDialmakerCampaignCampaignIdGet: (campaignId: string, params: RequestParams = {}) =>
      this.request<ModelsDialMaker2CampaignAggregateCampaign, HTTPValidationError>({
        path: `/dialmaker/campaign/${campaignId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name UpdateCampaignDialmakerCampaignCampaignIdPut
     * @summary Update Campaign
     * @request PUT:/dialmaker/campaign/{campaign_id}
     * @secure
     */
    updateCampaignDialmakerCampaignCampaignIdPut: (
      campaignId: string,
      data: UpdateCampaignData,
      params: RequestParams = {},
    ) =>
      this.request<ModelsDialMaker2CampaignAggregateCampaign, HTTPValidationError>({
        path: `/dialmaker/campaign/${campaignId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetCampaignSourceDialmakerCampaignCampaignIdDataSourceGet
     * @summary Get Campaign Source
     * @request GET:/dialmaker/campaign/{campaign_id}/data/source
     * @secure
     */
    getCampaignSourceDialmakerCampaignCampaignIdDataSourceGet: (campaignId: string, params: RequestParams = {}) =>
      this.request<
        SheetCampaignSource | BigQueryCampaignSource | (SheetCampaignSource & BigQueryCampaignSource),
        HTTPValidationError
      >({
        path: `/dialmaker/campaign/${campaignId}/data/source`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetCampaignExtractionsDialmakerCampaignCampaignIdExtractionsGet
     * @summary Get Campaign Extractions
     * @request GET:/dialmaker/campaign/{campaign_id}/extractions
     * @secure
     */
    getCampaignExtractionsDialmakerCampaignCampaignIdExtractionsGet: (
      campaignId: string,
      query?: { page?: number; size?: number },
      params: RequestParams = {},
    ) =>
      this.request<PageCampaignExtraction, HTTPValidationError>({
        path: `/dialmaker/campaign/${campaignId}/extractions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetCampaignSheetsDialmakerCampaignCampaignIdDataSheetsGet
     * @summary Get Campaign Sheets
     * @request GET:/dialmaker/campaign/{campaign_id}/data/sheets
     * @secure
     */
    getCampaignSheetsDialmakerCampaignCampaignIdDataSheetsGet: (
      campaignId: string,
      query?: { page?: number; size?: number },
      params: RequestParams = {},
    ) =>
      this.request<PageSheet, HTTPValidationError>({
        path: `/dialmaker/campaign/${campaignId}/data/sheets`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name DeactivateCampaignDialmakerCampaignDeactivatePost
     * @summary Deactivate Campaign
     * @request POST:/dialmaker/campaign/deactivate
     * @secure
     */
    deactivateCampaignDialmakerCampaignDeactivatePost: (
      data: BodyDeactivateCampaignDialmakerCampaignDeactivatePost,
      params: RequestParams = {},
    ) =>
      this.request<ModelsDialMaker2CampaignAggregateCampaign, HTTPValidationError>({
        path: `/dialmaker/campaign/deactivate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name ActivateCampaignDialmakerCampaignActivatePost
     * @summary Activate Campaign
     * @request POST:/dialmaker/campaign/activate
     * @secure
     */
    activateCampaignDialmakerCampaignActivatePost: (
      data: BodyActivateCampaignDialmakerCampaignActivatePost,
      params: RequestParams = {},
    ) =>
      this.request<ModelsDialMaker2CampaignAggregateCampaign, HTTPValidationError>({
        path: `/dialmaker/campaign/activate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name ExtractCampaignsDialmakerCampaignExtractPost
     * @summary Extract Campaigns
     * @request POST:/dialmaker/campaign/extract
     * @secure
     */
    extractCampaignsDialmakerCampaignExtractPost: (
      data: BodyExtractCampaignsDialmakerCampaignExtractPost,
      params: RequestParams = {},
    ) =>
      this.request<ModelsDialMaker2CampaignAggregateCampaign, HTTPValidationError>({
        path: `/dialmaker/campaign/extract`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name DeleteExtractionDialmakerCampaignExtractionDelete
     * @summary Delete Extraction
     * @request DELETE:/dialmaker/campaign/extraction
     * @secure
     */
    deleteExtractionDialmakerCampaignExtractionDelete: (
      data: BodyDeleteExtractionDialmakerCampaignExtractionDelete,
      params: RequestParams = {},
    ) =>
      this.request<ModelsDialMaker2CampaignAggregateCampaign, HTTPValidationError>({
        path: `/dialmaker/campaign/extraction`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name FindCampaignsDialmakerCampaignFindPost
     * @summary Find Campaigns
     * @request POST:/dialmaker/campaign/find
     * @secure
     */
    findCampaignsDialmakerCampaignFindPost: (
      data: BodyFindCampaignsDialmakerCampaignFindPost,
      query?: { page?: number; size?: number },
      params: RequestParams = {},
    ) =>
      this.request<PageCampaign, HTTPValidationError>({
        path: `/dialmaker/campaign/find`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetLeadsDialmakerCampaignLeadsCampaignIdGet
     * @summary Get Leads
     * @request GET:/dialmaker/campaign/leads/{campaign_id}
     * @secure
     */
    getLeadsDialmakerCampaignLeadsCampaignIdGet: (
      campaignId: string,
      query?: { page?: number; size?: number },
      params: RequestParams = {},
    ) =>
      this.request<PageDMLead, HTTPValidationError>({
        path: `/dialmaker/campaign/leads/${campaignId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name ImportLeadsDialmakerCampaignImportPost
     * @summary Import Leads
     * @request POST:/dialmaker/campaign/import
     * @secure
     */
    importLeadsDialmakerCampaignImportPost: (
      data: BodyImportLeadsDialmakerCampaignImportPost,
      query?: { synchronous?: boolean },
      params: RequestParams = {},
    ) =>
      this.request<ModelsDialMaker2CampaignAggregateCampaign | string, HTTPValidationError>({
        path: `/dialmaker/campaign/import`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetJobStatusOrResultDialmakerCampaignJobStatusJobIdGet
     * @summary Get Job Status Or Result
     * @request GET:/dialmaker/campaign/job-status/{job_id}
     * @secure
     */
    getJobStatusOrResultDialmakerCampaignJobStatusJobIdGet: (jobId: string, params: RequestParams = {}) =>
      this.request<InterimLeadJob | InterimLead[] | (InterimLeadJob & InterimLead[]), HTTPValidationError>({
        path: `/dialmaker/campaign/job-status/${jobId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name UploadAttachmentDialmakerCampaignImageUploadPost
     * @summary Upload Attachment
     * @request POST:/dialmaker/campaign/image/upload
     * @secure
     */
    uploadAttachmentDialmakerCampaignImageUploadPost: (
      data: BodyUploadAttachmentDialmakerCampaignImageUploadPost,
      params: RequestParams = {},
    ) =>
      this.request<DateTime, HTTPValidationError>({
        path: `/dialmaker/campaign/image/upload`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name ExportAndExtractLeadsUrlDialmakerCampaignExportPost
     * @summary Export And Extract Leads Url
     * @request POST:/dialmaker/campaign/export
     * @secure
     */
    exportAndExtractLeadsUrlDialmakerCampaignExportPost: (
      data: BodyExportAndExtractLeadsUrlDialmakerCampaignExportPost,
      params: RequestParams = {},
    ) =>
      this.request<RoutersDialMaker2PayloadsSignedUrl, HTTPValidationError>({
        path: `/dialmaker/campaign/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name ExportAndExtractLeadsUrlDownloadDialmakerCampaignExtractionExportPost
     * @summary Export And Extract Leads Url Download
     * @request POST:/dialmaker/campaign/extraction/export
     * @secure
     */
    exportAndExtractLeadsUrlDownloadDialmakerCampaignExtractionExportPost: (
      data: BodyExportAndExtractLeadsUrlDownloadDialmakerCampaignExtractionExportPost,
      params: RequestParams = {},
    ) =>
      this.request<RoutersDialMaker2PayloadsSignedUrl, HTTPValidationError>({
        path: `/dialmaker/campaign/extraction/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetOngoingExtractionsDialmakerCampaignCampaignIdOngoingExtractionsPost
     * @summary Get Ongoing Extractions
     * @request POST:/dialmaker/campaign/{campaign_id}/ongoing_extractions
     * @secure
     */
    getOngoingExtractionsDialmakerCampaignCampaignIdOngoingExtractionsPost: (
      campaignId: string,
      params: RequestParams = {},
    ) =>
      this.request<CampaignOngoingExtraction[], HTTPValidationError>({
        path: `/dialmaker/campaign/${campaignId}/ongoing_extractions`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetOutcomesReportDialmakerCampaignSearchLeadsPost
     * @summary Get Outcomes Report
     * @request POST:/dialmaker/campaign/search-leads
     * @secure
     */
    getOutcomesReportDialmakerCampaignSearchLeadsPost: (
      data: SearchLeadsPayload,
      query?: { page?: number; size?: number },
      params: RequestParams = {},
    ) =>
      this.request<PageDMLead, HTTPValidationError>({
        path: `/dialmaker/campaign/search-leads`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint is used to get statistics: - Leads with 0 outcomes - Available leads to call - Already extracted count - Leads left to extract (cold campaigns only)
     *
     * @tags Dial Maker 2
     * @name GetExtractionsStatsDialmakerCampaignCampaignIdExtractionsStatsGet
     * @summary Get Extractions Stats
     * @request GET:/dialmaker/campaign/{campaign_id}/extractions_stats
     * @secure
     */
    getExtractionsStatsDialmakerCampaignCampaignIdExtractionsStatsGet: (
      campaignId: string,
      params: RequestParams = {},
    ) =>
      this.request<CampaignExtractionsStats, HTTPValidationError>({
        path: `/dialmaker/campaign/${campaignId}/extractions_stats`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetUserCampaignsDialmakerCampaignsGet
     * @summary Get User Campaigns
     * @request GET:/dialmaker/campaigns
     * @deprecated
     * @secure
     */
    getUserCampaignsDialmakerCampaignsGet: (params: RequestParams = {}) =>
      this.request<UserCampaignsExt, HTTPValidationError>({
        path: `/dialmaker/campaigns`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name AvailableCampaignsDialmakerCampaignsAvailablePost
     * @summary Available Campaigns
     * @request POST:/dialmaker/campaigns/available
     * @secure
     */
    availableCampaignsDialmakerCampaignsAvailablePost: (params: RequestParams = {}) =>
      this.request<Available, HTTPValidationError>({
        path: `/dialmaker/campaigns/available`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name JoinCampaignDialmakerCampaignsJoinPost
     * @summary Join Campaign
     * @request POST:/dialmaker/campaigns/join
     * @secure
     */
    joinCampaignDialmakerCampaignsJoinPost: (
      data: BodyJoinCampaignDialmakerCampaignsJoinPost,
      params: RequestParams = {},
    ) =>
      this.request<Available, HTTPValidationError>({
        path: `/dialmaker/campaigns/join`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name LeaveCampaignDialmakerCampaignsLeavePost
     * @summary Leave Campaign
     * @request POST:/dialmaker/campaigns/leave
     * @secure
     */
    leaveCampaignDialmakerCampaignsLeavePost: (
      data: BodyLeaveCampaignDialmakerCampaignsLeavePost,
      params: RequestParams = {},
    ) =>
      this.request<Available, HTTPValidationError>({
        path: `/dialmaker/campaigns/leave`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name PlayCampaignDialmakerCampaignsPlayPost
     * @summary Play Campaign
     * @request POST:/dialmaker/campaigns/play
     * @secure
     */
    playCampaignDialmakerCampaignsPlayPost: (
      data: BodyPlayCampaignDialmakerCampaignsPlayPost,
      params: RequestParams = {},
    ) =>
      this.request<Available, HTTPValidationError>({
        path: `/dialmaker/campaigns/play`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name PauseCampaignDialmakerCampaignsPausePost
     * @summary Pause Campaign
     * @request POST:/dialmaker/campaigns/pause
     * @secure
     */
    pauseCampaignDialmakerCampaignsPausePost: (
      data: BodyPauseCampaignDialmakerCampaignsPausePost,
      params: RequestParams = {},
    ) =>
      this.request<Available, HTTPValidationError>({
        path: `/dialmaker/campaigns/pause`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetCardDialmakerCardNextPost
     * @summary Get Card
     * @request POST:/dialmaker/card/next
     * @secure
     */
    getCardDialmakerCardNextPost: (params: RequestParams = {}) =>
      this.request<DMLeadExt, HTTPValidationError>({
        path: `/dialmaker/card/next`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name ViewDialmakerCardViewPost
     * @summary View
     * @request POST:/dialmaker/card/view
     * @secure
     */
    viewDialmakerCardViewPost: (data: BodyViewDialmakerCardViewPost, params: RequestParams = {}) =>
      this.request<DMLeadExt, HTTPValidationError>({
        path: `/dialmaker/card/view`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name UpdateDialmakerCardUpdatePost
     * @summary Update
     * @request POST:/dialmaker/card/update
     * @secure
     */
    updateDialmakerCardUpdatePost: (data: BodyUpdateDialmakerCardUpdatePost, params: RequestParams = {}) =>
      this.request<DMLead, HTTPValidationError>({
        path: `/dialmaker/card/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name HangupDialmakerCardHangupPost
     * @summary Hangup
     * @request POST:/dialmaker/card/hangup
     * @secure
     */
    hangupDialmakerCardHangupPost: (data: BodyHangupDialmakerCardHangupPost, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/dialmaker/card/hangup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name CallSuccessDialmakerCardOutcomeSuccessPost
     * @summary Call Success
     * @request POST:/dialmaker/card/outcome/success
     * @secure
     */
    callSuccessDialmakerCardOutcomeSuccessPost: (
      data: BodyCallSuccessDialmakerCardOutcomeSuccessPost,
      params: RequestParams = {},
    ) =>
      this.request<DMLeadExt, HTTPValidationError>({
        path: `/dialmaker/card/outcome/success`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name CallBackDialmakerCardOutcomeCallBackPost
     * @summary Call Back
     * @request POST:/dialmaker/card/outcome/call_back
     * @secure
     */
    callBackDialmakerCardOutcomeCallBackPost: (
      data: BodyCallBackDialmakerCardOutcomeCallBackPost,
      params: RequestParams = {},
    ) =>
      this.request<DMLeadExt, HTTPValidationError>({
        path: `/dialmaker/card/outcome/call_back`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name CallBackDialmakerCardOutcomeLaterPost
     * @summary Call Back
     * @request POST:/dialmaker/card/outcome/later
     * @secure
     */
    callBackDialmakerCardOutcomeLaterPost: (
      data: BodyCallBackDialmakerCardOutcomeLaterPost,
      params: RequestParams = {},
    ) =>
      this.request<DMLeadExt, HTTPValidationError>({
        path: `/dialmaker/card/outcome/later`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name CallNoContactDialmakerCardOutcomeNoContactPost
     * @summary Call No Contact
     * @request POST:/dialmaker/card/outcome/no_contact
     * @secure
     */
    callNoContactDialmakerCardOutcomeNoContactPost: (
      data: BodyCallNoContactDialmakerCardOutcomeNoContactPost,
      params: RequestParams = {},
    ) =>
      this.request<DMLeadExt, HTTPValidationError>({
        path: `/dialmaker/card/outcome/no_contact`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name CallFailureDialmakerCardOutcomeFailurePost
     * @summary Call Failure
     * @request POST:/dialmaker/card/outcome/failure
     * @secure
     */
    callFailureDialmakerCardOutcomeFailurePost: (
      data: BodyCallFailureDialmakerCardOutcomeFailurePost,
      params: RequestParams = {},
    ) =>
      this.request<DMLeadExt, HTTPValidationError>({
        path: `/dialmaker/card/outcome/failure`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetOutcomesDialmakerCardOutcomesPost
     * @summary Get Outcomes
     * @request POST:/dialmaker/card/outcomes
     * @secure
     */
    getOutcomesDialmakerCardOutcomesPost: (
      data: BodyGetOutcomesDialmakerCardOutcomesPost,
      params: RequestParams = {},
    ) =>
      this.request<Outcomes, HTTPValidationError>({
        path: `/dialmaker/card/outcomes`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name SearchDialmakerCardSearchPost
     * @summary Search
     * @request POST:/dialmaker/card/search
     * @secure
     */
    searchDialmakerCardSearchPost: (data: BodySearchDialmakerCardSearchPost, params: RequestParams = {}) =>
      this.request<DMLeadExt[], HTTPValidationError>({
        path: `/dialmaker/card/search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name LockDialmakerCardLockPost
     * @summary Lock
     * @request POST:/dialmaker/card/lock
     * @secure
     */
    lockDialmakerCardLockPost: (data: BodyLockDialmakerCardLockPost, params: RequestParams = {}) =>
      this.request<DMLead, HTTPValidationError>({
        path: `/dialmaker/card/lock`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name PersonalCallbacksDialmakerCardPersonalCallbacksPost
     * @summary Personal Callbacks
     * @request POST:/dialmaker/card/personal_callbacks
     * @secure
     */
    personalCallbacksDialmakerCardPersonalCallbacksPost: (params: RequestParams = {}) =>
      this.request<DMLeadExt[], HTTPValidationError>({
        path: `/dialmaker/card/personal_callbacks`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetSlotsDialmakerCardSlotsGet
     * @summary Get Slots
     * @request GET:/dialmaker/card/slots
     * @secure
     */
    getSlotsDialmakerCardSlotsGet: (query: { date: string }, params: RequestParams = {}) =>
      this.request<BookableSlot[], HTTPValidationError>({
        path: `/dialmaker/card/slots`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetPreviousAppsDialmakerCardPreviousAppsPost
     * @summary Get Previous Apps
     * @request POST:/dialmaker/card/previous_apps
     * @secure
     */
    getPreviousAppsDialmakerCardPreviousAppsPost: (query: { customer_id: string }, params: RequestParams = {}) =>
      this.request<PreviousApplicationsList, HTTPValidationError>({
        path: `/dialmaker/card/previous_apps`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name MineDialmakerCardOutcomesMineTodayPost
     * @summary Mine
     * @request POST:/dialmaker/card/outcomes/mine_today
     * @secure
     */
    mineDialmakerCardOutcomesMineTodayPost: (
      query: { start_date: string; end_date: string },
      params: RequestParams = {},
    ) =>
      this.request<OutcomeCount, HTTPValidationError>({
        path: `/dialmaker/card/outcomes/mine_today`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Upload file and return a preview of sheet, together with the file id needed to import leads. Uploaded file whether it's csv or xlsx should have headers in the first row to be able to map the columns to the lead data model.
     *
     * @tags Dial Maker 2
     * @name UploadDialmakerSheetCampaignIdUploadWithPreviewPost
     * @summary Upload
     * @request POST:/dialmaker/sheet/{campaign_id}/upload_with_preview
     * @secure
     */
    uploadDialmakerSheetCampaignIdUploadWithPreviewPost: (
      campaignId: string,
      data: BodyUploadDialmakerSheetCampaignIdUploadWithPreviewPost,
      params: RequestParams = {},
    ) =>
      this.request<SheetPreview, HTTPValidationError>({
        path: `/dialmaker/sheet/${campaignId}/upload_with_preview`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint is used to import leads from a file to a global leads collection with campaign_id and file_id metadata
     *
     * @tags Dial Maker 2
     * @name ImportFromFileDialmakerSheetCampaignIdImportFromFileIdPost
     * @summary Import From File
     * @request POST:/dialmaker/sheet/{campaign_id}/import_from/{file_id}
     * @secure
     */
    importFromFileDialmakerSheetCampaignIdImportFromFileIdPost: (
      campaignId: string,
      fileId: string,
      data: Record<string, string>,
      query?: { synchronous?: boolean },
      params: RequestParams = {},
    ) =>
      this.request<ModelsDialMaker2CampaignAggregateCampaign | string, HTTPValidationError>({
        path: `/dialmaker/sheet/${campaignId}/import_from/${fileId}`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint is used to delete a file from the database if it was not imported yet
     *
     * @tags Dial Maker 2
     * @name DeleteCampaignSheetDialmakerSheetCampaignIdDeleteFileFileIdDelete
     * @summary Delete Campaign Sheet
     * @request DELETE:/dialmaker/sheet/{campaign_id}/delete_file/{file_id}
     * @secure
     */
    deleteCampaignSheetDialmakerSheetCampaignIdDeleteFileFileIdDelete: (
      campaignId: string,
      fileId: string,
      params: RequestParams = {},
    ) =>
      this.request<ModelsDialMaker2CampaignAggregateCampaign, HTTPValidationError>({
        path: `/dialmaker/sheet/${campaignId}/delete_file/${fileId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint is used to delete import of a given sheet_id with all interim leads
     *
     * @tags Dial Maker 2
     * @name DeleteInterimLeadsDialmakerSheetCampaignIdImportSheetIdDelete
     * @summary Delete Interim Leads
     * @request DELETE:/dialmaker/sheet/{campaign_id}/import/{sheet_id}
     * @secure
     */
    deleteInterimLeadsDialmakerSheetCampaignIdImportSheetIdDelete: (
      campaignId: string,
      sheetId: string,
      params: RequestParams = {},
    ) =>
      this.request<ModelsDialMaker2CampaignAggregateCampaign, HTTPValidationError>({
        path: `/dialmaker/sheet/${campaignId}/import/${sheetId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetOutcomesDialmakerMiscOutcomesGet
     * @summary Get Outcomes
     * @request GET:/dialmaker/misc/outcomes
     * @secure
     */
    getOutcomesDialmakerMiscOutcomesGet: (params: RequestParams = {}) =>
      this.request<Outcomes, HTTPValidationError>({
        path: `/dialmaker/misc/outcomes`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name SaveOutcomesDialmakerMiscOutcomesPost
     * @summary Save Outcomes
     * @request POST:/dialmaker/misc/outcomes
     * @secure
     */
    saveOutcomesDialmakerMiscOutcomesPost: (
      data: BodySaveOutcomesDialmakerMiscOutcomesPost,
      params: RequestParams = {},
    ) =>
      this.request<Outcomes, HTTPValidationError>({
        path: `/dialmaker/misc/outcomes`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name AdminDialmakerAdminOutcomesPost
     * @summary Admin
     * @request POST:/dialmaker/admin/outcomes
     * @secure
     */
    adminDialmakerAdminOutcomesPost: (
      query: { start_date: string; end_date: string },
      data: BodyAdminDialmakerAdminOutcomesPost,
      params: RequestParams = {},
    ) =>
      this.request<OutcomeCount, HTTPValidationError>({
        path: `/dialmaker/admin/outcomes`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name BlockFieldsDialmakerAdminBlockPost
     * @summary Block Fields
     * @request POST:/dialmaker/admin/block
     * @secure
     */
    blockFieldsDialmakerAdminBlockPost: (data: BlockCustomerFieldManuallyPayload, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/dialmaker/admin/block`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  bank = {
    /**
     * No description
     *
     * @tags Bank Login
     * @name LoginBankLoginPost
     * @summary Login
     * @request POST:/bank/login
     */
    loginBankLoginPost: (data: Login, params: RequestParams = {}) =>
      this.request<LoginResp, HTTPValidationError>({
        path: `/bank/login`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank Login
     * @name ValidateOtpCodeBankLoginValidatePost
     * @summary Validate Otp Code
     * @request POST:/bank/login/validate
     */
    validateOtpCodeBankLoginValidatePost: (data: OTPValidation, params: RequestParams = {}) =>
      this.request<OTPValidationResp, HTTPValidationError>({
        path: `/bank/login/validate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank Login
     * @name SetNewPasswordBankSetPasswordPost
     * @summary Set New Password
     * @request POST:/bank/set-password
     */
    setNewPasswordBankSetPasswordPost: (data: SetPassword, params: RequestParams = {}) =>
      this.request<SetPasswordResp, HTTPValidationError>({
        path: `/bank/set-password`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank Login
     * @name RequestNewOtpBankNewOtpPost
     * @summary Request New Otp
     * @request POST:/bank/new-otp
     */
    requestNewOtpBankNewOtpPost: (data: RequestNewOTP, params: RequestParams = {}) =>
      this.request<SetPasswordResp, HTTPValidationError>({
        path: `/bank/new-otp`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank User Administration
     * @name CreateNewBankUserBankCreateUserPost
     * @summary Create New Bank User
     * @request POST:/bank/create-user
     * @secure
     */
    createNewBankUserBankCreateUserPost: (data: CreateUser, params: RequestParams = {}) =>
      this.request<CreateUserResp, HTTPValidationError>({
        path: `/bank/create-user`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank User Administration
     * @name GetBankUsersBankGetPost
     * @summary Get Bank Users
     * @request POST:/bank/get
     * @secure
     */
    getBankUsersBankGetPost: (data: GetUsersPayload, params: RequestParams = {}) =>
      this.request<BankUserWithBankNames[], HTTPValidationError>({
        path: `/bank/get`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank User Administration
     * @name GetBankUserBankUserIdGet
     * @summary Get Bank User
     * @request GET:/bank/{user_id}
     * @secure
     */
    getBankUserBankUserIdGet: (userId: string, params: RequestParams = {}) =>
      this.request<BankUserWithBankNames, HTTPValidationError>({
        path: `/bank/${userId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank User Administration
     * @name EditBankUserBankUserIdPut
     * @summary Edit Bank User
     * @request PUT:/bank/{user_id}
     * @secure
     */
    editBankUserBankUserIdPut: (userId: string, data: EditUser, params: RequestParams = {}) =>
      this.request<BankUserWithBankNames, HTTPValidationError>({
        path: `/bank/${userId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank User Administration
     * @name ResetBankUserPasswordBankResetPasswordPost
     * @summary Reset Bank User Password
     * @request POST:/bank/reset-password
     * @secure
     */
    resetBankUserPasswordBankResetPasswordPost: (data: ResetPasswordPayload, params: RequestParams = {}) =>
      this.request<CreateUserResp, HTTPValidationError>({
        path: `/bank/reset-password`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank User Administration
     * @name DeactivateBankUserBankDeactivatePut
     * @summary Deactivate Bank User
     * @request PUT:/bank/deactivate
     * @secure
     */
    deactivateBankUserBankDeactivatePut: (data: DeactivateUserPayload, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/bank/deactivate`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank
     * @name GetApplicationsBankApplicationsPost
     * @summary Get Applications
     * @request POST:/bank/applications
     * @secure
     */
    getApplicationsBankApplicationsPost: (data: GetApplications, params: RequestParams = {}) =>
      this.request<BankBaseApp[], HTTPValidationError>({
        path: `/bank/applications`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank
     * @name GetApplicationBankApplicationApplicationIdGet
     * @summary Get Application
     * @request GET:/bank/application/{application_id}
     * @secure
     */
    getApplicationBankApplicationApplicationIdGet: (applicationId: string, params: RequestParams = {}) =>
      this.request<BankBaseApp, HTTPValidationError>({
        path: `/bank/application/${applicationId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank
     * @name GetDocumentMetaBankDocumentMetaCustomerIdDocumentIdGet
     * @summary Get Document Meta
     * @request GET:/bank/document/meta/{customer_id}/{document_id}
     * @secure
     */
    getDocumentMetaBankDocumentMetaCustomerIdDocumentIdGet: (
      customerId: string,
      documentId: string,
      params: RequestParams = {},
    ) =>
      this.request<DocumentMeta, HTTPValidationError>({
        path: `/bank/document/meta/${customerId}/${documentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank
     * @name GetDocumentBankGetCustomerIdDocumentIdGet
     * @summary Get Document
     * @request GET:/bank/get/{customer_id}/{document_id}
     * @secure
     */
    getDocumentBankGetCustomerIdDocumentIdGet: (customerId: string, documentId: string, params: RequestParams = {}) =>
      this.request<ModelsDocumentDocumentDocument, HTTPValidationError>({
        path: `/bank/get/${customerId}/${documentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank
     * @name GetAllBanksBankGetBanksPost
     * @summary Get All Banks
     * @request POST:/bank/get-banks
     * @secure
     */
    getAllBanksBankGetBanksPost: (data: GetBanksPayload, params: RequestParams = {}) =>
      this.request<Bank[], HTTPValidationError>({
        path: `/bank/get-banks`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank
     * @name GetAppEventsBankGetAppEventsApplicationIdGet
     * @summary Get App Events
     * @request GET:/bank/get_app_events/{application_id}
     * @secure
     */
    getAppEventsBankGetAppEventsApplicationIdGet: (applicationId: string, params: RequestParams = {}) =>
      this.request<EventsResponse, HTTPValidationError>({
        path: `/bank/get_app_events/${applicationId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank
     * @name AddCommentBankCommentPost
     * @summary Add Comment
     * @request POST:/bank/comment
     * @secure
     */
    addCommentBankCommentPost: (data: BankComment, params: RequestParams = {}) =>
      this.request<EventsResponse, HTTPValidationError>({
        path: `/bank/comment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank
     * @name PostOfferBankOfferPost
     * @summary Post Offer
     * @request POST:/bank/offer
     * @secure
     */
    postOfferBankOfferPost: (data: BankOfferPayload, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/bank/offer`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank, Application
     * @name RejectBankRejectPost
     * @summary Reject
     * @request POST:/bank/reject
     * @secure
     */
    rejectBankRejectPost: (data: BankRejectPayload, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/bank/reject`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank, Application
     * @name DisburseBankDisbursePost
     * @summary Disburse
     * @request POST:/bank/disburse
     * @secure
     */
    disburseBankDisbursePost: (data: BankDisbursePayload, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/bank/disburse`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank
     * @name SearchApplicationsBankSearchPost
     * @summary Search Applications
     * @request POST:/bank/search
     * @secure
     */
    searchApplicationsBankSearchPost: (
      data: RoutersBankPayloadsSearchPayload,
      query?: { page?: number; limit?: number },
      params: RequestParams = {},
    ) =>
      this.request<BankBaseApp[], HTTPValidationError>({
        path: `/bank/search`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  jotform = {
    /**
     * No description
     *
     * @tags Jotform
     * @name SubmissionJotformWebhookFormIdPost
     * @summary Submission
     * @request POST:/jotform/webhook/{form_id}
     */
    submissionJotformWebhookFormIdPost: (
      formId: string,
      data: BodySubmissionJotformWebhookFormIdPost,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/jotform/webhook/${formId}`,
        method: "POST",
        body: data,
        type: ContentType.UrlEncoded,
        format: "json",
        ...params,
      }),
  };
  campaign = {
    /**
     * No description
     *
     * @tags Affiliate
     * @name CreateCampaignInitializedEventCampaignCampaignIdGet
     * @summary Create Campaign Initialized Event
     * @request GET:/campaign/{campaign_id}
     */
    createCampaignInitializedEventCampaignCampaignIdGet: (campaignId: string, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/campaign/${campaignId}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  visit = {
    /**
     * No description
     *
     * @tags Affiliate
     * @name CreateVisitEventVisitCountryZidPost
     * @summary Create Visit Event
     * @request POST:/visit/{country}/{zid}
     */
    createVisitEventVisitCountryZidPost: (
      country: Country,
      zid: string,
      data: WebsiteVisitPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/visit/${country}/${zid}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  slack = {
    /**
     * No description
     *
     * @tags Slack
     * @name SlackCallbackSlackCallbackPost
     * @summary Slack Callback
     * @request POST:/slack/callback
     */
    slackCallbackSlackCallbackPost: (data: BodySlackCallbackSlackCallbackPost, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/slack/callback`,
        method: "POST",
        body: data,
        type: ContentType.UrlEncoded,
        format: "json",
        ...params,
      }),
  };
  dialMaker2 = {
    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetImageDialMaker2ImageGet
     * @summary Get Image
     * @request GET:/dial-maker2/image
     */
    getImageDialMaker2ImageGet: (query: { file_id: string }, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/dial-maker2/image`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name DownloadLeadsXlsxDialMaker2ExportDownloadSignatureGet
     * @summary Download Leads Xlsx
     * @request GET:/dial-maker2/export/download/{signature}
     */
    downloadLeadsXlsxDialMaker2ExportDownloadSignatureGet: (signature: string, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/dial-maker2/export/download/${signature}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  wellKnown = {
    /**
     * No description
     *
     * @tags Well known
     * @name GetJwksWellKnownJwksJsonGet
     * @summary Get Jwks
     * @request GET:/.well-known/jwks.json
     */
    getJwksWellKnownJwksJsonGet: (params: RequestParams = {}) =>
      this.request<BankCommunicationData, any>({
        path: `/.well-known/jwks.json`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  infra = {
    /**
     * No description
     *
     * @tags Other
     * @name Auth0EventsProxyInfraAuth0EventsPost
     * @summary Auth0 Events Proxy
     * @request POST:/infra/auth0/events
     * @secure
     */
    auth0EventsProxyInfraAuth0EventsPost: (data: object[], params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/infra/auth0/events`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  callmaker = {
    /**
     * No description
     *
     * @tags Callmaker Callbacks
     * @name GetCallmakerDataCallmakerCallbackCallPost
     * @summary Get Callmaker Data
     * @request POST:/callmaker/callback/call
     * @secure
     */
    getCallmakerDataCallmakerCallbackCallPost: (data: BankCommunicationData, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/callmaker/callback/call`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Callmaker Callbacks
     * @name GetProcessedDataCallmakerCallbackProcessPost
     * @summary Get Processed Data
     * @request POST:/callmaker/callback/process
     * @secure
     */
    getProcessedDataCallmakerCallbackProcessPost: (data: BankCommunicationData, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/callmaker/callback/process`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  v1 = {
    /**
     * No description
     *
     * @tags V1 Affiliate API
     * @name CreateBlancoApplicationV1AffiliateApplicationsBlancoPost
     * @summary Create Blanco Application
     * @request POST:/v1/affiliate/applications/blanco
     * @secure
     */
    createBlancoApplicationV1AffiliateApplicationsBlancoPost: (
      data: AffiliateCreateBlancoApplication,
      params: RequestParams = {},
    ) =>
      this.request<AffiliateResponse, HTTPValidationError>({
        path: `/v1/affiliate/applications/blanco`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V1 Affiliate API
     * @name GetBookingsBlancoV1AffiliateBookingsBlancoGet
     * @summary Get Bookings Blanco
     * @request GET:/v1/affiliate/bookings/blanco
     * @secure
     */
    getBookingsBlancoV1AffiliateBookingsBlancoGet: (
      query: { start_date: string; end_date: string; country: Country },
      params: RequestParams = {},
    ) =>
      this.request<AvailableBookings, HTTPValidationError>({
        path: `/v1/affiliate/bookings/blanco`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V1 Affiliate API
     * @name CreateMortgageLeadV1AffiliateLeadsMortgagePost
     * @summary Create Mortgage Lead
     * @request POST:/v1/affiliate/leads/mortgage
     * @secure
     */
    createMortgageLeadV1AffiliateLeadsMortgagePost: (data: AffiliateLeadCreationPayload, params: RequestParams = {}) =>
      this.request<AffiliateResponse, HTTPValidationError>({
        path: `/v1/affiliate/leads/mortgage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V1 Affiliate API
     * @name GetBookingsMortgageV1AffiliateBookingsMortgageGet
     * @summary Get Bookings Mortgage
     * @request GET:/v1/affiliate/bookings/mortgage
     * @secure
     */
    getBookingsMortgageV1AffiliateBookingsMortgageGet: (
      query: { start_date: string; end_date: string; country: Country },
      params: RequestParams = {},
    ) =>
      this.request<AvailableBookings, HTTPValidationError>({
        path: `/v1/affiliate/bookings/mortgage`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns all allowed enum values
     *
     * @tags V1 Affiliate API
     * @name GetOptionsV1AffiliateOptionsCountryProductGet
     * @summary Get Options
     * @request GET:/v1/affiliate/options/{country}/{product}
     * @secure
     */
    getOptionsV1AffiliateOptionsCountryProductGet: (country: Country, product: Product, params: RequestParams = {}) =>
      this.request<AffiliateOptionsResponse, HTTPValidationError>({
        path: `/v1/affiliate/options/${country}/${product}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V1 Affiliate API
     * @name GetBlancoStatusV1AffiliateApplicationsBlancoSubmissionIdGet
     * @summary Get Blanco Status
     * @request GET:/v1/affiliate/applications/blanco/{submission_id}
     * @secure
     */
    getBlancoStatusV1AffiliateApplicationsBlancoSubmissionIdGet: (submissionId: string, params: RequestParams = {}) =>
      this.request<AffiliateCallback, HTTPValidationError>({
        path: `/v1/affiliate/applications/blanco/${submissionId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V1 Affiliate API
     * @name GetMortgageStatusV1AffiliateLeadsMortgageSubmissionIdGet
     * @summary Get Mortgage Status
     * @request GET:/v1/affiliate/leads/mortgage/{submission_id}
     * @secure
     */
    getMortgageStatusV1AffiliateLeadsMortgageSubmissionIdGet: (submissionId: string, params: RequestParams = {}) =>
      this.request<AffiliateCallback, HTTPValidationError>({
        path: `/v1/affiliate/leads/mortgage/${submissionId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
